// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3E%3Cpath fill=%27%23fff%27 d=%27M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 4 4%27%3E%3Cpath stroke=%27%23fff%27 d=%27M0 2h4%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3E%3Ccircle r=%273%27 fill=%27%23fff%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 4 5%27%3E%3Cpath fill=%27%23343a40%27 d=%27M2 0L0 2h4zm0 5L0 3h4z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg viewBox=%270 0 30 30%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath stroke=%27rgba%280, 0, 0, 0.5%29%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg viewBox=%270 0 30 30%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath stroke=%27rgba%28255, 255, 255, 0.5%29%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23fff%27 viewBox=%270 0 8 8%27%3E%3Cpath d=%27M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23fff%27 viewBox=%270 0 8 8%27%3E%3Cpath d=%27M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!
 * Bootstrap v4.1.1 (https://getbootstrap.com/)
 * Copyright 2011-2018 The Bootstrap Authors
 * Copyright 2011-2018 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 */
:root {
  --blue: #007bff;
  --indigo: #6610f2;
  --purple: #6f42c1;
  --pink: #e83e8c;
  --red: #dc3545;
  --orange: #fd7e14;
  --yellow: #ffc107;
  --green: #28a745;
  --teal: #20c997;
  --cyan: #17a2b8;
  --white: #fff;
  --gray: #6c757d;
  --gray-dark: #343a40;
  --primary: #007bff;
  --secondary: #6c757d;
  --success: #28a745;
  --info: #17a2b8;
  --warning: #ffc107;
  --danger: #dc3545;
  --light: #f8f9fa;
  --dark: #343a40;
  --breakpoint-xs: 0;
  --breakpoint-sm: 576px;
  --breakpoint-md: 768px;
  --breakpoint-lg: 992px;
  --breakpoint-xl: 1200px;
  --font-family-sans-serif: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; }

*,
*::before,
*::after {
  box-sizing: border-box; }

html {
  font-family: sans-serif;
  line-height: 1.15;
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
  -ms-overflow-style: scrollbar;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0); }
article, aside, dialog, figcaption, figure, footer, header, hgroup, main, nav, section {
  display: block; }

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  text-align: left;
  background-color: #fff; }

[tabindex="-1"]:focus {
  outline: 0 !important; }

hr {
  box-sizing: content-box;
  height: 0;
  overflow: visible; }

h1, h2, h3, h4, h5, h6 {
  margin-top: 0;
  margin-bottom: 0.5rem; }

p {
  margin-top: 0;
  margin-bottom: 1rem; }

abbr[title],
abbr[data-original-title] {
  text-decoration: underline;
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  border-bottom: 0; }

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit; }

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem; }

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0; }

dt {
  font-weight: 700; }

dd {
  margin-bottom: .5rem;
  margin-left: 0; }

blockquote {
  margin: 0 0 1rem; }

dfn {
  font-style: italic; }

b,
strong {
  font-weight: bolder; }

small {
  font-size: 80%; }

sub,
sup {
  position: relative;
  font-size: 75%;
  line-height: 0;
  vertical-align: baseline; }

sub {
  bottom: -.25em; }

sup {
  top: -.5em; }

a {
  color: #007bff;
  text-decoration: none;
  background-color: transparent;
  -webkit-text-decoration-skip: objects; }
  a:hover {
    color: #0056b3;
    text-decoration: underline; }

a:not([href]):not([tabindex]) {
  color: inherit;
  text-decoration: none; }
  a:not([href]):not([tabindex]):hover, a:not([href]):not([tabindex]):focus {
    color: inherit;
    text-decoration: none; }
  a:not([href]):not([tabindex]):focus {
    outline: 0; }

pre,
code,
kbd,
samp {
  font-family: monospace, monospace;
  font-size: 1em; }

pre {
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  -ms-overflow-style: scrollbar; }

figure {
  margin: 0 0 1rem; }

img {
  vertical-align: middle;
  border-style: none; }

svg:not(:root) {
  overflow: hidden; }

table {
  border-collapse: collapse; }

caption {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  color: #6c757d;
  text-align: left;
  caption-side: bottom; }

th {
  text-align: inherit; }

label {
  display: inline-block;
  margin-bottom: 0.5rem; }

button {
  border-radius: 0; }

button:focus {
  outline: 1px dotted;
  outline: 5px auto -webkit-focus-ring-color; }

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit; }

button,
input {
  overflow: visible; }

button,
select {
  text-transform: none; }

button,
html [type="button"],
[type="reset"],
[type="submit"] {
  -webkit-appearance: button; }

button::-moz-focus-inner,
[type="button"]::-moz-focus-inner,
[type="reset"]::-moz-focus-inner,
[type="submit"]::-moz-focus-inner {
  padding: 0;
  border-style: none; }

input[type="radio"],
input[type="checkbox"] {
  box-sizing: border-box;
  padding: 0; }

input[type="date"],
input[type="time"],
input[type="datetime-local"],
input[type="month"] {
  -webkit-appearance: listbox; }

textarea {
  overflow: auto;
  resize: vertical; }

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0; }

legend {
  display: block;
  width: 100%;
  max-width: 100%;
  padding: 0;
  margin-bottom: .5rem;
  font-size: 1.5rem;
  line-height: inherit;
  color: inherit;
  white-space: normal; }

progress {
  vertical-align: baseline; }

[type="number"]::-webkit-inner-spin-button,
[type="number"]::-webkit-outer-spin-button {
  height: auto; }

[type="search"] {
  outline-offset: -2px;
  -webkit-appearance: none; }

[type="search"]::-webkit-search-cancel-button,
[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none; }

::-webkit-file-upload-button {
  font: inherit;
  -webkit-appearance: button; }

output {
  display: inline-block; }

summary {
  display: list-item;
  cursor: pointer; }

template {
  display: none; }

[hidden] {
  display: none !important; }

h1, h2, h3, h4, h5, h6,
.h1, .h2, .h3, .h4, .h5, .h6 {
  margin-bottom: 0.5rem;
  font-family: inherit;
  font-weight: 500;
  line-height: 1.2;
  color: inherit; }

h1, .h1 {
  font-size: 2.5rem; }

h2, .h2 {
  font-size: 2rem; }

h3, .h3 {
  font-size: 1.75rem; }

h4, .h4 {
  font-size: 1.5rem; }

h5, .h5 {
  font-size: 1.25rem; }

h6, .h6 {
  font-size: 1rem; }

.lead {
  font-size: 1.25rem;
  font-weight: 300; }

.display-1 {
  font-size: 6rem;
  font-weight: 300;
  line-height: 1.2; }

.display-2 {
  font-size: 5.5rem;
  font-weight: 300;
  line-height: 1.2; }

.display-3 {
  font-size: 4.5rem;
  font-weight: 300;
  line-height: 1.2; }

.display-4 {
  font-size: 3.5rem;
  font-weight: 300;
  line-height: 1.2; }

hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1); }

small,
.small {
  font-size: 80%;
  font-weight: 400; }

mark,
.mark {
  padding: 0.2em;
  background-color: #fcf8e3; }

.list-unstyled {
  padding-left: 0;
  list-style: none; }

.list-inline {
  padding-left: 0;
  list-style: none; }

.list-inline-item {
  display: inline-block; }
  .list-inline-item:not(:last-child) {
    margin-right: 0.5rem; }

.initialism {
  font-size: 90%;
  text-transform: uppercase; }

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.25rem; }

.blockquote-footer {
  display: block;
  font-size: 80%;
  color: #6c757d;
  position: relative; }
  .blockquote-footer::before {
    content: "\\2014 \\00A0"; }

.img-fluid {
  max-width: 100%;
  height: auto; }

.img-thumbnail {
  padding: 0.25rem;
  background-color: #fff;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  max-width: 100%;
  height: auto; }

.figure {
  display: inline-block; }

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1; }

.figure-caption {
  font-size: 90%;
  color: #6c757d; }

code,
kbd,
pre,
samp {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; }

code {
  font-size: 87.5%;
  color: #e83e8c;
  word-break: break-word; }
  a > code {
    color: inherit; }

kbd {
  padding: 0.2rem 0.4rem;
  font-size: 87.5%;
  color: #fff;
  background-color: #212529;
  border-radius: 0.2rem; }
  kbd kbd {
    padding: 0;
    font-size: 100%;
    font-weight: 700; }

pre {
  display: block;
  font-size: 87.5%;
  color: #212529; }
  pre code {
    font-size: inherit;
    color: inherit;
    word-break: normal; }

.pre-scrollable {
  max-height: 340px;
  overflow-y: scroll; }

.container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto; }
  @media (min-width: 576px) {
    .container {
      max-width: 540px; } }
  @media (min-width: 768px) {
    .container {
      max-width: 720px; } }
  @media (min-width: 992px) {
    .container {
      max-width: 960px; } }
  @media (min-width: 1200px) {
    .container {
      max-width: 1140px; } }

.container-fluid {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto; }

.row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px; }

.no-gutters {
  margin-right: 0;
  margin-left: 0; }
  .no-gutters > .col,
  .no-gutters > [class*="col-"] {
    padding-right: 0;
    padding-left: 0; }

.col-1, .col-2, .col-3, .col-4, .col-5, .col-6, .col-7, .col-8, .col-9, .col-10, .col-11, .col-12, .col,
.col-auto, .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm,
.col-sm-auto, .col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12, .col-md,
.col-md-auto, .col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg,
.col-lg-auto, .col-xl-1, .col-xl-2, .col-xl-3, .col-xl-4, .col-xl-5, .col-xl-6, .col-xl-7, .col-xl-8, .col-xl-9, .col-xl-10, .col-xl-11, .col-xl-12, .col-xl,
.col-xl-auto {
  position: relative;
  width: 100%;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px; }

.col {
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%; }

.col-auto {
  flex: 0 0 auto;
  width: auto;
  max-width: none; }

.col-1 {
  flex: 0 0 8.3333333333%;
  max-width: 8.3333333333%; }

.col-2 {
  flex: 0 0 16.6666666667%;
  max-width: 16.6666666667%; }

.col-3 {
  flex: 0 0 25%;
  max-width: 25%; }

.col-4 {
  flex: 0 0 33.3333333333%;
  max-width: 33.3333333333%; }

.col-5 {
  flex: 0 0 41.6666666667%;
  max-width: 41.6666666667%; }

.col-6 {
  flex: 0 0 50%;
  max-width: 50%; }

.col-7 {
  flex: 0 0 58.3333333333%;
  max-width: 58.3333333333%; }

.col-8 {
  flex: 0 0 66.6666666667%;
  max-width: 66.6666666667%; }

.col-9 {
  flex: 0 0 75%;
  max-width: 75%; }

.col-10 {
  flex: 0 0 83.3333333333%;
  max-width: 83.3333333333%; }

.col-11 {
  flex: 0 0 91.6666666667%;
  max-width: 91.6666666667%; }

.col-12 {
  flex: 0 0 100%;
  max-width: 100%; }

.order-first {
  order: -1; }

.order-last {
  order: 13; }

.order-0 {
  order: 0; }

.order-1 {
  order: 1; }

.order-2 {
  order: 2; }

.order-3 {
  order: 3; }

.order-4 {
  order: 4; }

.order-5 {
  order: 5; }

.order-6 {
  order: 6; }

.order-7 {
  order: 7; }

.order-8 {
  order: 8; }

.order-9 {
  order: 9; }

.order-10 {
  order: 10; }

.order-11 {
  order: 11; }

.order-12 {
  order: 12; }

.offset-1 {
  margin-left: 8.3333333333%; }

.offset-2 {
  margin-left: 16.6666666667%; }

.offset-3 {
  margin-left: 25%; }

.offset-4 {
  margin-left: 33.3333333333%; }

.offset-5 {
  margin-left: 41.6666666667%; }

.offset-6 {
  margin-left: 50%; }

.offset-7 {
  margin-left: 58.3333333333%; }

.offset-8 {
  margin-left: 66.6666666667%; }

.offset-9 {
  margin-left: 75%; }

.offset-10 {
  margin-left: 83.3333333333%; }

.offset-11 {
  margin-left: 91.6666666667%; }

@media (min-width: 576px) {
  .col-sm {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%; }

  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: none; }

  .col-sm-1 {
    flex: 0 0 8.3333333333%;
    max-width: 8.3333333333%; }

  .col-sm-2 {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%; }

  .col-sm-3 {
    flex: 0 0 25%;
    max-width: 25%; }

  .col-sm-4 {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%; }

  .col-sm-5 {
    flex: 0 0 41.6666666667%;
    max-width: 41.6666666667%; }

  .col-sm-6 {
    flex: 0 0 50%;
    max-width: 50%; }

  .col-sm-7 {
    flex: 0 0 58.3333333333%;
    max-width: 58.3333333333%; }

  .col-sm-8 {
    flex: 0 0 66.6666666667%;
    max-width: 66.6666666667%; }

  .col-sm-9 {
    flex: 0 0 75%;
    max-width: 75%; }

  .col-sm-10 {
    flex: 0 0 83.3333333333%;
    max-width: 83.3333333333%; }

  .col-sm-11 {
    flex: 0 0 91.6666666667%;
    max-width: 91.6666666667%; }

  .col-sm-12 {
    flex: 0 0 100%;
    max-width: 100%; }

  .order-sm-first {
    order: -1; }

  .order-sm-last {
    order: 13; }

  .order-sm-0 {
    order: 0; }

  .order-sm-1 {
    order: 1; }

  .order-sm-2 {
    order: 2; }

  .order-sm-3 {
    order: 3; }

  .order-sm-4 {
    order: 4; }

  .order-sm-5 {
    order: 5; }

  .order-sm-6 {
    order: 6; }

  .order-sm-7 {
    order: 7; }

  .order-sm-8 {
    order: 8; }

  .order-sm-9 {
    order: 9; }

  .order-sm-10 {
    order: 10; }

  .order-sm-11 {
    order: 11; }

  .order-sm-12 {
    order: 12; }

  .offset-sm-0 {
    margin-left: 0; }

  .offset-sm-1 {
    margin-left: 8.3333333333%; }

  .offset-sm-2 {
    margin-left: 16.6666666667%; }

  .offset-sm-3 {
    margin-left: 25%; }

  .offset-sm-4 {
    margin-left: 33.3333333333%; }

  .offset-sm-5 {
    margin-left: 41.6666666667%; }

  .offset-sm-6 {
    margin-left: 50%; }

  .offset-sm-7 {
    margin-left: 58.3333333333%; }

  .offset-sm-8 {
    margin-left: 66.6666666667%; }

  .offset-sm-9 {
    margin-left: 75%; }

  .offset-sm-10 {
    margin-left: 83.3333333333%; }

  .offset-sm-11 {
    margin-left: 91.6666666667%; } }
@media (min-width: 768px) {
  .col-md {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%; }

  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: none; }

  .col-md-1 {
    flex: 0 0 8.3333333333%;
    max-width: 8.3333333333%; }

  .col-md-2 {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%; }

  .col-md-3 {
    flex: 0 0 25%;
    max-width: 25%; }

  .col-md-4 {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%; }

  .col-md-5 {
    flex: 0 0 41.6666666667%;
    max-width: 41.6666666667%; }

  .col-md-6 {
    flex: 0 0 50%;
    max-width: 50%; }

  .col-md-7 {
    flex: 0 0 58.3333333333%;
    max-width: 58.3333333333%; }

  .col-md-8 {
    flex: 0 0 66.6666666667%;
    max-width: 66.6666666667%; }

  .col-md-9 {
    flex: 0 0 75%;
    max-width: 75%; }

  .col-md-10 {
    flex: 0 0 83.3333333333%;
    max-width: 83.3333333333%; }

  .col-md-11 {
    flex: 0 0 91.6666666667%;
    max-width: 91.6666666667%; }

  .col-md-12 {
    flex: 0 0 100%;
    max-width: 100%; }

  .order-md-first {
    order: -1; }

  .order-md-last {
    order: 13; }

  .order-md-0 {
    order: 0; }

  .order-md-1 {
    order: 1; }

  .order-md-2 {
    order: 2; }

  .order-md-3 {
    order: 3; }

  .order-md-4 {
    order: 4; }

  .order-md-5 {
    order: 5; }

  .order-md-6 {
    order: 6; }

  .order-md-7 {
    order: 7; }

  .order-md-8 {
    order: 8; }

  .order-md-9 {
    order: 9; }

  .order-md-10 {
    order: 10; }

  .order-md-11 {
    order: 11; }

  .order-md-12 {
    order: 12; }

  .offset-md-0 {
    margin-left: 0; }

  .offset-md-1 {
    margin-left: 8.3333333333%; }

  .offset-md-2 {
    margin-left: 16.6666666667%; }

  .offset-md-3 {
    margin-left: 25%; }

  .offset-md-4 {
    margin-left: 33.3333333333%; }

  .offset-md-5 {
    margin-left: 41.6666666667%; }

  .offset-md-6 {
    margin-left: 50%; }

  .offset-md-7 {
    margin-left: 58.3333333333%; }

  .offset-md-8 {
    margin-left: 66.6666666667%; }

  .offset-md-9 {
    margin-left: 75%; }

  .offset-md-10 {
    margin-left: 83.3333333333%; }

  .offset-md-11 {
    margin-left: 91.6666666667%; } }
@media (min-width: 992px) {
  .col-lg {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%; }

  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: none; }

  .col-lg-1 {
    flex: 0 0 8.3333333333%;
    max-width: 8.3333333333%; }

  .col-lg-2 {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%; }

  .col-lg-3 {
    flex: 0 0 25%;
    max-width: 25%; }

  .col-lg-4 {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%; }

  .col-lg-5 {
    flex: 0 0 41.6666666667%;
    max-width: 41.6666666667%; }

  .col-lg-6 {
    flex: 0 0 50%;
    max-width: 50%; }

  .col-lg-7 {
    flex: 0 0 58.3333333333%;
    max-width: 58.3333333333%; }

  .col-lg-8 {
    flex: 0 0 66.6666666667%;
    max-width: 66.6666666667%; }

  .col-lg-9 {
    flex: 0 0 75%;
    max-width: 75%; }

  .col-lg-10 {
    flex: 0 0 83.3333333333%;
    max-width: 83.3333333333%; }

  .col-lg-11 {
    flex: 0 0 91.6666666667%;
    max-width: 91.6666666667%; }

  .col-lg-12 {
    flex: 0 0 100%;
    max-width: 100%; }

  .order-lg-first {
    order: -1; }

  .order-lg-last {
    order: 13; }

  .order-lg-0 {
    order: 0; }

  .order-lg-1 {
    order: 1; }

  .order-lg-2 {
    order: 2; }

  .order-lg-3 {
    order: 3; }

  .order-lg-4 {
    order: 4; }

  .order-lg-5 {
    order: 5; }

  .order-lg-6 {
    order: 6; }

  .order-lg-7 {
    order: 7; }

  .order-lg-8 {
    order: 8; }

  .order-lg-9 {
    order: 9; }

  .order-lg-10 {
    order: 10; }

  .order-lg-11 {
    order: 11; }

  .order-lg-12 {
    order: 12; }

  .offset-lg-0 {
    margin-left: 0; }

  .offset-lg-1 {
    margin-left: 8.3333333333%; }

  .offset-lg-2 {
    margin-left: 16.6666666667%; }

  .offset-lg-3 {
    margin-left: 25%; }

  .offset-lg-4 {
    margin-left: 33.3333333333%; }

  .offset-lg-5 {
    margin-left: 41.6666666667%; }

  .offset-lg-6 {
    margin-left: 50%; }

  .offset-lg-7 {
    margin-left: 58.3333333333%; }

  .offset-lg-8 {
    margin-left: 66.6666666667%; }

  .offset-lg-9 {
    margin-left: 75%; }

  .offset-lg-10 {
    margin-left: 83.3333333333%; }

  .offset-lg-11 {
    margin-left: 91.6666666667%; } }
@media (min-width: 1200px) {
  .col-xl {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%; }

  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: none; }

  .col-xl-1 {
    flex: 0 0 8.3333333333%;
    max-width: 8.3333333333%; }

  .col-xl-2 {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%; }

  .col-xl-3 {
    flex: 0 0 25%;
    max-width: 25%; }

  .col-xl-4 {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%; }

  .col-xl-5 {
    flex: 0 0 41.6666666667%;
    max-width: 41.6666666667%; }

  .col-xl-6 {
    flex: 0 0 50%;
    max-width: 50%; }

  .col-xl-7 {
    flex: 0 0 58.3333333333%;
    max-width: 58.3333333333%; }

  .col-xl-8 {
    flex: 0 0 66.6666666667%;
    max-width: 66.6666666667%; }

  .col-xl-9 {
    flex: 0 0 75%;
    max-width: 75%; }

  .col-xl-10 {
    flex: 0 0 83.3333333333%;
    max-width: 83.3333333333%; }

  .col-xl-11 {
    flex: 0 0 91.6666666667%;
    max-width: 91.6666666667%; }

  .col-xl-12 {
    flex: 0 0 100%;
    max-width: 100%; }

  .order-xl-first {
    order: -1; }

  .order-xl-last {
    order: 13; }

  .order-xl-0 {
    order: 0; }

  .order-xl-1 {
    order: 1; }

  .order-xl-2 {
    order: 2; }

  .order-xl-3 {
    order: 3; }

  .order-xl-4 {
    order: 4; }

  .order-xl-5 {
    order: 5; }

  .order-xl-6 {
    order: 6; }

  .order-xl-7 {
    order: 7; }

  .order-xl-8 {
    order: 8; }

  .order-xl-9 {
    order: 9; }

  .order-xl-10 {
    order: 10; }

  .order-xl-11 {
    order: 11; }

  .order-xl-12 {
    order: 12; }

  .offset-xl-0 {
    margin-left: 0; }

  .offset-xl-1 {
    margin-left: 8.3333333333%; }

  .offset-xl-2 {
    margin-left: 16.6666666667%; }

  .offset-xl-3 {
    margin-left: 25%; }

  .offset-xl-4 {
    margin-left: 33.3333333333%; }

  .offset-xl-5 {
    margin-left: 41.6666666667%; }

  .offset-xl-6 {
    margin-left: 50%; }

  .offset-xl-7 {
    margin-left: 58.3333333333%; }

  .offset-xl-8 {
    margin-left: 66.6666666667%; }

  .offset-xl-9 {
    margin-left: 75%; }

  .offset-xl-10 {
    margin-left: 83.3333333333%; }

  .offset-xl-11 {
    margin-left: 91.6666666667%; } }
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 1rem;
  background-color: transparent; }
  .table th,
  .table td {
    padding: 0.75rem;
    vertical-align: top;
    border-top: 1px solid #dee2e6; }
  .table thead th {
    vertical-align: bottom;
    border-bottom: 2px solid #dee2e6; }
  .table tbody + tbody {
    border-top: 2px solid #dee2e6; }
  .table .table {
    background-color: #fff; }

.table-sm th,
.table-sm td {
  padding: 0.3rem; }

.table-bordered {
  border: 1px solid #dee2e6; }
  .table-bordered th,
  .table-bordered td {
    border: 1px solid #dee2e6; }
  .table-bordered thead th,
  .table-bordered thead td {
    border-bottom-width: 2px; }

.table-borderless th,
.table-borderless td,
.table-borderless thead th,
.table-borderless tbody + tbody {
  border: 0; }

.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05); }

.table-hover tbody tr:hover {
  background-color: rgba(0, 0, 0, 0.075); }

.table-primary,
.table-primary > th,
.table-primary > td {
  background-color: #b8daff; }

.table-hover .table-primary:hover {
  background-color: #9fcdff; }
  .table-hover .table-primary:hover > td,
  .table-hover .table-primary:hover > th {
    background-color: #9fcdff; }

.table-secondary,
.table-secondary > th,
.table-secondary > td {
  background-color: #d6d8db; }

.table-hover .table-secondary:hover {
  background-color: #c8cbcf; }
  .table-hover .table-secondary:hover > td,
  .table-hover .table-secondary:hover > th {
    background-color: #c8cbcf; }

.table-success,
.table-success > th,
.table-success > td {
  background-color: #c3e6cb; }

.table-hover .table-success:hover {
  background-color: #b1dfbb; }
  .table-hover .table-success:hover > td,
  .table-hover .table-success:hover > th {
    background-color: #b1dfbb; }

.table-info,
.table-info > th,
.table-info > td {
  background-color: #bee5eb; }

.table-hover .table-info:hover {
  background-color: #abdde5; }
  .table-hover .table-info:hover > td,
  .table-hover .table-info:hover > th {
    background-color: #abdde5; }

.table-warning,
.table-warning > th,
.table-warning > td {
  background-color: #ffeeba; }

.table-hover .table-warning:hover {
  background-color: #ffe8a1; }
  .table-hover .table-warning:hover > td,
  .table-hover .table-warning:hover > th {
    background-color: #ffe8a1; }

.table-danger,
.table-danger > th,
.table-danger > td {
  background-color: #f5c6cb; }

.table-hover .table-danger:hover {
  background-color: #f1b0b7; }
  .table-hover .table-danger:hover > td,
  .table-hover .table-danger:hover > th {
    background-color: #f1b0b7; }

.table-light,
.table-light > th,
.table-light > td {
  background-color: #fdfdfe; }

.table-hover .table-light:hover {
  background-color: #ececf6; }
  .table-hover .table-light:hover > td,
  .table-hover .table-light:hover > th {
    background-color: #ececf6; }

.table-dark,
.table-dark > th,
.table-dark > td {
  background-color: #c6c8ca; }

.table-hover .table-dark:hover {
  background-color: #b9bbbe; }
  .table-hover .table-dark:hover > td,
  .table-hover .table-dark:hover > th {
    background-color: #b9bbbe; }

.table-active,
.table-active > th,
.table-active > td {
  background-color: rgba(0, 0, 0, 0.075); }

.table-hover .table-active:hover {
  background-color: rgba(0, 0, 0, 0.075); }
  .table-hover .table-active:hover > td,
  .table-hover .table-active:hover > th {
    background-color: rgba(0, 0, 0, 0.075); }

.table .thead-dark th {
  color: #fff;
  background-color: #212529;
  border-color: #32383e; }
.table .thead-light th {
  color: #495057;
  background-color: #e9ecef;
  border-color: #dee2e6; }

.table-dark {
  color: #fff;
  background-color: #212529; }
  .table-dark th,
  .table-dark td,
  .table-dark thead th {
    border-color: #32383e; }
  .table-dark.table-bordered {
    border: 0; }
  .table-dark.table-striped tbody tr:nth-of-type(odd) {
    background-color: rgba(255, 255, 255, 0.05); }
  .table-dark.table-hover tbody tr:hover {
    background-color: rgba(255, 255, 255, 0.075); }

@media (max-width: 575.98px) {
  .table-responsive-sm {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: -ms-autohiding-scrollbar; }
    .table-responsive-sm > .table-bordered {
      border: 0; } }
@media (max-width: 767.98px) {
  .table-responsive-md {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: -ms-autohiding-scrollbar; }
    .table-responsive-md > .table-bordered {
      border: 0; } }
@media (max-width: 991.98px) {
  .table-responsive-lg {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: -ms-autohiding-scrollbar; }
    .table-responsive-lg > .table-bordered {
      border: 0; } }
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: -ms-autohiding-scrollbar; }
    .table-responsive-xl > .table-bordered {
      border: 0; } }
.table-responsive {
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: -ms-autohiding-scrollbar; }
  .table-responsive > .table-bordered {
    border: 0; }

.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
  .form-control1 {
    display: block;
    width: 100%;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
    .form-control3 {
      display: block;
      width: 210%;
      padding: 0.375rem 0.75rem;
      font-size: 1rem;
      line-height: 1.5;
      color: #495057;
      background-color: #fff;
      background-clip: padding-box;
      border: 1px solid #ced4da;
      border-radius: 0.25rem;
      transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
  
    .form-control2 {
      display: block;
      width: 96%;
      padding: 0.375rem 0.75rem;
      font-size: 1rem;
      line-height: 1.5;
      color: #495057;
      background-color: #fff;
      background-clip: padding-box;
      border: 1px solid #ced4da;
      border-radius: 0.25rem;
      transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
  @media screen and (prefers-reduced-motion: reduce) {
    .form-control {
      transition: none; } }
  .form-control::-ms-expand {
    background-color: transparent;
    border: 0; }
  .form-control:focus {
    color: #495057;
    background-color: #fff;
    border-color: #80bdff;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25); }
  .form-control::placeholder {
    color: #6c757d;
    opacity: 1; }
  .form-control:disabled, .form-control[readonly] {
    background-color: #e9ecef;
    opacity: 1; }

select.form-control:not([size]):not([multiple]) {
  height: calc(2.25rem + 2px); }
select.form-control:focus::-ms-value {
  color: #495057;
  background-color: #fff; }

.form-control-file,
.form-control-range {
  display: block;
  width: 100%; }

.col-form-label {
  padding-top: calc(0.375rem + 1px);
  padding-bottom: calc(0.375rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5; }

.col-form-label-lg {
  padding-top: calc(0.5rem + 1px);
  padding-bottom: calc(0.5rem + 1px);
  font-size: 1.25rem;
  line-height: 1.5; }

.col-form-label-sm {
  padding-top: calc(0.25rem + 1px);
  padding-bottom: calc(0.25rem + 1px);
  font-size: 0.875rem;
  line-height: 1.5; }

.form-control-plaintext {
  display: block;
  width: 100%;
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
  margin-bottom: 0;
  line-height: 1.5;
  color: #212529;
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0; }
  .form-control-plaintext.form-control-sm, .input-group-sm > .form-control-plaintext.form-control,
  .input-group-sm > .input-group-prepend > .form-control-plaintext.input-group-text,
  .input-group-sm > .input-group-append > .form-control-plaintext.input-group-text,
  .input-group-sm > .input-group-prepend > .form-control-plaintext.btn,
  .input-group-sm > .input-group-append > .form-control-plaintext.btn, .form-control-plaintext.form-control-lg, .input-group-lg > .form-control-plaintext.form-control,
  .input-group-lg > .input-group-prepend > .form-control-plaintext.input-group-text,
  .input-group-lg > .input-group-append > .form-control-plaintext.input-group-text,
  .input-group-lg > .input-group-prepend > .form-control-plaintext.btn,
  .input-group-lg > .input-group-append > .form-control-plaintext.btn {
    padding-right: 0;
    padding-left: 0; }

.form-control-sm, .input-group-sm > .form-control,
.input-group-sm > .input-group-prepend > .input-group-text,
.input-group-sm > .input-group-append > .input-group-text,
.input-group-sm > .input-group-prepend > .btn,
.input-group-sm > .input-group-append > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem; }

select.form-control-sm:not([size]):not([multiple]), .input-group-sm > select.form-control:not([size]):not([multiple]),
.input-group-sm > .input-group-prepend > select.input-group-text:not([size]):not([multiple]),
.input-group-sm > .input-group-append > select.input-group-text:not([size]):not([multiple]),
.input-group-sm > .input-group-prepend > select.btn:not([size]):not([multiple]),
.input-group-sm > .input-group-append > select.btn:not([size]):not([multiple]) {
  height: calc(1.8125rem + 2px); }

.form-control-lg, .input-group-lg > .form-control,
.input-group-lg > .input-group-prepend > .input-group-text,
.input-group-lg > .input-group-append > .input-group-text,
.input-group-lg > .input-group-prepend > .btn,
.input-group-lg > .input-group-append > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  line-height: 1.5;
  border-radius: 0.3rem; }

select.form-control-lg:not([size]):not([multiple]), .input-group-lg > select.form-control:not([size]):not([multiple]),
.input-group-lg > .input-group-prepend > select.input-group-text:not([size]):not([multiple]),
.input-group-lg > .input-group-append > select.input-group-text:not([size]):not([multiple]),
.input-group-lg > .input-group-prepend > select.btn:not([size]):not([multiple]),
.input-group-lg > .input-group-append > select.btn:not([size]):not([multiple]) {
  height: calc(2.875rem + 2px); }

.form-group {
  margin-bottom: 1rem; }
  .form-group2 {
    margin-bottom: 1rem; }

.form-group1 {
    margin-top: -95px;
  margin-right:-40px }
.form-group3{
  margin-bottom: 50px; 
  margin-left:835px;
  margin-top:-98px;
}

.form-text {
  display: block;
  margin-top: 0.25rem; }

.form-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -5px;
  margin-left: -5px; }
  .form-row > .col,
  .form-row > [class*="col-"] {
    padding-right: 5px;
    padding-left: 5px; }

.form-check {
  position: relative;
  display: block;
  padding-left: 1.25rem; }

.form-check-input {
  position: absolute;
  margin-top: 0.3rem;
  margin-left: -1.25rem; }
  .form-check-input:disabled ~ .form-check-label {
    color: #6c757d; }

.form-check-label {
  margin-bottom: 0; }

.form-check-inline {
  display: inline-flex;
  align-items: center;
  padding-left: 0;
  margin-right: 0.75rem; }
  .form-check-inline .form-check-input {
    position: static;
    margin-top: 0;
    margin-right: 0.3125rem;
    margin-left: 0; }

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #28a745; }

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: .5rem;
  margin-top: .1rem;
  font-size: .875rem;
  line-height: 1;
  color: #fff;
  background-color: rgba(40, 167, 69, 0.8);
  border-radius: .2rem; }

.was-validated .form-control:valid, .form-control.is-valid,
.was-validated .custom-select:valid,
.custom-select.is-valid {
  border-color: #28a745; }
  .was-validated .form-control:valid:focus, .form-control.is-valid:focus,
  .was-validated .custom-select:valid:focus,
  .custom-select.is-valid:focus {
    border-color: #28a745;
    box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25); }
  .was-validated .form-control:valid ~ .valid-feedback,
  .was-validated .form-control:valid ~ .valid-tooltip, .form-control.is-valid ~ .valid-feedback,
  .form-control.is-valid ~ .valid-tooltip,
  .was-validated .custom-select:valid ~ .valid-feedback,
  .was-validated .custom-select:valid ~ .valid-tooltip,
  .custom-select.is-valid ~ .valid-feedback,
  .custom-select.is-valid ~ .valid-tooltip {
    display: block; }

.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: #28a745; }
.was-validated .form-check-input:valid ~ .valid-feedback,
.was-validated .form-check-input:valid ~ .valid-tooltip, .form-check-input.is-valid ~ .valid-feedback,
.form-check-input.is-valid ~ .valid-tooltip {
  display: block; }

.was-validated .custom-control-input:valid ~ .custom-control-label, .custom-control-input.is-valid ~ .custom-control-label {
  color: #28a745; }
  .was-validated .custom-control-input:valid ~ .custom-control-label::before, .custom-control-input.is-valid ~ .custom-control-label::before {
    background-color: #71dd8a; }
.was-validated .custom-control-input:valid ~ .valid-feedback,
.was-validated .custom-control-input:valid ~ .valid-tooltip, .custom-control-input.is-valid ~ .valid-feedback,
.custom-control-input.is-valid ~ .valid-tooltip {
  display: block; }
.was-validated .custom-control-input:valid:checked ~ .custom-control-label::before, .custom-control-input.is-valid:checked ~ .custom-control-label::before {
  background-color: #34ce57; }
.was-validated .custom-control-input:valid:focus ~ .custom-control-label::before, .custom-control-input.is-valid:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(40, 167, 69, 0.25); }

.was-validated .custom-file-input:valid ~ .custom-file-label, .custom-file-input.is-valid ~ .custom-file-label {
  border-color: #28a745; }
  .was-validated .custom-file-input:valid ~ .custom-file-label::before, .custom-file-input.is-valid ~ .custom-file-label::before {
    border-color: inherit; }
.was-validated .custom-file-input:valid ~ .valid-feedback,
.was-validated .custom-file-input:valid ~ .valid-tooltip, .custom-file-input.is-valid ~ .valid-feedback,
.custom-file-input.is-valid ~ .valid-tooltip {
  display: block; }
.was-validated .custom-file-input:valid:focus ~ .custom-file-label, .custom-file-input.is-valid:focus ~ .custom-file-label {
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25); }

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #dc3545; }

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: .5rem;
  margin-top: .1rem;
  font-size: .875rem;
  line-height: 1;
  color: #fff;
  background-color: rgba(220, 53, 69, 0.8);
  border-radius: .2rem; }

.was-validated .form-control:invalid, .form-control.is-invalid,
.was-validated .custom-select:invalid,
.custom-select.is-invalid {
  border-color: #dc3545; }
  .was-validated .form-control:invalid:focus, .form-control.is-invalid:focus,
  .was-validated .custom-select:invalid:focus,
  .custom-select.is-invalid:focus {
    border-color: #dc3545;
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25); }
  .was-validated .form-control:invalid ~ .invalid-feedback,
  .was-validated .form-control:invalid ~ .invalid-tooltip, .form-control.is-invalid ~ .invalid-feedback,
  .form-control.is-invalid ~ .invalid-tooltip,
  .was-validated .custom-select:invalid ~ .invalid-feedback,
  .was-validated .custom-select:invalid ~ .invalid-tooltip,
  .custom-select.is-invalid ~ .invalid-feedback,
  .custom-select.is-invalid ~ .invalid-tooltip {
    display: block; }

.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: #dc3545; }
.was-validated .form-check-input:invalid ~ .invalid-feedback,
.was-validated .form-check-input:invalid ~ .invalid-tooltip, .form-check-input.is-invalid ~ .invalid-feedback,
.form-check-input.is-invalid ~ .invalid-tooltip {
  display: block; }

.was-validated .custom-control-input:invalid ~ .custom-control-label, .custom-control-input.is-invalid ~ .custom-control-label {
  color: #dc3545; }
  .was-validated .custom-control-input:invalid ~ .custom-control-label::before, .custom-control-input.is-invalid ~ .custom-control-label::before {
    background-color: #efa2a9; }
.was-validated .custom-control-input:invalid ~ .invalid-feedback,
.was-validated .custom-control-input:invalid ~ .invalid-tooltip, .custom-control-input.is-invalid ~ .invalid-feedback,
.custom-control-input.is-invalid ~ .invalid-tooltip {
  display: block; }
.was-validated .custom-control-input:invalid:checked ~ .custom-control-label::before, .custom-control-input.is-invalid:checked ~ .custom-control-label::before {
  background-color: #e4606d; }
.was-validated .custom-control-input:invalid:focus ~ .custom-control-label::before, .custom-control-input.is-invalid:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(220, 53, 69, 0.25); }

.was-validated .custom-file-input:invalid ~ .custom-file-label, .custom-file-input.is-invalid ~ .custom-file-label {
  border-color: #dc3545; }
  .was-validated .custom-file-input:invalid ~ .custom-file-label::before, .custom-file-input.is-invalid ~ .custom-file-label::before {
    border-color: inherit; }
.was-validated .custom-file-input:invalid ~ .invalid-feedback,
.was-validated .custom-file-input:invalid ~ .invalid-tooltip, .custom-file-input.is-invalid ~ .invalid-feedback,
.custom-file-input.is-invalid ~ .invalid-tooltip {
  display: block; }
.was-validated .custom-file-input:invalid:focus ~ .custom-file-label, .custom-file-input.is-invalid:focus ~ .custom-file-label {
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25); }

.form-inline {
  display: flex;
  flex-flow: row wrap;
  align-items: center; }
  .form-inline .form-check {
    width: 100%; }
  @media (min-width: 576px) {
    .form-inline label {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 0; }
    .form-inline .form-group {
      display: flex;
      flex: 0 0 auto;
      flex-flow: row wrap;
      align-items: center;
      margin-bottom: 0; }
    .form-inline .form-control {
      display: inline-block;
      width: auto;
      vertical-align: middle; }
    .form-inline .form-control-plaintext {
      display: inline-block; }
    .form-inline .input-group,
    .form-inline .custom-select {
      width: auto; }
    .form-inline .form-check {
      display: flex;
      align-items: center;
      justify-content: center;
      width: auto;
      padding-left: 0; }
    .form-inline .form-check-input {
      position: relative;
      margin-top: 0;
      margin-right: 0.25rem;
      margin-left: 0; }
    .form-inline .custom-control {
      align-items: center;
      justify-content: center; }
    .form-inline .custom-control-label {
      margin-bottom: 0; } }

.btn {
  display: inline-block;
  font-weight: 400;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -webkit-user-select: none;
          user-select: none;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  /* font-size: 1rem; */
  line-height: 1.5;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
  @media screen and (prefers-reduced-motion: reduce) {
    .btn {
      transition: none; } }
  .btn:hover, .btn:focus {
    text-decoration: none; }
  .btn:focus, .btn.focus {
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25); }
  .btn.disabled, .btn:disabled {
    opacity: 0.65; }
  .btn:not(:disabled):not(.disabled) {
    cursor: pointer; }
  .btn:not(:disabled):not(.disabled):active, .btn:not(:disabled):not(.disabled).active {
    background-image: none; }

a.btn.disabled,
fieldset:disabled a.btn {
  pointer-events: none; }
  .btn1 {
    display: inline-block;
    font-weight: 500;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    -webkit-user-select: none;
            user-select: none;
    border: 1px solid transparent;
    padding: 0.375rem 0.75rem;
    font-size: 0.8rem;
    line-height: 1.4;
    border-radius: 0px;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
    @media screen and (prefers-reduced-motion: reduce) {
      .btn1 {
        transition: none; } }
    .btn1:hover, .btn1:focus {
      text-decoration: none; }
    .btn1:focus, .btn1.focus {
      outline: 0;
      box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25); }
    .btn1.disabled, .btn1:disabled {
      opacity: 0.65; }
    .btn1:not(:disabled):not(.disabled) {
      cursor: pointer; }
    .btn1:not(:disabled):not(.disabled):active, .btn1:not(:disabled):not(.disabled).active {
      background-image: none; }
  
  a.btn1.disabled,
  fieldset:disabled a.btn1 {
    pointer-events: none; }
  
.btn-primary {
  color: #fff;
  background-color: #007bff;
  border-color: #007bff; }
  .btn-primary:hover {
    color: #fff;
    background-color: #0069d9;
    border-color: #0062cc; }
  .btn-primary:focus, .btn-primary.focus {
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5); }
  .btn-primary.disabled, .btn-primary:disabled {
    color: #fff;
    background-color: #007bff;
    border-color: #007bff; }
  .btn-primary:not(:disabled):not(.disabled):active, .btn-primary:not(:disabled):not(.disabled).active, .show > .btn-primary.dropdown-toggle {
    color: #fff;
    background-color: #0062cc;
    border-color: #005cbf; }
    .btn-primary:not(:disabled):not(.disabled):active:focus, .btn-primary:not(:disabled):not(.disabled).active:focus, .show > .btn-primary.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5); }

.btn-secondary {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d; }
  .btn-secondary:hover {
    color: #fff;
    background-color: #5a6268;
    border-color: #545b62; }
  .btn-secondary:focus, .btn-secondary.focus {
    box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5); }
  .btn-secondary.disabled, .btn-secondary:disabled {
    color: #fff;
    background-color: #6c757d;
    border-color: #6c757d; }
  .btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active, .show > .btn-secondary.dropdown-toggle {
    color: #fff;
    background-color: #545b62;
    border-color: #4e555b; }
    .btn-secondary:not(:disabled):not(.disabled):active:focus, .btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-secondary.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5); }

.btn-success {
  color: #fff;
  background-color: #28a745;
  border-color: #28a745; }
  .btn-success:hover {
    color: #fff;
    background-color: #218838;
    border-color: #1e7e34; }
  .btn-success:focus, .btn-success.focus {
    box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5); }
  .btn-success.disabled, .btn-success:disabled {
    color: #fff;
    background-color: #28a745;
    border-color: #28a745; }
  .btn-success:not(:disabled):not(.disabled):active, .btn-success:not(:disabled):not(.disabled).active, .show > .btn-success.dropdown-toggle {
    color: #fff;
    background-color: #1e7e34;
    border-color: #1c7430; }
    .btn-success:not(:disabled):not(.disabled):active:focus, .btn-success:not(:disabled):not(.disabled).active:focus, .show > .btn-success.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5); }

.btn-info {
  color: #fff;
  background-color: #17a2b8;
  border-color: #17a2b8; }
  .btn-info:hover {
    color: #fff;
    background-color: #138496;
    border-color: #117a8b; }
  .btn-info:focus, .btn-info.focus {
    box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5); }
  .btn-info.disabled, .btn-info:disabled {
    color: #fff;
    background-color: #17a2b8;
    border-color: #17a2b8; }
  .btn-info:not(:disabled):not(.disabled):active, .btn-info:not(:disabled):not(.disabled).active, .show > .btn-info.dropdown-toggle {
    color: #fff;
    background-color: #117a8b;
    border-color: #10707f; }
    .btn-info:not(:disabled):not(.disabled):active:focus, .btn-info:not(:disabled):not(.disabled).active:focus, .show > .btn-info.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5); }

.btn-warning {
  color: #212529;
  background-color: #ffc107;
  border-color: #ffc107; }
  .btn-warning:hover {
    color: #212529;
    background-color: #e0a800;
    border-color: #d39e00; }
  .btn-warning:focus, .btn-warning.focus {
    box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5); }
  .btn-warning.disabled, .btn-warning:disabled {
    color: #212529;
    background-color: #ffc107;
    border-color: #ffc107; }
  .btn-warning:not(:disabled):not(.disabled):active, .btn-warning:not(:disabled):not(.disabled).active, .show > .btn-warning.dropdown-toggle {
    color: #212529;
    background-color: #d39e00;
    border-color: #c69500; }
    .btn-warning:not(:disabled):not(.disabled):active:focus, .btn-warning:not(:disabled):not(.disabled).active:focus, .show > .btn-warning.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5); }

.btn-danger {
  color: #fff;
  background-color: #dc3545;
  border-color: #dc3545; }
  .btn-danger:hover {
    color: #fff;
    background-color: #c82333;
    border-color: #bd2130; }
  .btn-danger:focus, .btn-danger.focus {
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.5); }
  .btn-danger.disabled, .btn-danger:disabled {
    color: #fff;
    background-color: #dc3545;
    border-color: #dc3545; }
  .btn-danger:not(:disabled):not(.disabled):active, .btn-danger:not(:disabled):not(.disabled).active, .show > .btn-danger.dropdown-toggle {
    color: #fff;
    background-color: #bd2130;
    border-color: #b21f2d; }
    .btn-danger:not(:disabled):not(.disabled):active:focus, .btn-danger:not(:disabled):not(.disabled).active:focus, .show > .btn-danger.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.5); }

.btn-light {
  color: #212529;
  background-color: #f8f9fa;
  border-color: #f8f9fa; }
  .btn-light:hover {
    color: #212529;
    background-color: #e2e6ea;
    border-color: #dae0e5; }
  .btn-light:focus, .btn-light.focus {
    box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5); }
  .btn-light.disabled, .btn-light:disabled {
    color: #212529;
    background-color: #f8f9fa;
    border-color: #f8f9fa; }
  .btn-light:not(:disabled):not(.disabled):active, .btn-light:not(:disabled):not(.disabled).active, .show > .btn-light.dropdown-toggle {
    color: #212529;
    background-color: #dae0e5;
    border-color: #d3d9df; }
    .btn-light:not(:disabled):not(.disabled):active:focus, .btn-light:not(:disabled):not(.disabled).active:focus, .show > .btn-light.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5); }

.btn-dark {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40; }
  .btn-dark:hover {
    color: #fff;
    background-color: #23272b;
    border-color: #1d2124; }
  .btn-dark:focus, .btn-dark.focus {
    box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5); }
  .btn-dark.disabled, .btn-dark:disabled {
    color: #fff;
    background-color: #343a40;
    border-color: #343a40; }
  .btn-dark:not(:disabled):not(.disabled):active, .btn-dark:not(:disabled):not(.disabled).active, .show > .btn-dark.dropdown-toggle {
    color: #fff;
    background-color: #1d2124;
    border-color: #171a1d; }
    .btn-dark:not(:disabled):not(.disabled):active:focus, .btn-dark:not(:disabled):not(.disabled).active:focus, .show > .btn-dark.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5); }

.btn-outline-primary {
  color: #007bff;
  background-color: transparent;
  background-image: none;
  border-color: #007bff; }
  .btn-outline-primary:hover {
    color: #fff;
    background-color: #007bff;
    border-color: #007bff; }
  .btn-outline-primary:focus, .btn-outline-primary.focus {
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5); }
  .btn-outline-primary.disabled, .btn-outline-primary:disabled {
    color: #007bff;
    background-color: transparent; }
  .btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .btn-outline-primary.dropdown-toggle {
    color: #fff;
    background-color: #007bff;
    border-color: #007bff; }
    .btn-outline-primary:not(:disabled):not(.disabled):active:focus, .btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-primary.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5); }

.btn-outline-secondary {
  color: #6c757d;
  background-color: transparent;
  background-image: none;
  border-color: #6c757d; }
  .btn-outline-secondary:hover {
    color: #fff;
    background-color: #6c757d;
    border-color: #6c757d; }
  .btn-outline-secondary:focus, .btn-outline-secondary.focus {
    box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5); }
  .btn-outline-secondary.disabled, .btn-outline-secondary:disabled {
    color: #6c757d;
    background-color: transparent; }
  .btn-outline-secondary:not(:disabled):not(.disabled):active, .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .btn-outline-secondary.dropdown-toggle {
    color: #fff;
    background-color: #6c757d;
    border-color: #6c757d; }
    .btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-secondary.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5); }

.btn-outline-success {
  color: #28a745;
  background-color: transparent;
  background-image: none;
  border-color: #28a745; }
  .btn-outline-success:hover {
    color: #fff;
    background-color: #28a745;
    border-color: #28a745; }
  .btn-outline-success:focus, .btn-outline-success.focus {
    box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5); }
  .btn-outline-success.disabled, .btn-outline-success:disabled {
    color: #28a745;
    background-color: transparent; }
  .btn-outline-success:not(:disabled):not(.disabled):active, .btn-outline-success:not(:disabled):not(.disabled).active, .show > .btn-outline-success.dropdown-toggle {
    color: #fff;
    background-color: #28a745;
    border-color: #28a745; }
    .btn-outline-success:not(:disabled):not(.disabled):active:focus, .btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-success.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5); }

.btn-outline-info {
  color: #17a2b8;
  background-color: transparent;
  background-image: none;
  border-color: #17a2b8; }
  .btn-outline-info:hover {
    color: #fff;
    background-color: #17a2b8;
    border-color: #17a2b8; }
  .btn-outline-info:focus, .btn-outline-info.focus {
    box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5); }
  .btn-outline-info.disabled, .btn-outline-info:disabled {
    color: #17a2b8;
    background-color: transparent; }
  .btn-outline-info:not(:disabled):not(.disabled):active, .btn-outline-info:not(:disabled):not(.disabled).active, .show > .btn-outline-info.dropdown-toggle {
    color: #fff;
    background-color: #17a2b8;
    border-color: #17a2b8; }
    .btn-outline-info:not(:disabled):not(.disabled):active:focus, .btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-info.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5); }

.btn-outline-warning {
  color: #ffc107;
  background-color: transparent;
  background-image: none;
  border-color: #ffc107; }
  .btn-outline-warning:hover {
    color: #212529;
    background-color: #ffc107;
    border-color: #ffc107; }
  .btn-outline-warning:focus, .btn-outline-warning.focus {
    box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5); }
  .btn-outline-warning.disabled, .btn-outline-warning:disabled {
    color: #ffc107;
    background-color: transparent; }
  .btn-outline-warning:not(:disabled):not(.disabled):active, .btn-outline-warning:not(:disabled):not(.disabled).active, .show > .btn-outline-warning.dropdown-toggle {
    color: #212529;
    background-color: #ffc107;
    border-color: #ffc107; }
    .btn-outline-warning:not(:disabled):not(.disabled):active:focus, .btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-warning.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5); }

.btn-outline-danger {
  color: #dc3545;
  background-color: transparent;
  background-image: none;
  border-color: #dc3545; }
  .btn-outline-danger:hover {
    color: #fff;
    background-color: #dc3545;
    border-color: #dc3545; }
  .btn-outline-danger:focus, .btn-outline-danger.focus {
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.5); }
  .btn-outline-danger.disabled, .btn-outline-danger:disabled {
    color: #dc3545;
    background-color: transparent; }
  .btn-outline-danger:not(:disabled):not(.disabled):active, .btn-outline-danger:not(:disabled):not(.disabled).active, .show > .btn-outline-danger.dropdown-toggle {
    color: #fff;
    background-color: #dc3545;
    border-color: #dc3545; }
    .btn-outline-danger:not(:disabled):not(.disabled):active:focus, .btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-danger.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.5); }

.btn-outline-light {
  color: #f8f9fa;
  background-color: transparent;
  background-image: none;
  border-color: #f8f9fa; }
  .btn-outline-light:hover {
    color: #212529;
    background-color: #f8f9fa;
    border-color: #f8f9fa; }
  .btn-outline-light:focus, .btn-outline-light.focus {
    box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5); }
  .btn-outline-light.disabled, .btn-outline-light:disabled {
    color: #f8f9fa;
    background-color: transparent; }
  .btn-outline-light:not(:disabled):not(.disabled):active, .btn-outline-light:not(:disabled):not(.disabled).active, .show > .btn-outline-light.dropdown-toggle {
    color: #212529;
    background-color: #f8f9fa;
    border-color: #f8f9fa; }
    .btn-outline-light:not(:disabled):not(.disabled):active:focus, .btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-light.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5); }

.btn-outline-dark {
  color: #343a40;
  background-color: transparent;
  background-image: none;
  border-color: #343a40; }
  .btn-outline-dark:hover {
    color: #fff;
    background-color: #343a40;
    border-color: #343a40; }
  .btn-outline-dark:focus, .btn-outline-dark.focus {
    box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5); }
  .btn-outline-dark.disabled, .btn-outline-dark:disabled {
    color: #343a40;
    background-color: transparent; }
  .btn-outline-dark:not(:disabled):not(.disabled):active, .btn-outline-dark:not(:disabled):not(.disabled).active, .show > .btn-outline-dark.dropdown-toggle {
    color: #fff;
    background-color: #343a40;
    border-color: #343a40; }
    .btn-outline-dark:not(:disabled):not(.disabled):active:focus, .btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-dark.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5); }

.btn-link {
  font-weight: 400;
  color: #007bff;
  background-color: transparent; }
  .btn-link:hover {
    color: #0056b3;
    text-decoration: underline;
    background-color: transparent;
    border-color: transparent; }
  .btn-link:focus, .btn-link.focus {
    text-decoration: underline;
    border-color: transparent;
    box-shadow: none; }
  .btn-link:disabled, .btn-link.disabled {
    color: #6c757d;
    pointer-events: none; }

.btn-lg, .btn-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  line-height: 1.5;
  border-radius: 0.3rem; }

.btn-sm, .btn-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem; }

.btn-block {
  display: block;
  width: 100%; }
  .btn-block + .btn-block {
    margin-top: 0.5rem; }

input[type="submit"].btn-block,
input[type="reset"].btn-block,
input[type="button"].btn-block {
  width: 100%; }

.fade {
  transition: opacity 0.15s linear; }
  @media screen and (prefers-reduced-motion: reduce) {
    .fade {
      transition: none; } }
  .fade:not(.show) {
    opacity: 0; }

.collapse:not(.show) {
  display: none; }

.collapsing {
  position: relative;
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease; }
  @media screen and (prefers-reduced-motion: reduce) {
    .collapsing {
      transition: none; } }

.dropup,
.dropright,
.dropdown,
.dropleft {
  position: relative; }

.dropdown-toggle::after {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent; }
.dropdown-toggle:empty::after {
  margin-left: 0; }

.dropdown-menu, span.twitter-typeahead .tt-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  display: none;
  float: left;
  min-width: 10rem;
  padding: 0.5rem 0;
  margin: 0.125rem 0 0;
  font-size: 1rem;
  color: #212529;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem; }

.dropdown-menu-right {
  right: 0;
  left: auto; }

.dropup .dropdown-menu, .dropup span.twitter-typeahead .tt-menu, span.twitter-typeahead .dropup .tt-menu {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: 0.125rem; }
.dropup .dropdown-toggle::after {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent; }
.dropup .dropdown-toggle:empty::after {
  margin-left: 0; }

.dropright .dropdown-menu, .dropright span.twitter-typeahead .tt-menu, span.twitter-typeahead .dropright .tt-menu {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: 0.125rem; }
.dropright .dropdown-toggle::after {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid; }
.dropright .dropdown-toggle:empty::after {
  margin-left: 0; }
.dropright .dropdown-toggle::after {
  vertical-align: 0; }

.dropleft .dropdown-menu, .dropleft span.twitter-typeahead .tt-menu, span.twitter-typeahead .dropleft .tt-menu {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: 0.125rem; }
.dropleft .dropdown-toggle::after {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: ""; }
.dropleft .dropdown-toggle::after {
  display: none; }
.dropleft .dropdown-toggle::before {
  display: inline-block;
  width: 0;
  height: 0;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent; }
.dropleft .dropdown-toggle:empty::after {
  margin-left: 0; }
.dropleft .dropdown-toggle::before {
  vertical-align: 0; }

.dropdown-menu[x-placement^="top"], span.twitter-typeahead [x-placement^="top"].tt-menu, .dropdown-menu[x-placement^="right"], span.twitter-typeahead [x-placement^="right"].tt-menu, .dropdown-menu[x-placement^="bottom"], span.twitter-typeahead [x-placement^="bottom"].tt-menu, .dropdown-menu[x-placement^="left"], span.twitter-typeahead [x-placement^="left"].tt-menu {
  right: auto;
  bottom: auto; }

.dropdown-divider {
  height: 0;
  margin: 0.5rem 0;
  overflow: hidden;
  border-top: 1px solid #e9ecef; }

.dropdown-item, span.twitter-typeahead .tt-suggestion {
  display: block;
  width: 100%;
  padding: 0.25rem 1.5rem;
  clear: both;
  font-weight: 400;
  color: #212529;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0; }
  .dropdown-item:hover, span.twitter-typeahead .tt-suggestion:hover, .dropdown-item:focus, span.twitter-typeahead .tt-suggestion:focus {
    color: #16181b;
    text-decoration: none;
    background-color: #f8f9fa; }
  .dropdown-item.active, span.twitter-typeahead .active.tt-suggestion, span.twitter-typeahead .tt-suggestion.tt-cursor, .dropdown-item:active, span.twitter-typeahead .tt-suggestion:active {
    color: #fff;
    text-decoration: none;
    background-color: #007bff; }
  .dropdown-item.disabled, span.twitter-typeahead .disabled.tt-suggestion, .dropdown-item:disabled, span.twitter-typeahead .tt-suggestion:disabled {
    color: #6c757d;
    background-color: transparent; }

.dropdown-menu.show, span.twitter-typeahead .show.tt-menu {
  display: block; }

.dropdown-header {
  display: block;
  padding: 0.5rem 1.5rem;
  margin-bottom: 0;
  font-size: 0.875rem;
  color: #6c757d;
  white-space: nowrap; }

.dropdown-item-text {
  display: block;
  padding: 0.25rem 1.5rem;
  color: #212529; }

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle; }
  .btn-group > .btn,
  .btn-group-vertical > .btn {
    position: relative;
    flex: 0 1 auto; }
    .btn-group > .btn:hover,
    .btn-group-vertical > .btn:hover {
      z-index: 1; }
    .btn-group > .btn:focus, .btn-group > .btn:active, .btn-group > .btn.active,
    .btn-group-vertical > .btn:focus,
    .btn-group-vertical > .btn:active,
    .btn-group-vertical > .btn.active {
      z-index: 1; }
  .btn-group .btn + .btn,
  .btn-group .btn + .btn-group,
  .btn-group .btn-group + .btn,
  .btn-group .btn-group + .btn-group,
  .btn-group-vertical .btn + .btn,
  .btn-group-vertical .btn + .btn-group,
  .btn-group-vertical .btn-group + .btn,
  .btn-group-vertical .btn-group + .btn-group {
    margin-left: -1px; }

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start; }
  .btn-toolbar .input-group {
    width: auto; }

.btn-group > .btn:first-child {
  margin-left: 0; }
.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0; }
.btn-group > .btn:not(:first-child),
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0; }

.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem; }
  .dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropright .dropdown-toggle-split::after {
    margin-left: 0; }
  .dropleft .dropdown-toggle-split::before {
    margin-right: 0; }

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem; }

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem; }

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center; }
  .btn-group-vertical .btn,
  .btn-group-vertical .btn-group {
    width: 100%; }
  .btn-group-vertical > .btn + .btn,
  .btn-group-vertical > .btn + .btn-group,
  .btn-group-vertical > .btn-group + .btn,
  .btn-group-vertical > .btn-group + .btn-group {
    margin-top: -1px;
    margin-left: 0; }
  .btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
  .btn-group-vertical > .btn-group:not(:last-child) > .btn {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0; }
  .btn-group-vertical > .btn:not(:first-child),
  .btn-group-vertical > .btn-group:not(:first-child) > .btn {
    border-top-left-radius: 0;
    border-top-right-radius: 0; }

.btn-group-toggle > .btn,
.btn-group-toggle > .btn-group > .btn {
  margin-bottom: 0; }
  .btn-group-toggle > .btn input[type="radio"],
  .btn-group-toggle > .btn input[type="checkbox"],
  .btn-group-toggle > .btn-group > .btn input[type="radio"],
  .btn-group-toggle > .btn-group > .btn input[type="checkbox"] {
    position: absolute;
    clip: rect(0, 0, 0, 0);
    pointer-events: none; }

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%; }
  .input-group > .form-control,
  .input-group > .custom-select,
  .input-group > .custom-file {
    position: relative;
    flex: 1 1 auto;
    width: 1%;
    margin-bottom: 0; }
    .input-group > .form-control:focus,
    .input-group > .custom-select:focus,
    .input-group > .custom-file:focus {
      z-index: 3; }
    .input-group > .form-control + .form-control,
    .input-group > .form-control + .custom-select,
    .input-group > .form-control + .custom-file,
    .input-group > .custom-select + .form-control,
    .input-group > .custom-select + .custom-select,
    .input-group > .custom-select + .custom-file,
    .input-group > .custom-file + .form-control,
    .input-group > .custom-file + .custom-select,
    .input-group > .custom-file + .custom-file {
      margin-left: -1px; }
  .input-group > .form-control:not(:last-child),
  .input-group > .custom-select:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0; }
  .input-group > .form-control:not(:first-child),
  .input-group > .custom-select:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0; }
  .input-group > .custom-file {
    display: flex;
    align-items: center; }
    .input-group > .custom-file:not(:last-child) .custom-file-label, .input-group > .custom-file:not(:last-child) .custom-file-label::after {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0; }
    .input-group > .custom-file:not(:first-child) .custom-file-label, .input-group > .custom-file:not(:first-child) .custom-file-label::after {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0; }

.input-group-prepend,
.input-group-append {
  display: flex; }
  .input-group-prepend .btn,
  .input-group-append .btn {
    position: relative;
    z-index: 2; }
  .input-group-prepend .btn + .btn,
  .input-group-prepend .btn + .input-group-text,
  .input-group-prepend .input-group-text + .input-group-text,
  .input-group-prepend .input-group-text + .btn,
  .input-group-append .btn + .btn,
  .input-group-append .btn + .input-group-text,
  .input-group-append .input-group-text + .input-group-text,
  .input-group-append .input-group-text + .btn {
    margin-left: -1px; }

.input-group-prepend {
  margin-right: -1px; }

.input-group-append {
  margin-left: -1px; }

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  margin-bottom: 0;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  text-align: center;
  white-space: nowrap;
  background-color: #e9ecef;
  border: 1px solid #ced4da;
  border-radius: 0.25rem; }
  .input-group-text input[type="radio"],
  .input-group-text input[type="checkbox"] {
    margin-top: 0; }

.input-group > .input-group-prepend > .btn,
.input-group > .input-group-prepend > .input-group-text,
.input-group > .input-group-append:not(:last-child) > .btn,
.input-group > .input-group-append:not(:last-child) > .input-group-text,
.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),
.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0; }

.input-group > .input-group-append > .btn,
.input-group > .input-group-append > .input-group-text,
.input-group > .input-group-prepend:not(:first-child) > .btn,
.input-group > .input-group-prepend:not(:first-child) > .input-group-text,
.input-group > .input-group-prepend:first-child > .btn:not(:first-child),
.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0; }

.custom-control {
  position: relative;
  display: block;
  min-height: 1.5rem;
  padding-left: 1.5rem; }

.custom-control-inline {
  display: inline-flex;
  margin-right: 1rem; }

.custom-control-input {
  position: absolute;
  z-index: -1;
  opacity: 0; }
  .custom-control-input:checked ~ .custom-control-label::before {
    color: #fff;
    background-color: #007bff; }
  .custom-control-input:focus ~ .custom-control-label::before {
    box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(0, 123, 255, 0.25); }
  .custom-control-input:active ~ .custom-control-label::before {
    color: #fff;
    background-color: #b3d7ff; }
  .custom-control-input:disabled ~ .custom-control-label {
    color: #6c757d; }
    .custom-control-input:disabled ~ .custom-control-label::before {
      background-color: #e9ecef; }

.custom-control-label {
  margin-bottom: 0; }
  .custom-control-label::before {
    position: absolute;
    top: 0.25rem;
    left: 0;
    display: block;
    width: 1rem;
    height: 1rem;
    pointer-events: none;
    content: "";
    -webkit-user-select: none;
            user-select: none;
    background-color: #dee2e6; }
  .custom-control-label::after {
    position: absolute;
    top: 0.25rem;
    left: 0;
    display: block;
    width: 1rem;
    height: 1rem;
    content: "";
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 50% 50%; }

.custom-checkbox .custom-control-label::before {
  border-radius: 0.25rem; }
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #007bff; }
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); }
.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::before {
  background-color: #007bff; }
.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}); }
.custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(0, 123, 255, 0.5); }
.custom-checkbox .custom-control-input:disabled:indeterminate ~ .custom-control-label::before {
  background-color: rgba(0, 123, 255, 0.5); }

.custom-radio .custom-control-label::before {
  border-radius: 50%; }
.custom-radio .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #007bff; }
.custom-radio .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___}); }
.custom-radio .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(0, 123, 255, 0.5); }

.custom-select {
  display: inline-block;
  width: 100%;
  height: calc(2.25rem + 2px);
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  line-height: 1.5;
  color: #495057;
  vertical-align: middle;
  background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat right 0.75rem center;
  background-size: 8px 10px;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  appearance: none; }
  .custom-select:focus {
    border-color: #80bdff;
    outline: 0;
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075), 0 0 5px rgba(128, 189, 255, 0.5); }
    .custom-select:focus::-ms-value {
      color: #495057;
      background-color: #fff; }
  .custom-select[multiple], .custom-select[size]:not([size="1"]) {
    height: auto;
    padding-right: 0.75rem;
    background-image: none; }
  .custom-select:disabled {
    color: #6c757d;
    background-color: #e9ecef; }
  .custom-select::-ms-expand {
    opacity: 0; }

.custom-select-sm {
  height: calc(1.8125rem + 2px);
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
  font-size: 75%; }

.custom-select-lg {
  height: calc(2.875rem + 2px);
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
  font-size: 125%; }

.custom-file {
  position: relative;
  display: inline-block;
  width: 100%;
  height: calc(2.25rem + 2px);
  margin-bottom: 0; }

.custom-file-input {
  position: relative;
  z-index: 2;
  width: 100%;
  height: calc(2.25rem + 2px);
  margin: 0;
  opacity: 0; }
  .custom-file-input:focus ~ .custom-file-label {
    border-color: #80bdff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25); }
    .custom-file-input:focus ~ .custom-file-label::after {
      border-color: #80bdff; }
  .custom-file-input:lang(en) ~ .custom-file-label::after {
    content: "Browse"; }

.custom-file-label {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1;
  height: calc(2.25rem + 2px);
  padding: 0.375rem 0.75rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  border: 1px solid #ced4da;
  border-radius: 0.25rem; }
  .custom-file-label::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 3;
    display: block;
    height: calc(calc(2.25rem + 2px) - 1px * 2);
    padding: 0.375rem 0.75rem;
    line-height: 1.5;
    color: #495057;
    content: "Browse";
    background-color: #e9ecef;
    border-left: 1px solid #ced4da;
    border-radius: 0 0.25rem 0.25rem 0; }

.custom-range {
  width: 100%;
  padding-left: 0;
  background-color: transparent;
  appearance: none; }
  .custom-range:focus {
    outline: none; }
  .custom-range::-moz-focus-outer {
    border: 0; }
  .custom-range::-webkit-slider-thumb {
    width: 1rem;
    height: 1rem;
    margin-top: -0.25rem;
    background-color: #007bff;
    border: 0;
    border-radius: 1rem;
    appearance: none; }
    .custom-range::-webkit-slider-thumb:focus {
      outline: none;
      box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(0, 123, 255, 0.25); }
    .custom-range::-webkit-slider-thumb:active {
      background-color: #b3d7ff; }
  .custom-range::-webkit-slider-runnable-track {
    width: 100%;
    height: 0.5rem;
    color: transparent;
    cursor: pointer;
    background-color: #dee2e6;
    border-color: transparent;
    border-radius: 1rem; }
  .custom-range::-moz-range-thumb {
    width: 1rem;
    height: 1rem;
    background-color: #007bff;
    border: 0;
    border-radius: 1rem;
    appearance: none; }
    .custom-range::-moz-range-thumb:focus {
      outline: none;
      box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(0, 123, 255, 0.25); }
    .custom-range::-moz-range-thumb:active {
      background-color: #b3d7ff; }
  .custom-range::-moz-range-track {
    width: 100%;
    height: 0.5rem;
    color: transparent;
    cursor: pointer;
    background-color: #dee2e6;
    border-color: transparent;
    border-radius: 1rem; }
  .custom-range::-ms-thumb {
    width: 1rem;
    height: 1rem;
    background-color: #007bff;
    border: 0;
    border-radius: 1rem;
    appearance: none; }
    .custom-range::-ms-thumb:focus {
      outline: none;
      box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(0, 123, 255, 0.25); }
    .custom-range::-ms-thumb:active {
      background-color: #b3d7ff; }
  .custom-range::-ms-track {
    width: 100%;
    height: 0.5rem;
    color: transparent;
    cursor: pointer;
    background-color: transparent;
    border-color: transparent;
    border-width: 0.5rem; }
  .custom-range::-ms-fill-lower {
    background-color: #dee2e6;
    border-radius: 1rem; }
  .custom-range::-ms-fill-upper {
    margin-right: 15px;
    background-color: #dee2e6;
    border-radius: 1rem; }

.nav {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none; }

.nav-link {
  display: block;
  padding: 0.5rem 1rem; }
  .nav-link:hover, .nav-link:focus {
    text-decoration: none; }
  .nav-link.disabled {
    color: #6c757d; }

.nav-tabs {
  border-bottom: 1px solid #dee2e6; }
  .nav-tabs .nav-item {
    margin-bottom: -1px; }
  .nav-tabs .nav-link {
    border: 1px solid transparent;
    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem; }
    .nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
      border-color: #e9ecef #e9ecef #dee2e6; }
    .nav-tabs .nav-link.disabled {
      color: #6c757d;
      background-color: transparent;
      border-color: transparent; }
  .nav-tabs .nav-link.active,
  .nav-tabs .nav-item.show .nav-link {
    color: #495057;
    background-color: #fff;
    border-color: #dee2e6 #dee2e6 #fff; }
  .nav-tabs .dropdown-menu, .nav-tabs span.twitter-typeahead .tt-menu, span.twitter-typeahead .nav-tabs .tt-menu {
    margin-top: -1px;
    border-top-left-radius: 0;
    border-top-right-radius: 0; }

.nav-pills .nav-link {
  border-radius: 0.25rem; }
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #fff;
  background-color: #007bff; }

.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center; }

.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center; }

.tab-content > .tab-pane {
  display: none; }
.tab-content > .active {
  display: block; }

.navbar {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 1rem; }
  .navbar > .container,
  .navbar > .container-fluid {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between; }

.navbar-brand {
  display: inline-block;
  padding-top: 0.3125rem;
  padding-bottom: 0.3125rem;
  margin-right: 1rem;
  font-size: 1.25rem;
  line-height: inherit;
  white-space: nowrap; }
  .navbar-brand:hover, .navbar-brand:focus {
    text-decoration: none; }

.navbar-nav {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none; }
  .navbar-nav .nav-link {
    padding-right: 0;
    padding-left: 0; }
  .navbar-nav .dropdown-menu, .navbar-nav span.twitter-typeahead .tt-menu, span.twitter-typeahead .navbar-nav .tt-menu {
    position: static;
    float: none; }

.navbar-text {
  display: inline-block;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem; }

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center; }

.navbar-toggler {
  padding: 0.25rem 0.75rem;
  font-size: 1.25rem;
  line-height: 1;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 0.25rem; }
  .navbar-toggler:hover, .navbar-toggler:focus {
    text-decoration: none; }
  .navbar-toggler:not(:disabled):not(.disabled) {
    cursor: pointer; }

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  content: "";
  background: no-repeat center center;
  background-size: 100% 100%; }

@media (max-width: 575.98px) {
  .navbar-expand-sm > .container,
  .navbar-expand-sm > .container-fluid {
    padding-right: 0;
    padding-left: 0; } }
@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-flow: row nowrap;
    justify-content: flex-start; }
    .navbar-expand-sm .navbar-nav {
      flex-direction: row; }
      .navbar-expand-sm .navbar-nav .dropdown-menu, .navbar-expand-sm .navbar-nav span.twitter-typeahead .tt-menu, span.twitter-typeahead .navbar-expand-sm .navbar-nav .tt-menu {
        position: absolute; }
      .navbar-expand-sm .navbar-nav .nav-link {
        padding-right: 0.5rem;
        padding-left: 0.5rem; }
    .navbar-expand-sm > .container,
    .navbar-expand-sm > .container-fluid {
      flex-wrap: nowrap; }
    .navbar-expand-sm .navbar-collapse {
      display: flex !important;
      flex-basis: auto; }
    .navbar-expand-sm .navbar-toggler {
      display: none; } }
@media (max-width: 767.98px) {
  .navbar-expand-md > .container,
  .navbar-expand-md > .container-fluid {
    padding-right: 0;
    padding-left: 0; } }
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-flow: row nowrap;
    justify-content: flex-start; }
    .navbar-expand-md .navbar-nav {
      flex-direction: row; }
      .navbar-expand-md .navbar-nav .dropdown-menu, .navbar-expand-md .navbar-nav span.twitter-typeahead .tt-menu, span.twitter-typeahead .navbar-expand-md .navbar-nav .tt-menu {
        position: absolute; }
      .navbar-expand-md .navbar-nav .nav-link {
        padding-right: 0.5rem;
        padding-left: 0.5rem; }
    .navbar-expand-md > .container,
    .navbar-expand-md > .container-fluid {
      flex-wrap: nowrap; }
    .navbar-expand-md .navbar-collapse {
      display: flex !important;
      flex-basis: auto; }
    .navbar-expand-md .navbar-toggler {
      display: none; } }
@media (max-width: 991.98px) {
  .navbar-expand-lg > .container,
  .navbar-expand-lg > .container-fluid {
    padding-right: 0;
    padding-left: 0; } }
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-flow: row nowrap;
    justify-content: flex-start; }
    .navbar-expand-lg .navbar-nav {
      flex-direction: row; }
      .navbar-expand-lg .navbar-nav .dropdown-menu, .navbar-expand-lg .navbar-nav span.twitter-typeahead .tt-menu, span.twitter-typeahead .navbar-expand-lg .navbar-nav .tt-menu {
        position: absolute; }
      .navbar-expand-lg .navbar-nav .nav-link {
        padding-right: 0.5rem;
        padding-left: 0.5rem; }
    .navbar-expand-lg > .container,
    .navbar-expand-lg > .container-fluid {
      flex-wrap: nowrap; }
    .navbar-expand-lg .navbar-collapse {
      display: flex !important;
      flex-basis: auto; }
    .navbar-expand-lg .navbar-toggler {
      display: none; } }
@media (max-width: 1199.98px) {
  .navbar-expand-xl > .container,
  .navbar-expand-xl > .container-fluid {
    padding-right: 0;
    padding-left: 0; } }
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-flow: row nowrap;
    justify-content: flex-start; }
    .navbar-expand-xl .navbar-nav {
      flex-direction: row; }
      .navbar-expand-xl .navbar-nav .dropdown-menu, .navbar-expand-xl .navbar-nav span.twitter-typeahead .tt-menu, span.twitter-typeahead .navbar-expand-xl .navbar-nav .tt-menu {
        position: absolute; }
      .navbar-expand-xl .navbar-nav .nav-link {
        padding-right: 0.5rem;
        padding-left: 0.5rem; }
    .navbar-expand-xl > .container,
    .navbar-expand-xl > .container-fluid {
      flex-wrap: nowrap; }
    .navbar-expand-xl .navbar-collapse {
      display: flex !important;
      flex-basis: auto; }
    .navbar-expand-xl .navbar-toggler {
      display: none; } }
.navbar-expand {
  flex-flow: row nowrap;
  justify-content: flex-start; }
  .navbar-expand > .container,
  .navbar-expand > .container-fluid {
    padding-right: 0;
    padding-left: 0; }
  .navbar-expand .navbar-nav {
    flex-direction: row; }
    .navbar-expand .navbar-nav .dropdown-menu, .navbar-expand .navbar-nav span.twitter-typeahead .tt-menu, span.twitter-typeahead .navbar-expand .navbar-nav .tt-menu {
      position: absolute; }
    .navbar-expand .navbar-nav .nav-link {
      padding-right: 0.5rem;
      padding-left: 0.5rem; }
  .navbar-expand > .container,
  .navbar-expand > .container-fluid {
    flex-wrap: nowrap; }
  .navbar-expand .navbar-collapse {
    display: flex !important;
    flex-basis: auto; }
  .navbar-expand .navbar-toggler {
    display: none; }

.navbar-light .navbar-brand {
  color: rgba(0, 0, 0, 0.9); }
  .navbar-light .navbar-brand:hover, .navbar-light .navbar-brand:focus {
    color: rgba(0, 0, 0, 0.9); }
.navbar-light .navbar-nav .nav-link {
  color: rgba(0, 0, 0, 0.5); }
  .navbar-light .navbar-nav .nav-link:hover, .navbar-light .navbar-nav .nav-link:focus {
    color: rgba(0, 0, 0, 0.7); }
  .navbar-light .navbar-nav .nav-link.disabled {
    color: rgba(0, 0, 0, 0.3); }
.navbar-light .navbar-nav .show > .nav-link,
.navbar-light .navbar-nav .active > .nav-link,
.navbar-light .navbar-nav .nav-link.show,
.navbar-light .navbar-nav .nav-link.active {
  color: rgba(0, 0, 0, 0.9); }
.navbar-light .navbar-toggler {
  color: rgba(0, 0, 0, 0.5);
  border-color: rgba(0, 0, 0, 0.1); }
.navbar-light .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___}); }
.navbar-light .navbar-text {
  color: rgba(0, 0, 0, 0.5); }
  .navbar-light .navbar-text a {
    color: rgba(0, 0, 0, 0.9); }
    .navbar-light .navbar-text a:hover, .navbar-light .navbar-text a:focus {
      color: rgba(0, 0, 0, 0.9); }

.navbar-dark .navbar-brand {
  color: #fff; }
  .navbar-dark .navbar-brand:hover, .navbar-dark .navbar-brand:focus {
    color: #fff; }
.navbar-dark .navbar-nav .nav-link {
  color: rgba(255, 255, 255, 0.5); }
  .navbar-dark .navbar-nav .nav-link:hover, .navbar-dark .navbar-nav .nav-link:focus {
    color: rgba(255, 255, 255, 0.75); }
  .navbar-dark .navbar-nav .nav-link.disabled {
    color: rgba(255, 255, 255, 0.25); }
.navbar-dark .navbar-nav .show > .nav-link,
.navbar-dark .navbar-nav .active > .nav-link,
.navbar-dark .navbar-nav .nav-link.show,
.navbar-dark .navbar-nav .nav-link.active {
  color: #fff; }
.navbar-dark .navbar-toggler {
  color: rgba(255, 255, 255, 0.5);
  border-color: rgba(255, 255, 255, 0.1); }
.navbar-dark .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___}); }
.navbar-dark .navbar-text {
  color: rgba(255, 255, 255, 0.5); }
  .navbar-dark .navbar-text a {
    color: #fff; }
    .navbar-dark .navbar-text a:hover, .navbar-dark .navbar-text a:focus {
      color: #fff; }

.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem; }
  .card > hr {
    margin-right: 0;
    margin-left: 0; }
  .card > .list-group:first-child .list-group-item:first-child {
    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem; }
  .card > .list-group:last-child .list-group-item:last-child {
    border-bottom-right-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem; }

.card-body {
  flex: 1 1 auto;
  padding: 1.25rem; }

.card-title {
  margin-bottom: 0.75rem; }

.card-subtitle {
  margin-top: -0.375rem;
  margin-bottom: 0; }

.card-text:last-child {
  margin-bottom: 0; }

.card-link:hover {
  text-decoration: none; }
.card-link + .card-link {
  margin-left: 1.25rem; }

.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid rgba(0, 0, 0, 0.125); }
  .card-header:first-child {
    border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0; }
  .card-header + .list-group .list-group-item:first-child {
    border-top: 0; }

.card-footer {
  padding: 0.75rem 1.25rem;
  background-color: rgba(0, 0, 0, 0.03);
  border-top: 1px solid rgba(0, 0, 0, 0.125); }
  .card-footer:last-child {
    border-radius: 0 0 calc(0.25rem - 1px) calc(0.25rem - 1px); }

.card-header-tabs {
  margin-right: -0.625rem;
  margin-bottom: -0.75rem;
  margin-left: -0.625rem;
  border-bottom: 0; }

.card-header-pills {
  margin-right: -0.625rem;
  margin-left: -0.625rem; }

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 1.25rem; }

.card-img {
  width: 100%;
  border-radius: calc(0.25rem - 1px); }

.card-img-top {
  width: 100%;
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px); }

.card-img-bottom {
  width: 100%;
  border-bottom-right-radius: calc(0.25rem - 1px);
  border-bottom-left-radius: calc(0.25rem - 1px); }

.card-deck {
  display: flex;
  flex-direction: column; }
  .card-deck .card {
    margin-bottom: 15px; }
  @media (min-width: 576px) {
    .card-deck {
      flex-flow: row wrap;
      margin-right: -15px;
      margin-left: -15px; }
      .card-deck .card {
        display: flex;
        flex: 1 0;
        flex-direction: column;
        margin-right: 15px;
        margin-bottom: 0;
        margin-left: 15px; } }

.card-group {
  display: flex;
  flex-direction: column; }
  .card-group > .card {
    margin-bottom: 15px; }
  @media (min-width: 576px) {
    .card-group {
      flex-flow: row wrap; }
      .card-group > .card {
        flex: 1 0;
        margin-bottom: 0; }
        .card-group > .card + .card {
          margin-left: 0;
          border-left: 0; }
        .card-group > .card:first-child {
          border-top-right-radius: 0;
          border-bottom-right-radius: 0; }
          .card-group > .card:first-child .card-img-top,
          .card-group > .card:first-child .card-header {
            border-top-right-radius: 0; }
          .card-group > .card:first-child .card-img-bottom,
          .card-group > .card:first-child .card-footer {
            border-bottom-right-radius: 0; }
        .card-group > .card:last-child {
          border-top-left-radius: 0;
          border-bottom-left-radius: 0; }
          .card-group > .card:last-child .card-img-top,
          .card-group > .card:last-child .card-header {
            border-top-left-radius: 0; }
          .card-group > .card:last-child .card-img-bottom,
          .card-group > .card:last-child .card-footer {
            border-bottom-left-radius: 0; }
        .card-group > .card:only-child {
          border-radius: 0.25rem; }
          .card-group > .card:only-child .card-img-top,
          .card-group > .card:only-child .card-header {
            border-top-left-radius: 0.25rem;
            border-top-right-radius: 0.25rem; }
          .card-group > .card:only-child .card-img-bottom,
          .card-group > .card:only-child .card-footer {
            border-bottom-right-radius: 0.25rem;
            border-bottom-left-radius: 0.25rem; }
        .card-group > .card:not(:first-child):not(:last-child):not(:only-child) {
          border-radius: 0; }
          .card-group > .card:not(:first-child):not(:last-child):not(:only-child) .card-img-top,
          .card-group > .card:not(:first-child):not(:last-child):not(:only-child) .card-img-bottom,
          .card-group > .card:not(:first-child):not(:last-child):not(:only-child) .card-header,
          .card-group > .card:not(:first-child):not(:last-child):not(:only-child) .card-footer {
            border-radius: 0; } }

.card-columns .card {
  margin-bottom: 0.75rem; }
@media (min-width: 576px) {
  .card-columns {
    column-count: 3;
    column-gap: 1.25rem;
    orphans: 1;
    widows: 1; }
    .card-columns .card {
      display: inline-block;
      width: 100%; } }

.accordion .card:not(:first-of-type):not(:last-of-type) {
  border-bottom: 0;
  border-radius: 0; }
.accordion .card:not(:first-of-type) .card-header:first-child {
  border-radius: 0; }
.accordion .card:first-of-type {
  border-bottom: 0;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0; }
.accordion .card:last-of-type {
  border-top-left-radius: 0;
  border-top-right-radius: 0; }

.breadcrumb {
  display: flex;
  flex-wrap: wrap;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  list-style: none;
  background-color: #e9ecef;
  border-radius: 0.25rem; }

.breadcrumb-item + .breadcrumb-item {
  padding-left: 0.5rem; }
  .breadcrumb-item + .breadcrumb-item::before {
    display: inline-block;
    padding-right: 0.5rem;
    color: #6c757d;
    content: "/"; }
.breadcrumb-item + .breadcrumb-item:hover::before {
  text-decoration: underline; }
.breadcrumb-item + .breadcrumb-item:hover::before {
  text-decoration: none; }
.breadcrumb-item.active {
  color: #6c757d; }

.pagination {
  display: flex;
  padding-left: 0;
  list-style: none;
  border-radius: 0.25rem; }

.page-link {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #007bff;
  background-color: #fff;
  border: 1px solid #dee2e6; }
  .page-link:hover {
    z-index: 2;
    color: #0056b3;
    text-decoration: none;
    background-color: #e9ecef;
    border-color: #dee2e6; }
  .page-link:focus {
    z-index: 2;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25); }
  .page-link:not(:disabled):not(.disabled) {
    cursor: pointer; }

.page-item:first-child .page-link {
  margin-left: 0;
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem; }
.page-item:last-child .page-link {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem; }
.page-item.active .page-link {
  z-index: 1;
  color: #fff;
  background-color: #007bff;
  border-color: #007bff; }
.page-item.disabled .page-link {
  color: #6c757d;
  pointer-events: none;
  cursor: auto;
  background-color: #fff;
  border-color: #dee2e6; }

.pagination-lg .page-link {
  padding: 0.75rem 1.5rem;
  font-size: 1.25rem;
  line-height: 1.5; }
.pagination-lg .page-item:first-child .page-link {
  border-top-left-radius: 0.3rem;
  border-bottom-left-radius: 0.3rem; }
.pagination-lg .page-item:last-child .page-link {
  border-top-right-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem; }

.pagination-sm .page-link {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5; }
.pagination-sm .page-item:first-child .page-link {
  border-top-left-radius: 0.2rem;
  border-bottom-left-radius: 0.2rem; }
.pagination-sm .page-item:last-child .page-link {
  border-top-right-radius: 0.2rem;
  border-bottom-right-radius: 0.2rem; }

.badge {
  display: inline-block;
  padding: 0.25em 0.4em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem; }
  .badge:empty {
    display: none; }

.btn .badge {
  position: relative;
  top: -1px; }

.badge-pill {
  padding-right: 0.6em;
  padding-left: 0.6em;
  border-radius: 10rem; }

.badge-primary {
  color: #fff;
  background-color: #007bff; }
  .badge-primary[href]:hover, .badge-primary[href]:focus {
    color: #fff;
    text-decoration: none;
    background-color: #0062cc; }

.badge-secondary {
  color: #fff;
  background-color: #6c757d; }
  .badge-secondary[href]:hover, .badge-secondary[href]:focus {
    color: #fff;
    text-decoration: none;
    background-color: #545b62; }

.badge-success {
  color: #fff;
  background-color: #28a745; }
  .badge-success[href]:hover, .badge-success[href]:focus {
    color: #fff;
    text-decoration: none;
    background-color: #1e7e34; }

.badge-info {
  color: #fff;
  background-color: #17a2b8; }
  .badge-info[href]:hover, .badge-info[href]:focus {
    color: #fff;
    text-decoration: none;
    background-color: #117a8b; }

.badge-warning {
  color: #212529;
  background-color: #ffc107; }
  .badge-warning[href]:hover, .badge-warning[href]:focus {
    color: #212529;
    text-decoration: none;
    background-color: #d39e00; }

.badge-danger {
  color: #fff;
  background-color: #dc3545; }
  .badge-danger[href]:hover, .badge-danger[href]:focus {
    color: #fff;
    text-decoration: none;
    background-color: #bd2130; }

.badge-light {
  color: #212529;
  background-color: #f8f9fa; }
  .badge-light[href]:hover, .badge-light[href]:focus {
    color: #212529;
    text-decoration: none;
    background-color: #dae0e5; }

.badge-dark {
  color: #fff;
  background-color: #343a40; }
  .badge-dark[href]:hover, .badge-dark[href]:focus {
    color: #fff;
    text-decoration: none;
    background-color: #1d2124; }

.jumbotron {
  padding: 2rem 1rem;
  margin-bottom: 2rem;
  background-color: #e9ecef;
  border-radius: 0.3rem; }
  @media (min-width: 576px) {
    .jumbotron {
      padding: 4rem 2rem; } }

.jumbotron-fluid {
  padding-right: 0;
  padding-left: 0;
  border-radius: 0; }

.alert {
  position: relative;
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.25rem; }

.alert-heading {
  color: inherit; }

.alert-link {
  font-weight: 700; }

.alert-dismissible {
  padding-right: 4rem; }
  .alert-dismissible .close {
    position: absolute;
    top: 0;
    right: 0;
    padding: 0.75rem 1.25rem;
    color: inherit; }

.alert-primary {
  color: #004085;
  background-color: #cce5ff;
  border-color: #b8daff; }
  .alert-primary hr {
    border-top-color: #9fcdff; }
  .alert-primary .alert-link {
    color: #002752; }

.alert-secondary {
  color: #383d41;
  background-color: #e2e3e5;
  border-color: #d6d8db; }
  .alert-secondary hr {
    border-top-color: #c8cbcf; }
  .alert-secondary .alert-link {
    color: #202326; }

.alert-success {
  color: #155724;
  background-color: #d4edda;
  border-color: #c3e6cb; }
  .alert-success hr {
    border-top-color: #b1dfbb; }
  .alert-success .alert-link {
    color: #0b2e13; }

.alert-info {
  color: #0c5460;
  background-color: #d1ecf1;
  border-color: #bee5eb; }
  .alert-info hr {
    border-top-color: #abdde5; }
  .alert-info .alert-link {
    color: #062c33; }

.alert-warning {
  color: #856404;
  background-color: #fff3cd;
  border-color: #ffeeba; }
  .alert-warning hr {
    border-top-color: #ffe8a1; }
  .alert-warning .alert-link {
    color: #533f03; }

.alert-danger {
  color: #721c24;
  background-color: #f8d7da;
  border-color: #f5c6cb; }
  .alert-danger hr {
    border-top-color: #f1b0b7; }
  .alert-danger .alert-link {
    color: #491217; }

.alert-light {
  color: #818182;
  background-color: #fefefe;
  border-color: #fdfdfe; }
  .alert-light hr {
    border-top-color: #ececf6; }
  .alert-light .alert-link {
    color: #686868; }

.alert-dark {
  color: #1b1e21;
  background-color: #d6d8d9;
  border-color: #c6c8ca; }
  .alert-dark hr {
    border-top-color: #b9bbbe; }
  .alert-dark .alert-link {
    color: #040505; }

@keyframes progress-bar-stripes {
  from {
    background-position: 1rem 0; }
  to {
    background-position: 0 0; } }
.progress {
  display: flex;
  height: 1rem;
  overflow: hidden;
  font-size: 0.75rem;
  background-color: #e9ecef;
  border-radius: 0.25rem; }

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  background-color: #007bff;
  transition: width 0.6s ease; }
  @media screen and (prefers-reduced-motion: reduce) {
    .progress-bar {
      transition: none; } }

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: 1rem 1rem; }

.progress-bar-animated {
  animation: progress-bar-stripes 1s linear infinite; }

.media {
  display: flex;
  align-items: flex-start; }

.media-body {
  flex: 1 1; }

.list-group {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0; }

.list-group-item-action {
  width: 100%;
  color: #495057;
  text-align: inherit; }
  .list-group-item-action:hover, .list-group-item-action:focus {
    color: #495057;
    text-decoration: none;
    background-color: #f8f9fa; }
  .list-group-item-action:active {
    color: #212529;
    background-color: #e9ecef; }

.list-group-item {
  position: relative;
  display: block;
  padding: 0.75rem 1.25rem;
  margin-bottom: -1px;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.125); }
  .list-group-item:first-child {
    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem; }
  .list-group-item:last-child {
    margin-bottom: 0;
    border-bottom-right-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem; }
  .list-group-item:hover, .list-group-item:focus {
    z-index: 1;
    text-decoration: none; }
  .list-group-item.disabled, .list-group-item:disabled {
    color: #6c757d;
    background-color: #fff; }
  .list-group-item.active {
    z-index: 2;
    color: #fff;
    background-color: #007bff;
    border-color: #007bff; }

.list-group-flush .list-group-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0; }
.list-group-flush:first-child .list-group-item:first-child {
  border-top: 0; }
.list-group-flush:last-child .list-group-item:last-child {
  border-bottom: 0; }

.list-group-item-primary {
  color: #004085;
  background-color: #b8daff; }
  .list-group-item-primary.list-group-item-action:hover, .list-group-item-primary.list-group-item-action:focus {
    color: #004085;
    background-color: #9fcdff; }
  .list-group-item-primary.list-group-item-action.active {
    color: #fff;
    background-color: #004085;
    border-color: #004085; }

.list-group-item-secondary {
  color: #383d41;
  background-color: #d6d8db; }
  .list-group-item-secondary.list-group-item-action:hover, .list-group-item-secondary.list-group-item-action:focus {
    color: #383d41;
    background-color: #c8cbcf; }
  .list-group-item-secondary.list-group-item-action.active {
    color: #fff;
    background-color: #383d41;
    border-color: #383d41; }

.list-group-item-success {
  color: #155724;
  background-color: #c3e6cb; }
  .list-group-item-success.list-group-item-action:hover, .list-group-item-success.list-group-item-action:focus {
    color: #155724;
    background-color: #b1dfbb; }
  .list-group-item-success.list-group-item-action.active {
    color: #fff;
    background-color: #155724;
    border-color: #155724; }

.list-group-item-info {
  color: #0c5460;
  background-color: #bee5eb; }
  .list-group-item-info.list-group-item-action:hover, .list-group-item-info.list-group-item-action:focus {
    color: #0c5460;
    background-color: #abdde5; }
  .list-group-item-info.list-group-item-action.active {
    color: #fff;
    background-color: #0c5460;
    border-color: #0c5460; }

.list-group-item-warning {
  color: #856404;
  background-color: #ffeeba; }
  .list-group-item-warning.list-group-item-action:hover, .list-group-item-warning.list-group-item-action:focus {
    color: #856404;
    background-color: #ffe8a1; }
  .list-group-item-warning.list-group-item-action.active {
    color: #fff;
    background-color: #856404;
    border-color: #856404; }

.list-group-item-danger {
  color: #721c24;
  background-color: #f5c6cb; }
  .list-group-item-danger.list-group-item-action:hover, .list-group-item-danger.list-group-item-action:focus {
    color: #721c24;
    background-color: #f1b0b7; }
  .list-group-item-danger.list-group-item-action.active {
    color: #fff;
    background-color: #721c24;
    border-color: #721c24; }

.list-group-item-light {
  color: #818182;
  background-color: #fdfdfe; }
  .list-group-item-light.list-group-item-action:hover, .list-group-item-light.list-group-item-action:focus {
    color: #818182;
    background-color: #ececf6; }
  .list-group-item-light.list-group-item-action.active {
    color: #fff;
    background-color: #818182;
    border-color: #818182; }

.list-group-item-dark {
  color: #1b1e21;
  background-color: #c6c8ca; }
  .list-group-item-dark.list-group-item-action:hover, .list-group-item-dark.list-group-item-action:focus {
    color: #1b1e21;
    background-color: #b9bbbe; }
  .list-group-item-dark.list-group-item-action.active {
    color: #fff;
    background-color: #1b1e21;
    border-color: #1b1e21; }

.close {
  float: right;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  opacity: .5; }
  .close:hover, .close:focus {
    color: #000;
    text-decoration: none;
    opacity: .75; }
  .close:not(:disabled):not(.disabled) {
    cursor: pointer; }

button.close {
  padding: 0;
  background-color: transparent;
  border: 0;
  -webkit-appearance: none; }

.modal-open {
  overflow: hidden; }

.modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  display: none;
  overflow: hidden;
  outline: 0; }
  .modal-open .modal {
    overflow-x: hidden;
    overflow-y: auto; }

.modal-dialog {
  position: relative;
  width: auto;
  margin: 0.5rem;
  pointer-events: none; }
  .modal.fade .modal-dialog {
    transition: transform 0.3s ease-out;
    transform: translate(0, -25%); }
    @media screen and (prefers-reduced-motion: reduce) {
      .modal.fade .modal-dialog {
        transition: none; } }
  .modal.show .modal-dialog {
    transform: translate(0, 0); }

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - (0.5rem * 2)); }

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
  outline: 0; }

.modal-backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1040;
  background-color: #000; }
  .modal-backdrop.fade {
    opacity: 0; }
  .modal-backdrop.show {
    opacity: 0.5; }

.modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 1rem;
  border-bottom: 1px solid #e9ecef;
  border-top-left-radius: 0.3rem;
  border-top-right-radius: 0.3rem; }
  .modal-header .close {
    padding: 1rem;
    margin: -1rem -1rem -1rem auto; }

.modal-title {
  margin-bottom: 0;
  line-height: 1.5; }

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: 1rem; }

.modal-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 1rem;
  border-top: 1px solid #e9ecef; }
  .modal-footer > :not(:first-child) {
    margin-left: .25rem; }
  .modal-footer > :not(:last-child) {
    margin-right: .25rem; }

.modal-scrollbar-measure {
  position: absolute;
  top: -9999px;
  width: 50px;
  height: 50px;
  overflow: scroll; }

@media (min-width: 576px) {
  .modal-dialog {
    max-width: 650px;
    margin: 1.75rem auto; }

  .modal-dialog-centered {
    min-height: calc(100% - (1.75rem * 2)); }

  .modal-sm {
    max-width: 300px; } }
@media (min-width: 992px) {
  .modal-lg {
    max-width: 800px; } }
.tooltip {
  position: absolute;
  z-index: 1070;
  display: block;
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  white-space: normal;
  line-break: auto;
  font-size: 0.875rem;
  word-wrap: break-word;
  opacity: 0; }
  .tooltip.show {
    opacity: 0.9; }
  .tooltip .arrow {
    position: absolute;
    display: block;
    width: 0.8rem;
    height: 0.4rem; }
    .tooltip .arrow::before {
      position: absolute;
      content: "";
      border-color: transparent;
      border-style: solid; }

.bs-tooltip-top, .bs-tooltip-auto[x-placement^="top"] {
  padding: 0.4rem 0; }
  .bs-tooltip-top .arrow, .bs-tooltip-auto[x-placement^="top"] .arrow {
    bottom: 0; }
    .bs-tooltip-top .arrow::before, .bs-tooltip-auto[x-placement^="top"] .arrow::before {
      top: 0;
      border-width: 0.4rem 0.4rem 0;
      border-top-color: #000; }

.bs-tooltip-right, .bs-tooltip-auto[x-placement^="right"] {
  padding: 0 0.4rem; }
  .bs-tooltip-right .arrow, .bs-tooltip-auto[x-placement^="right"] .arrow {
    left: 0;
    width: 0.4rem;
    height: 0.8rem; }
    .bs-tooltip-right .arrow::before, .bs-tooltip-auto[x-placement^="right"] .arrow::before {
      right: 0;
      border-width: 0.4rem 0.4rem 0.4rem 0;
      border-right-color: #000; }

.bs-tooltip-bottom, .bs-tooltip-auto[x-placement^="bottom"] {
  padding: 0.4rem 0; }
  .bs-tooltip-bottom .arrow, .bs-tooltip-auto[x-placement^="bottom"] .arrow {
    top: 0; }
    .bs-tooltip-bottom .arrow::before, .bs-tooltip-auto[x-placement^="bottom"] .arrow::before {
      bottom: 0;
      border-width: 0 0.4rem 0.4rem;
      border-bottom-color: #000; }

.bs-tooltip-left, .bs-tooltip-auto[x-placement^="left"] {
  padding: 0 0.4rem; }
  .bs-tooltip-left .arrow, .bs-tooltip-auto[x-placement^="left"] .arrow {
    right: 0;
    width: 0.4rem;
    height: 0.8rem; }
    .bs-tooltip-left .arrow::before, .bs-tooltip-auto[x-placement^="left"] .arrow::before {
      left: 0;
      border-width: 0.4rem 0 0.4rem 0.4rem;
      border-left-color: #000; }

.tooltip-inner {
  max-width: 200px;
  padding: 0.25rem 0.5rem;
  color: #fff;
  text-align: center;
  background-color: #000;
  border-radius: 0.25rem; }

.popover {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1060;
  display: block;
  max-width: 276px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  white-space: normal;
  line-break: auto;
  font-size: 0.875rem;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem; }
  .popover .arrow {
    position: absolute;
    display: block;
    width: 1rem;
    height: 0.5rem;
    margin: 0 0.3rem; }
    .popover .arrow::before, .popover .arrow::after {
      position: absolute;
      display: block;
      content: "";
      border-color: transparent;
      border-style: solid; }

.bs-popover-top, .bs-popover-auto[x-placement^="top"] {
  margin-bottom: 0.5rem; }
  .bs-popover-top .arrow, .bs-popover-auto[x-placement^="top"] .arrow {
    bottom: calc((0.5rem + 1px) * -1); }
  .bs-popover-top .arrow::before, .bs-popover-auto[x-placement^="top"] .arrow::before,
  .bs-popover-top .arrow::after,
  .bs-popover-auto[x-placement^="top"] .arrow::after {
    border-width: 0.5rem 0.5rem 0; }
  .bs-popover-top .arrow::before, .bs-popover-auto[x-placement^="top"] .arrow::before {
    bottom: 0;
    border-top-color: rgba(0, 0, 0, 0.25); }
  .bs-popover-top .arrow::after, .bs-popover-auto[x-placement^="top"] .arrow::after {
    bottom: 1px;
    border-top-color: #fff; }

.bs-popover-right, .bs-popover-auto[x-placement^="right"] {
  margin-left: 0.5rem; }
  .bs-popover-right .arrow, .bs-popover-auto[x-placement^="right"] .arrow {
    left: calc((0.5rem + 1px) * -1);
    width: 0.5rem;
    height: 1rem;
    margin: 0.3rem 0; }
  .bs-popover-right .arrow::before, .bs-popover-auto[x-placement^="right"] .arrow::before,
  .bs-popover-right .arrow::after,
  .bs-popover-auto[x-placement^="right"] .arrow::after {
    border-width: 0.5rem 0.5rem 0.5rem 0; }
  .bs-popover-right .arrow::before, .bs-popover-auto[x-placement^="right"] .arrow::before {
    left: 0;
    border-right-color: rgba(0, 0, 0, 0.25); }
  .bs-popover-right .arrow::after, .bs-popover-auto[x-placement^="right"] .arrow::after {
    left: 1px;
    border-right-color: #fff; }

.bs-popover-bottom, .bs-popover-auto[x-placement^="bottom"] {
  margin-top: 0.5rem; }
  .bs-popover-bottom .arrow, .bs-popover-auto[x-placement^="bottom"] .arrow {
    top: calc((0.5rem + 1px) * -1); }
  .bs-popover-bottom .arrow::before, .bs-popover-auto[x-placement^="bottom"] .arrow::before,
  .bs-popover-bottom .arrow::after,
  .bs-popover-auto[x-placement^="bottom"] .arrow::after {
    border-width: 0 0.5rem 0.5rem 0.5rem; }
  .bs-popover-bottom .arrow::before, .bs-popover-auto[x-placement^="bottom"] .arrow::before {
    top: 0;
    border-bottom-color: rgba(0, 0, 0, 0.25); }
  .bs-popover-bottom .arrow::after, .bs-popover-auto[x-placement^="bottom"] .arrow::after {
    top: 1px;
    border-bottom-color: #fff; }
  .bs-popover-bottom .popover-header::before, .bs-popover-auto[x-placement^="bottom"] .popover-header::before {
    position: absolute;
    top: 0;
    left: 50%;
    display: block;
    width: 1rem;
    margin-left: -0.5rem;
    content: "";
    border-bottom: 1px solid #f7f7f7; }

.bs-popover-left, .bs-popover-auto[x-placement^="left"] {
  margin-right: 0.5rem; }
  .bs-popover-left .arrow, .bs-popover-auto[x-placement^="left"] .arrow {
    right: calc((0.5rem + 1px) * -1);
    width: 0.5rem;
    height: 1rem;
    margin: 0.3rem 0; }
  .bs-popover-left .arrow::before, .bs-popover-auto[x-placement^="left"] .arrow::before,
  .bs-popover-left .arrow::after,
  .bs-popover-auto[x-placement^="left"] .arrow::after {
    border-width: 0.5rem 0 0.5rem 0.5rem; }
  .bs-popover-left .arrow::before, .bs-popover-auto[x-placement^="left"] .arrow::before {
    right: 0;
    border-left-color: rgba(0, 0, 0, 0.25); }
  .bs-popover-left .arrow::after, .bs-popover-auto[x-placement^="left"] .arrow::after {
    right: 1px;
    border-left-color: #fff; }

.popover-header {
  padding: 0.5rem 0.75rem;
  margin-bottom: 0;
  font-size: 1rem;
  color: inherit;
  background-color: #f7f7f7;
  border-bottom: 1px solid #ebebeb;
  border-top-left-radius: calc(0.3rem - 1px);
  border-top-right-radius: calc(0.3rem - 1px); }
  .popover-header:empty {
    display: none; }

.popover-body {
  padding: 0.5rem 0.75rem;
  color: #212529; }

.carousel {
  position: relative; }

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden; }

.carousel-item {
  position: relative;
  display: none;
  align-items: center;
  width: 100%;
  transition: transform 0.6s ease;
  backface-visibility: hidden;
  perspective: 1000px; }
  @media screen and (prefers-reduced-motion: reduce) {
    .carousel-item {
      transition: none; } }

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block; }

.carousel-item-next,
.carousel-item-prev {
  position: absolute;
  top: 0; }

.carousel-item-next.carousel-item-left,
.carousel-item-prev.carousel-item-right {
  transform: translateX(0); }
  @supports (transform-style: preserve-3d) {
    .carousel-item-next.carousel-item-left,
    .carousel-item-prev.carousel-item-right {
      transform: translate3d(0, 0, 0); } }

.carousel-item-next,
.active.carousel-item-right {
  transform: translateX(100%); }
  @supports (transform-style: preserve-3d) {
    .carousel-item-next,
    .active.carousel-item-right {
      transform: translate3d(100%, 0, 0); } }

.carousel-item-prev,
.active.carousel-item-left {
  transform: translateX(-100%); }
  @supports (transform-style: preserve-3d) {
    .carousel-item-prev,
    .active.carousel-item-left {
      transform: translate3d(-100%, 0, 0); } }

.carousel-fade .carousel-item {
  opacity: 0;
  transition-duration: .6s;
  transition-property: opacity; }
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-left,
.carousel-fade .carousel-item-prev.carousel-item-right {
  opacity: 1; }
.carousel-fade .active.carousel-item-left,
.carousel-fade .active.carousel-item-right {
  opacity: 0; }
.carousel-fade .carousel-item-next,
.carousel-fade .carousel-item-prev,
.carousel-fade .carousel-item.active,
.carousel-fade .active.carousel-item-left,
.carousel-fade .active.carousel-item-prev {
  transform: translateX(0); }
  @supports (transform-style: preserve-3d) {
    .carousel-fade .carousel-item-next,
    .carousel-fade .carousel-item-prev,
    .carousel-fade .carousel-item.active,
    .carousel-fade .active.carousel-item-left,
    .carousel-fade .active.carousel-item-prev {
      transform: translate3d(0, 0, 0); } }

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  color: #fff;
  text-align: center;
  opacity: 0.5; }
  .carousel-control-prev:hover, .carousel-control-prev:focus,
  .carousel-control-next:hover,
  .carousel-control-next:focus {
    color: #fff;
    text-decoration: none;
    outline: 0;
    opacity: .9; }

.carousel-control-prev {
  left: 0; }

.carousel-control-next {
  right: 0; }

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: transparent no-repeat center center;
  background-size: 100% 100%; }

.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___}); }

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___}); }

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 10px;
  left: 0;
  z-index: 15;
  display: flex;
  justify-content: center;
  padding-left: 0;
  margin-right: 15%;
  margin-left: 15%;
  list-style: none; }
  .carousel-indicators li {
    position: relative;
    flex: 0 1 auto;
    width: 30px;
    height: 3px;
    margin-right: 3px;
    margin-left: 3px;
    text-indent: -999px;
    background-color: rgba(255, 255, 255, 0.5); }
    .carousel-indicators li::before {
      position: absolute;
      top: -10px;
      left: 0;
      display: inline-block;
      width: 100%;
      height: 10px;
      content: ""; }
    .carousel-indicators li::after {
      position: absolute;
      bottom: -10px;
      left: 0;
      display: inline-block;
      width: 100%;
      height: 10px;
      content: ""; }
  .carousel-indicators .active {
    background-color: #fff; }

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 20px;
  left: 15%;
  z-index: 10;
  padding-top: 20px;
  padding-bottom: 20px;
  color: #fff;
  text-align: center; }

.align-baseline {
  vertical-align: baseline !important; }

.align-top {
  vertical-align: top !important; }

.align-middle {
  vertical-align: middle !important; }

.align-bottom {
  vertical-align: bottom !important; }

.align-text-bottom {
  vertical-align: text-bottom !important; }

.align-text-top {
  vertical-align: text-top !important; }

.bg-primary {
  background-color: #007bff !important; }

a.bg-primary:hover, a.bg-primary:focus,
button.bg-primary:hover,
button.bg-primary:focus {
  background-color: #0062cc !important; }

.bg-secondary {
  background-color: #6c757d !important; }

a.bg-secondary:hover, a.bg-secondary:focus,
button.bg-secondary:hover,
button.bg-secondary:focus {
  background-color: #545b62 !important; }

.bg-success {
  background-color: #28a745 !important; }

a.bg-success:hover, a.bg-success:focus,
button.bg-success:hover,
button.bg-success:focus {
  background-color: #1e7e34 !important; }

.bg-info {
  background-color: #015ec9 !important; }

a.bg-info:hover, a.bg-info:focus,
button.bg-info:hover,
button.bg-info:focus {
  background-color: #117a8b !important; }

.bg-warning {
  background-color: #ffc107 !important; }

a.bg-warning:hover, a.bg-warning:focus,
button.bg-warning:hover,
button.bg-warning:focus {
  background-color: #d39e00 !important; }

.bg-danger {
  background-color: #dc3545 !important; }

a.bg-danger:hover, a.bg-danger:focus,
button.bg-danger:hover,
button.bg-danger:focus {
  background-color: #bd2130 !important; }

.bg-light {
  background-color: #f8f9fa !important; }

a.bg-light:hover, a.bg-light:focus,
button.bg-light:hover,
button.bg-light:focus {
  background-color: #dae0e5 !important; }

.bg-dark {
  background-color: #343a40 !important; }

a.bg-dark:hover, a.bg-dark:focus,
button.bg-dark:hover,
button.bg-dark:focus {
  background-color: #1d2124 !important; }

.bg-white {
  background-color: #fff !important; }

.bg-transparent {
  background-color: transparent !important; }

.border {
  border: 1px solid #dee2e6 !important; }

.border-top {
  border-top: 1px solid #dee2e6 !important; }

.border-right {
  border-right: 1px solid #dee2e6 !important; }

.border-bottom {
  border-bottom: 1px solid #dee2e6 !important; }

.border-left {
  border-left: 1px solid #dee2e6 !important; }

.border-0 {
  border: 0 !important; }

.border-top-0 {
  border-top: 0 !important; }

.border-right-0 {
  border-right: 0 !important; }

.border-bottom-0 {
  border-bottom: 0 !important; }

.border-left-0 {
  border-left: 0 !important; }

.border-primary {
  border-color: #007bff !important; }

.border-secondary {
  border-color: #6c757d !important; }

.border-success {
  border-color: #28a745 !important; }

.border-info {
  border-color: #17a2b8 !important; }

.border-warning {
  border-color: #ffc107 !important; }

.border-danger {
  border-color: #dc3545 !important; }

.border-light {
  border-color: #f8f9fa !important; }

.border-dark {
  border-color: #343a40 !important; }

.border-white {
  border-color: #fff !important; }

.rounded {
  border-radius: 0.25rem !important; }

.rounded-top {
  border-top-left-radius: 0.25rem !important;
  border-top-right-radius: 0.25rem !important; }

.rounded-right {
  border-top-right-radius: 0.25rem !important;
  border-bottom-right-radius: 0.25rem !important; }

.rounded-bottom {
  border-bottom-right-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important; }

.rounded-left {
  border-top-left-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important; }

.rounded-circle {
  border-radius: 50% !important; }

.rounded-0 {
  border-radius: 0 !important; }

.clearfix::after {
  display: block;
  clear: both;
  content: ""; }

.d-none {
  display: none !important; }

.d-inline {
  display: inline !important; }

.d-inline-block {
  display: inline-block !important; }

.d-block {
  display: block !important; }

.d-table {
  display: table !important; }

.d-table-row {
  display: table-row !important; }

.d-table-cell {
  display: table-cell !important; }

.d-flex {
  display: flex !important; }

.d-inline-flex {
  display: inline-flex !important; }

@media (min-width: 576px) {
  .d-sm-none {
    display: none !important; }

  .d-sm-inline {
    display: inline !important; }

  .d-sm-inline-block {
    display: inline-block !important; }

  .d-sm-block {
    display: block !important; }

  .d-sm-table {
    display: table !important; }

  .d-sm-table-row {
    display: table-row !important; }

  .d-sm-table-cell {
    display: table-cell !important; }

  .d-sm-flex {
    display: flex !important; }

  .d-sm-inline-flex {
    display: inline-flex !important; } }
@media (min-width: 768px) {
  .d-md-none {
    display: none !important; }

  .d-md-inline {
    display: inline !important; }

  .d-md-inline-block {
    display: inline-block !important; }

  .d-md-block {
    display: block !important; }

  .d-md-table {
    display: table !important; }

  .d-md-table-row {
    display: table-row !important; }

  .d-md-table-cell {
    display: table-cell !important; }

  .d-md-flex {
    display: flex !important; }

  .d-md-inline-flex {
    display: inline-flex !important; } }
@media (min-width: 992px) {
  .d-lg-none {
    display: none !important; }

  .d-lg-inline {
    display: inline !important; }

  .d-lg-inline-block {
    display: inline-block !important; }

  .d-lg-block {
    display: block !important; }

  .d-lg-table {
    display: table !important; }

  .d-lg-table-row {
    display: table-row !important; }

  .d-lg-table-cell {
    display: table-cell !important; }

  .d-lg-flex {
    display: flex !important; }

  .d-lg-inline-flex {
    display: inline-flex !important; } }
@media (min-width: 1200px) {
  .d-xl-none {
    display: none !important; }

  .d-xl-inline {
    display: inline !important; }

  .d-xl-inline-block {
    display: inline-block !important; }

  .d-xl-block {
    display: block !important; }

  .d-xl-table {
    display: table !important; }

  .d-xl-table-row {
    display: table-row !important; }

  .d-xl-table-cell {
    display: table-cell !important; }

  .d-xl-flex {
    display: flex !important; }

  .d-xl-inline-flex {
    display: inline-flex !important; } }
@media print {
  .d-print-none {
    display: none !important; }

  .d-print-inline {
    display: inline !important; }

  .d-print-inline-block {
    display: inline-block !important; }

  .d-print-block {
    display: block !important; }

  .d-print-table {
    display: table !important; }

  .d-print-table-row {
    display: table-row !important; }

  .d-print-table-cell {
    display: table-cell !important; }

  .d-print-flex {
    display: flex !important; }

  .d-print-inline-flex {
    display: inline-flex !important; } }
.embed-responsive {
  position: relative;
  display: block;
  width: 100%;
  padding: 0;
  overflow: hidden; }
  .embed-responsive::before {
    display: block;
    content: ""; }
  .embed-responsive .embed-responsive-item,
  .embed-responsive iframe,
  .embed-responsive embed,
  .embed-responsive object,
  .embed-responsive video {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0; }

.embed-responsive-21by9::before {
  padding-top: 42.8571428571%; }

.embed-responsive-16by9::before {
  padding-top: 56.25%; }

.embed-responsive-4by3::before {
  padding-top: 75%; }

.embed-responsive-1by1::before {
  padding-top: 100%; }

.flex-row {
  flex-direction: row !important; }

.flex-column {
  flex-direction: column !important; }

.flex-row-reverse {
  flex-direction: row-reverse !important; }

.flex-column-reverse {
  flex-direction: column-reverse !important; }

.flex-wrap {
  flex-wrap: wrap !important; }

.flex-nowrap {
  flex-wrap: nowrap !important; }

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important; }

.flex-fill {
  flex: 1 1 auto !important; }

.flex-grow-0 {
  flex-grow: 0 !important; }

.flex-grow-1 {
  flex-grow: 1 !important; }

.flex-shrink-0 {
  flex-shrink: 0 !important; }

.flex-shrink-1 {
  flex-shrink: 1 !important; }

.justify-content-start {
  justify-content: flex-start !important; }

.justify-content-end {
  justify-content: flex-end !important; }

.justify-content-center {
  justify-content: center !important; }

.justify-content-between {
  justify-content: space-between !important; }

.justify-content-around {
  justify-content: space-around !important; }

.align-items-start {
  align-items: flex-start !important; }

.align-items-end {
  align-items: flex-end !important; }

.align-items-center {
  align-items: center !important; }

.align-items-baseline {
  align-items: baseline !important; }

.align-items-stretch {
  align-items: stretch !important; }

.align-content-start {
  align-content: flex-start !important; }

.align-content-end {
  align-content: flex-end !important; }

.align-content-center {
  align-content: center !important; }

.align-content-between {
  align-content: space-between !important; }

.align-content-around {
  align-content: space-around !important; }

.align-content-stretch {
  align-content: stretch !important; }

.align-self-auto {
  align-self: auto !important; }

.align-self-start {
  align-self: flex-start !important; }

.align-self-end {
  align-self: flex-end !important; }

.align-self-center {
  align-self: center !important; }

.align-self-baseline {
  align-self: baseline !important; }

.align-self-stretch {
  align-self: stretch !important; }

@media (min-width: 576px) {
  .flex-sm-row {
    flex-direction: row !important; }

  .flex-sm-column {
    flex-direction: column !important; }

  .flex-sm-row-reverse {
    flex-direction: row-reverse !important; }

  .flex-sm-column-reverse {
    flex-direction: column-reverse !important; }

  .flex-sm-wrap {
    flex-wrap: wrap !important; }

  .flex-sm-nowrap {
    flex-wrap: nowrap !important; }

  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important; }

  .flex-sm-fill {
    flex: 1 1 auto !important; }

  .flex-sm-grow-0 {
    flex-grow: 0 !important; }

  .flex-sm-grow-1 {
    flex-grow: 1 !important; }

  .flex-sm-shrink-0 {
    flex-shrink: 0 !important; }

  .flex-sm-shrink-1 {
    flex-shrink: 1 !important; }

  .justify-content-sm-start {
    justify-content: flex-start !important; }

  .justify-content-sm-end {
    justify-content: flex-end !important; }

  .justify-content-sm-center {
    justify-content: center !important; }

  .justify-content-sm-between {
    justify-content: space-between !important; }

  .justify-content-sm-around {
    justify-content: space-around !important; }

  .align-items-sm-start {
    align-items: flex-start !important; }

  .align-items-sm-end {
    align-items: flex-end !important; }

  .align-items-sm-center {
    align-items: center !important; }

  .align-items-sm-baseline {
    align-items: baseline !important; }

  .align-items-sm-stretch {
    align-items: stretch !important; }

  .align-content-sm-start {
    align-content: flex-start !important; }

  .align-content-sm-end {
    align-content: flex-end !important; }

  .align-content-sm-center {
    align-content: center !important; }

  .align-content-sm-between {
    align-content: space-between !important; }

  .align-content-sm-around {
    align-content: space-around !important; }

  .align-content-sm-stretch {
    align-content: stretch !important; }

  .align-self-sm-auto {
    align-self: auto !important; }

  .align-self-sm-start {
    align-self: flex-start !important; }

  .align-self-sm-end {
    align-self: flex-end !important; }

  .align-self-sm-center {
    align-self: center !important; }

  .align-self-sm-baseline {
    align-self: baseline !important; }

  .align-self-sm-stretch {
    align-self: stretch !important; } }
@media (min-width: 768px) {
  .flex-md-row {
    flex-direction: row !important; }

  .flex-md-column {
    flex-direction: column !important; }

  .flex-md-row-reverse {
    flex-direction: row-reverse !important; }

  .flex-md-column-reverse {
    flex-direction: column-reverse !important; }

  .flex-md-wrap {
    flex-wrap: wrap !important; }

  .flex-md-nowrap {
    flex-wrap: nowrap !important; }

  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important; }

  .flex-md-fill {
    flex: 1 1 auto !important; }

  .flex-md-grow-0 {
    flex-grow: 0 !important; }

  .flex-md-grow-1 {
    flex-grow: 1 !important; }

  .flex-md-shrink-0 {
    flex-shrink: 0 !important; }

  .flex-md-shrink-1 {
    flex-shrink: 1 !important; }

  .justify-content-md-start {
    justify-content: flex-start !important; }

  .justify-content-md-end {
    justify-content: flex-end !important; }

  .justify-content-md-center {
    justify-content: center !important; }

  .justify-content-md-between {
    justify-content: space-between !important; }

  .justify-content-md-around {
    justify-content: space-around !important; }

  .align-items-md-start {
    align-items: flex-start !important; }

  .align-items-md-end {
    align-items: flex-end !important; }

  .align-items-md-center {
    align-items: center !important; }

  .align-items-md-baseline {
    align-items: baseline !important; }

  .align-items-md-stretch {
    align-items: stretch !important; }

  .align-content-md-start {
    align-content: flex-start !important; }

  .align-content-md-end {
    align-content: flex-end !important; }

  .align-content-md-center {
    align-content: center !important; }

  .align-content-md-between {
    align-content: space-between !important; }

  .align-content-md-around {
    align-content: space-around !important; }

  .align-content-md-stretch {
    align-content: stretch !important; }

  .align-self-md-auto {
    align-self: auto !important; }

  .align-self-md-start {
    align-self: flex-start !important; }

  .align-self-md-end {
    align-self: flex-end !important; }

  .align-self-md-center {
    align-self: center !important; }

  .align-self-md-baseline {
    align-self: baseline !important; }

  .align-self-md-stretch {
    align-self: stretch !important; } }
@media (min-width: 992px) {
  .flex-lg-row {
    flex-direction: row !important; }

  .flex-lg-column {
    flex-direction: column !important; }

  .flex-lg-row-reverse {
    flex-direction: row-reverse !important; }

  .flex-lg-column-reverse {
    flex-direction: column-reverse !important; }

  .flex-lg-wrap {
    flex-wrap: wrap !important; }

  .flex-lg-nowrap {
    flex-wrap: nowrap !important; }

  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important; }

  .flex-lg-fill {
    flex: 1 1 auto !important; }

  .flex-lg-grow-0 {
    flex-grow: 0 !important; }

  .flex-lg-grow-1 {
    flex-grow: 1 !important; }

  .flex-lg-shrink-0 {
    flex-shrink: 0 !important; }

  .flex-lg-shrink-1 {
    flex-shrink: 1 !important; }

  .justify-content-lg-start {
    justify-content: flex-start !important; }

  .justify-content-lg-end {
    justify-content: flex-end !important; }

  .justify-content-lg-center {
    justify-content: center !important; }

  .justify-content-lg-between {
    justify-content: space-between !important; }

  .justify-content-lg-around {
    justify-content: space-around !important; }

  .align-items-lg-start {
    align-items: flex-start !important; }

  .align-items-lg-end {
    align-items: flex-end !important; }

  .align-items-lg-center {
    align-items: center !important; }

  .align-items-lg-baseline {
    align-items: baseline !important; }

  .align-items-lg-stretch {
    align-items: stretch !important; }

  .align-content-lg-start {
    align-content: flex-start !important; }

  .align-content-lg-end {
    align-content: flex-end !important; }

  .align-content-lg-center {
    align-content: center !important; }

  .align-content-lg-between {
    align-content: space-between !important; }

  .align-content-lg-around {
    align-content: space-around !important; }

  .align-content-lg-stretch {
    align-content: stretch !important; }

  .align-self-lg-auto {
    align-self: auto !important; }

  .align-self-lg-start {
    align-self: flex-start !important; }

  .align-self-lg-end {
    align-self: flex-end !important; }

  .align-self-lg-center {
    align-self: center !important; }

  .align-self-lg-baseline {
    align-self: baseline !important; }

  .align-self-lg-stretch {
    align-self: stretch !important; } }
@media (min-width: 1200px) {
  .flex-xl-row {
    flex-direction: row !important; }

  .flex-xl-column {
    flex-direction: column !important; }

  .flex-xl-row-reverse {
    flex-direction: row-reverse !important; }

  .flex-xl-column-reverse {
    flex-direction: column-reverse !important; }

  .flex-xl-wrap {
    flex-wrap: wrap !important; }

  .flex-xl-nowrap {
    flex-wrap: nowrap !important; }

  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important; }

  .flex-xl-fill {
    flex: 1 1 auto !important; }

  .flex-xl-grow-0 {
    flex-grow: 0 !important; }

  .flex-xl-grow-1 {
    flex-grow: 1 !important; }

  .flex-xl-shrink-0 {
    flex-shrink: 0 !important; }

  .flex-xl-shrink-1 {
    flex-shrink: 1 !important; }

  .justify-content-xl-start {
    justify-content: flex-start !important; }

  .justify-content-xl-end {
    justify-content: flex-end !important; }

  .justify-content-xl-center {
    justify-content: center !important; }

  .justify-content-xl-between {
    justify-content: space-between !important; }

  .justify-content-xl-around {
    justify-content: space-around !important; }

  .align-items-xl-start {
    align-items: flex-start !important; }

  .align-items-xl-end {
    align-items: flex-end !important; }

  .align-items-xl-center {
    align-items: center !important; }

  .align-items-xl-baseline {
    align-items: baseline !important; }

  .align-items-xl-stretch {
    align-items: stretch !important; }

  .align-content-xl-start {
    align-content: flex-start !important; }

  .align-content-xl-end {
    align-content: flex-end !important; }

  .align-content-xl-center {
    align-content: center !important; }

  .align-content-xl-between {
    align-content: space-between !important; }

  .align-content-xl-around {
    align-content: space-around !important; }

  .align-content-xl-stretch {
    align-content: stretch !important; }

  .align-self-xl-auto {
    align-self: auto !important; }

  .align-self-xl-start {
    align-self: flex-start !important; }

  .align-self-xl-end {
    align-self: flex-end !important; }

  .align-self-xl-center {
    align-self: center !important; }

  .align-self-xl-baseline {
    align-self: baseline !important; }

  .align-self-xl-stretch {
    align-self: stretch !important; } }
.float-left {
  float: left !important; }

.float-right {
  float: right !important; }

.float-none {
  float: none !important; }

@media (min-width: 576px) {
  .float-sm-left {
    float: left !important; }

  .float-sm-right {
    float: right !important; }

  .float-sm-none {
    float: none !important; } }
@media (min-width: 768px) {
  .float-md-left {
    float: left !important; }

  .float-md-right {
    float: right !important; }

  .float-md-none {
    float: none !important; } }
@media (min-width: 992px) {
  .float-lg-left {
    float: left !important; }

  .float-lg-right {
    float: right !important; }

  .float-lg-none {
    float: none !important; } }
@media (min-width: 1200px) {
  .float-xl-left {
    float: left !important; }

  .float-xl-right {
    float: right !important; }

  .float-xl-none {
    float: none !important; } }
.position-static {
  position: static !important; }

.position-relative {
  position: relative !important; }

.position-absolute {
  position: absolute !important; }

.position-fixed {
  position: fixed !important; }

.position-sticky {
  position: sticky !important; }

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030; }

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030; }

@supports (position: sticky) {
  .sticky-top {
    position: sticky;
    top: 0;
    z-index: 1020; } }

.sr-only, .bootstrap-datetimepicker-widget .btn[data-action="incrementHours"]::after, .bootstrap-datetimepicker-widget .btn[data-action="incrementMinutes"]::after, .bootstrap-datetimepicker-widget .btn[data-action="decrementHours"]::after, .bootstrap-datetimepicker-widget .btn[data-action="decrementMinutes"]::after, .bootstrap-datetimepicker-widget .btn[data-action="showHours"]::after, .bootstrap-datetimepicker-widget .btn[data-action="showMinutes"]::after, .bootstrap-datetimepicker-widget .btn[data-action="togglePeriod"]::after, .bootstrap-datetimepicker-widget .btn[data-action="clear"]::after, .bootstrap-datetimepicker-widget .btn[data-action="today"]::after, .bootstrap-datetimepicker-widget .picker-switch::after, .bootstrap-datetimepicker-widget table th.prev::after, .bootstrap-datetimepicker-widget table th.next::after {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0; }

.sr-only-focusable:active, .sr-only-focusable:focus {
  position: static;
  width: auto;
  height: auto;
  overflow: visible;
  clip: auto;
  white-space: normal; }

.shadow-sm {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important; }

.shadow {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important; }

.shadow-lg {
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important; }

.shadow-none {
  box-shadow: none !important; }

.w-25 {
  width: 25% !important; }

.w-50 {
  width: 50% !important; }

.w-75 {
  width: 75% !important; }

.w-100 {
  width: 100% !important; }

.w-auto {
  width: auto !important; }

.h-25 {
  height: 25% !important; }

.h-50 {
  height: 50% !important; }

.h-75 {
  height: 75% !important; }

.h-100 {
  height: 100% !important; }

.h-auto {
  height: auto !important; }

.mw-100 {
  max-width: 100% !important; }

.mh-100 {
  max-height: 100% !important; }

.m-0 {
  margin: 0 !important; }

.mt-0,
.my-0 {
  margin-top: 0 !important; }

.mr-0,
.mx-0 {
  margin-right: 0 !important; }

.mb-0,
.my-0 {
  margin-bottom: 0 !important; }

.ml-0,
.mx-0 {
  margin-left: 0 !important; }

.m-1 {
  margin: 0.25rem !important; }

.mt-1,
.my-1 {
  margin-top: 0.25rem !important; }

.mr-1,
.mx-1 {
  margin-right: 0.25rem !important; }

.mb-1,
.my-1 {
  margin-bottom: 0.25rem !important; }

.ml-1,
.mx-1 {
  margin-left: 0.25rem !important; }

.m-2 {
  margin: 0.5rem !important; }

.mt-2,
.my-2 {
  margin-top: 0.5rem !important; }

.mr-2,
.mx-2 {
  margin-right: 0.5rem !important; }

.mb-2,
.my-2 {
  margin-bottom: 0.5rem !important; }

.ml-2,
.mx-2 {
  margin-left: 0.5rem !important; }

.m-3 {
  margin: 1rem !important; }

.mt-3,
.my-3 {
  margin-top: 1rem !important; }

.mr-3,
.mx-3 {
  margin-right: 1rem !important; }

.mb-3,
.my-3 {
  margin-bottom: 1rem !important; }

.ml-3,
.mx-3 {
  margin-left: 1rem !important; }

.m-4 {
  margin: 1.5rem !important; }

.mt-4,
.my-4 {
  margin-top: 1.5rem !important; }

.mr-4,
.mx-4 {
  margin-right: 1.5rem !important; }

.mb-4,
.my-4 {
  margin-bottom: 1.5rem !important; }

.ml-4,
.mx-4 {
  margin-left: 1.5rem !important; }

.m-5 {
  margin: 3rem !important; }

.mt-5,
.my-5 {
  margin-top: 3rem !important; }

.mr-5,
.mx-5 {
  margin-right: 3rem !important; }

.mb-5,
.my-5 {
  margin-bottom: 3rem !important; }

.ml-5,
.mx-5 {
  margin-left: 3rem !important; }

.p-0 {
  padding: 0 !important; }

.pt-0,
.py-0 {
  padding-top: 0 !important; }

.pr-0,
.px-0 {
  padding-right: 0 !important; }

.pb-0,
.py-0 {
  padding-bottom: 0 !important; }

.pl-0,
.px-0 {
  padding-left: 0 !important; }

.p-1 {
  padding: 0.25rem !important; }

.pt-1,
.py-1 {
  padding-top: 0.25rem !important; }

.pr-1,
.px-1 {
  padding-right: 0.25rem !important; }

.pb-1,
.py-1 {
  padding-bottom: 0.25rem !important; }

.pl-1,
.px-1 {
  padding-left: 0.25rem !important; }

.p-2 {
  padding: 0.5rem !important; }

.pt-2,
.py-2 {
  padding-top: 0.5rem !important; }

.pr-2,
.px-2 {
  padding-right: 0.5rem !important; }

.pb-2,
.py-2 {
  padding-bottom: 0.5rem !important; }

.pl-2,
.px-2 {
  padding-left: 0.5rem !important; }

.p-3 {
  padding: 1rem !important; }

.pt-3,
.py-3 {
  padding-top: 1rem !important; }

.pr-3,
.px-3 {
  padding-right: 1rem !important; }

.pb-3,
.py-3 {
  padding-bottom: 1rem !important; }

.pl-3,
.px-3 {
  padding-left: 1rem !important; }

.p-4 {
  padding: 1.5rem !important; }

.pt-4,
.py-4 {
  padding-top: 1.5rem !important; }

.pr-4,
.px-4 {
  padding-right: 1.5rem !important; }

.pb-4,
.py-4 {
  padding-bottom: 1.5rem !important; }

.pl-4,
.px-4 {
  padding-left: 1.5rem !important; }

.p-5 {
  padding: 3rem !important; }

.pt-5,
.py-5 {
  padding-top: 3rem !important; }

.pr-5,
.px-5 {
  padding-right: 3rem !important; }

.pb-5,
.py-5 {
  padding-bottom: 3rem !important; }

.pl-5,
.px-5 {
  padding-left: 3rem !important; }

.m-auto {
  margin: auto !important; }

.mt-auto,
.my-auto {
  margin-top: auto !important; }

.mr-auto,
.mx-auto {
  margin-right: auto !important; }

.mb-auto,
.my-auto {
  margin-bottom: auto !important; }

.ml-auto,
.mx-auto {
  margin-left: auto !important; }

@media (min-width: 576px) {
  .m-sm-0 {
    margin: 0 !important; }

  .mt-sm-0,
  .my-sm-0 {
    margin-top: 0 !important; }

  .mr-sm-0,
  .mx-sm-0 {
    margin-right: 0 !important; }

  .mb-sm-0,
  .my-sm-0 {
    margin-bottom: 0 !important; }

  .ml-sm-0,
  .mx-sm-0 {
    margin-left: 0 !important; }

  .m-sm-1 {
    margin: 0.25rem !important; }

  .mt-sm-1,
  .my-sm-1 {
    margin-top: 0.25rem !important; }

  .mr-sm-1,
  .mx-sm-1 {
    margin-right: 0.25rem !important; }

  .mb-sm-1,
  .my-sm-1 {
    margin-bottom: 0.25rem !important; }

  .ml-sm-1,
  .mx-sm-1 {
    margin-left: 0.25rem !important; }

  .m-sm-2 {
    margin: 0.5rem !important; }

  .mt-sm-2,
  .my-sm-2 {
    margin-top: 0.5rem !important; }

  .mr-sm-2,
  .mx-sm-2 {
    margin-right: 0.5rem !important; }

  .mb-sm-2,
  .my-sm-2 {
    margin-bottom: 0.5rem !important; }

  .ml-sm-2,
  .mx-sm-2 {
    margin-left: 0.5rem !important; }

  .m-sm-3 {
    margin: 1rem !important; }

  .mt-sm-3,
  .my-sm-3 {
    margin-top: 1rem !important; }

  .mr-sm-3,
  .mx-sm-3 {
    margin-right: 1rem !important; }

  .mb-sm-3,
  .my-sm-3 {
    margin-bottom: 1rem !important; }

  .ml-sm-3,
  .mx-sm-3 {
    margin-left: 1rem !important; }

  .m-sm-4 {
    margin: 1.5rem !important; }

  .mt-sm-4,
  .my-sm-4 {
    margin-top: 1.5rem !important; }

  .mr-sm-4,
  .mx-sm-4 {
    margin-right: 1.5rem !important; }

  .mb-sm-4,
  .my-sm-4 {
    margin-bottom: 1.5rem !important; }

  .ml-sm-4,
  .mx-sm-4 {
    margin-left: 1.5rem !important; }

  .m-sm-5 {
    margin: 3rem !important; }

  .mt-sm-5,
  .my-sm-5 {
    margin-top: 3rem !important; }

  .mr-sm-5,
  .mx-sm-5 {
    margin-right: 3rem !important; }

  .mb-sm-5,
  .my-sm-5 {
    margin-bottom: 3rem !important; }

  .ml-sm-5,
  .mx-sm-5 {
    margin-left: 3rem !important; }

  .p-sm-0 {
    padding: 0 !important; }

  .pt-sm-0,
  .py-sm-0 {
    padding-top: 0 !important; }

  .pr-sm-0,
  .px-sm-0 {
    padding-right: 0 !important; }

  .pb-sm-0,
  .py-sm-0 {
    padding-bottom: 0 !important; }

  .pl-sm-0,
  .px-sm-0 {
    padding-left: 0 !important; }

  .p-sm-1 {
    padding: 0.25rem !important; }

  .pt-sm-1,
  .py-sm-1 {
    padding-top: 0.25rem !important; }

  .pr-sm-1,
  .px-sm-1 {
    padding-right: 0.25rem !important; }

  .pb-sm-1,
  .py-sm-1 {
    padding-bottom: 0.25rem !important; }

  .pl-sm-1,
  .px-sm-1 {
    padding-left: 0.25rem !important; }

  .p-sm-2 {
    padding: 0.5rem !important; }

  .pt-sm-2,
  .py-sm-2 {
    padding-top: 0.5rem !important; }

  .pr-sm-2,
  .px-sm-2 {
    padding-right: 0.5rem !important; }

  .pb-sm-2,
  .py-sm-2 {
    padding-bottom: 0.5rem !important; }

  .pl-sm-2,
  .px-sm-2 {
    padding-left: 0.5rem !important; }

  .p-sm-3 {
    padding: 1rem !important; }

  .pt-sm-3,
  .py-sm-3 {
    padding-top: 1rem !important; }

  .pr-sm-3,
  .px-sm-3 {
    padding-right: 1rem !important; }

  .pb-sm-3,
  .py-sm-3 {
    padding-bottom: 1rem !important; }

  .pl-sm-3,
  .px-sm-3 {
    padding-left: 1rem !important; }

  .p-sm-4 {
    padding: 1.5rem !important; }

  .pt-sm-4,
  .py-sm-4 {
    padding-top: 1.5rem !important; }

  .pr-sm-4,
  .px-sm-4 {
    padding-right: 1.5rem !important; }

  .pb-sm-4,
  .py-sm-4 {
    padding-bottom: 1.5rem !important; }

  .pl-sm-4,
  .px-sm-4 {
    padding-left: 1.5rem !important; }

  .p-sm-5 {
    padding: 3rem !important; }

  .pt-sm-5,
  .py-sm-5 {
    padding-top: 3rem !important; }

  .pr-sm-5,
  .px-sm-5 {
    padding-right: 3rem !important; }

  .pb-sm-5,
  .py-sm-5 {
    padding-bottom: 3rem !important; }

  .pl-sm-5,
  .px-sm-5 {
    padding-left: 3rem !important; }

  .m-sm-auto {
    margin: auto !important; }

  .mt-sm-auto,
  .my-sm-auto {
    margin-top: auto !important; }

  .mr-sm-auto,
  .mx-sm-auto {
    margin-right: auto !important; }

  .mb-sm-auto,
  .my-sm-auto {
    margin-bottom: auto !important; }

  .ml-sm-auto,
  .mx-sm-auto {
    margin-left: auto !important; } }
@media (min-width: 768px) {
  .m-md-0 {
    margin: 0 !important; }

  .mt-md-0,
  .my-md-0 {
    margin-top: 0 !important; }

  .mr-md-0,
  .mx-md-0 {
    margin-right: 0 !important; }

  .mb-md-0,
  .my-md-0 {
    margin-bottom: 0 !important; }

  .ml-md-0,
  .mx-md-0 {
    margin-left: 0 !important; }

  .m-md-1 {
    margin: 0.25rem !important; }

  .mt-md-1,
  .my-md-1 {
    margin-top: 0.25rem !important; }

  .mr-md-1,
  .mx-md-1 {
    margin-right: 0.25rem !important; }

  .mb-md-1,
  .my-md-1 {
    margin-bottom: 0.25rem !important; }

  .ml-md-1,
  .mx-md-1 {
    margin-left: 0.25rem !important; }

  .m-md-2 {
    margin: 0.5rem !important; }

  .mt-md-2,
  .my-md-2 {
    margin-top: 0.5rem !important; }

  .mr-md-2,
  .mx-md-2 {
    margin-right: 0.5rem !important; }

  .mb-md-2,
  .my-md-2 {
    margin-bottom: 0.5rem !important; }

  .ml-md-2,
  .mx-md-2 {
    margin-left: 0.5rem !important; }

  .m-md-3 {
    margin: 1rem !important; }

  .mt-md-3,
  .my-md-3 {
    margin-top: 1rem !important; }

  .mr-md-3,
  .mx-md-3 {
    margin-right: 1rem !important; }

  .mb-md-3,
  .my-md-3 {
    margin-bottom: 1rem !important; }

  .ml-md-3,
  .mx-md-3 {
    margin-left: 1rem !important; }

  .m-md-4 {
    margin: 1.5rem !important; }

  .mt-md-4,
  .my-md-4 {
    margin-top: 1.5rem !important; }

  .mr-md-4,
  .mx-md-4 {
    margin-right: 1.5rem !important; }

  .mb-md-4,
  .my-md-4 {
    margin-bottom: 1.5rem !important; }

  .ml-md-4,
  .mx-md-4 {
    margin-left: 1.5rem !important; }

  .m-md-5 {
    margin: 3rem !important; }

  .mt-md-5,
  .my-md-5 {
    margin-top: 3rem !important; }

  .mr-md-5,
  .mx-md-5 {
    margin-right: 3rem !important; }

  .mb-md-5,
  .my-md-5 {
    margin-bottom: 3rem !important; }

  .ml-md-5,
  .mx-md-5 {
    margin-left: 3rem !important; }

  .p-md-0 {
    padding: 0 !important; }

  .pt-md-0,
  .py-md-0 {
    padding-top: 0 !important; }

  .pr-md-0,
  .px-md-0 {
    padding-right: 0 !important; }

  .pb-md-0,
  .py-md-0 {
    padding-bottom: 0 !important; }

  .pl-md-0,
  .px-md-0 {
    padding-left: 0 !important; }

  .p-md-1 {
    padding: 0.25rem !important; }

  .pt-md-1,
  .py-md-1 {
    padding-top: 0.25rem !important; }

  .pr-md-1,
  .px-md-1 {
    padding-right: 0.25rem !important; }

  .pb-md-1,
  .py-md-1 {
    padding-bottom: 0.25rem !important; }

  .pl-md-1,
  .px-md-1 {
    padding-left: 0.25rem !important; }

  .p-md-2 {
    padding: 0.5rem !important; }

  .pt-md-2,
  .py-md-2 {
    padding-top: 0.5rem !important; }

  .pr-md-2,
  .px-md-2 {
    padding-right: 0.5rem !important; }

  .pb-md-2,
  .py-md-2 {
    padding-bottom: 0.5rem !important; }

  .pl-md-2,
  .px-md-2 {
    padding-left: 0.5rem !important; }

  .p-md-3 {
    padding: 1rem !important; }

  .pt-md-3,
  .py-md-3 {
    padding-top: 1rem !important; }

  .pr-md-3,
  .px-md-3 {
    padding-right: 1rem !important; }

  .pb-md-3,
  .py-md-3 {
    padding-bottom: 1rem !important; }

  .pl-md-3,
  .px-md-3 {
    padding-left: 1rem !important; }

  .p-md-4 {
    padding: 1.5rem !important; }

  .pt-md-4,
  .py-md-4 {
    padding-top: 1.5rem !important; }

  .pr-md-4,
  .px-md-4 {
    padding-right: 1.5rem !important; }

  .pb-md-4,
  .py-md-4 {
    padding-bottom: 1.5rem !important; }

  .pl-md-4,
  .px-md-4 {
    padding-left: 1.5rem !important; }

  .p-md-5 {
    padding: 3rem !important; }

  .pt-md-5,
  .py-md-5 {
    padding-top: 3rem !important; }

  .pr-md-5,
  .px-md-5 {
    padding-right: 3rem !important; }

  .pb-md-5,
  .py-md-5 {
    padding-bottom: 3rem !important; }

  .pl-md-5,
  .px-md-5 {
    padding-left: 3rem !important; }

  .m-md-auto {
    margin: auto !important; }

  .mt-md-auto,
  .my-md-auto {
    margin-top: auto !important; }

  .mr-md-auto,
  .mx-md-auto {
    margin-right: auto !important; }

  .mb-md-auto,
  .my-md-auto {
    margin-bottom: auto !important; }

  .ml-md-auto,
  .mx-md-auto {
    margin-left: auto !important; } }
@media (min-width: 992px) {
  .m-lg-0 {
    margin: 0 !important; }

  .mt-lg-0,
  .my-lg-0 {
    margin-top: 0 !important; }

  .mr-lg-0,
  .mx-lg-0 {
    margin-right: 0 !important; }

  .mb-lg-0,
  .my-lg-0 {
    margin-bottom: 0 !important; }

  .ml-lg-0,
  .mx-lg-0 {
    margin-left: 0 !important; }

  .m-lg-1 {
    margin: 0.25rem !important; }

  .mt-lg-1,
  .my-lg-1 {
    margin-top: 0.25rem !important; }

  .mr-lg-1,
  .mx-lg-1 {
    margin-right: 0.25rem !important; }

  .mb-lg-1,
  .my-lg-1 {
    margin-bottom: 0.25rem !important; }

  .ml-lg-1,
  .mx-lg-1 {
    margin-left: 0.25rem !important; }

  .m-lg-2 {
    margin: 0.5rem !important; }

  .mt-lg-2,
  .my-lg-2 {
    margin-top: 0.5rem !important; }

  .mr-lg-2,
  .mx-lg-2 {
    margin-right: 0.5rem !important; }

  .mb-lg-2,
  .my-lg-2 {
    margin-bottom: 0.5rem !important; }

  .ml-lg-2,
  .mx-lg-2 {
    margin-left: 0.5rem !important; }

  .m-lg-3 {
    margin: 1rem !important; }

  .mt-lg-3,
  .my-lg-3 {
    margin-top: 1rem !important; }

  .mr-lg-3,
  .mx-lg-3 {
    margin-right: 1rem !important; }

  .mb-lg-3,
  .my-lg-3 {
    margin-bottom: 1rem !important; }

  .ml-lg-3,
  .mx-lg-3 {
    margin-left: 1rem !important; }

  .m-lg-4 {
    margin: 1.5rem !important; }

  .mt-lg-4,
  .my-lg-4 {
    margin-top: 1.5rem !important; }

  .mr-lg-4,
  .mx-lg-4 {
    margin-right: 1.5rem !important; }

  .mb-lg-4,
  .my-lg-4 {
    margin-bottom: 1.5rem !important; }

  .ml-lg-4,
  .mx-lg-4 {
    margin-left: 1.5rem !important; }

  .m-lg-5 {
    margin: 3rem !important; }

  .mt-lg-5,
  .my-lg-5 {
    margin-top: 3rem !important; }

  .mr-lg-5,
  .mx-lg-5 {
    margin-right: 3rem !important; }

  .mb-lg-5,
  .my-lg-5 {
    margin-bottom: 3rem !important; }

  .ml-lg-5,
  .mx-lg-5 {
    margin-left: 3rem !important; }

  .p-lg-0 {
    padding: 0 !important; }

  .pt-lg-0,
  .py-lg-0 {
    padding-top: 0 !important; }

  .pr-lg-0,
  .px-lg-0 {
    padding-right: 0 !important; }

  .pb-lg-0,
  .py-lg-0 {
    padding-bottom: 0 !important; }

  .pl-lg-0,
  .px-lg-0 {
    padding-left: 0 !important; }

  .p-lg-1 {
    padding: 0.25rem !important; }

  .pt-lg-1,
  .py-lg-1 {
    padding-top: 0.25rem !important; }

  .pr-lg-1,
  .px-lg-1 {
    padding-right: 0.25rem !important; }

  .pb-lg-1,
  .py-lg-1 {
    padding-bottom: 0.25rem !important; }

  .pl-lg-1,
  .px-lg-1 {
    padding-left: 0.25rem !important; }

  .p-lg-2 {
    padding: 0.5rem !important; }

  .pt-lg-2,
  .py-lg-2 {
    padding-top: 0.5rem !important; }

  .pr-lg-2,
  .px-lg-2 {
    padding-right: 0.5rem !important; }

  .pb-lg-2,
  .py-lg-2 {
    padding-bottom: 0.5rem !important; }

  .pl-lg-2,
  .px-lg-2 {
    padding-left: 0.5rem !important; }

  .p-lg-3 {
    padding: 1rem !important; }

  .pt-lg-3,
  .py-lg-3 {
    padding-top: 1rem !important; }

  .pr-lg-3,
  .px-lg-3 {
    padding-right: 1rem !important; }

  .pb-lg-3,
  .py-lg-3 {
    padding-bottom: 1rem !important; }

  .pl-lg-3,
  .px-lg-3 {
    padding-left: 1rem !important; }

  .p-lg-4 {
    padding: 1.5rem !important; }

  .pt-lg-4,
  .py-lg-4 {
    padding-top: 1.5rem !important; }

  .pr-lg-4,
  .px-lg-4 {
    padding-right: 1.5rem !important; }

  .pb-lg-4,
  .py-lg-4 {
    padding-bottom: 1.5rem !important; }

  .pl-lg-4,
  .px-lg-4 {
    padding-left: 1.5rem !important; }

  .p-lg-5 {
    padding: 3rem !important; }

  .pt-lg-5,
  .py-lg-5 {
    padding-top: 3rem !important; }

  .pr-lg-5,
  .px-lg-5 {
    padding-right: 3rem !important; }

  .pb-lg-5,
  .py-lg-5 {
    padding-bottom: 3rem !important; }

  .pl-lg-5,
  .px-lg-5 {
    padding-left: 3rem !important; }

  .m-lg-auto {
    margin: auto !important; }

  .mt-lg-auto,
  .my-lg-auto {
    margin-top: auto !important; }

  .mr-lg-auto,
  .mx-lg-auto {
    margin-right: auto !important; }

  .mb-lg-auto,
  .my-lg-auto {
    margin-bottom: auto !important; }

  .ml-lg-auto,
  .mx-lg-auto {
    margin-left: auto !important; } }
@media (min-width: 1200px) {
  .m-xl-0 {
    margin: 0 !important; }

  .mt-xl-0,
  .my-xl-0 {
    margin-top: 0 !important; }

  .mr-xl-0,
  .mx-xl-0 {
    margin-right: 0 !important; }

  .mb-xl-0,
  .my-xl-0 {
    margin-bottom: 0 !important; }

  .ml-xl-0,
  .mx-xl-0 {
    margin-left: 0 !important; }

  .m-xl-1 {
    margin: 0.25rem !important; }

  .mt-xl-1,
  .my-xl-1 {
    margin-top: 0.25rem !important; }

  .mr-xl-1,
  .mx-xl-1 {
    margin-right: 0.25rem !important; }

  .mb-xl-1,
  .my-xl-1 {
    margin-bottom: 0.25rem !important; }

  .ml-xl-1,
  .mx-xl-1 {
    margin-left: 0.25rem !important; }

  .m-xl-2 {
    margin: 0.5rem !important; }

  .mt-xl-2,
  .my-xl-2 {
    margin-top: 0.5rem !important; }

  .mr-xl-2,
  .mx-xl-2 {
    margin-right: 0.5rem !important; }

  .mb-xl-2,
  .my-xl-2 {
    margin-bottom: 0.5rem !important; }

  .ml-xl-2,
  .mx-xl-2 {
    margin-left: 0.5rem !important; }

  .m-xl-3 {
    margin: 1rem !important; }

  .mt-xl-3,
  .my-xl-3 {
    margin-top: 1rem !important; }

  .mr-xl-3,
  .mx-xl-3 {
    margin-right: 1rem !important; }

  .mb-xl-3,
  .my-xl-3 {
    margin-bottom: 1rem !important; }

  .ml-xl-3,
  .mx-xl-3 {
    margin-left: 1rem !important; }

  .m-xl-4 {
    margin: 1.5rem !important; }

  .mt-xl-4,
  .my-xl-4 {
    margin-top: 1.5rem !important; }

  .mr-xl-4,
  .mx-xl-4 {
    margin-right: 1.5rem !important; }

  .mb-xl-4,
  .my-xl-4 {
    margin-bottom: 1.5rem !important; }

  .ml-xl-4,
  .mx-xl-4 {
    margin-left: 1.5rem !important; }

  .m-xl-5 {
    margin: 3rem !important; }

  .mt-xl-5,
  .my-xl-5 {
    margin-top: 3rem !important; }

  .mr-xl-5,
  .mx-xl-5 {
    margin-right: 3rem !important; }

  .mb-xl-5,
  .my-xl-5 {
    margin-bottom: 3rem !important; }

  .ml-xl-5,
  .mx-xl-5 {
    margin-left: 3rem !important; }

  .p-xl-0 {
    padding: 0 !important; }

  .pt-xl-0,
  .py-xl-0 {
    padding-top: 0 !important; }

  .pr-xl-0,
  .px-xl-0 {
    padding-right: 0 !important; }

  .pb-xl-0,
  .py-xl-0 {
    padding-bottom: 0 !important; }

  .pl-xl-0,
  .px-xl-0 {
    padding-left: 0 !important; }

  .p-xl-1 {
    padding: 0.25rem !important; }

  .pt-xl-1,
  .py-xl-1 {
    padding-top: 0.25rem !important; }

  .pr-xl-1,
  .px-xl-1 {
    padding-right: 0.25rem !important; }

  .pb-xl-1,
  .py-xl-1 {
    padding-bottom: 0.25rem !important; }

  .pl-xl-1,
  .px-xl-1 {
    padding-left: 0.25rem !important; }

  .p-xl-2 {
    padding: 0.5rem !important; }

  .pt-xl-2,
  .py-xl-2 {
    padding-top: 0.5rem !important; }

  .pr-xl-2,
  .px-xl-2 {
    padding-right: 0.5rem !important; }

  .pb-xl-2,
  .py-xl-2 {
    padding-bottom: 0.5rem !important; }

  .pl-xl-2,
  .px-xl-2 {
    padding-left: 0.5rem !important; }

  .p-xl-3 {
    padding: 1rem !important; }

  .pt-xl-3,
  .py-xl-3 {
    padding-top: 1rem !important; }

  .pr-xl-3,
  .px-xl-3 {
    padding-right: 1rem !important; }

  .pb-xl-3,
  .py-xl-3 {
    padding-bottom: 1rem !important; }

  .pl-xl-3,
  .px-xl-3 {
    padding-left: 1rem !important; }

  .p-xl-4 {
    padding: 1.5rem !important; }

  .pt-xl-4,
  .py-xl-4 {
    padding-top: 1.5rem !important; }

  .pr-xl-4,
  .px-xl-4 {
    padding-right: 1.5rem !important; }

  .pb-xl-4,
  .py-xl-4 {
    padding-bottom: 1.5rem !important; }

  .pl-xl-4,
  .px-xl-4 {
    padding-left: 1.5rem !important; }

  .p-xl-5 {
    padding: 3rem !important; }

  .pt-xl-5,
  .py-xl-5 {
    padding-top: 3rem !important; }

  .pr-xl-5,
  .px-xl-5 {
    padding-right: 3rem !important; }

  .pb-xl-5,
  .py-xl-5 {
    padding-bottom: 3rem !important; }

  .pl-xl-5,
  .px-xl-5 {
    padding-left: 3rem !important; }

  .m-xl-auto {
    margin: auto !important; }

  .mt-xl-auto,
  .my-xl-auto {
    margin-top: auto !important; }

  .mr-xl-auto,
  .mx-xl-auto {
    margin-right: auto !important; }

  .mb-xl-auto,
  .my-xl-auto {
    margin-bottom: auto !important; }

  .ml-xl-auto,
  .mx-xl-auto {
    margin-left: auto !important; } }
.text-monospace {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; }

.text-justify {
  text-align: justify !important; }

.text-nowrap {
  white-space: nowrap !important; }

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; }

.text-left {
  text-align: left !important; }

.text-right {
  text-align: right !important; }

.text-center {
  text-align: center !important; }

@media (min-width: 576px) {
  .text-sm-left {
    text-align: left !important; }

  .text-sm-right {
    text-align: right !important; }

  .text-sm-center {
    text-align: center !important; } }
@media (min-width: 768px) {
  .text-md-left {
    text-align: left !important; }

  .text-md-right {
    text-align: right !important; }

  .text-md-center {
    text-align: center !important; } }
@media (min-width: 992px) {
  .text-lg-left {
    text-align: left !important; }

  .text-lg-right {
    text-align: right !important; }

  .text-lg-center {
    text-align: center !important; } }
@media (min-width: 1200px) {
  .text-xl-left {
    text-align: left !important; }

  .text-xl-right {
    text-align: right !important; }

  .text-xl-center {
    text-align: center !important; } }
.text-lowercase {
  text-transform: lowercase !important; }

.text-uppercase {
  text-transform: uppercase !important; }

.text-capitalize {
  text-transform: capitalize !important; }

.font-weight-light {
  font-weight: 300 !important; }

.font-weight-normal {
  font-weight: 400 !important; }

.font-weight-bold {
  font-weight: 700 !important; }

.font-italic {
  font-style: italic !important; }

.text-white {
  color: #fff !important; }

.text-primary {
  color: #007bff !important; }

a.text-primary:hover, a.text-primary:focus {
  color: #0062cc !important; }

.text-secondary {
  color: #6c757d !important; }

a.text-secondary:hover, a.text-secondary:focus {
  color: #545b62 !important; }

.text-success {
  color: #28a745 !important; }

a.text-success:hover, a.text-success:focus {
  color: #1e7e34 !important; }

.text-info {
  color: #17a2b8 !important; }

a.text-info:hover, a.text-info:focus {
  color: #117a8b !important; }

.text-warning {
  color: #ffc107 !important; }

a.text-warning:hover, a.text-warning:focus {
  color: #d39e00 !important; }

.text-danger {
  color: #dc3545 !important; }

a.text-danger:hover, a.text-danger:focus {
  color: #bd2130 !important; }

.text-light {
  color: #f8f9fa !important; }

a.text-light:hover, a.text-light:focus {
  color: #dae0e5 !important; }

.text-dark {
  color: #343a40 !important; }

a.text-dark:hover, a.text-dark:focus {
  color: #1d2124 !important; }

.text-body {
  color: #212529 !important; }

.text-muted {
  color: #6c757d !important; }

.text-black-50 {
  color: rgba(0, 0, 0, 0.5) !important; }

.text-white-50 {
  color: rgba(255, 255, 255, 0.5) !important; }

.text-hide {
  font: 0/0 a;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  border: 0; }

.visible {
  visibility: visible !important; }

.invisible {
  visibility: hidden !important; }

@media print {
  *,
  *::before,
  *::after {
    text-shadow: none !important;
    box-shadow: none !important; }

  a:not(.btn) {
    text-decoration: underline; }

  abbr[title]::after {
    content: " (" attr(title) ")"; }

  pre {
    white-space: pre-wrap !important; }

  pre,
  blockquote {
    border: 1px solid #adb5bd;
    page-break-inside: avoid; }

  thead {
    display: table-header-group; }

  tr,
  img {
    page-break-inside: avoid; }

  p,
  h2,
  h3 {
    orphans: 3;
    widows: 3; }

  h2,
  h3 {
    page-break-after: avoid; }

  @page {
    size: a3; }
  body {
    min-width: 992px !important; }

  .container {
    min-width: 992px !important; }

  .navbar {
    display: none; }

  .badge {
    border: 1px solid #000; }

  .table {
    border-collapse: collapse !important; }
    .table td,
    .table th {
      background-color: #fff !important; }

  .table-bordered th,
  .table-bordered td {
    border: 1px solid #dee2e6 !important; } }
/*========Typeaheadjs css start=======*/
span.twitter-typeahead {
  width: 100%; }
  span.twitter-typeahead .tt-menu {
    width: 100%; }
  span.twitter-typeahead .tt-suggestion {
    font-size: 14px; }
  .input-group span.twitter-typeahead {
    display: flex !important;
    align-items: center;
    position: relative;
    flex: 1 1 auto;
    width: 1%; }
    .input-group span.twitter-typeahead .tt-menu, .input-group span.twitter-typeahead .tt-hint, .input-group span.twitter-typeahead .tt-input {
      width: 100%; }

/*========Typeaheadjs css end=======*/
.bootstrap-datetimepicker-widget {
  list-style: none; }
  .bootstrap-datetimepicker-widget.dropdown-menu, span.twitter-typeahead .bootstrap-datetimepicker-widget.tt-menu {
    display: block;
    margin: 2px 0;
    padding: 4px;
    width: 14rem; }
    @media (min-width: 576px) {
      .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs, span.twitter-typeahead .bootstrap-datetimepicker-widget.timepicker-sbs.tt-menu {
        width: 38em; } }
    @media (min-width: 768px) {
      .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs, span.twitter-typeahead .bootstrap-datetimepicker-widget.timepicker-sbs.tt-menu {
        width: 38em; } }
    @media (min-width: 992px) {
      .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs, span.twitter-typeahead .bootstrap-datetimepicker-widget.timepicker-sbs.tt-menu {
        width: 38em; } }
    .bootstrap-datetimepicker-widget.dropdown-menu:before, span.twitter-typeahead .bootstrap-datetimepicker-widget.tt-menu:before, .bootstrap-datetimepicker-widget.dropdown-menu:after, span.twitter-typeahead .bootstrap-datetimepicker-widget.tt-menu:after {
      content: '';
      display: inline-block;
      position: absolute; }
    .bootstrap-datetimepicker-widget.dropdown-menu.bottom:before, span.twitter-typeahead .bootstrap-datetimepicker-widget.bottom.tt-menu:before {
      border-left: 7px solid transparent;
      border-right: 7px solid transparent;
      border-bottom: 7px solid #ccc;
      border-bottom-color: rgba(0, 0, 0, 0.2);
      top: -7px;
      left: 7px; }
    .bootstrap-datetimepicker-widget.dropdown-menu.bottom:after, span.twitter-typeahead .bootstrap-datetimepicker-widget.bottom.tt-menu:after {
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      border-bottom: 6px solid white;
      top: -6px;
      left: 8px; }
    .bootstrap-datetimepicker-widget.dropdown-menu.top:before, span.twitter-typeahead .bootstrap-datetimepicker-widget.top.tt-menu:before {
      border-left: 7px solid transparent;
      border-right: 7px solid transparent;
      border-top: 7px solid #ccc;
      border-top-color: rgba(0, 0, 0, 0.2);
      bottom: -7px;
      left: 6px; }
    .bootstrap-datetimepicker-widget.dropdown-menu.top:after, span.twitter-typeahead .bootstrap-datetimepicker-widget.top.tt-menu:after {
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      border-top: 6px solid white;
      bottom: -6px;
      left: 7px; }
    .bootstrap-datetimepicker-widget.dropdown-menu.float-right:before, span.twitter-typeahead .bootstrap-datetimepicker-widget.float-right.tt-menu:before {
      left: auto;
      right: 6px; }
    .bootstrap-datetimepicker-widget.dropdown-menu.float-right:after, span.twitter-typeahead .bootstrap-datetimepicker-widget.float-right.tt-menu:after {
      left: auto;
      right: 7px; }
  .bootstrap-datetimepicker-widget .list-unstyled {
    margin: 0; }
  .bootstrap-datetimepicker-widget a[data-action] {
    padding: 6px 0; }
  .bootstrap-datetimepicker-widget a[data-action]:active {
    box-shadow: none; }
  .bootstrap-datetimepicker-widget .timepicker-hour, .bootstrap-datetimepicker-widget .timepicker-minute, .bootstrap-datetimepicker-widget .timepicker-second {
    width: 54px;
    font-weight: bold;
    font-size: 1.2em;
    margin: 0; }
  .bootstrap-datetimepicker-widget button[data-action] {
    padding: 6px; }
  .bootstrap-datetimepicker-widget .btn[data-action="incrementHours"]::after {
    content: "Increment Hours"; }
  .bootstrap-datetimepicker-widget .btn[data-action="incrementMinutes"]::after {
    content: "Increment Minutes"; }
  .bootstrap-datetimepicker-widget .btn[data-action="decrementHours"]::after {
    content: "Decrement Hours"; }
  .bootstrap-datetimepicker-widget .btn[data-action="decrementMinutes"]::after {
    content: "Decrement Minutes"; }
  .bootstrap-datetimepicker-widget .btn[data-action="showHours"]::after {
    content: "Show Hours"; }
  .bootstrap-datetimepicker-widget .btn[data-action="showMinutes"]::after {
    content: "Show Minutes"; }
  .bootstrap-datetimepicker-widget .btn[data-action="togglePeriod"]::after {
    content: "Toggle AM/PM"; }
  .bootstrap-datetimepicker-widget .btn[data-action="clear"]::after {
    content: "Clear the picker"; }
  .bootstrap-datetimepicker-widget .btn[data-action="today"]::after {
    content: "Set the date to today"; }
  .bootstrap-datetimepicker-widget .picker-switch {
    text-align: center; }
    .bootstrap-datetimepicker-widget .picker-switch::after {
      content: "Toggle Date and Time Screens"; }
    .bootstrap-datetimepicker-widget .picker-switch td {
      padding: 0;
      margin: 0;
      height: auto;
      width: auto;
      line-height: inherit; }
      .bootstrap-datetimepicker-widget .picker-switch td span {
        line-height: 2.5;
        height: 2.5em;
        width: 100%; }
  .bootstrap-datetimepicker-widget table {
    width: 100%;
    margin: 0; }
    .bootstrap-datetimepicker-widget table td, .bootstrap-datetimepicker-widget table th {
      text-align: center;
      border-radius: 0.25rem; }
    .bootstrap-datetimepicker-widget table th {
      height: 20px;
      line-height: 20px;
      width: 20px; }
      .bootstrap-datetimepicker-widget table th.picker-switch {
        width: 145px; }
      .bootstrap-datetimepicker-widget table th.disabled, .bootstrap-datetimepicker-widget table th.disabled:hover {
        background: none;
        color: #6c757d;
        cursor: not-allowed; }
      .bootstrap-datetimepicker-widget table th.prev::after {
        content: "Previous Month"; }
      .bootstrap-datetimepicker-widget table th.next::after {
        content: "Next Month"; }
    .bootstrap-datetimepicker-widget table thead tr:first-child th {
      cursor: pointer; }
      .bootstrap-datetimepicker-widget table thead tr:first-child th:hover {
        background: #e9ecef; }
    .bootstrap-datetimepicker-widget table td {
      height: 54px;
      line-height: 54px;
      width: 54px; }
      .bootstrap-datetimepicker-widget table td.cw {
        font-size: .8em;
        height: 20px;
        line-height: 20px;
        color: #6c757d; }
      .bootstrap-datetimepicker-widget table td.day {
        height: 20px;
        line-height: 20px;
        width: 20px; }
      .bootstrap-datetimepicker-widget table td.day:hover, .bootstrap-datetimepicker-widget table td.hour:hover, .bootstrap-datetimepicker-widget table td.minute:hover, .bootstrap-datetimepicker-widget table td.second:hover {
        background: #e9ecef;
        cursor: pointer; }
      .bootstrap-datetimepicker-widget table td.old, .bootstrap-datetimepicker-widget table td.new {
        color: #6c757d; }
      .bootstrap-datetimepicker-widget table td.today {
        position: relative; }
        .bootstrap-datetimepicker-widget table td.today:before {
          content: '';
          display: inline-block;
          border: solid transparent;
          border-width: 0 0 7px 7px;
          border-bottom-color: #ab8ce4;
          border-top-color: rgba(0, 0, 0, 0.2);
          position: absolute;
          bottom: 4px;
          right: 4px; }
      .bootstrap-datetimepicker-widget table td.active, .bootstrap-datetimepicker-widget table td.active:hover {
        background-color: #ab8ce4;
        color: #fff;
        text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25); }
      .bootstrap-datetimepicker-widget table td.active.today:before {
        border-bottom-color: #fff; }
      .bootstrap-datetimepicker-widget table td.disabled, .bootstrap-datetimepicker-widget table td.disabled:hover {
        background: none;
        color: #6c757d;
        cursor: not-allowed; }
      .bootstrap-datetimepicker-widget table td span {
        display: inline-block;
        width: 54px;
        height: 54px;
        line-height: 54px;
        margin: 2px 1.5px;
        cursor: pointer;
        border-radius: 0.25rem; }
        .bootstrap-datetimepicker-widget table td span:hover {
          background: #e9ecef; }
        .bootstrap-datetimepicker-widget table td span.active {
          background-color: #ab8ce4;
          color: #fff;
          text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25); }
        .bootstrap-datetimepicker-widget table td span.old {
          color: #6c757d; }
        .bootstrap-datetimepicker-widget table td span.disabled, .bootstrap-datetimepicker-widget table td span.disabled:hover {
          background: none;
          color: #6c757d;
          cursor: not-allowed; }
  .bootstrap-datetimepicker-widget.usetwentyfour td.hour {
    height: 27px;
    line-height: 27px; }

.input-group [data-toggle="datetimepicker"] {
  cursor: pointer; }
.entity-form-group{
  max-width:20%;
  margin-bottom: 16px; 
}`, "",{"version":3,"sources":["webpack://./src/assets/css/bootstrap.css"],"names":[],"mappings":"AAAA;;;;;EAKE;AACF;EACE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;EACvB,8KAA8K;EAC9K,6GAA6G,EAAE;;AAEjH;;;EAGE,sBAAsB,EAAE;;AAE1B;EACE,uBAAuB;EACvB,iBAAiB;EACjB,8BAA8B;EAC9B,0BAA0B;EAC1B,6BAA6B;EAC7B,6CAA6C,EAAE;AAIjD;EACE,cAAc,EAAE;;AAElB;EACE,SAAS;EACT,iKAAiK;EACjK,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,sBAAsB,EAAE;;AAE1B;EACE,qBAAqB,EAAE;;AAEzB;EACE,uBAAuB;EACvB,SAAS;EACT,iBAAiB,EAAE;;AAErB;EACE,aAAa;EACb,qBAAqB,EAAE;;AAEzB;EACE,aAAa;EACb,mBAAmB,EAAE;;AAEvB;;EAEE,0BAA0B;EAC1B,yCAAiC;UAAjC,iCAAiC;EACjC,YAAY;EACZ,gBAAgB,EAAE;;AAEpB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB,EAAE;;AAExB;;;EAGE,aAAa;EACb,mBAAmB,EAAE;;AAEvB;;;;EAIE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,oBAAoB;EACpB,cAAc,EAAE;;AAElB;EACE,gBAAgB,EAAE;;AAEpB;EACE,kBAAkB,EAAE;;AAEtB;;EAEE,mBAAmB,EAAE;;AAEvB;EACE,cAAc,EAAE;;AAElB;;EAEE,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,wBAAwB,EAAE;;AAE5B;EACE,cAAc,EAAE;;AAElB;EACE,UAAU,EAAE;;AAEd;EACE,cAAc;EACd,qBAAqB;EACrB,6BAA6B;EAC7B,qCAAqC,EAAE;EACvC;IACE,cAAc;IACd,0BAA0B,EAAE;;AAEhC;EACE,cAAc;EACd,qBAAqB,EAAE;EACvB;IACE,cAAc;IACd,qBAAqB,EAAE;EACzB;IACE,UAAU,EAAE;;AAEhB;;;;EAIE,iCAAiC;EACjC,cAAc,EAAE;;AAElB;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,6BAA6B,EAAE;;AAEjC;EACE,gBAAgB,EAAE;;AAEpB;EACE,sBAAsB;EACtB,kBAAkB,EAAE;;AAEtB;EACE,gBAAgB,EAAE;;AAEpB;EACE,yBAAyB,EAAE;;AAE7B;EACE,oBAAoB;EACpB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,oBAAoB,EAAE;;AAExB;EACE,mBAAmB,EAAE;;AAEvB;EACE,qBAAqB;EACrB,qBAAqB,EAAE;;AAEzB;EACE,gBAAgB,EAAE;;AAEpB;EACE,mBAAmB;EACnB,0CAA0C,EAAE;;AAE9C;;;;;EAKE,SAAS;EACT,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB,EAAE;;AAExB;;EAEE,iBAAiB,EAAE;;AAErB;;EAEE,oBAAoB,EAAE;;AAExB;;;;EAIE,0BAA0B,EAAE;;AAE9B;;;;EAIE,UAAU;EACV,kBAAkB,EAAE;;AAEtB;;EAEE,sBAAsB;EACtB,UAAU,EAAE;;AAEd;;;;EAIE,2BAA2B,EAAE;;AAE/B;EACE,cAAc;EACd,gBAAgB,EAAE;;AAEpB;EACE,YAAY;EACZ,UAAU;EACV,SAAS;EACT,SAAS,EAAE;;AAEb;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,UAAU;EACV,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,mBAAmB,EAAE;;AAEvB;EACE,wBAAwB,EAAE;;AAE5B;;EAEE,YAAY,EAAE;;AAEhB;EACE,oBAAoB;EACpB,wBAAwB,EAAE;;AAE5B;;EAEE,wBAAwB,EAAE;;AAE5B;EACE,aAAa;EACb,0BAA0B,EAAE;;AAE9B;EACE,qBAAqB,EAAE;;AAEzB;EACE,kBAAkB;EAClB,eAAe,EAAE;;AAEnB;EACE,aAAa,EAAE;;AAEjB;EACE,wBAAwB,EAAE;;AAE5B;;EAEE,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc,EAAE;;AAElB;EACE,iBAAiB,EAAE;;AAErB;EACE,eAAe,EAAE;;AAEnB;EACE,kBAAkB,EAAE;;AAEtB;EACE,iBAAiB,EAAE;;AAErB;EACE,kBAAkB,EAAE;;AAEtB;EACE,eAAe,EAAE;;AAEnB;EACE,kBAAkB;EAClB,gBAAgB,EAAE;;AAEpB;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB,EAAE;;AAEpB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB,EAAE;;AAEpB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB,EAAE;;AAEpB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,wCAAwC,EAAE;;AAE5C;;EAEE,cAAc;EACd,gBAAgB,EAAE;;AAEpB;;EAEE,cAAc;EACd,yBAAyB,EAAE;;AAE7B;EACE,eAAe;EACf,gBAAgB,EAAE;;AAEpB;EACE,eAAe;EACf,gBAAgB,EAAE;;AAEpB;EACE,qBAAqB,EAAE;EACvB;IACE,oBAAoB,EAAE;;AAE1B;EACE,cAAc;EACd,yBAAyB,EAAE;;AAE7B;EACE,mBAAmB;EACnB,kBAAkB,EAAE;;AAEtB;EACE,cAAc;EACd,cAAc;EACd,cAAc;EACd,kBAAkB,EAAE;EACpB;IACE,sBAAsB,EAAE;;AAE5B;EACE,eAAe;EACf,YAAY,EAAE;;AAEhB;EACE,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,YAAY,EAAE;;AAEhB;EACE,qBAAqB,EAAE;;AAEzB;EACE,qBAAqB;EACrB,cAAc,EAAE;;AAElB;EACE,cAAc;EACd,cAAc,EAAE;;AAElB;;;;EAIE,iGAAiG,EAAE;;AAErG;EACE,gBAAgB;EAChB,cAAc;EACd,sBAAsB,EAAE;EACxB;IACE,cAAc,EAAE;;AAEpB;EACE,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,qBAAqB,EAAE;EACvB;IACE,UAAU;IACV,eAAe;IACf,gBAAgB,EAAE;;AAEtB;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc,EAAE;EAChB;IACE,kBAAkB;IAClB,cAAc;IACd,kBAAkB,EAAE;;AAExB;EACE,iBAAiB;EACjB,kBAAkB,EAAE;;AAEtB;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB,EAAE;EACnB;IACE;MACE,gBAAgB,EAAE,EAAE;EACxB;IACE;MACE,gBAAgB,EAAE,EAAE;EACxB;IACE;MACE,gBAAgB,EAAE,EAAE;EACxB;IACE;MACE,iBAAiB,EAAE,EAAE;;AAE3B;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB,EAAE;;AAErB;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,kBAAkB,EAAE;;AAEtB;EACE,eAAe;EACf,cAAc,EAAE;EAChB;;IAEE,gBAAgB;IAChB,eAAe,EAAE;;AAErB;;;;;;EAME,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,kBAAkB,EAAE;;AAEtB;EACE,aAAa;EACb,YAAY;EACZ,eAAe,EAAE;;AAEnB;EACE,cAAc;EACd,WAAW;EACX,eAAe,EAAE;;AAEnB;EACE,uBAAuB;EACvB,wBAAwB,EAAE;;AAE5B;EACE,wBAAwB;EACxB,yBAAyB,EAAE;;AAE7B;EACE,aAAa;EACb,cAAc,EAAE;;AAElB;EACE,wBAAwB;EACxB,yBAAyB,EAAE;;AAE7B;EACE,wBAAwB;EACxB,yBAAyB,EAAE;;AAE7B;EACE,aAAa;EACb,cAAc,EAAE;;AAElB;EACE,wBAAwB;EACxB,yBAAyB,EAAE;;AAE7B;EACE,wBAAwB;EACxB,yBAAyB,EAAE;;AAE7B;EACE,aAAa;EACb,cAAc,EAAE;;AAElB;EACE,wBAAwB;EACxB,yBAAyB,EAAE;;AAE7B;EACE,wBAAwB;EACxB,yBAAyB,EAAE;;AAE7B;EACE,cAAc;EACd,eAAe,EAAE;;AAEnB;EACE,SAAS,EAAE;;AAEb;EACE,SAAS,EAAE;;AAEb;EACE,QAAQ,EAAE;;AAEZ;EACE,QAAQ,EAAE;;AAEZ;EACE,QAAQ,EAAE;;AAEZ;EACE,QAAQ,EAAE;;AAEZ;EACE,QAAQ,EAAE;;AAEZ;EACE,QAAQ,EAAE;;AAEZ;EACE,QAAQ,EAAE;;AAEZ;EACE,QAAQ,EAAE;;AAEZ;EACE,QAAQ,EAAE;;AAEZ;EACE,QAAQ,EAAE;;AAEZ;EACE,SAAS,EAAE;;AAEb;EACE,SAAS,EAAE;;AAEb;EACE,SAAS,EAAE;;AAEb;EACE,0BAA0B,EAAE;;AAE9B;EACE,2BAA2B,EAAE;;AAE/B;EACE,gBAAgB,EAAE;;AAEpB;EACE,2BAA2B,EAAE;;AAE/B;EACE,2BAA2B,EAAE;;AAE/B;EACE,gBAAgB,EAAE;;AAEpB;EACE,2BAA2B,EAAE;;AAE/B;EACE,2BAA2B,EAAE;;AAE/B;EACE,gBAAgB,EAAE;;AAEpB;EACE,2BAA2B,EAAE;;AAE/B;EACE,2BAA2B,EAAE;;AAE/B;EACE;IACE,aAAa;IACb,YAAY;IACZ,eAAe,EAAE;;EAEnB;IACE,cAAc;IACd,WAAW;IACX,eAAe,EAAE;;EAEnB;IACE,uBAAuB;IACvB,wBAAwB,EAAE;;EAE5B;IACE,wBAAwB;IACxB,yBAAyB,EAAE;;EAE7B;IACE,aAAa;IACb,cAAc,EAAE;;EAElB;IACE,wBAAwB;IACxB,yBAAyB,EAAE;;EAE7B;IACE,wBAAwB;IACxB,yBAAyB,EAAE;;EAE7B;IACE,aAAa;IACb,cAAc,EAAE;;EAElB;IACE,wBAAwB;IACxB,yBAAyB,EAAE;;EAE7B;IACE,wBAAwB;IACxB,yBAAyB,EAAE;;EAE7B;IACE,aAAa;IACb,cAAc,EAAE;;EAElB;IACE,wBAAwB;IACxB,yBAAyB,EAAE;;EAE7B;IACE,wBAAwB;IACxB,yBAAyB,EAAE;;EAE7B;IACE,cAAc;IACd,eAAe,EAAE;;EAEnB;IACE,SAAS,EAAE;;EAEb;IACE,SAAS,EAAE;;EAEb;IACE,QAAQ,EAAE;;EAEZ;IACE,QAAQ,EAAE;;EAEZ;IACE,QAAQ,EAAE;;EAEZ;IACE,QAAQ,EAAE;;EAEZ;IACE,QAAQ,EAAE;;EAEZ;IACE,QAAQ,EAAE;;EAEZ;IACE,QAAQ,EAAE;;EAEZ;IACE,QAAQ,EAAE;;EAEZ;IACE,QAAQ,EAAE;;EAEZ;IACE,QAAQ,EAAE;;EAEZ;IACE,SAAS,EAAE;;EAEb;IACE,SAAS,EAAE;;EAEb;IACE,SAAS,EAAE;;EAEb;IACE,cAAc,EAAE;;EAElB;IACE,0BAA0B,EAAE;;EAE9B;IACE,2BAA2B,EAAE;;EAE/B;IACE,gBAAgB,EAAE;;EAEpB;IACE,2BAA2B,EAAE;;EAE/B;IACE,2BAA2B,EAAE;;EAE/B;IACE,gBAAgB,EAAE;;EAEpB;IACE,2BAA2B,EAAE;;EAE/B;IACE,2BAA2B,EAAE;;EAE/B;IACE,gBAAgB,EAAE;;EAEpB;IACE,2BAA2B,EAAE;;EAE/B;IACE,2BAA2B,EAAE,EAAE;AACnC;EACE;IACE,aAAa;IACb,YAAY;IACZ,eAAe,EAAE;;EAEnB;IACE,cAAc;IACd,WAAW;IACX,eAAe,EAAE;;EAEnB;IACE,uBAAuB;IACvB,wBAAwB,EAAE;;EAE5B;IACE,wBAAwB;IACxB,yBAAyB,EAAE;;EAE7B;IACE,aAAa;IACb,cAAc,EAAE;;EAElB;IACE,wBAAwB;IACxB,yBAAyB,EAAE;;EAE7B;IACE,wBAAwB;IACxB,yBAAyB,EAAE;;EAE7B;IACE,aAAa;IACb,cAAc,EAAE;;EAElB;IACE,wBAAwB;IACxB,yBAAyB,EAAE;;EAE7B;IACE,wBAAwB;IACxB,yBAAyB,EAAE;;EAE7B;IACE,aAAa;IACb,cAAc,EAAE;;EAElB;IACE,wBAAwB;IACxB,yBAAyB,EAAE;;EAE7B;IACE,wBAAwB;IACxB,yBAAyB,EAAE;;EAE7B;IACE,cAAc;IACd,eAAe,EAAE;;EAEnB;IACE,SAAS,EAAE;;EAEb;IACE,SAAS,EAAE;;EAEb;IACE,QAAQ,EAAE;;EAEZ;IACE,QAAQ,EAAE;;EAEZ;IACE,QAAQ,EAAE;;EAEZ;IACE,QAAQ,EAAE;;EAEZ;IACE,QAAQ,EAAE;;EAEZ;IACE,QAAQ,EAAE;;EAEZ;IACE,QAAQ,EAAE;;EAEZ;IACE,QAAQ,EAAE;;EAEZ;IACE,QAAQ,EAAE;;EAEZ;IACE,QAAQ,EAAE;;EAEZ;IACE,SAAS,EAAE;;EAEb;IACE,SAAS,EAAE;;EAEb;IACE,SAAS,EAAE;;EAEb;IACE,cAAc,EAAE;;EAElB;IACE,0BAA0B,EAAE;;EAE9B;IACE,2BAA2B,EAAE;;EAE/B;IACE,gBAAgB,EAAE;;EAEpB;IACE,2BAA2B,EAAE;;EAE/B;IACE,2BAA2B,EAAE;;EAE/B;IACE,gBAAgB,EAAE;;EAEpB;IACE,2BAA2B,EAAE;;EAE/B;IACE,2BAA2B,EAAE;;EAE/B;IACE,gBAAgB,EAAE;;EAEpB;IACE,2BAA2B,EAAE;;EAE/B;IACE,2BAA2B,EAAE,EAAE;AACnC;EACE;IACE,aAAa;IACb,YAAY;IACZ,eAAe,EAAE;;EAEnB;IACE,cAAc;IACd,WAAW;IACX,eAAe,EAAE;;EAEnB;IACE,uBAAuB;IACvB,wBAAwB,EAAE;;EAE5B;IACE,wBAAwB;IACxB,yBAAyB,EAAE;;EAE7B;IACE,aAAa;IACb,cAAc,EAAE;;EAElB;IACE,wBAAwB;IACxB,yBAAyB,EAAE;;EAE7B;IACE,wBAAwB;IACxB,yBAAyB,EAAE;;EAE7B;IACE,aAAa;IACb,cAAc,EAAE;;EAElB;IACE,wBAAwB;IACxB,yBAAyB,EAAE;;EAE7B;IACE,wBAAwB;IACxB,yBAAyB,EAAE;;EAE7B;IACE,aAAa;IACb,cAAc,EAAE;;EAElB;IACE,wBAAwB;IACxB,yBAAyB,EAAE;;EAE7B;IACE,wBAAwB;IACxB,yBAAyB,EAAE;;EAE7B;IACE,cAAc;IACd,eAAe,EAAE;;EAEnB;IACE,SAAS,EAAE;;EAEb;IACE,SAAS,EAAE;;EAEb;IACE,QAAQ,EAAE;;EAEZ;IACE,QAAQ,EAAE;;EAEZ;IACE,QAAQ,EAAE;;EAEZ;IACE,QAAQ,EAAE;;EAEZ;IACE,QAAQ,EAAE;;EAEZ;IACE,QAAQ,EAAE;;EAEZ;IACE,QAAQ,EAAE;;EAEZ;IACE,QAAQ,EAAE;;EAEZ;IACE,QAAQ,EAAE;;EAEZ;IACE,QAAQ,EAAE;;EAEZ;IACE,SAAS,EAAE;;EAEb;IACE,SAAS,EAAE;;EAEb;IACE,SAAS,EAAE;;EAEb;IACE,cAAc,EAAE;;EAElB;IACE,0BAA0B,EAAE;;EAE9B;IACE,2BAA2B,EAAE;;EAE/B;IACE,gBAAgB,EAAE;;EAEpB;IACE,2BAA2B,EAAE;;EAE/B;IACE,2BAA2B,EAAE;;EAE/B;IACE,gBAAgB,EAAE;;EAEpB;IACE,2BAA2B,EAAE;;EAE/B;IACE,2BAA2B,EAAE;;EAE/B;IACE,gBAAgB,EAAE;;EAEpB;IACE,2BAA2B,EAAE;;EAE/B;IACE,2BAA2B,EAAE,EAAE;AACnC;EACE;IACE,aAAa;IACb,YAAY;IACZ,eAAe,EAAE;;EAEnB;IACE,cAAc;IACd,WAAW;IACX,eAAe,EAAE;;EAEnB;IACE,uBAAuB;IACvB,wBAAwB,EAAE;;EAE5B;IACE,wBAAwB;IACxB,yBAAyB,EAAE;;EAE7B;IACE,aAAa;IACb,cAAc,EAAE;;EAElB;IACE,wBAAwB;IACxB,yBAAyB,EAAE;;EAE7B;IACE,wBAAwB;IACxB,yBAAyB,EAAE;;EAE7B;IACE,aAAa;IACb,cAAc,EAAE;;EAElB;IACE,wBAAwB;IACxB,yBAAyB,EAAE;;EAE7B;IACE,wBAAwB;IACxB,yBAAyB,EAAE;;EAE7B;IACE,aAAa;IACb,cAAc,EAAE;;EAElB;IACE,wBAAwB;IACxB,yBAAyB,EAAE;;EAE7B;IACE,wBAAwB;IACxB,yBAAyB,EAAE;;EAE7B;IACE,cAAc;IACd,eAAe,EAAE;;EAEnB;IACE,SAAS,EAAE;;EAEb;IACE,SAAS,EAAE;;EAEb;IACE,QAAQ,EAAE;;EAEZ;IACE,QAAQ,EAAE;;EAEZ;IACE,QAAQ,EAAE;;EAEZ;IACE,QAAQ,EAAE;;EAEZ;IACE,QAAQ,EAAE;;EAEZ;IACE,QAAQ,EAAE;;EAEZ;IACE,QAAQ,EAAE;;EAEZ;IACE,QAAQ,EAAE;;EAEZ;IACE,QAAQ,EAAE;;EAEZ;IACE,QAAQ,EAAE;;EAEZ;IACE,SAAS,EAAE;;EAEb;IACE,SAAS,EAAE;;EAEb;IACE,SAAS,EAAE;;EAEb;IACE,cAAc,EAAE;;EAElB;IACE,0BAA0B,EAAE;;EAE9B;IACE,2BAA2B,EAAE;;EAE/B;IACE,gBAAgB,EAAE;;EAEpB;IACE,2BAA2B,EAAE;;EAE/B;IACE,2BAA2B,EAAE;;EAE/B;IACE,gBAAgB,EAAE;;EAEpB;IACE,2BAA2B,EAAE;;EAE/B;IACE,2BAA2B,EAAE;;EAE/B;IACE,gBAAgB,EAAE;;EAEpB;IACE,2BAA2B,EAAE;;EAE/B;IACE,2BAA2B,EAAE,EAAE;AACnC;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,6BAA6B,EAAE;EAC/B;;IAEE,gBAAgB;IAChB,mBAAmB;IACnB,6BAA6B,EAAE;EACjC;IACE,sBAAsB;IACtB,gCAAgC,EAAE;EACpC;IACE,6BAA6B,EAAE;EACjC;IACE,sBAAsB,EAAE;;AAE5B;;EAEE,eAAe,EAAE;;AAEnB;EACE,yBAAyB,EAAE;EAC3B;;IAEE,yBAAyB,EAAE;EAC7B;;IAEE,wBAAwB,EAAE;;AAE9B;;;;EAIE,SAAS,EAAE;;AAEb;EACE,qCAAqC,EAAE;;AAEzC;EACE,sCAAsC,EAAE;;AAE1C;;;EAGE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;EAC3B;;IAEE,yBAAyB,EAAE;;AAE/B;;;EAGE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;EAC3B;;IAEE,yBAAyB,EAAE;;AAE/B;;;EAGE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;EAC3B;;IAEE,yBAAyB,EAAE;;AAE/B;;;EAGE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;EAC3B;;IAEE,yBAAyB,EAAE;;AAE/B;;;EAGE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;EAC3B;;IAEE,yBAAyB,EAAE;;AAE/B;;;EAGE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;EAC3B;;IAEE,yBAAyB,EAAE;;AAE/B;;;EAGE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;EAC3B;;IAEE,yBAAyB,EAAE;;AAE/B;;;EAGE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;EAC3B;;IAEE,yBAAyB,EAAE;;AAE/B;;;EAGE,sCAAsC,EAAE;;AAE1C;EACE,sCAAsC,EAAE;EACxC;;IAEE,sCAAsC,EAAE;;AAE5C;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB,EAAE;AACzB;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB,EAAE;;AAEzB;EACE,WAAW;EACX,yBAAyB,EAAE;EAC3B;;;IAGE,qBAAqB,EAAE;EACzB;IACE,SAAS,EAAE;EACb;IACE,2CAA2C,EAAE;EAC/C;IACE,4CAA4C,EAAE;;AAElD;EACE;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,iCAAiC;IACjC,4CAA4C,EAAE;IAC9C;MACE,SAAS,EAAE,EAAE;AACnB;EACE;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,iCAAiC;IACjC,4CAA4C,EAAE;IAC9C;MACE,SAAS,EAAE,EAAE;AACnB;EACE;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,iCAAiC;IACjC,4CAA4C,EAAE;IAC9C;MACE,SAAS,EAAE,EAAE;AACnB;EACE;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,iCAAiC;IACjC,4CAA4C,EAAE;IAC9C;MACE,SAAS,EAAE,EAAE;AACnB;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,iCAAiC;EACjC,4CAA4C,EAAE;EAC9C;IACE,SAAS,EAAE;;AAEf;EACE,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;EACtB,wEAAwE,EAAE;EAC1E;IACE,cAAc;IACd,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,4BAA4B;IAC5B,yBAAyB;IACzB,sBAAsB;IACtB,wEAAwE,EAAE;IAC1E;MACE,cAAc;MACd,WAAW;MACX,yBAAyB;MACzB,eAAe;MACf,gBAAgB;MAChB,cAAc;MACd,sBAAsB;MACtB,4BAA4B;MAC5B,yBAAyB;MACzB,sBAAsB;MACtB,wEAAwE,EAAE;;IAE5E;MACE,cAAc;MACd,UAAU;MACV,yBAAyB;MACzB,eAAe;MACf,gBAAgB;MAChB,cAAc;MACd,sBAAsB;MACtB,4BAA4B;MAC5B,yBAAyB;MACzB,sBAAsB;MACtB,wEAAwE,EAAE;EAC9E;IACE;MACE,gBAAgB,EAAE,EAAE;EACxB;IACE,6BAA6B;IAC7B,SAAS,EAAE;EACb;IACE,cAAc;IACd,sBAAsB;IACtB,qBAAqB;IACrB,UAAU;IACV,gDAAgD,EAAE;EACpD;IACE,cAAc;IACd,UAAU,EAAE;EACd;IACE,yBAAyB;IACzB,UAAU,EAAE;;AAEhB;EACE,2BAA2B,EAAE;AAC/B;EACE,cAAc;EACd,sBAAsB,EAAE;;AAE1B;;EAEE,cAAc;EACd,WAAW,EAAE;;AAEf;EACE,iCAAiC;EACjC,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB,EAAE;;AAEpB;EACE,+BAA+B;EAC/B,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB,EAAE;;AAEpB;EACE,gCAAgC;EAChC,mCAAmC;EACnC,mBAAmB;EACnB,gBAAgB,EAAE;;AAEpB;EACE,cAAc;EACd,WAAW;EACX,qBAAqB;EACrB,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,6BAA6B;EAC7B,yBAAyB;EACzB,mBAAmB,EAAE;EACrB;;;;;;;;;IASE,gBAAgB;IAChB,eAAe,EAAE;;AAErB;;;;;EAKE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB,EAAE;;AAEzB;;;;;EAKE,6BAA6B,EAAE;;AAEjC;;;;;EAKE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB,EAAE;;AAEzB;;;;;EAKE,4BAA4B,EAAE;;AAEhC;EACE,mBAAmB,EAAE;EACrB;IACE,mBAAmB,EAAE;;AAEzB;IACI,iBAAiB;EACnB,mBAAmB;AACrB;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB,EAAE;;AAEvB;EACE,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,iBAAiB,EAAE;EACnB;;IAEE,kBAAkB;IAClB,iBAAiB,EAAE;;AAEvB;EACE,kBAAkB;EAClB,cAAc;EACd,qBAAqB,EAAE;;AAEzB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB,EAAE;EACvB;IACE,cAAc,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,qBAAqB,EAAE;EACvB;IACE,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,cAAc,EAAE;;AAEpB;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,cAAc,EAAE;;AAElB;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,wCAAwC;EACxC,oBAAoB,EAAE;;AAExB;;;EAGE,qBAAqB,EAAE;EACvB;;;IAGE,qBAAqB;IACrB,gDAAgD,EAAE;EACpD;;;;;;;IAOE,cAAc,EAAE;;AAEpB;EACE,cAAc,EAAE;AAClB;;;EAGE,cAAc,EAAE;;AAElB;EACE,cAAc,EAAE;EAChB;IACE,yBAAyB,EAAE;AAC/B;;;EAGE,cAAc,EAAE;AAClB;EACE,yBAAyB,EAAE;AAC7B;EACE,gEAAgE,EAAE;;AAEpE;EACE,qBAAqB,EAAE;EACvB;IACE,qBAAqB,EAAE;AAC3B;;;EAGE,cAAc,EAAE;AAClB;EACE,gDAAgD,EAAE;;AAEpD;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,cAAc,EAAE;;AAElB;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,wCAAwC;EACxC,oBAAoB,EAAE;;AAExB;;;EAGE,qBAAqB,EAAE;EACvB;;;IAGE,qBAAqB;IACrB,gDAAgD,EAAE;EACpD;;;;;;;IAOE,cAAc,EAAE;;AAEpB;EACE,cAAc,EAAE;AAClB;;;EAGE,cAAc,EAAE;;AAElB;EACE,cAAc,EAAE;EAChB;IACE,yBAAyB,EAAE;AAC/B;;;EAGE,cAAc,EAAE;AAClB;EACE,yBAAyB,EAAE;AAC7B;EACE,gEAAgE,EAAE;;AAEpE;EACE,qBAAqB,EAAE;EACvB;IACE,qBAAqB,EAAE;AAC3B;;;EAGE,cAAc,EAAE;AAClB;EACE,gDAAgD,EAAE;;AAEpD;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB,EAAE;EACrB;IACE,WAAW,EAAE;EACf;IACE;MACE,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,gBAAgB,EAAE;IACpB;MACE,aAAa;MACb,cAAc;MACd,mBAAmB;MACnB,mBAAmB;MACnB,gBAAgB,EAAE;IACpB;MACE,qBAAqB;MACrB,WAAW;MACX,sBAAsB,EAAE;IAC1B;MACE,qBAAqB,EAAE;IACzB;;MAEE,WAAW,EAAE;IACf;MACE,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,WAAW;MACX,eAAe,EAAE;IACnB;MACE,kBAAkB;MAClB,aAAa;MACb,qBAAqB;MACrB,cAAc,EAAE;IAClB;MACE,mBAAmB;MACnB,uBAAuB,EAAE;IAC3B;MACE,gBAAgB,EAAE,EAAE;;AAE1B;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,yBAAiB;UAAjB,iBAAiB;EACjB,6BAA6B;EAC7B,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;EACtB,qIAAqI,EAAE;EACvI;IACE;MACE,gBAAgB,EAAE,EAAE;EACxB;IACE,qBAAqB,EAAE;EACzB;IACE,UAAU;IACV,gDAAgD,EAAE;EACpD;IACE,aAAa,EAAE;EACjB;IACE,eAAe,EAAE;EACnB;IACE,sBAAsB,EAAE;;AAE5B;;EAEE,oBAAoB,EAAE;EACtB;IACE,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,yBAAiB;YAAjB,iBAAiB;IACjB,6BAA6B;IAC7B,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,qIAAqI,EAAE;IACvI;MACE;QACE,gBAAgB,EAAE,EAAE;IACxB;MACE,qBAAqB,EAAE;IACzB;MACE,UAAU;MACV,gDAAgD,EAAE;IACpD;MACE,aAAa,EAAE;IACjB;MACE,eAAe,EAAE;IACnB;MACE,sBAAsB,EAAE;;EAE5B;;IAEE,oBAAoB,EAAE;;AAE1B;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB,EAAE;EACvB;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;IACE,+CAA+C,EAAE;EACnD;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;IACvB;MACE,+CAA+C,EAAE;;AAEvD;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB,EAAE;EACvB;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;IACE,iDAAiD,EAAE;EACrD;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;IACvB;MACE,iDAAiD,EAAE;;AAEzD;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB,EAAE;EACvB;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;IACE,+CAA+C,EAAE;EACnD;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;IACvB;MACE,+CAA+C,EAAE;;AAEvD;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB,EAAE;EACvB;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;IACE,gDAAgD,EAAE;EACpD;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;IACvB;MACE,gDAAgD,EAAE;;AAExD;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB,EAAE;EACvB;IACE,cAAc;IACd,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;IACE,+CAA+C,EAAE;EACnD;IACE,cAAc;IACd,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;IACE,cAAc;IACd,yBAAyB;IACzB,qBAAqB,EAAE;IACvB;MACE,+CAA+C,EAAE;;AAEvD;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB,EAAE;EACvB;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;IACE,+CAA+C,EAAE;EACnD;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;IACvB;MACE,+CAA+C,EAAE;;AAEvD;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB,EAAE;EACvB;IACE,cAAc;IACd,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;IACE,iDAAiD,EAAE;EACrD;IACE,cAAc;IACd,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;IACE,cAAc;IACd,yBAAyB;IACzB,qBAAqB,EAAE;IACvB;MACE,iDAAiD,EAAE;;AAEzD;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB,EAAE;EACvB;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;IACE,8CAA8C,EAAE;EAClD;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;IACvB;MACE,8CAA8C,EAAE;;AAEtD;EACE,cAAc;EACd,6BAA6B;EAC7B,sBAAsB;EACtB,qBAAqB,EAAE;EACvB;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;IACE,+CAA+C,EAAE;EACnD;IACE,cAAc;IACd,6BAA6B,EAAE;EACjC;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;IACvB;MACE,+CAA+C,EAAE;;AAEvD;EACE,cAAc;EACd,6BAA6B;EAC7B,sBAAsB;EACtB,qBAAqB,EAAE;EACvB;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;IACE,iDAAiD,EAAE;EACrD;IACE,cAAc;IACd,6BAA6B,EAAE;EACjC;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;IACvB;MACE,iDAAiD,EAAE;;AAEzD;EACE,cAAc;EACd,6BAA6B;EAC7B,sBAAsB;EACtB,qBAAqB,EAAE;EACvB;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;IACE,+CAA+C,EAAE;EACnD;IACE,cAAc;IACd,6BAA6B,EAAE;EACjC;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;IACvB;MACE,+CAA+C,EAAE;;AAEvD;EACE,cAAc;EACd,6BAA6B;EAC7B,sBAAsB;EACtB,qBAAqB,EAAE;EACvB;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;IACE,gDAAgD,EAAE;EACpD;IACE,cAAc;IACd,6BAA6B,EAAE;EACjC;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;IACvB;MACE,gDAAgD,EAAE;;AAExD;EACE,cAAc;EACd,6BAA6B;EAC7B,sBAAsB;EACtB,qBAAqB,EAAE;EACvB;IACE,cAAc;IACd,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;IACE,+CAA+C,EAAE;EACnD;IACE,cAAc;IACd,6BAA6B,EAAE;EACjC;IACE,cAAc;IACd,yBAAyB;IACzB,qBAAqB,EAAE;IACvB;MACE,+CAA+C,EAAE;;AAEvD;EACE,cAAc;EACd,6BAA6B;EAC7B,sBAAsB;EACtB,qBAAqB,EAAE;EACvB;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;IACE,+CAA+C,EAAE;EACnD;IACE,cAAc;IACd,6BAA6B,EAAE;EACjC;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;IACvB;MACE,+CAA+C,EAAE;;AAEvD;EACE,cAAc;EACd,6BAA6B;EAC7B,sBAAsB;EACtB,qBAAqB,EAAE;EACvB;IACE,cAAc;IACd,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;IACE,iDAAiD,EAAE;EACrD;IACE,cAAc;IACd,6BAA6B,EAAE;EACjC;IACE,cAAc;IACd,yBAAyB;IACzB,qBAAqB,EAAE;IACvB;MACE,iDAAiD,EAAE;;AAEzD;EACE,cAAc;EACd,6BAA6B;EAC7B,sBAAsB;EACtB,qBAAqB,EAAE;EACvB;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;IACE,8CAA8C,EAAE;EAClD;IACE,cAAc;IACd,6BAA6B,EAAE;EACjC;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;IACvB;MACE,8CAA8C,EAAE;;AAEtD;EACE,gBAAgB;EAChB,cAAc;EACd,6BAA6B,EAAE;EAC/B;IACE,cAAc;IACd,0BAA0B;IAC1B,6BAA6B;IAC7B,yBAAyB,EAAE;EAC7B;IACE,0BAA0B;IAC1B,yBAAyB;IACzB,gBAAgB,EAAE;EACpB;IACE,cAAc;IACd,oBAAoB,EAAE;;AAE1B;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB,EAAE;;AAEzB;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB,EAAE;;AAEzB;EACE,cAAc;EACd,WAAW,EAAE;EACb;IACE,kBAAkB,EAAE;;AAExB;;;EAGE,WAAW,EAAE;;AAEf;EACE,gCAAgC,EAAE;EAClC;IACE;MACE,gBAAgB,EAAE,EAAE;EACxB;IACE,UAAU,EAAE;;AAEhB;EACE,aAAa,EAAE;;AAEjB;EACE,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,6BAA6B,EAAE;EAC/B;IACE;MACE,gBAAgB,EAAE,EAAE;;AAE1B;;;;EAIE,kBAAkB,EAAE;;AAEtB;EACE,qBAAqB;EACrB,QAAQ;EACR,SAAS;EACT,oBAAoB;EACpB,uBAAuB;EACvB,WAAW;EACX,uBAAuB;EACvB,qCAAqC;EACrC,gBAAgB;EAChB,oCAAoC,EAAE;AACxC;EACE,cAAc,EAAE;;AAElB;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,aAAa;EACb,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,4BAA4B;EAC5B,qCAAqC;EACrC,sBAAsB,EAAE;;AAE1B;EACE,QAAQ;EACR,UAAU,EAAE;;AAEd;EACE,SAAS;EACT,YAAY;EACZ,aAAa;EACb,uBAAuB,EAAE;AAC3B;EACE,qBAAqB;EACrB,QAAQ;EACR,SAAS;EACT,oBAAoB;EACpB,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,qCAAqC;EACrC,0BAA0B;EAC1B,oCAAoC,EAAE;AACxC;EACE,cAAc,EAAE;;AAElB;EACE,MAAM;EACN,WAAW;EACX,UAAU;EACV,aAAa;EACb,qBAAqB,EAAE;AACzB;EACE,qBAAqB;EACrB,QAAQ;EACR,SAAS;EACT,oBAAoB;EACpB,uBAAuB;EACvB,WAAW;EACX,mCAAmC;EACnC,eAAe;EACf,sCAAsC;EACtC,wBAAwB,EAAE;AAC5B;EACE,cAAc,EAAE;AAClB;EACE,iBAAiB,EAAE;;AAErB;EACE,MAAM;EACN,WAAW;EACX,UAAU;EACV,aAAa;EACb,sBAAsB,EAAE;AAC1B;EACE,qBAAqB;EACrB,QAAQ;EACR,SAAS;EACT,oBAAoB;EACpB,uBAAuB;EACvB,WAAW,EAAE;AACf;EACE,aAAa,EAAE;AACjB;EACE,qBAAqB;EACrB,QAAQ;EACR,SAAS;EACT,qBAAqB;EACrB,uBAAuB;EACvB,WAAW;EACX,mCAAmC;EACnC,yBAAyB;EACzB,sCAAsC,EAAE;AAC1C;EACE,cAAc,EAAE;AAClB;EACE,iBAAiB,EAAE;;AAErB;EACE,WAAW;EACX,YAAY,EAAE;;AAEhB;EACE,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B,EAAE;;AAEjC;EACE,cAAc;EACd,WAAW;EACX,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,SAAS,EAAE;EACX;IACE,cAAc;IACd,qBAAqB;IACrB,yBAAyB,EAAE;EAC7B;IACE,WAAW;IACX,qBAAqB;IACrB,yBAAyB,EAAE;EAC7B;IACE,cAAc;IACd,6BAA6B,EAAE;;AAEnC;EACE,cAAc,EAAE;;AAElB;EACE,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,mBAAmB,EAAE;;AAEvB;EACE,cAAc;EACd,uBAAuB;EACvB,cAAc,EAAE;;AAElB;;EAEE,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB,EAAE;EACxB;;IAEE,kBAAkB;IAClB,cAAc,EAAE;IAChB;;MAEE,UAAU,EAAE;IACd;;;;MAIE,UAAU,EAAE;EAChB;;;;;;;;IAQE,iBAAiB,EAAE;;AAEvB;EACE,aAAa;EACb,eAAe;EACf,2BAA2B,EAAE;EAC7B;IACE,WAAW,EAAE;;AAEjB;EACE,cAAc,EAAE;AAClB;;EAEE,0BAA0B;EAC1B,6BAA6B,EAAE;AACjC;;EAEE,yBAAyB;EACzB,4BAA4B,EAAE;;AAEhC;EACE,wBAAwB;EACxB,uBAAuB,EAAE;EACzB;IACE,cAAc,EAAE;EAClB;IACE,eAAe,EAAE;;AAErB;EACE,uBAAuB;EACvB,sBAAsB,EAAE;;AAE1B;EACE,sBAAsB;EACtB,qBAAqB,EAAE;;AAEzB;EACE,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB,EAAE;EACzB;;IAEE,WAAW,EAAE;EACf;;;;IAIE,gBAAgB;IAChB,cAAc,EAAE;EAClB;;IAEE,6BAA6B;IAC7B,4BAA4B,EAAE;EAChC;;IAEE,yBAAyB;IACzB,0BAA0B,EAAE;;AAEhC;;EAEE,gBAAgB,EAAE;EAClB;;;;IAIE,kBAAkB;IAClB,sBAAsB;IACtB,oBAAoB,EAAE;;AAE1B;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,WAAW,EAAE;EACb;;;IAGE,kBAAkB;IAClB,cAAc;IACd,SAAS;IACT,gBAAgB,EAAE;IAClB;;;MAGE,UAAU,EAAE;IACd;;;;;;;;;MASE,iBAAiB,EAAE;EACvB;;IAEE,0BAA0B;IAC1B,6BAA6B,EAAE;EACjC;;IAEE,yBAAyB;IACzB,4BAA4B,EAAE;EAChC;IACE,aAAa;IACb,mBAAmB,EAAE;IACrB;MACE,0BAA0B;MAC1B,6BAA6B,EAAE;IACjC;MACE,yBAAyB;MACzB,4BAA4B,EAAE;;AAEpC;;EAEE,aAAa,EAAE;EACf;;IAEE,kBAAkB;IAClB,UAAU,EAAE;EACd;;;;;;;;IAQE,iBAAiB,EAAE;;AAEvB;EACE,kBAAkB,EAAE;;AAEtB;EACE,iBAAiB,EAAE;;AAErB;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB,EAAE;EACxB;;IAEE,aAAa,EAAE;;AAEnB;;;;;;EAME,0BAA0B;EAC1B,6BAA6B,EAAE;;AAEjC;;;;;;EAME,yBAAyB;EACzB,4BAA4B,EAAE;;AAEhC;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,oBAAoB,EAAE;;AAExB;EACE,oBAAoB;EACpB,kBAAkB,EAAE;;AAEtB;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU,EAAE;EACZ;IACE,WAAW;IACX,yBAAyB,EAAE;EAC7B;IACE,gEAAgE,EAAE;EACpE;IACE,WAAW;IACX,yBAAyB,EAAE;EAC7B;IACE,cAAc,EAAE;IAChB;MACE,yBAAyB,EAAE;;AAEjC;EACE,gBAAgB,EAAE;EAClB;IACE,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,cAAc;IACd,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,WAAW;IACX,yBAAiB;YAAjB,iBAAiB;IACjB,yBAAyB,EAAE;EAC7B;IACE,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,cAAc;IACd,WAAW;IACX,YAAY;IACZ,WAAW;IACX,4BAA4B;IAC5B,kCAAkC;IAClC,wBAAwB,EAAE;;AAE9B;EACE,sBAAsB,EAAE;AAC1B;EACE,yBAAyB,EAAE;AAC7B;EACE,yDAA0N,EAAE;AAC9N;EACE,yBAAyB,EAAE;AAC7B;EACE,yDAAuK,EAAE;AAC3K;EACE,wCAAwC,EAAE;AAC5C;EACE,wCAAwC,EAAE;;AAE5C;EACE,kBAAkB,EAAE;AACtB;EACE,yBAAyB,EAAE;AAC7B;EACE,yDAAoK,EAAE;AACxK;EACE,wCAAwC,EAAE;;AAE5C;EACE,qBAAqB;EACrB,WAAW;EACX,2BAA2B;EAC3B,0CAA0C;EAC1C,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,uFAAsN;EACtN,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB,EAAE;EAClB;IACE,qBAAqB;IACrB,UAAU;IACV,kFAAkF,EAAE;IACpF;MACE,cAAc;MACd,sBAAsB,EAAE;EAC5B;IACE,YAAY;IACZ,sBAAsB;IACtB,sBAAsB,EAAE;EAC1B;IACE,cAAc;IACd,yBAAyB,EAAE;EAC7B;IACE,UAAU,EAAE;;AAEhB;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,wBAAwB;EACxB,cAAc,EAAE;;AAElB;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,wBAAwB;EACxB,eAAe,EAAE;;AAEnB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,2BAA2B;EAC3B,gBAAgB,EAAE;;AAEpB;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,2BAA2B;EAC3B,SAAS;EACT,UAAU,EAAE;EACZ;IACE,qBAAqB;IACrB,gDAAgD,EAAE;IAClD;MACE,qBAAqB,EAAE;EAC3B;IACE,iBAAiB,EAAE;;AAEvB;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,OAAO;EACP,UAAU;EACV,2BAA2B;EAC3B,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB,EAAE;EACxB;IACE,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,UAAU;IACV,cAAc;IACd,2CAA2C;IAC3C,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,yBAAyB;IACzB,8BAA8B;IAC9B,kCAAkC,EAAE;;AAExC;EACE,WAAW;EACX,eAAe;EACf,6BAA6B;EAC7B,gBAAgB,EAAE;EAClB;IACE,aAAa,EAAE;EACjB;IACE,SAAS,EAAE;EACb;IACE,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,yBAAyB;IACzB,SAAS;IACT,mBAAmB;IACnB,gBAAgB,EAAE;IAClB;MACE,aAAa;MACb,gEAAgE,EAAE;IACpE;MACE,yBAAyB,EAAE;EAC/B;IACE,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB,EAAE;EACvB;IACE,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,SAAS;IACT,mBAAmB;IACnB,gBAAgB,EAAE;IAClB;MACE,aAAa;MACb,gEAAgE,EAAE;IACpE;MACE,yBAAyB,EAAE;EAC/B;IACE,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB,EAAE;EACvB;IACE,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,SAAS;IACT,mBAAmB;IACnB,gBAAgB,EAAE;IAClB;MACE,aAAa;MACb,gEAAgE,EAAE;IACpE;MACE,yBAAyB,EAAE;EAC/B;IACE,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,6BAA6B;IAC7B,yBAAyB;IACzB,oBAAoB,EAAE;EACxB;IACE,yBAAyB;IACzB,mBAAmB,EAAE;EACvB;IACE,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB,EAAE;;AAEzB;EACE,aAAa;EACb,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB,EAAE;;AAEpB;EACE,cAAc;EACd,oBAAoB,EAAE;EACtB;IACE,qBAAqB,EAAE;EACzB;IACE,cAAc,EAAE;;AAEpB;EACE,gCAAgC,EAAE;EAClC;IACE,mBAAmB,EAAE;EACvB;IACE,6BAA6B;IAC7B,+BAA+B;IAC/B,gCAAgC,EAAE;IAClC;MACE,qCAAqC,EAAE;IACzC;MACE,cAAc;MACd,6BAA6B;MAC7B,yBAAyB,EAAE;EAC/B;;IAEE,cAAc;IACd,sBAAsB;IACtB,kCAAkC,EAAE;EACtC;IACE,gBAAgB;IAChB,yBAAyB;IACzB,0BAA0B,EAAE;;AAEhC;EACE,sBAAsB,EAAE;AAC1B;;EAEE,WAAW;EACX,yBAAyB,EAAE;;AAE7B;EACE,cAAc;EACd,kBAAkB,EAAE;;AAEtB;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB,EAAE;;AAEtB;EACE,aAAa,EAAE;AACjB;EACE,cAAc,EAAE;;AAElB;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB,EAAE;EACtB;;IAEE,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,8BAA8B,EAAE;;AAEpC;EACE,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB,EAAE;EACrB;IACE,qBAAqB,EAAE;;AAE3B;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,gBAAgB,EAAE;EAClB;IACE,gBAAgB;IAChB,eAAe,EAAE;EACnB;IACE,gBAAgB;IAChB,WAAW,EAAE;;AAEjB;EACE,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB,EAAE;;AAE1B;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB,EAAE;;AAEvB;EACE,wBAAwB;EACxB,kBAAkB;EAClB,cAAc;EACd,6BAA6B;EAC7B,6BAA6B;EAC7B,sBAAsB,EAAE;EACxB;IACE,qBAAqB,EAAE;EACzB;IACE,eAAe,EAAE;;AAErB;EACE,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mCAAmC;EACnC,0BAA0B,EAAE;;AAE9B;EACE;;IAEE,gBAAgB;IAChB,eAAe,EAAE,EAAE;AACvB;EACE;IACE,qBAAqB;IACrB,2BAA2B,EAAE;IAC7B;MACE,mBAAmB,EAAE;MACrB;QACE,kBAAkB,EAAE;MACtB;QACE,qBAAqB;QACrB,oBAAoB,EAAE;IAC1B;;MAEE,iBAAiB,EAAE;IACrB;MACE,wBAAwB;MACxB,gBAAgB,EAAE;IACpB;MACE,aAAa,EAAE,EAAE;AACvB;EACE;;IAEE,gBAAgB;IAChB,eAAe,EAAE,EAAE;AACvB;EACE;IACE,qBAAqB;IACrB,2BAA2B,EAAE;IAC7B;MACE,mBAAmB,EAAE;MACrB;QACE,kBAAkB,EAAE;MACtB;QACE,qBAAqB;QACrB,oBAAoB,EAAE;IAC1B;;MAEE,iBAAiB,EAAE;IACrB;MACE,wBAAwB;MACxB,gBAAgB,EAAE;IACpB;MACE,aAAa,EAAE,EAAE;AACvB;EACE;;IAEE,gBAAgB;IAChB,eAAe,EAAE,EAAE;AACvB;EACE;IACE,qBAAqB;IACrB,2BAA2B,EAAE;IAC7B;MACE,mBAAmB,EAAE;MACrB;QACE,kBAAkB,EAAE;MACtB;QACE,qBAAqB;QACrB,oBAAoB,EAAE;IAC1B;;MAEE,iBAAiB,EAAE;IACrB;MACE,wBAAwB;MACxB,gBAAgB,EAAE;IACpB;MACE,aAAa,EAAE,EAAE;AACvB;EACE;;IAEE,gBAAgB;IAChB,eAAe,EAAE,EAAE;AACvB;EACE;IACE,qBAAqB;IACrB,2BAA2B,EAAE;IAC7B;MACE,mBAAmB,EAAE;MACrB;QACE,kBAAkB,EAAE;MACtB;QACE,qBAAqB;QACrB,oBAAoB,EAAE;IAC1B;;MAEE,iBAAiB,EAAE;IACrB;MACE,wBAAwB;MACxB,gBAAgB,EAAE;IACpB;MACE,aAAa,EAAE,EAAE;AACvB;EACE,qBAAqB;EACrB,2BAA2B,EAAE;EAC7B;;IAEE,gBAAgB;IAChB,eAAe,EAAE;EACnB;IACE,mBAAmB,EAAE;IACrB;MACE,kBAAkB,EAAE;IACtB;MACE,qBAAqB;MACrB,oBAAoB,EAAE;EAC1B;;IAEE,iBAAiB,EAAE;EACrB;IACE,wBAAwB;IACxB,gBAAgB,EAAE;EACpB;IACE,aAAa,EAAE;;AAEnB;EACE,yBAAyB,EAAE;EAC3B;IACE,yBAAyB,EAAE;AAC/B;EACE,yBAAyB,EAAE;EAC3B;IACE,yBAAyB,EAAE;EAC7B;IACE,yBAAyB,EAAE;AAC/B;;;;EAIE,yBAAyB,EAAE;AAC7B;EACE,yBAAyB;EACzB,gCAAgC,EAAE;AACpC;EACE,yDAAqQ,EAAE;AACzQ;EACE,yBAAyB,EAAE;EAC3B;IACE,yBAAyB,EAAE;IAC3B;MACE,yBAAyB,EAAE;;AAEjC;EACE,WAAW,EAAE;EACb;IACE,WAAW,EAAE;AACjB;EACE,+BAA+B,EAAE;EACjC;IACE,gCAAgC,EAAE;EACpC;IACE,gCAAgC,EAAE;AACtC;;;;EAIE,WAAW,EAAE;AACf;EACE,+BAA+B;EAC/B,sCAAsC,EAAE;AAC1C;EACE,yDAA2Q,EAAE;AAC/Q;EACE,+BAA+B,EAAE;EACjC;IACE,WAAW,EAAE;IACb;MACE,WAAW,EAAE;;AAEnB;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,2BAA2B;EAC3B,sCAAsC;EACtC,sBAAsB,EAAE;EACxB;IACE,eAAe;IACf,cAAc,EAAE;EAClB;IACE,+BAA+B;IAC/B,gCAAgC,EAAE;EACpC;IACE,mCAAmC;IACnC,kCAAkC,EAAE;;AAExC;EACE,cAAc;EACd,gBAAgB,EAAE;;AAEpB;EACE,sBAAsB,EAAE;;AAE1B;EACE,qBAAqB;EACrB,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,qBAAqB,EAAE;AACzB;EACE,oBAAoB,EAAE;;AAExB;EACE,wBAAwB;EACxB,gBAAgB;EAChB,qCAAqC;EACrC,6CAA6C,EAAE;EAC/C;IACE,0DAA0D,EAAE;EAC9D;IACE,aAAa,EAAE;;AAEnB;EACE,wBAAwB;EACxB,qCAAqC;EACrC,0CAA0C,EAAE;EAC5C;IACE,0DAA0D,EAAE;;AAEhE;EACE,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB,EAAE;;AAEpB;EACE,uBAAuB;EACvB,sBAAsB,EAAE;;AAE1B;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,gBAAgB,EAAE;;AAEpB;EACE,WAAW;EACX,kCAAkC,EAAE;;AAEtC;EACE,WAAW;EACX,2CAA2C;EAC3C,4CAA4C,EAAE;;AAEhD;EACE,WAAW;EACX,+CAA+C;EAC/C,8CAA8C,EAAE;;AAElD;EACE,aAAa;EACb,sBAAsB,EAAE;EACxB;IACE,mBAAmB,EAAE;EACvB;IACE;MACE,mBAAmB;MACnB,mBAAmB;MACnB,kBAAkB,EAAE;MACpB;QACE,aAAa;QACb,SAAY;QACZ,sBAAsB;QACtB,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB,EAAE,EAAE;;AAE7B;EACE,aAAa;EACb,sBAAsB,EAAE;EACxB;IACE,mBAAmB,EAAE;EACvB;IACE;MACE,mBAAmB,EAAE;MACrB;QACE,SAAY;QACZ,gBAAgB,EAAE;QAClB;UACE,cAAc;UACd,cAAc,EAAE;QAClB;UACE,0BAA0B;UAC1B,6BAA6B,EAAE;UAC/B;;YAEE,0BAA0B,EAAE;UAC9B;;YAEE,6BAA6B,EAAE;QACnC;UACE,yBAAyB;UACzB,4BAA4B,EAAE;UAC9B;;YAEE,yBAAyB,EAAE;UAC7B;;YAEE,4BAA4B,EAAE;QAClC;UACE,sBAAsB,EAAE;UACxB;;YAEE,+BAA+B;YAC/B,gCAAgC,EAAE;UACpC;;YAEE,mCAAmC;YACnC,kCAAkC,EAAE;QACxC;UACE,gBAAgB,EAAE;UAClB;;;;YAIE,gBAAgB,EAAE,EAAE;;AAEhC;EACE,sBAAsB,EAAE;AAC1B;EACE;IACE,eAAe;IACf,mBAAmB;IACnB,UAAU;IACV,SAAS,EAAE;IACX;MACE,qBAAqB;MACrB,WAAW,EAAE,EAAE;;AAErB;EACE,gBAAgB;EAChB,gBAAgB,EAAE;AACpB;EACE,gBAAgB,EAAE;AACpB;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,4BAA4B,EAAE;AAChC;EACE,yBAAyB;EACzB,0BAA0B,EAAE;;AAE9B;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB,EAAE;;AAE1B;EACE,oBAAoB,EAAE;EACtB;IACE,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,YAAY,EAAE;AAClB;EACE,0BAA0B,EAAE;AAC9B;EACE,qBAAqB,EAAE;AACzB;EACE,cAAc,EAAE;;AAElB;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,sBAAsB,EAAE;;AAE1B;EACE,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,yBAAyB,EAAE;EAC3B;IACE,UAAU;IACV,cAAc;IACd,qBAAqB;IACrB,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;IACE,UAAU;IACV,UAAU;IACV,gDAAgD,EAAE;EACpD;IACE,eAAe,EAAE;;AAErB;EACE,cAAc;EACd,+BAA+B;EAC/B,kCAAkC,EAAE;AACtC;EACE,gCAAgC;EAChC,mCAAmC,EAAE;AACvC;EACE,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,qBAAqB,EAAE;AACzB;EACE,cAAc;EACd,oBAAoB;EACpB,YAAY;EACZ,sBAAsB;EACtB,qBAAqB,EAAE;;AAEzB;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB,EAAE;AACpB;EACE,8BAA8B;EAC9B,iCAAiC,EAAE;AACrC;EACE,+BAA+B;EAC/B,kCAAkC,EAAE;;AAEtC;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB,EAAE;AACpB;EACE,8BAA8B;EAC9B,iCAAiC,EAAE;AACrC;EACE,+BAA+B;EAC/B,kCAAkC,EAAE;;AAEtC;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,sBAAsB,EAAE;EACxB;IACE,aAAa,EAAE;;AAEnB;EACE,kBAAkB;EAClB,SAAS,EAAE;;AAEb;EACE,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB,EAAE;;AAExB;EACE,WAAW;EACX,yBAAyB,EAAE;EAC3B;IACE,WAAW;IACX,qBAAqB;IACrB,yBAAyB,EAAE;;AAE/B;EACE,WAAW;EACX,yBAAyB,EAAE;EAC3B;IACE,WAAW;IACX,qBAAqB;IACrB,yBAAyB,EAAE;;AAE/B;EACE,WAAW;EACX,yBAAyB,EAAE;EAC3B;IACE,WAAW;IACX,qBAAqB;IACrB,yBAAyB,EAAE;;AAE/B;EACE,WAAW;EACX,yBAAyB,EAAE;EAC3B;IACE,WAAW;IACX,qBAAqB;IACrB,yBAAyB,EAAE;;AAE/B;EACE,cAAc;EACd,yBAAyB,EAAE;EAC3B;IACE,cAAc;IACd,qBAAqB;IACrB,yBAAyB,EAAE;;AAE/B;EACE,WAAW;EACX,yBAAyB,EAAE;EAC3B;IACE,WAAW;IACX,qBAAqB;IACrB,yBAAyB,EAAE;;AAE/B;EACE,cAAc;EACd,yBAAyB,EAAE;EAC3B;IACE,cAAc;IACd,qBAAqB;IACrB,yBAAyB,EAAE;;AAE/B;EACE,WAAW;EACX,yBAAyB,EAAE;EAC3B;IACE,WAAW;IACX,qBAAqB;IACrB,yBAAyB,EAAE;;AAE/B;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB,EAAE;EACvB;IACE;MACE,kBAAkB,EAAE,EAAE;;AAE5B;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB,EAAE;;AAEpB;EACE,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,6BAA6B;EAC7B,sBAAsB,EAAE;;AAE1B;EACE,cAAc,EAAE;;AAElB;EACE,gBAAgB,EAAE;;AAEpB;EACE,mBAAmB,EAAE;EACrB;IACE,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,wBAAwB;IACxB,cAAc,EAAE;;AAEpB;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB,EAAE;EACvB;IACE,yBAAyB,EAAE;EAC7B;IACE,cAAc,EAAE;;AAEpB;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB,EAAE;EACvB;IACE,yBAAyB,EAAE;EAC7B;IACE,cAAc,EAAE;;AAEpB;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB,EAAE;EACvB;IACE,yBAAyB,EAAE;EAC7B;IACE,cAAc,EAAE;;AAEpB;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB,EAAE;EACvB;IACE,yBAAyB,EAAE;EAC7B;IACE,cAAc,EAAE;;AAEpB;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB,EAAE;EACvB;IACE,yBAAyB,EAAE;EAC7B;IACE,cAAc,EAAE;;AAEpB;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB,EAAE;EACvB;IACE,yBAAyB,EAAE;EAC7B;IACE,cAAc,EAAE;;AAEpB;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB,EAAE;EACvB;IACE,yBAAyB,EAAE;EAC7B;IACE,cAAc,EAAE;;AAEpB;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB,EAAE;EACvB;IACE,yBAAyB,EAAE;EAC7B;IACE,cAAc,EAAE;;AAEpB;EACE;IACE,2BAA2B,EAAE;EAC/B;IACE,wBAAwB,EAAE,EAAE;AAChC;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,2BAA2B,EAAE;EAC7B;IACE;MACE,gBAAgB,EAAE,EAAE;;AAE1B;EACE,qMAAqM;EACrM,0BAA0B,EAAE;;AAE9B;EACE,kDAAkD,EAAE;;AAEtD;EACE,aAAa;EACb,uBAAuB,EAAE;;AAE3B;EACE,SAAO,EAAE;;AAEX;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,gBAAgB,EAAE;;AAEpB;EACE,WAAW;EACX,cAAc;EACd,mBAAmB,EAAE;EACrB;IACE,cAAc;IACd,qBAAqB;IACrB,yBAAyB,EAAE;EAC7B;IACE,cAAc;IACd,yBAAyB,EAAE;;AAE/B;EACE,kBAAkB;EAClB,cAAc;EACd,wBAAwB;EACxB,mBAAmB;EACnB,sBAAsB;EACtB,sCAAsC,EAAE;EACxC;IACE,+BAA+B;IAC/B,gCAAgC,EAAE;EACpC;IACE,gBAAgB;IAChB,mCAAmC;IACnC,kCAAkC,EAAE;EACtC;IACE,UAAU;IACV,qBAAqB,EAAE;EACzB;IACE,cAAc;IACd,sBAAsB,EAAE;EAC1B;IACE,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;;AAE3B;EACE,eAAe;EACf,cAAc;EACd,gBAAgB,EAAE;AACpB;EACE,aAAa,EAAE;AACjB;EACE,gBAAgB,EAAE;;AAEpB;EACE,cAAc;EACd,yBAAyB,EAAE;EAC3B;IACE,cAAc;IACd,yBAAyB,EAAE;EAC7B;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;;AAE3B;EACE,cAAc;EACd,yBAAyB,EAAE;EAC3B;IACE,cAAc;IACd,yBAAyB,EAAE;EAC7B;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;;AAE3B;EACE,cAAc;EACd,yBAAyB,EAAE;EAC3B;IACE,cAAc;IACd,yBAAyB,EAAE;EAC7B;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;;AAE3B;EACE,cAAc;EACd,yBAAyB,EAAE;EAC3B;IACE,cAAc;IACd,yBAAyB,EAAE;EAC7B;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;;AAE3B;EACE,cAAc;EACd,yBAAyB,EAAE;EAC3B;IACE,cAAc;IACd,yBAAyB,EAAE;EAC7B;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;;AAE3B;EACE,cAAc;EACd,yBAAyB,EAAE;EAC3B;IACE,cAAc;IACd,yBAAyB,EAAE;EAC7B;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;;AAE3B;EACE,cAAc;EACd,yBAAyB,EAAE;EAC3B;IACE,cAAc;IACd,yBAAyB,EAAE;EAC7B;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;;AAE3B;EACE,cAAc;EACd,yBAAyB,EAAE;EAC3B;IACE,cAAc;IACd,yBAAyB,EAAE;EAC7B;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;;AAE3B;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,WAAW,EAAE;EACb;IACE,WAAW;IACX,qBAAqB;IACrB,YAAY,EAAE;EAChB;IACE,eAAe,EAAE;;AAErB;EACE,UAAU;EACV,6BAA6B;EAC7B,SAAS;EACT,wBAAwB,EAAE;;AAE5B;EACE,gBAAgB,EAAE;;AAEpB;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,UAAU,EAAE;EACZ;IACE,kBAAkB;IAClB,gBAAgB,EAAE;;AAEtB;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,oBAAoB,EAAE;EACtB;IACE,mCAAmC;IACnC,6BAA6B,EAAE;IAC/B;MACE;QACE,gBAAgB,EAAE,EAAE;EAC1B;IACE,0BAA0B,EAAE;;AAEhC;EACE,aAAa;EACb,mBAAmB;EACnB,qCAAqC,EAAE;;AAEzC;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,oBAAoB;EACpB,sBAAsB;EACtB,4BAA4B;EAC5B,oCAAoC;EACpC,qBAAqB;EACrB,UAAU,EAAE;;AAEd;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,aAAa;EACb,sBAAsB,EAAE;EACxB;IACE,UAAU,EAAE;EACd;IACE,YAAY,EAAE;;AAElB;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,aAAa;EACb,gCAAgC;EAChC,8BAA8B;EAC9B,+BAA+B,EAAE;EACjC;IACE,aAAa;IACb,8BAA8B,EAAE;;AAEpC;EACE,gBAAgB;EAChB,gBAAgB,EAAE;;AAEpB;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa,EAAE;;AAEjB;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,6BAA6B,EAAE;EAC/B;IACE,mBAAmB,EAAE;EACvB;IACE,oBAAoB,EAAE;;AAE1B;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,gBAAgB,EAAE;;AAEpB;EACE;IACE,gBAAgB;IAChB,oBAAoB,EAAE;;EAExB;IACE,sCAAsC,EAAE;;EAE1C;IACE,gBAAgB,EAAE,EAAE;AACxB;EACE;IACE,gBAAgB,EAAE,EAAE;AACxB;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,SAAS;EACT,iKAAiK;EACjK,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,UAAU,EAAE;EACZ;IACE,YAAY,EAAE;EAChB;IACE,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,cAAc,EAAE;IAChB;MACE,kBAAkB;MAClB,WAAW;MACX,yBAAyB;MACzB,mBAAmB,EAAE;;AAE3B;EACE,iBAAiB,EAAE;EACnB;IACE,SAAS,EAAE;IACX;MACE,MAAM;MACN,6BAA6B;MAC7B,sBAAsB,EAAE;;AAE9B;EACE,iBAAiB,EAAE;EACnB;IACE,OAAO;IACP,aAAa;IACb,cAAc,EAAE;IAChB;MACE,QAAQ;MACR,oCAAoC;MACpC,wBAAwB,EAAE;;AAEhC;EACE,iBAAiB,EAAE;EACnB;IACE,MAAM,EAAE;IACR;MACE,SAAS;MACT,6BAA6B;MAC7B,yBAAyB,EAAE;;AAEjC;EACE,iBAAiB,EAAE;EACnB;IACE,QAAQ;IACR,aAAa;IACb,cAAc,EAAE;IAChB;MACE,OAAO;MACP,oCAAoC;MACpC,uBAAuB,EAAE;;AAE/B;EACE,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB,EAAE;;AAE1B;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,iKAAiK;EACjK,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,4BAA4B;EAC5B,oCAAoC;EACpC,qBAAqB,EAAE;EACvB;IACE,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,cAAc;IACd,gBAAgB,EAAE;IAClB;MACE,kBAAkB;MAClB,cAAc;MACd,WAAW;MACX,yBAAyB;MACzB,mBAAmB,EAAE;;AAE3B;EACE,qBAAqB,EAAE;EACvB;IACE,iCAAiC,EAAE;EACrC;;;IAGE,6BAA6B,EAAE;EACjC;IACE,SAAS;IACT,qCAAqC,EAAE;EACzC;IACE,WAAW;IACX,sBAAsB,EAAE;;AAE5B;EACE,mBAAmB,EAAE;EACrB;IACE,+BAA+B;IAC/B,aAAa;IACb,YAAY;IACZ,gBAAgB,EAAE;EACpB;;;IAGE,oCAAoC,EAAE;EACxC;IACE,OAAO;IACP,uCAAuC,EAAE;EAC3C;IACE,SAAS;IACT,wBAAwB,EAAE;;AAE9B;EACE,kBAAkB,EAAE;EACpB;IACE,8BAA8B,EAAE;EAClC;;;IAGE,oCAAoC,EAAE;EACxC;IACE,MAAM;IACN,wCAAwC,EAAE;EAC5C;IACE,QAAQ;IACR,yBAAyB,EAAE;EAC7B;IACE,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,cAAc;IACd,WAAW;IACX,oBAAoB;IACpB,WAAW;IACX,gCAAgC,EAAE;;AAEtC;EACE,oBAAoB,EAAE;EACtB;IACE,gCAAgC;IAChC,aAAa;IACb,YAAY;IACZ,gBAAgB,EAAE;EACpB;;;IAGE,oCAAoC,EAAE;EACxC;IACE,QAAQ;IACR,sCAAsC,EAAE;EAC1C;IACE,UAAU;IACV,uBAAuB,EAAE;;AAE7B;EACE,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,gCAAgC;EAChC,0CAA0C;EAC1C,2CAA2C,EAAE;EAC7C;IACE,aAAa,EAAE;;AAEnB;EACE,uBAAuB;EACvB,cAAc,EAAE;;AAElB;EACE,kBAAkB,EAAE;;AAEtB;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB,EAAE;;AAEpB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,+BAA+B;EAC/B,2BAA2B;EAC3B,mBAAmB,EAAE;EACrB;IACE;MACE,gBAAgB,EAAE,EAAE;;AAE1B;;;EAGE,cAAc,EAAE;;AAElB;;EAEE,kBAAkB;EAClB,MAAM,EAAE;;AAEV;;EAEE,wBAAwB,EAAE;EAC1B;IACE;;MAEE,+BAA+B,EAAE,EAAE;;AAEzC;;EAEE,2BAA2B,EAAE;EAC7B;IACE;;MAEE,kCAAkC,EAAE,EAAE;;AAE5C;;EAEE,4BAA4B,EAAE;EAC9B;IACE;;MAEE,mCAAmC,EAAE,EAAE;;AAE7C;EACE,UAAU;EACV,wBAAwB;EACxB,4BAA4B,EAAE;AAChC;;;EAGE,UAAU,EAAE;AACd;;EAEE,UAAU,EAAE;AACd;;;;;EAKE,wBAAwB,EAAE;EAC1B;IACE;;;;;MAKE,+BAA+B,EAAE,EAAE;;AAEzC;;EAEE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,YAAY,EAAE;EACd;;;IAGE,WAAW;IACX,qBAAqB;IACrB,UAAU;IACV,WAAW,EAAE;;AAEjB;EACE,OAAO,EAAE;;AAEX;EACE,QAAQ,EAAE;;AAEZ;;EAEE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,+CAA+C;EAC/C,0BAA0B,EAAE;;AAE9B;EACE,yDAAgN,EAAE;;AAEpN;EACE,yDAAgN,EAAE;;AAEpN;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,OAAO;EACP,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB,EAAE;EAClB;IACE,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,0CAA0C,EAAE;IAC5C;MACE,kBAAkB;MAClB,UAAU;MACV,OAAO;MACP,qBAAqB;MACrB,WAAW;MACX,YAAY;MACZ,WAAW,EAAE;IACf;MACE,kBAAkB;MAClB,aAAa;MACb,OAAO;MACP,qBAAqB;MACrB,WAAW;MACX,YAAY;MACZ,WAAW,EAAE;EACjB;IACE,sBAAsB,EAAE;;AAE5B;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,mCAAmC,EAAE;;AAEvC;EACE,8BAA8B,EAAE;;AAElC;EACE,iCAAiC,EAAE;;AAErC;EACE,iCAAiC,EAAE;;AAErC;EACE,sCAAsC,EAAE;;AAE1C;EACE,mCAAmC,EAAE;;AAEvC;EACE,oCAAoC,EAAE;;AAExC;;;EAGE,oCAAoC,EAAE;;AAExC;EACE,oCAAoC,EAAE;;AAExC;;;EAGE,oCAAoC,EAAE;;AAExC;EACE,oCAAoC,EAAE;;AAExC;;;EAGE,oCAAoC,EAAE;;AAExC;EACE,oCAAoC,EAAE;;AAExC;;;EAGE,oCAAoC,EAAE;;AAExC;EACE,oCAAoC,EAAE;;AAExC;;;EAGE,oCAAoC,EAAE;;AAExC;EACE,oCAAoC,EAAE;;AAExC;;;EAGE,oCAAoC,EAAE;;AAExC;EACE,oCAAoC,EAAE;;AAExC;;;EAGE,oCAAoC,EAAE;;AAExC;EACE,oCAAoC,EAAE;;AAExC;;;EAGE,oCAAoC,EAAE;;AAExC;EACE,iCAAiC,EAAE;;AAErC;EACE,wCAAwC,EAAE;;AAE5C;EACE,oCAAoC,EAAE;;AAExC;EACE,wCAAwC,EAAE;;AAE5C;EACE,0CAA0C,EAAE;;AAE9C;EACE,2CAA2C,EAAE;;AAE/C;EACE,yCAAyC,EAAE;;AAE7C;EACE,oBAAoB,EAAE;;AAExB;EACE,wBAAwB,EAAE;;AAE5B;EACE,0BAA0B,EAAE;;AAE9B;EACE,2BAA2B,EAAE;;AAE/B;EACE,yBAAyB,EAAE;;AAE7B;EACE,gCAAgC,EAAE;;AAEpC;EACE,gCAAgC,EAAE;;AAEpC;EACE,gCAAgC,EAAE;;AAEpC;EACE,gCAAgC,EAAE;;AAEpC;EACE,gCAAgC,EAAE;;AAEpC;EACE,gCAAgC,EAAE;;AAEpC;EACE,gCAAgC,EAAE;;AAEpC;EACE,gCAAgC,EAAE;;AAEpC;EACE,6BAA6B,EAAE;;AAEjC;EACE,iCAAiC,EAAE;;AAErC;EACE,0CAA0C;EAC1C,2CAA2C,EAAE;;AAE/C;EACE,2CAA2C;EAC3C,8CAA8C,EAAE;;AAElD;EACE,8CAA8C;EAC9C,6CAA6C,EAAE;;AAEjD;EACE,0CAA0C;EAC1C,6CAA6C,EAAE;;AAEjD;EACE,6BAA6B,EAAE;;AAEjC;EACE,2BAA2B,EAAE;;AAE/B;EACE,cAAc;EACd,WAAW;EACX,WAAW,EAAE;;AAEf;EACE,wBAAwB,EAAE;;AAE5B;EACE,0BAA0B,EAAE;;AAE9B;EACE,gCAAgC,EAAE;;AAEpC;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,6BAA6B,EAAE;;AAEjC;EACE,8BAA8B,EAAE;;AAElC;EACE,wBAAwB,EAAE;;AAE5B;EACE,+BAA+B,EAAE;;AAEnC;EACE;IACE,wBAAwB,EAAE;;EAE5B;IACE,0BAA0B,EAAE;;EAE9B;IACE,gCAAgC,EAAE;;EAEpC;IACE,yBAAyB,EAAE;;EAE7B;IACE,yBAAyB,EAAE;;EAE7B;IACE,6BAA6B,EAAE;;EAEjC;IACE,8BAA8B,EAAE;;EAElC;IACE,wBAAwB,EAAE;;EAE5B;IACE,+BAA+B,EAAE,EAAE;AACvC;EACE;IACE,wBAAwB,EAAE;;EAE5B;IACE,0BAA0B,EAAE;;EAE9B;IACE,gCAAgC,EAAE;;EAEpC;IACE,yBAAyB,EAAE;;EAE7B;IACE,yBAAyB,EAAE;;EAE7B;IACE,6BAA6B,EAAE;;EAEjC;IACE,8BAA8B,EAAE;;EAElC;IACE,wBAAwB,EAAE;;EAE5B;IACE,+BAA+B,EAAE,EAAE;AACvC;EACE;IACE,wBAAwB,EAAE;;EAE5B;IACE,0BAA0B,EAAE;;EAE9B;IACE,gCAAgC,EAAE;;EAEpC;IACE,yBAAyB,EAAE;;EAE7B;IACE,yBAAyB,EAAE;;EAE7B;IACE,6BAA6B,EAAE;;EAEjC;IACE,8BAA8B,EAAE;;EAElC;IACE,wBAAwB,EAAE;;EAE5B;IACE,+BAA+B,EAAE,EAAE;AACvC;EACE;IACE,wBAAwB,EAAE;;EAE5B;IACE,0BAA0B,EAAE;;EAE9B;IACE,gCAAgC,EAAE;;EAEpC;IACE,yBAAyB,EAAE;;EAE7B;IACE,yBAAyB,EAAE;;EAE7B;IACE,6BAA6B,EAAE;;EAEjC;IACE,8BAA8B,EAAE;;EAElC;IACE,wBAAwB,EAAE;;EAE5B;IACE,+BAA+B,EAAE,EAAE;AACvC;EACE;IACE,wBAAwB,EAAE;;EAE5B;IACE,0BAA0B,EAAE;;EAE9B;IACE,gCAAgC,EAAE;;EAEpC;IACE,yBAAyB,EAAE;;EAE7B;IACE,yBAAyB,EAAE;;EAE7B;IACE,6BAA6B,EAAE;;EAEjC;IACE,8BAA8B,EAAE;;EAElC;IACE,wBAAwB,EAAE;;EAE5B;IACE,+BAA+B,EAAE,EAAE;AACvC;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,UAAU;EACV,gBAAgB,EAAE;EAClB;IACE,cAAc;IACd,WAAW,EAAE;EACf;;;;;IAKE,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,OAAO;IACP,WAAW;IACX,YAAY;IACZ,SAAS,EAAE;;AAEf;EACE,2BAA2B,EAAE;;AAE/B;EACE,mBAAmB,EAAE;;AAEvB;EACE,gBAAgB,EAAE;;AAEpB;EACE,iBAAiB,EAAE;;AAErB;EACE,8BAA8B,EAAE;;AAElC;EACE,iCAAiC,EAAE;;AAErC;EACE,sCAAsC,EAAE;;AAE1C;EACE,yCAAyC,EAAE;;AAE7C;EACE,0BAA0B,EAAE;;AAE9B;EACE,4BAA4B,EAAE;;AAEhC;EACE,kCAAkC,EAAE;;AAEtC;EACE,yBAAyB,EAAE;;AAE7B;EACE,uBAAuB,EAAE;;AAE3B;EACE,uBAAuB,EAAE;;AAE3B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,sCAAsC,EAAE;;AAE1C;EACE,oCAAoC,EAAE;;AAExC;EACE,kCAAkC,EAAE;;AAEtC;EACE,yCAAyC,EAAE;;AAE7C;EACE,wCAAwC,EAAE;;AAE5C;EACE,kCAAkC,EAAE;;AAEtC;EACE,gCAAgC,EAAE;;AAEpC;EACE,8BAA8B,EAAE;;AAElC;EACE,gCAAgC,EAAE;;AAEpC;EACE,+BAA+B,EAAE;;AAEnC;EACE,oCAAoC,EAAE;;AAExC;EACE,kCAAkC,EAAE;;AAEtC;EACE,gCAAgC,EAAE;;AAEpC;EACE,uCAAuC,EAAE;;AAE3C;EACE,sCAAsC,EAAE;;AAE1C;EACE,iCAAiC,EAAE;;AAErC;EACE,2BAA2B,EAAE;;AAE/B;EACE,iCAAiC,EAAE;;AAErC;EACE,+BAA+B,EAAE;;AAEnC;EACE,6BAA6B,EAAE;;AAEjC;EACE,+BAA+B,EAAE;;AAEnC;EACE,8BAA8B,EAAE;;AAElC;EACE;IACE,8BAA8B,EAAE;;EAElC;IACE,iCAAiC,EAAE;;EAErC;IACE,sCAAsC,EAAE;;EAE1C;IACE,yCAAyC,EAAE;;EAE7C;IACE,0BAA0B,EAAE;;EAE9B;IACE,4BAA4B,EAAE;;EAEhC;IACE,kCAAkC,EAAE;;EAEtC;IACE,yBAAyB,EAAE;;EAE7B;IACE,uBAAuB,EAAE;;EAE3B;IACE,uBAAuB,EAAE;;EAE3B;IACE,yBAAyB,EAAE;;EAE7B;IACE,yBAAyB,EAAE;;EAE7B;IACE,sCAAsC,EAAE;;EAE1C;IACE,oCAAoC,EAAE;;EAExC;IACE,kCAAkC,EAAE;;EAEtC;IACE,yCAAyC,EAAE;;EAE7C;IACE,wCAAwC,EAAE;;EAE5C;IACE,kCAAkC,EAAE;;EAEtC;IACE,gCAAgC,EAAE;;EAEpC;IACE,8BAA8B,EAAE;;EAElC;IACE,gCAAgC,EAAE;;EAEpC;IACE,+BAA+B,EAAE;;EAEnC;IACE,oCAAoC,EAAE;;EAExC;IACE,kCAAkC,EAAE;;EAEtC;IACE,gCAAgC,EAAE;;EAEpC;IACE,uCAAuC,EAAE;;EAE3C;IACE,sCAAsC,EAAE;;EAE1C;IACE,iCAAiC,EAAE;;EAErC;IACE,2BAA2B,EAAE;;EAE/B;IACE,iCAAiC,EAAE;;EAErC;IACE,+BAA+B,EAAE;;EAEnC;IACE,6BAA6B,EAAE;;EAEjC;IACE,+BAA+B,EAAE;;EAEnC;IACE,8BAA8B,EAAE,EAAE;AACtC;EACE;IACE,8BAA8B,EAAE;;EAElC;IACE,iCAAiC,EAAE;;EAErC;IACE,sCAAsC,EAAE;;EAE1C;IACE,yCAAyC,EAAE;;EAE7C;IACE,0BAA0B,EAAE;;EAE9B;IACE,4BAA4B,EAAE;;EAEhC;IACE,kCAAkC,EAAE;;EAEtC;IACE,yBAAyB,EAAE;;EAE7B;IACE,uBAAuB,EAAE;;EAE3B;IACE,uBAAuB,EAAE;;EAE3B;IACE,yBAAyB,EAAE;;EAE7B;IACE,yBAAyB,EAAE;;EAE7B;IACE,sCAAsC,EAAE;;EAE1C;IACE,oCAAoC,EAAE;;EAExC;IACE,kCAAkC,EAAE;;EAEtC;IACE,yCAAyC,EAAE;;EAE7C;IACE,wCAAwC,EAAE;;EAE5C;IACE,kCAAkC,EAAE;;EAEtC;IACE,gCAAgC,EAAE;;EAEpC;IACE,8BAA8B,EAAE;;EAElC;IACE,gCAAgC,EAAE;;EAEpC;IACE,+BAA+B,EAAE;;EAEnC;IACE,oCAAoC,EAAE;;EAExC;IACE,kCAAkC,EAAE;;EAEtC;IACE,gCAAgC,EAAE;;EAEpC;IACE,uCAAuC,EAAE;;EAE3C;IACE,sCAAsC,EAAE;;EAE1C;IACE,iCAAiC,EAAE;;EAErC;IACE,2BAA2B,EAAE;;EAE/B;IACE,iCAAiC,EAAE;;EAErC;IACE,+BAA+B,EAAE;;EAEnC;IACE,6BAA6B,EAAE;;EAEjC;IACE,+BAA+B,EAAE;;EAEnC;IACE,8BAA8B,EAAE,EAAE;AACtC;EACE;IACE,8BAA8B,EAAE;;EAElC;IACE,iCAAiC,EAAE;;EAErC;IACE,sCAAsC,EAAE;;EAE1C;IACE,yCAAyC,EAAE;;EAE7C;IACE,0BAA0B,EAAE;;EAE9B;IACE,4BAA4B,EAAE;;EAEhC;IACE,kCAAkC,EAAE;;EAEtC;IACE,yBAAyB,EAAE;;EAE7B;IACE,uBAAuB,EAAE;;EAE3B;IACE,uBAAuB,EAAE;;EAE3B;IACE,yBAAyB,EAAE;;EAE7B;IACE,yBAAyB,EAAE;;EAE7B;IACE,sCAAsC,EAAE;;EAE1C;IACE,oCAAoC,EAAE;;EAExC;IACE,kCAAkC,EAAE;;EAEtC;IACE,yCAAyC,EAAE;;EAE7C;IACE,wCAAwC,EAAE;;EAE5C;IACE,kCAAkC,EAAE;;EAEtC;IACE,gCAAgC,EAAE;;EAEpC;IACE,8BAA8B,EAAE;;EAElC;IACE,gCAAgC,EAAE;;EAEpC;IACE,+BAA+B,EAAE;;EAEnC;IACE,oCAAoC,EAAE;;EAExC;IACE,kCAAkC,EAAE;;EAEtC;IACE,gCAAgC,EAAE;;EAEpC;IACE,uCAAuC,EAAE;;EAE3C;IACE,sCAAsC,EAAE;;EAE1C;IACE,iCAAiC,EAAE;;EAErC;IACE,2BAA2B,EAAE;;EAE/B;IACE,iCAAiC,EAAE;;EAErC;IACE,+BAA+B,EAAE;;EAEnC;IACE,6BAA6B,EAAE;;EAEjC;IACE,+BAA+B,EAAE;;EAEnC;IACE,8BAA8B,EAAE,EAAE;AACtC;EACE;IACE,8BAA8B,EAAE;;EAElC;IACE,iCAAiC,EAAE;;EAErC;IACE,sCAAsC,EAAE;;EAE1C;IACE,yCAAyC,EAAE;;EAE7C;IACE,0BAA0B,EAAE;;EAE9B;IACE,4BAA4B,EAAE;;EAEhC;IACE,kCAAkC,EAAE;;EAEtC;IACE,yBAAyB,EAAE;;EAE7B;IACE,uBAAuB,EAAE;;EAE3B;IACE,uBAAuB,EAAE;;EAE3B;IACE,yBAAyB,EAAE;;EAE7B;IACE,yBAAyB,EAAE;;EAE7B;IACE,sCAAsC,EAAE;;EAE1C;IACE,oCAAoC,EAAE;;EAExC;IACE,kCAAkC,EAAE;;EAEtC;IACE,yCAAyC,EAAE;;EAE7C;IACE,wCAAwC,EAAE;;EAE5C;IACE,kCAAkC,EAAE;;EAEtC;IACE,gCAAgC,EAAE;;EAEpC;IACE,8BAA8B,EAAE;;EAElC;IACE,gCAAgC,EAAE;;EAEpC;IACE,+BAA+B,EAAE;;EAEnC;IACE,oCAAoC,EAAE;;EAExC;IACE,kCAAkC,EAAE;;EAEtC;IACE,gCAAgC,EAAE;;EAEpC;IACE,uCAAuC,EAAE;;EAE3C;IACE,sCAAsC,EAAE;;EAE1C;IACE,iCAAiC,EAAE;;EAErC;IACE,2BAA2B,EAAE;;EAE/B;IACE,iCAAiC,EAAE;;EAErC;IACE,+BAA+B,EAAE;;EAEnC;IACE,6BAA6B,EAAE;;EAEjC;IACE,+BAA+B,EAAE;;EAEnC;IACE,8BAA8B,EAAE,EAAE;AACtC;EACE,sBAAsB,EAAE;;AAE1B;EACE,uBAAuB,EAAE;;AAE3B;EACE,sBAAsB,EAAE;;AAE1B;EACE;IACE,sBAAsB,EAAE;;EAE1B;IACE,uBAAuB,EAAE;;EAE3B;IACE,sBAAsB,EAAE,EAAE;AAC9B;EACE;IACE,sBAAsB,EAAE;;EAE1B;IACE,uBAAuB,EAAE;;EAE3B;IACE,sBAAsB,EAAE,EAAE;AAC9B;EACE;IACE,sBAAsB,EAAE;;EAE1B;IACE,uBAAuB,EAAE;;EAE3B;IACE,sBAAsB,EAAE,EAAE;AAC9B;EACE;IACE,sBAAsB,EAAE;;EAE1B;IACE,uBAAuB,EAAE;;EAE3B;IACE,sBAAsB,EAAE,EAAE;AAC9B;EACE,2BAA2B,EAAE;;AAE/B;EACE,6BAA6B,EAAE;;AAEjC;EACE,6BAA6B,EAAE;;AAEjC;EACE,0BAA0B,EAAE;;AAE9B;EACE,2BAA2B,EAAE;;AAE/B;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,OAAO;EACP,aAAa,EAAE;;AAEjB;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,OAAO;EACP,aAAa,EAAE;;AAEjB;EACE;IACE,gBAAgB;IAChB,MAAM;IACN,aAAa,EAAE,EAAE;;AAErB;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS,EAAE;;AAEb;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,mBAAmB,EAAE;;AAEvB;EACE,8DAA8D,EAAE;;AAElE;EACE,wDAAwD,EAAE;;AAE5D;EACE,uDAAuD,EAAE;;AAE3D;EACE,2BAA2B,EAAE;;AAE/B;EACE,qBAAqB,EAAE;;AAEzB;EACE,qBAAqB,EAAE;;AAEzB;EACE,qBAAqB,EAAE;;AAEzB;EACE,sBAAsB,EAAE;;AAE1B;EACE,sBAAsB,EAAE;;AAE1B;EACE,sBAAsB,EAAE;;AAE1B;EACE,sBAAsB,EAAE;;AAE1B;EACE,sBAAsB,EAAE;;AAE1B;EACE,uBAAuB,EAAE;;AAE3B;EACE,uBAAuB,EAAE;;AAE3B;EACE,0BAA0B,EAAE;;AAE9B;EACE,2BAA2B,EAAE;;AAE/B;EACE,oBAAoB,EAAE;;AAExB;;EAEE,wBAAwB,EAAE;;AAE5B;;EAEE,0BAA0B,EAAE;;AAE9B;;EAEE,2BAA2B,EAAE;;AAE/B;;EAEE,yBAAyB,EAAE;;AAE7B;EACE,0BAA0B,EAAE;;AAE9B;;EAEE,8BAA8B,EAAE;;AAElC;;EAEE,gCAAgC,EAAE;;AAEpC;;EAEE,iCAAiC,EAAE;;AAErC;;EAEE,+BAA+B,EAAE;;AAEnC;EACE,yBAAyB,EAAE;;AAE7B;;EAEE,6BAA6B,EAAE;;AAEjC;;EAEE,+BAA+B,EAAE;;AAEnC;;EAEE,gCAAgC,EAAE;;AAEpC;;EAEE,8BAA8B,EAAE;;AAElC;EACE,uBAAuB,EAAE;;AAE3B;;EAEE,2BAA2B,EAAE;;AAE/B;;EAEE,6BAA6B,EAAE;;AAEjC;;EAEE,8BAA8B,EAAE;;AAElC;;EAEE,4BAA4B,EAAE;;AAEhC;EACE,yBAAyB,EAAE;;AAE7B;;EAEE,6BAA6B,EAAE;;AAEjC;;EAEE,+BAA+B,EAAE;;AAEnC;;EAEE,gCAAgC,EAAE;;AAEpC;;EAEE,8BAA8B,EAAE;;AAElC;EACE,uBAAuB,EAAE;;AAE3B;;EAEE,2BAA2B,EAAE;;AAE/B;;EAEE,6BAA6B,EAAE;;AAEjC;;EAEE,8BAA8B,EAAE;;AAElC;;EAEE,4BAA4B,EAAE;;AAEhC;EACE,qBAAqB,EAAE;;AAEzB;;EAEE,yBAAyB,EAAE;;AAE7B;;EAEE,2BAA2B,EAAE;;AAE/B;;EAEE,4BAA4B,EAAE;;AAEhC;;EAEE,0BAA0B,EAAE;;AAE9B;EACE,2BAA2B,EAAE;;AAE/B;;EAEE,+BAA+B,EAAE;;AAEnC;;EAEE,iCAAiC,EAAE;;AAErC;;EAEE,kCAAkC,EAAE;;AAEtC;;EAEE,gCAAgC,EAAE;;AAEpC;EACE,0BAA0B,EAAE;;AAE9B;;EAEE,8BAA8B,EAAE;;AAElC;;EAEE,gCAAgC,EAAE;;AAEpC;;EAEE,iCAAiC,EAAE;;AAErC;;EAEE,+BAA+B,EAAE;;AAEnC;EACE,wBAAwB,EAAE;;AAE5B;;EAEE,4BAA4B,EAAE;;AAEhC;;EAEE,8BAA8B,EAAE;;AAElC;;EAEE,+BAA+B,EAAE;;AAEnC;;EAEE,6BAA6B,EAAE;;AAEjC;EACE,0BAA0B,EAAE;;AAE9B;;EAEE,8BAA8B,EAAE;;AAElC;;EAEE,gCAAgC,EAAE;;AAEpC;;EAEE,iCAAiC,EAAE;;AAErC;;EAEE,+BAA+B,EAAE;;AAEnC;EACE,wBAAwB,EAAE;;AAE5B;;EAEE,4BAA4B,EAAE;;AAEhC;;EAEE,8BAA8B,EAAE;;AAElC;;EAEE,+BAA+B,EAAE;;AAEnC;;EAEE,6BAA6B,EAAE;;AAEjC;EACE,uBAAuB,EAAE;;AAE3B;;EAEE,2BAA2B,EAAE;;AAE/B;;EAEE,6BAA6B,EAAE;;AAEjC;;EAEE,8BAA8B,EAAE;;AAElC;;EAEE,4BAA4B,EAAE;;AAEhC;EACE;IACE,oBAAoB,EAAE;;EAExB;;IAEE,wBAAwB,EAAE;;EAE5B;;IAEE,0BAA0B,EAAE;;EAE9B;;IAEE,2BAA2B,EAAE;;EAE/B;;IAEE,yBAAyB,EAAE;;EAE7B;IACE,0BAA0B,EAAE;;EAE9B;;IAEE,8BAA8B,EAAE;;EAElC;;IAEE,gCAAgC,EAAE;;EAEpC;;IAEE,iCAAiC,EAAE;;EAErC;;IAEE,+BAA+B,EAAE;;EAEnC;IACE,yBAAyB,EAAE;;EAE7B;;IAEE,6BAA6B,EAAE;;EAEjC;;IAEE,+BAA+B,EAAE;;EAEnC;;IAEE,gCAAgC,EAAE;;EAEpC;;IAEE,8BAA8B,EAAE;;EAElC;IACE,uBAAuB,EAAE;;EAE3B;;IAEE,2BAA2B,EAAE;;EAE/B;;IAEE,6BAA6B,EAAE;;EAEjC;;IAEE,8BAA8B,EAAE;;EAElC;;IAEE,4BAA4B,EAAE;;EAEhC;IACE,yBAAyB,EAAE;;EAE7B;;IAEE,6BAA6B,EAAE;;EAEjC;;IAEE,+BAA+B,EAAE;;EAEnC;;IAEE,gCAAgC,EAAE;;EAEpC;;IAEE,8BAA8B,EAAE;;EAElC;IACE,uBAAuB,EAAE;;EAE3B;;IAEE,2BAA2B,EAAE;;EAE/B;;IAEE,6BAA6B,EAAE;;EAEjC;;IAEE,8BAA8B,EAAE;;EAElC;;IAEE,4BAA4B,EAAE;;EAEhC;IACE,qBAAqB,EAAE;;EAEzB;;IAEE,yBAAyB,EAAE;;EAE7B;;IAEE,2BAA2B,EAAE;;EAE/B;;IAEE,4BAA4B,EAAE;;EAEhC;;IAEE,0BAA0B,EAAE;;EAE9B;IACE,2BAA2B,EAAE;;EAE/B;;IAEE,+BAA+B,EAAE;;EAEnC;;IAEE,iCAAiC,EAAE;;EAErC;;IAEE,kCAAkC,EAAE;;EAEtC;;IAEE,gCAAgC,EAAE;;EAEpC;IACE,0BAA0B,EAAE;;EAE9B;;IAEE,8BAA8B,EAAE;;EAElC;;IAEE,gCAAgC,EAAE;;EAEpC;;IAEE,iCAAiC,EAAE;;EAErC;;IAEE,+BAA+B,EAAE;;EAEnC;IACE,wBAAwB,EAAE;;EAE5B;;IAEE,4BAA4B,EAAE;;EAEhC;;IAEE,8BAA8B,EAAE;;EAElC;;IAEE,+BAA+B,EAAE;;EAEnC;;IAEE,6BAA6B,EAAE;;EAEjC;IACE,0BAA0B,EAAE;;EAE9B;;IAEE,8BAA8B,EAAE;;EAElC;;IAEE,gCAAgC,EAAE;;EAEpC;;IAEE,iCAAiC,EAAE;;EAErC;;IAEE,+BAA+B,EAAE;;EAEnC;IACE,wBAAwB,EAAE;;EAE5B;;IAEE,4BAA4B,EAAE;;EAEhC;;IAEE,8BAA8B,EAAE;;EAElC;;IAEE,+BAA+B,EAAE;;EAEnC;;IAEE,6BAA6B,EAAE;;EAEjC;IACE,uBAAuB,EAAE;;EAE3B;;IAEE,2BAA2B,EAAE;;EAE/B;;IAEE,6BAA6B,EAAE;;EAEjC;;IAEE,8BAA8B,EAAE;;EAElC;;IAEE,4BAA4B,EAAE,EAAE;AACpC;EACE;IACE,oBAAoB,EAAE;;EAExB;;IAEE,wBAAwB,EAAE;;EAE5B;;IAEE,0BAA0B,EAAE;;EAE9B;;IAEE,2BAA2B,EAAE;;EAE/B;;IAEE,yBAAyB,EAAE;;EAE7B;IACE,0BAA0B,EAAE;;EAE9B;;IAEE,8BAA8B,EAAE;;EAElC;;IAEE,gCAAgC,EAAE;;EAEpC;;IAEE,iCAAiC,EAAE;;EAErC;;IAEE,+BAA+B,EAAE;;EAEnC;IACE,yBAAyB,EAAE;;EAE7B;;IAEE,6BAA6B,EAAE;;EAEjC;;IAEE,+BAA+B,EAAE;;EAEnC;;IAEE,gCAAgC,EAAE;;EAEpC;;IAEE,8BAA8B,EAAE;;EAElC;IACE,uBAAuB,EAAE;;EAE3B;;IAEE,2BAA2B,EAAE;;EAE/B;;IAEE,6BAA6B,EAAE;;EAEjC;;IAEE,8BAA8B,EAAE;;EAElC;;IAEE,4BAA4B,EAAE;;EAEhC;IACE,yBAAyB,EAAE;;EAE7B;;IAEE,6BAA6B,EAAE;;EAEjC;;IAEE,+BAA+B,EAAE;;EAEnC;;IAEE,gCAAgC,EAAE;;EAEpC;;IAEE,8BAA8B,EAAE;;EAElC;IACE,uBAAuB,EAAE;;EAE3B;;IAEE,2BAA2B,EAAE;;EAE/B;;IAEE,6BAA6B,EAAE;;EAEjC;;IAEE,8BAA8B,EAAE;;EAElC;;IAEE,4BAA4B,EAAE;;EAEhC;IACE,qBAAqB,EAAE;;EAEzB;;IAEE,yBAAyB,EAAE;;EAE7B;;IAEE,2BAA2B,EAAE;;EAE/B;;IAEE,4BAA4B,EAAE;;EAEhC;;IAEE,0BAA0B,EAAE;;EAE9B;IACE,2BAA2B,EAAE;;EAE/B;;IAEE,+BAA+B,EAAE;;EAEnC;;IAEE,iCAAiC,EAAE;;EAErC;;IAEE,kCAAkC,EAAE;;EAEtC;;IAEE,gCAAgC,EAAE;;EAEpC;IACE,0BAA0B,EAAE;;EAE9B;;IAEE,8BAA8B,EAAE;;EAElC;;IAEE,gCAAgC,EAAE;;EAEpC;;IAEE,iCAAiC,EAAE;;EAErC;;IAEE,+BAA+B,EAAE;;EAEnC;IACE,wBAAwB,EAAE;;EAE5B;;IAEE,4BAA4B,EAAE;;EAEhC;;IAEE,8BAA8B,EAAE;;EAElC;;IAEE,+BAA+B,EAAE;;EAEnC;;IAEE,6BAA6B,EAAE;;EAEjC;IACE,0BAA0B,EAAE;;EAE9B;;IAEE,8BAA8B,EAAE;;EAElC;;IAEE,gCAAgC,EAAE;;EAEpC;;IAEE,iCAAiC,EAAE;;EAErC;;IAEE,+BAA+B,EAAE;;EAEnC;IACE,wBAAwB,EAAE;;EAE5B;;IAEE,4BAA4B,EAAE;;EAEhC;;IAEE,8BAA8B,EAAE;;EAElC;;IAEE,+BAA+B,EAAE;;EAEnC;;IAEE,6BAA6B,EAAE;;EAEjC;IACE,uBAAuB,EAAE;;EAE3B;;IAEE,2BAA2B,EAAE;;EAE/B;;IAEE,6BAA6B,EAAE;;EAEjC;;IAEE,8BAA8B,EAAE;;EAElC;;IAEE,4BAA4B,EAAE,EAAE;AACpC;EACE;IACE,oBAAoB,EAAE;;EAExB;;IAEE,wBAAwB,EAAE;;EAE5B;;IAEE,0BAA0B,EAAE;;EAE9B;;IAEE,2BAA2B,EAAE;;EAE/B;;IAEE,yBAAyB,EAAE;;EAE7B;IACE,0BAA0B,EAAE;;EAE9B;;IAEE,8BAA8B,EAAE;;EAElC;;IAEE,gCAAgC,EAAE;;EAEpC;;IAEE,iCAAiC,EAAE;;EAErC;;IAEE,+BAA+B,EAAE;;EAEnC;IACE,yBAAyB,EAAE;;EAE7B;;IAEE,6BAA6B,EAAE;;EAEjC;;IAEE,+BAA+B,EAAE;;EAEnC;;IAEE,gCAAgC,EAAE;;EAEpC;;IAEE,8BAA8B,EAAE;;EAElC;IACE,uBAAuB,EAAE;;EAE3B;;IAEE,2BAA2B,EAAE;;EAE/B;;IAEE,6BAA6B,EAAE;;EAEjC;;IAEE,8BAA8B,EAAE;;EAElC;;IAEE,4BAA4B,EAAE;;EAEhC;IACE,yBAAyB,EAAE;;EAE7B;;IAEE,6BAA6B,EAAE;;EAEjC;;IAEE,+BAA+B,EAAE;;EAEnC;;IAEE,gCAAgC,EAAE;;EAEpC;;IAEE,8BAA8B,EAAE;;EAElC;IACE,uBAAuB,EAAE;;EAE3B;;IAEE,2BAA2B,EAAE;;EAE/B;;IAEE,6BAA6B,EAAE;;EAEjC;;IAEE,8BAA8B,EAAE;;EAElC;;IAEE,4BAA4B,EAAE;;EAEhC;IACE,qBAAqB,EAAE;;EAEzB;;IAEE,yBAAyB,EAAE;;EAE7B;;IAEE,2BAA2B,EAAE;;EAE/B;;IAEE,4BAA4B,EAAE;;EAEhC;;IAEE,0BAA0B,EAAE;;EAE9B;IACE,2BAA2B,EAAE;;EAE/B;;IAEE,+BAA+B,EAAE;;EAEnC;;IAEE,iCAAiC,EAAE;;EAErC;;IAEE,kCAAkC,EAAE;;EAEtC;;IAEE,gCAAgC,EAAE;;EAEpC;IACE,0BAA0B,EAAE;;EAE9B;;IAEE,8BAA8B,EAAE;;EAElC;;IAEE,gCAAgC,EAAE;;EAEpC;;IAEE,iCAAiC,EAAE;;EAErC;;IAEE,+BAA+B,EAAE;;EAEnC;IACE,wBAAwB,EAAE;;EAE5B;;IAEE,4BAA4B,EAAE;;EAEhC;;IAEE,8BAA8B,EAAE;;EAElC;;IAEE,+BAA+B,EAAE;;EAEnC;;IAEE,6BAA6B,EAAE;;EAEjC;IACE,0BAA0B,EAAE;;EAE9B;;IAEE,8BAA8B,EAAE;;EAElC;;IAEE,gCAAgC,EAAE;;EAEpC;;IAEE,iCAAiC,EAAE;;EAErC;;IAEE,+BAA+B,EAAE;;EAEnC;IACE,wBAAwB,EAAE;;EAE5B;;IAEE,4BAA4B,EAAE;;EAEhC;;IAEE,8BAA8B,EAAE;;EAElC;;IAEE,+BAA+B,EAAE;;EAEnC;;IAEE,6BAA6B,EAAE;;EAEjC;IACE,uBAAuB,EAAE;;EAE3B;;IAEE,2BAA2B,EAAE;;EAE/B;;IAEE,6BAA6B,EAAE;;EAEjC;;IAEE,8BAA8B,EAAE;;EAElC;;IAEE,4BAA4B,EAAE,EAAE;AACpC;EACE;IACE,oBAAoB,EAAE;;EAExB;;IAEE,wBAAwB,EAAE;;EAE5B;;IAEE,0BAA0B,EAAE;;EAE9B;;IAEE,2BAA2B,EAAE;;EAE/B;;IAEE,yBAAyB,EAAE;;EAE7B;IACE,0BAA0B,EAAE;;EAE9B;;IAEE,8BAA8B,EAAE;;EAElC;;IAEE,gCAAgC,EAAE;;EAEpC;;IAEE,iCAAiC,EAAE;;EAErC;;IAEE,+BAA+B,EAAE;;EAEnC;IACE,yBAAyB,EAAE;;EAE7B;;IAEE,6BAA6B,EAAE;;EAEjC;;IAEE,+BAA+B,EAAE;;EAEnC;;IAEE,gCAAgC,EAAE;;EAEpC;;IAEE,8BAA8B,EAAE;;EAElC;IACE,uBAAuB,EAAE;;EAE3B;;IAEE,2BAA2B,EAAE;;EAE/B;;IAEE,6BAA6B,EAAE;;EAEjC;;IAEE,8BAA8B,EAAE;;EAElC;;IAEE,4BAA4B,EAAE;;EAEhC;IACE,yBAAyB,EAAE;;EAE7B;;IAEE,6BAA6B,EAAE;;EAEjC;;IAEE,+BAA+B,EAAE;;EAEnC;;IAEE,gCAAgC,EAAE;;EAEpC;;IAEE,8BAA8B,EAAE;;EAElC;IACE,uBAAuB,EAAE;;EAE3B;;IAEE,2BAA2B,EAAE;;EAE/B;;IAEE,6BAA6B,EAAE;;EAEjC;;IAEE,8BAA8B,EAAE;;EAElC;;IAEE,4BAA4B,EAAE;;EAEhC;IACE,qBAAqB,EAAE;;EAEzB;;IAEE,yBAAyB,EAAE;;EAE7B;;IAEE,2BAA2B,EAAE;;EAE/B;;IAEE,4BAA4B,EAAE;;EAEhC;;IAEE,0BAA0B,EAAE;;EAE9B;IACE,2BAA2B,EAAE;;EAE/B;;IAEE,+BAA+B,EAAE;;EAEnC;;IAEE,iCAAiC,EAAE;;EAErC;;IAEE,kCAAkC,EAAE;;EAEtC;;IAEE,gCAAgC,EAAE;;EAEpC;IACE,0BAA0B,EAAE;;EAE9B;;IAEE,8BAA8B,EAAE;;EAElC;;IAEE,gCAAgC,EAAE;;EAEpC;;IAEE,iCAAiC,EAAE;;EAErC;;IAEE,+BAA+B,EAAE;;EAEnC;IACE,wBAAwB,EAAE;;EAE5B;;IAEE,4BAA4B,EAAE;;EAEhC;;IAEE,8BAA8B,EAAE;;EAElC;;IAEE,+BAA+B,EAAE;;EAEnC;;IAEE,6BAA6B,EAAE;;EAEjC;IACE,0BAA0B,EAAE;;EAE9B;;IAEE,8BAA8B,EAAE;;EAElC;;IAEE,gCAAgC,EAAE;;EAEpC;;IAEE,iCAAiC,EAAE;;EAErC;;IAEE,+BAA+B,EAAE;;EAEnC;IACE,wBAAwB,EAAE;;EAE5B;;IAEE,4BAA4B,EAAE;;EAEhC;;IAEE,8BAA8B,EAAE;;EAElC;;IAEE,+BAA+B,EAAE;;EAEnC;;IAEE,6BAA6B,EAAE;;EAEjC;IACE,uBAAuB,EAAE;;EAE3B;;IAEE,2BAA2B,EAAE;;EAE/B;;IAEE,6BAA6B,EAAE;;EAEjC;;IAEE,8BAA8B,EAAE;;EAElC;;IAEE,4BAA4B,EAAE,EAAE;AACpC;EACE,iGAAiG,EAAE;;AAErG;EACE,8BAA8B,EAAE;;AAElC;EACE,8BAA8B,EAAE;;AAElC;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB,EAAE;;AAEvB;EACE,2BAA2B,EAAE;;AAE/B;EACE,4BAA4B,EAAE;;AAEhC;EACE,6BAA6B,EAAE;;AAEjC;EACE;IACE,2BAA2B,EAAE;;EAE/B;IACE,4BAA4B,EAAE;;EAEhC;IACE,6BAA6B,EAAE,EAAE;AACrC;EACE;IACE,2BAA2B,EAAE;;EAE/B;IACE,4BAA4B,EAAE;;EAEhC;IACE,6BAA6B,EAAE,EAAE;AACrC;EACE;IACE,2BAA2B,EAAE;;EAE/B;IACE,4BAA4B,EAAE;;EAEhC;IACE,6BAA6B,EAAE,EAAE;AACrC;EACE;IACE,2BAA2B,EAAE;;EAE/B;IACE,4BAA4B,EAAE;;EAEhC;IACE,6BAA6B,EAAE,EAAE;AACrC;EACE,oCAAoC,EAAE;;AAExC;EACE,oCAAoC,EAAE;;AAExC;EACE,qCAAqC,EAAE;;AAEzC;EACE,2BAA2B,EAAE;;AAE/B;EACE,2BAA2B,EAAE;;AAE/B;EACE,2BAA2B,EAAE;;AAE/B;EACE,6BAA6B,EAAE;;AAEjC;EACE,sBAAsB,EAAE;;AAE1B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,oCAAoC,EAAE;;AAExC;EACE,0CAA0C,EAAE;;AAE9C;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;EAC7B,SAAS,EAAE;;AAEb;EACE,8BAA8B,EAAE;;AAElC;EACE,6BAA6B,EAAE;;AAEjC;EACE;;;IAGE,4BAA4B;IAC5B,2BAA2B,EAAE;;EAE/B;IACE,0BAA0B,EAAE;;EAE9B;IACE,6BAA6B,EAAE;;EAEjC;IACE,gCAAgC,EAAE;;EAEpC;;IAEE,yBAAyB;IACzB,wBAAwB,EAAE;;EAE5B;IACE,2BAA2B,EAAE;;EAE/B;;IAEE,wBAAwB,EAAE;;EAE5B;;;IAGE,UAAU;IACV,SAAS,EAAE;;EAEb;;IAEE,uBAAuB,EAAE;;EAE3B;IACE,QAAQ,EAAE;EACZ;IACE,2BAA2B,EAAE;;EAE/B;IACE,2BAA2B,EAAE;;EAE/B;IACE,aAAa,EAAE;;EAEjB;IACE,sBAAsB,EAAE;;EAE1B;IACE,oCAAoC,EAAE;IACtC;;MAEE,iCAAiC,EAAE;;EAEvC;;IAEE,oCAAoC,EAAE,EAAE;AAC5C,uCAAuC;AACvC;EACE,WAAW,EAAE;EACb;IACE,WAAW,EAAE;EACf;IACE,eAAe,EAAE;EACnB;IACE,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,SAAS,EAAE;IACX;MACE,WAAW,EAAE;;AAEnB,qCAAqC;AACrC;EACE,gBAAgB,EAAE;EAClB;IACE,cAAc;IACd,aAAa;IACb,YAAY;IACZ,YAAY,EAAE;IACd;MACE;QACE,WAAW,EAAE,EAAE;IACnB;MACE;QACE,WAAW,EAAE,EAAE;IACnB;MACE;QACE,WAAW,EAAE,EAAE;IACnB;MACE,WAAW;MACX,qBAAqB;MACrB,kBAAkB,EAAE;IACtB;MACE,kCAAkC;MAClC,mCAAmC;MACnC,6BAA6B;MAC7B,uCAAuC;MACvC,SAAS;MACT,SAAS,EAAE;IACb;MACE,kCAAkC;MAClC,mCAAmC;MACnC,8BAA8B;MAC9B,SAAS;MACT,SAAS,EAAE;IACb;MACE,kCAAkC;MAClC,mCAAmC;MACnC,0BAA0B;MAC1B,oCAAoC;MACpC,YAAY;MACZ,SAAS,EAAE;IACb;MACE,kCAAkC;MAClC,mCAAmC;MACnC,2BAA2B;MAC3B,YAAY;MACZ,SAAS,EAAE;IACb;MACE,UAAU;MACV,UAAU,EAAE;IACd;MACE,UAAU;MACV,UAAU,EAAE;EAChB;IACE,SAAS,EAAE;EACb;IACE,cAAc,EAAE;EAClB;IACE,gBAAgB,EAAE;EACpB;IACE,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,SAAS,EAAE;EACb;IACE,YAAY,EAAE;EAChB;IACE,0BAA0B,EAAE;EAC9B;IACE,4BAA4B,EAAE;EAChC;IACE,0BAA0B,EAAE;EAC9B;IACE,4BAA4B,EAAE;EAChC;IACE,qBAAqB,EAAE;EACzB;IACE,uBAAuB,EAAE;EAC3B;IACE,uBAAuB,EAAE;EAC3B;IACE,2BAA2B,EAAE;EAC/B;IACE,gCAAgC,EAAE;EACpC;IACE,kBAAkB,EAAE;IACpB;MACE,uCAAuC,EAAE;IAC3C;MACE,UAAU;MACV,SAAS;MACT,YAAY;MACZ,WAAW;MACX,oBAAoB,EAAE;MACtB;QACE,gBAAgB;QAChB,aAAa;QACb,WAAW,EAAE;EACnB;IACE,WAAW;IACX,SAAS,EAAE;IACX;MACE,kBAAkB;MAClB,sBAAsB,EAAE;IAC1B;MACE,YAAY;MACZ,iBAAiB;MACjB,WAAW,EAAE;MACb;QACE,YAAY,EAAE;MAChB;QACE,gBAAgB;QAChB,cAAc;QACd,mBAAmB,EAAE;MACvB;QACE,yBAAyB,EAAE;MAC7B;QACE,qBAAqB,EAAE;IAC3B;MACE,eAAe,EAAE;MACjB;QACE,mBAAmB,EAAE;IACzB;MACE,YAAY;MACZ,iBAAiB;MACjB,WAAW,EAAE;MACb;QACE,eAAe;QACf,YAAY;QACZ,iBAAiB;QACjB,cAAc,EAAE;MAClB;QACE,YAAY;QACZ,iBAAiB;QACjB,WAAW,EAAE;MACf;QACE,mBAAmB;QACnB,eAAe,EAAE;MACnB;QACE,cAAc,EAAE;MAClB;QACE,kBAAkB,EAAE;QACpB;UACE,WAAW;UACX,qBAAqB;UACrB,yBAAyB;UACzB,yBAAyB;UACzB,4BAA4B;UAC5B,oCAAoC;UACpC,kBAAkB;UAClB,WAAW;UACX,UAAU,EAAE;MAChB;QACE,yBAAyB;QACzB,WAAW;QACX,yCAAyC,EAAE;MAC7C;QACE,yBAAyB,EAAE;MAC7B;QACE,gBAAgB;QAChB,cAAc;QACd,mBAAmB,EAAE;MACvB;QACE,qBAAqB;QACrB,WAAW;QACX,YAAY;QACZ,iBAAiB;QACjB,iBAAiB;QACjB,eAAe;QACf,sBAAsB,EAAE;QACxB;UACE,mBAAmB,EAAE;QACvB;UACE,yBAAyB;UACzB,WAAW;UACX,yCAAyC,EAAE;QAC7C;UACE,cAAc,EAAE;QAClB;UACE,gBAAgB;UAChB,cAAc;UACd,mBAAmB,EAAE;EAC7B;IACE,YAAY;IACZ,iBAAiB,EAAE;;AAEvB;EACE,eAAe,EAAE;AACnB;EACE,aAAa;EACb,mBAAmB;AACrB","sourcesContent":["/*!\n * Bootstrap v4.1.1 (https://getbootstrap.com/)\n * Copyright 2011-2018 The Bootstrap Authors\n * Copyright 2011-2018 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n */\n:root {\n  --blue: #007bff;\n  --indigo: #6610f2;\n  --purple: #6f42c1;\n  --pink: #e83e8c;\n  --red: #dc3545;\n  --orange: #fd7e14;\n  --yellow: #ffc107;\n  --green: #28a745;\n  --teal: #20c997;\n  --cyan: #17a2b8;\n  --white: #fff;\n  --gray: #6c757d;\n  --gray-dark: #343a40;\n  --primary: #007bff;\n  --secondary: #6c757d;\n  --success: #28a745;\n  --info: #17a2b8;\n  --warning: #ffc107;\n  --danger: #dc3545;\n  --light: #f8f9fa;\n  --dark: #343a40;\n  --breakpoint-xs: 0;\n  --breakpoint-sm: 576px;\n  --breakpoint-md: 768px;\n  --breakpoint-lg: 992px;\n  --breakpoint-xl: 1200px;\n  --font-family-sans-serif: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n  --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace; }\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box; }\n\nhtml {\n  font-family: sans-serif;\n  line-height: 1.15;\n  -webkit-text-size-adjust: 100%;\n  -ms-text-size-adjust: 100%;\n  -ms-overflow-style: scrollbar;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0); }\n\n@-ms-viewport {\n  width: device-width; }\narticle, aside, dialog, figcaption, figure, footer, header, hgroup, main, nav, section {\n  display: block; }\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #212529;\n  text-align: left;\n  background-color: #fff; }\n\n[tabindex=\"-1\"]:focus {\n  outline: 0 !important; }\n\nhr {\n  box-sizing: content-box;\n  height: 0;\n  overflow: visible; }\n\nh1, h2, h3, h4, h5, h6 {\n  margin-top: 0;\n  margin-bottom: 0.5rem; }\n\np {\n  margin-top: 0;\n  margin-bottom: 1rem; }\n\nabbr[title],\nabbr[data-original-title] {\n  text-decoration: underline;\n  text-decoration: underline dotted;\n  cursor: help;\n  border-bottom: 0; }\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit; }\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem; }\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0; }\n\ndt {\n  font-weight: 700; }\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; }\n\nblockquote {\n  margin: 0 0 1rem; }\n\ndfn {\n  font-style: italic; }\n\nb,\nstrong {\n  font-weight: bolder; }\n\nsmall {\n  font-size: 80%; }\n\nsub,\nsup {\n  position: relative;\n  font-size: 75%;\n  line-height: 0;\n  vertical-align: baseline; }\n\nsub {\n  bottom: -.25em; }\n\nsup {\n  top: -.5em; }\n\na {\n  color: #007bff;\n  text-decoration: none;\n  background-color: transparent;\n  -webkit-text-decoration-skip: objects; }\n  a:hover {\n    color: #0056b3;\n    text-decoration: underline; }\n\na:not([href]):not([tabindex]) {\n  color: inherit;\n  text-decoration: none; }\n  a:not([href]):not([tabindex]):hover, a:not([href]):not([tabindex]):focus {\n    color: inherit;\n    text-decoration: none; }\n  a:not([href]):not([tabindex]):focus {\n    outline: 0; }\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: monospace, monospace;\n  font-size: 1em; }\n\npre {\n  margin-top: 0;\n  margin-bottom: 1rem;\n  overflow: auto;\n  -ms-overflow-style: scrollbar; }\n\nfigure {\n  margin: 0 0 1rem; }\n\nimg {\n  vertical-align: middle;\n  border-style: none; }\n\nsvg:not(:root) {\n  overflow: hidden; }\n\ntable {\n  border-collapse: collapse; }\n\ncaption {\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n  color: #6c757d;\n  text-align: left;\n  caption-side: bottom; }\n\nth {\n  text-align: inherit; }\n\nlabel {\n  display: inline-block;\n  margin-bottom: 0.5rem; }\n\nbutton {\n  border-radius: 0; }\n\nbutton:focus {\n  outline: 1px dotted;\n  outline: 5px auto -webkit-focus-ring-color; }\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit; }\n\nbutton,\ninput {\n  overflow: visible; }\n\nbutton,\nselect {\n  text-transform: none; }\n\nbutton,\nhtml [type=\"button\"],\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; }\n\nbutton::-moz-focus-inner,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n  padding: 0;\n  border-style: none; }\n\ninput[type=\"radio\"],\ninput[type=\"checkbox\"] {\n  box-sizing: border-box;\n  padding: 0; }\n\ninput[type=\"date\"],\ninput[type=\"time\"],\ninput[type=\"datetime-local\"],\ninput[type=\"month\"] {\n  -webkit-appearance: listbox; }\n\ntextarea {\n  overflow: auto;\n  resize: vertical; }\n\nfieldset {\n  min-width: 0;\n  padding: 0;\n  margin: 0;\n  border: 0; }\n\nlegend {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n  padding: 0;\n  margin-bottom: .5rem;\n  font-size: 1.5rem;\n  line-height: inherit;\n  color: inherit;\n  white-space: normal; }\n\nprogress {\n  vertical-align: baseline; }\n\n[type=\"number\"]::-webkit-inner-spin-button,\n[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto; }\n\n[type=\"search\"] {\n  outline-offset: -2px;\n  -webkit-appearance: none; }\n\n[type=\"search\"]::-webkit-search-cancel-button,\n[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none; }\n\n::-webkit-file-upload-button {\n  font: inherit;\n  -webkit-appearance: button; }\n\noutput {\n  display: inline-block; }\n\nsummary {\n  display: list-item;\n  cursor: pointer; }\n\ntemplate {\n  display: none; }\n\n[hidden] {\n  display: none !important; }\n\nh1, h2, h3, h4, h5, h6,\n.h1, .h2, .h3, .h4, .h5, .h6 {\n  margin-bottom: 0.5rem;\n  font-family: inherit;\n  font-weight: 500;\n  line-height: 1.2;\n  color: inherit; }\n\nh1, .h1 {\n  font-size: 2.5rem; }\n\nh2, .h2 {\n  font-size: 2rem; }\n\nh3, .h3 {\n  font-size: 1.75rem; }\n\nh4, .h4 {\n  font-size: 1.5rem; }\n\nh5, .h5 {\n  font-size: 1.25rem; }\n\nh6, .h6 {\n  font-size: 1rem; }\n\n.lead {\n  font-size: 1.25rem;\n  font-weight: 300; }\n\n.display-1 {\n  font-size: 6rem;\n  font-weight: 300;\n  line-height: 1.2; }\n\n.display-2 {\n  font-size: 5.5rem;\n  font-weight: 300;\n  line-height: 1.2; }\n\n.display-3 {\n  font-size: 4.5rem;\n  font-weight: 300;\n  line-height: 1.2; }\n\n.display-4 {\n  font-size: 3.5rem;\n  font-weight: 300;\n  line-height: 1.2; }\n\nhr {\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n  border: 0;\n  border-top: 1px solid rgba(0, 0, 0, 0.1); }\n\nsmall,\n.small {\n  font-size: 80%;\n  font-weight: 400; }\n\nmark,\n.mark {\n  padding: 0.2em;\n  background-color: #fcf8e3; }\n\n.list-unstyled {\n  padding-left: 0;\n  list-style: none; }\n\n.list-inline {\n  padding-left: 0;\n  list-style: none; }\n\n.list-inline-item {\n  display: inline-block; }\n  .list-inline-item:not(:last-child) {\n    margin-right: 0.5rem; }\n\n.initialism {\n  font-size: 90%;\n  text-transform: uppercase; }\n\n.blockquote {\n  margin-bottom: 1rem;\n  font-size: 1.25rem; }\n\n.blockquote-footer {\n  display: block;\n  font-size: 80%;\n  color: #6c757d;\n  position: relative; }\n  .blockquote-footer::before {\n    content: \"\\2014 \\00A0\"; }\n\n.img-fluid {\n  max-width: 100%;\n  height: auto; }\n\n.img-thumbnail {\n  padding: 0.25rem;\n  background-color: #fff;\n  border: 1px solid #dee2e6;\n  border-radius: 0.25rem;\n  max-width: 100%;\n  height: auto; }\n\n.figure {\n  display: inline-block; }\n\n.figure-img {\n  margin-bottom: 0.5rem;\n  line-height: 1; }\n\n.figure-caption {\n  font-size: 90%;\n  color: #6c757d; }\n\ncode,\nkbd,\npre,\nsamp {\n  font-family: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace; }\n\ncode {\n  font-size: 87.5%;\n  color: #e83e8c;\n  word-break: break-word; }\n  a > code {\n    color: inherit; }\n\nkbd {\n  padding: 0.2rem 0.4rem;\n  font-size: 87.5%;\n  color: #fff;\n  background-color: #212529;\n  border-radius: 0.2rem; }\n  kbd kbd {\n    padding: 0;\n    font-size: 100%;\n    font-weight: 700; }\n\npre {\n  display: block;\n  font-size: 87.5%;\n  color: #212529; }\n  pre code {\n    font-size: inherit;\n    color: inherit;\n    word-break: normal; }\n\n.pre-scrollable {\n  max-height: 340px;\n  overflow-y: scroll; }\n\n.container {\n  width: 100%;\n  padding-right: 15px;\n  padding-left: 15px;\n  margin-right: auto;\n  margin-left: auto; }\n  @media (min-width: 576px) {\n    .container {\n      max-width: 540px; } }\n  @media (min-width: 768px) {\n    .container {\n      max-width: 720px; } }\n  @media (min-width: 992px) {\n    .container {\n      max-width: 960px; } }\n  @media (min-width: 1200px) {\n    .container {\n      max-width: 1140px; } }\n\n.container-fluid {\n  width: 100%;\n  padding-right: 15px;\n  padding-left: 15px;\n  margin-right: auto;\n  margin-left: auto; }\n\n.row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -15px;\n  margin-left: -15px; }\n\n.no-gutters {\n  margin-right: 0;\n  margin-left: 0; }\n  .no-gutters > .col,\n  .no-gutters > [class*=\"col-\"] {\n    padding-right: 0;\n    padding-left: 0; }\n\n.col-1, .col-2, .col-3, .col-4, .col-5, .col-6, .col-7, .col-8, .col-9, .col-10, .col-11, .col-12, .col,\n.col-auto, .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm,\n.col-sm-auto, .col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12, .col-md,\n.col-md-auto, .col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg,\n.col-lg-auto, .col-xl-1, .col-xl-2, .col-xl-3, .col-xl-4, .col-xl-5, .col-xl-6, .col-xl-7, .col-xl-8, .col-xl-9, .col-xl-10, .col-xl-11, .col-xl-12, .col-xl,\n.col-xl-auto {\n  position: relative;\n  width: 100%;\n  min-height: 1px;\n  padding-right: 15px;\n  padding-left: 15px; }\n\n.col {\n  flex-basis: 0;\n  flex-grow: 1;\n  max-width: 100%; }\n\n.col-auto {\n  flex: 0 0 auto;\n  width: auto;\n  max-width: none; }\n\n.col-1 {\n  flex: 0 0 8.3333333333%;\n  max-width: 8.3333333333%; }\n\n.col-2 {\n  flex: 0 0 16.6666666667%;\n  max-width: 16.6666666667%; }\n\n.col-3 {\n  flex: 0 0 25%;\n  max-width: 25%; }\n\n.col-4 {\n  flex: 0 0 33.3333333333%;\n  max-width: 33.3333333333%; }\n\n.col-5 {\n  flex: 0 0 41.6666666667%;\n  max-width: 41.6666666667%; }\n\n.col-6 {\n  flex: 0 0 50%;\n  max-width: 50%; }\n\n.col-7 {\n  flex: 0 0 58.3333333333%;\n  max-width: 58.3333333333%; }\n\n.col-8 {\n  flex: 0 0 66.6666666667%;\n  max-width: 66.6666666667%; }\n\n.col-9 {\n  flex: 0 0 75%;\n  max-width: 75%; }\n\n.col-10 {\n  flex: 0 0 83.3333333333%;\n  max-width: 83.3333333333%; }\n\n.col-11 {\n  flex: 0 0 91.6666666667%;\n  max-width: 91.6666666667%; }\n\n.col-12 {\n  flex: 0 0 100%;\n  max-width: 100%; }\n\n.order-first {\n  order: -1; }\n\n.order-last {\n  order: 13; }\n\n.order-0 {\n  order: 0; }\n\n.order-1 {\n  order: 1; }\n\n.order-2 {\n  order: 2; }\n\n.order-3 {\n  order: 3; }\n\n.order-4 {\n  order: 4; }\n\n.order-5 {\n  order: 5; }\n\n.order-6 {\n  order: 6; }\n\n.order-7 {\n  order: 7; }\n\n.order-8 {\n  order: 8; }\n\n.order-9 {\n  order: 9; }\n\n.order-10 {\n  order: 10; }\n\n.order-11 {\n  order: 11; }\n\n.order-12 {\n  order: 12; }\n\n.offset-1 {\n  margin-left: 8.3333333333%; }\n\n.offset-2 {\n  margin-left: 16.6666666667%; }\n\n.offset-3 {\n  margin-left: 25%; }\n\n.offset-4 {\n  margin-left: 33.3333333333%; }\n\n.offset-5 {\n  margin-left: 41.6666666667%; }\n\n.offset-6 {\n  margin-left: 50%; }\n\n.offset-7 {\n  margin-left: 58.3333333333%; }\n\n.offset-8 {\n  margin-left: 66.6666666667%; }\n\n.offset-9 {\n  margin-left: 75%; }\n\n.offset-10 {\n  margin-left: 83.3333333333%; }\n\n.offset-11 {\n  margin-left: 91.6666666667%; }\n\n@media (min-width: 576px) {\n  .col-sm {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%; }\n\n  .col-sm-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: none; }\n\n  .col-sm-1 {\n    flex: 0 0 8.3333333333%;\n    max-width: 8.3333333333%; }\n\n  .col-sm-2 {\n    flex: 0 0 16.6666666667%;\n    max-width: 16.6666666667%; }\n\n  .col-sm-3 {\n    flex: 0 0 25%;\n    max-width: 25%; }\n\n  .col-sm-4 {\n    flex: 0 0 33.3333333333%;\n    max-width: 33.3333333333%; }\n\n  .col-sm-5 {\n    flex: 0 0 41.6666666667%;\n    max-width: 41.6666666667%; }\n\n  .col-sm-6 {\n    flex: 0 0 50%;\n    max-width: 50%; }\n\n  .col-sm-7 {\n    flex: 0 0 58.3333333333%;\n    max-width: 58.3333333333%; }\n\n  .col-sm-8 {\n    flex: 0 0 66.6666666667%;\n    max-width: 66.6666666667%; }\n\n  .col-sm-9 {\n    flex: 0 0 75%;\n    max-width: 75%; }\n\n  .col-sm-10 {\n    flex: 0 0 83.3333333333%;\n    max-width: 83.3333333333%; }\n\n  .col-sm-11 {\n    flex: 0 0 91.6666666667%;\n    max-width: 91.6666666667%; }\n\n  .col-sm-12 {\n    flex: 0 0 100%;\n    max-width: 100%; }\n\n  .order-sm-first {\n    order: -1; }\n\n  .order-sm-last {\n    order: 13; }\n\n  .order-sm-0 {\n    order: 0; }\n\n  .order-sm-1 {\n    order: 1; }\n\n  .order-sm-2 {\n    order: 2; }\n\n  .order-sm-3 {\n    order: 3; }\n\n  .order-sm-4 {\n    order: 4; }\n\n  .order-sm-5 {\n    order: 5; }\n\n  .order-sm-6 {\n    order: 6; }\n\n  .order-sm-7 {\n    order: 7; }\n\n  .order-sm-8 {\n    order: 8; }\n\n  .order-sm-9 {\n    order: 9; }\n\n  .order-sm-10 {\n    order: 10; }\n\n  .order-sm-11 {\n    order: 11; }\n\n  .order-sm-12 {\n    order: 12; }\n\n  .offset-sm-0 {\n    margin-left: 0; }\n\n  .offset-sm-1 {\n    margin-left: 8.3333333333%; }\n\n  .offset-sm-2 {\n    margin-left: 16.6666666667%; }\n\n  .offset-sm-3 {\n    margin-left: 25%; }\n\n  .offset-sm-4 {\n    margin-left: 33.3333333333%; }\n\n  .offset-sm-5 {\n    margin-left: 41.6666666667%; }\n\n  .offset-sm-6 {\n    margin-left: 50%; }\n\n  .offset-sm-7 {\n    margin-left: 58.3333333333%; }\n\n  .offset-sm-8 {\n    margin-left: 66.6666666667%; }\n\n  .offset-sm-9 {\n    margin-left: 75%; }\n\n  .offset-sm-10 {\n    margin-left: 83.3333333333%; }\n\n  .offset-sm-11 {\n    margin-left: 91.6666666667%; } }\n@media (min-width: 768px) {\n  .col-md {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%; }\n\n  .col-md-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: none; }\n\n  .col-md-1 {\n    flex: 0 0 8.3333333333%;\n    max-width: 8.3333333333%; }\n\n  .col-md-2 {\n    flex: 0 0 16.6666666667%;\n    max-width: 16.6666666667%; }\n\n  .col-md-3 {\n    flex: 0 0 25%;\n    max-width: 25%; }\n\n  .col-md-4 {\n    flex: 0 0 33.3333333333%;\n    max-width: 33.3333333333%; }\n\n  .col-md-5 {\n    flex: 0 0 41.6666666667%;\n    max-width: 41.6666666667%; }\n\n  .col-md-6 {\n    flex: 0 0 50%;\n    max-width: 50%; }\n\n  .col-md-7 {\n    flex: 0 0 58.3333333333%;\n    max-width: 58.3333333333%; }\n\n  .col-md-8 {\n    flex: 0 0 66.6666666667%;\n    max-width: 66.6666666667%; }\n\n  .col-md-9 {\n    flex: 0 0 75%;\n    max-width: 75%; }\n\n  .col-md-10 {\n    flex: 0 0 83.3333333333%;\n    max-width: 83.3333333333%; }\n\n  .col-md-11 {\n    flex: 0 0 91.6666666667%;\n    max-width: 91.6666666667%; }\n\n  .col-md-12 {\n    flex: 0 0 100%;\n    max-width: 100%; }\n\n  .order-md-first {\n    order: -1; }\n\n  .order-md-last {\n    order: 13; }\n\n  .order-md-0 {\n    order: 0; }\n\n  .order-md-1 {\n    order: 1; }\n\n  .order-md-2 {\n    order: 2; }\n\n  .order-md-3 {\n    order: 3; }\n\n  .order-md-4 {\n    order: 4; }\n\n  .order-md-5 {\n    order: 5; }\n\n  .order-md-6 {\n    order: 6; }\n\n  .order-md-7 {\n    order: 7; }\n\n  .order-md-8 {\n    order: 8; }\n\n  .order-md-9 {\n    order: 9; }\n\n  .order-md-10 {\n    order: 10; }\n\n  .order-md-11 {\n    order: 11; }\n\n  .order-md-12 {\n    order: 12; }\n\n  .offset-md-0 {\n    margin-left: 0; }\n\n  .offset-md-1 {\n    margin-left: 8.3333333333%; }\n\n  .offset-md-2 {\n    margin-left: 16.6666666667%; }\n\n  .offset-md-3 {\n    margin-left: 25%; }\n\n  .offset-md-4 {\n    margin-left: 33.3333333333%; }\n\n  .offset-md-5 {\n    margin-left: 41.6666666667%; }\n\n  .offset-md-6 {\n    margin-left: 50%; }\n\n  .offset-md-7 {\n    margin-left: 58.3333333333%; }\n\n  .offset-md-8 {\n    margin-left: 66.6666666667%; }\n\n  .offset-md-9 {\n    margin-left: 75%; }\n\n  .offset-md-10 {\n    margin-left: 83.3333333333%; }\n\n  .offset-md-11 {\n    margin-left: 91.6666666667%; } }\n@media (min-width: 992px) {\n  .col-lg {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%; }\n\n  .col-lg-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: none; }\n\n  .col-lg-1 {\n    flex: 0 0 8.3333333333%;\n    max-width: 8.3333333333%; }\n\n  .col-lg-2 {\n    flex: 0 0 16.6666666667%;\n    max-width: 16.6666666667%; }\n\n  .col-lg-3 {\n    flex: 0 0 25%;\n    max-width: 25%; }\n\n  .col-lg-4 {\n    flex: 0 0 33.3333333333%;\n    max-width: 33.3333333333%; }\n\n  .col-lg-5 {\n    flex: 0 0 41.6666666667%;\n    max-width: 41.6666666667%; }\n\n  .col-lg-6 {\n    flex: 0 0 50%;\n    max-width: 50%; }\n\n  .col-lg-7 {\n    flex: 0 0 58.3333333333%;\n    max-width: 58.3333333333%; }\n\n  .col-lg-8 {\n    flex: 0 0 66.6666666667%;\n    max-width: 66.6666666667%; }\n\n  .col-lg-9 {\n    flex: 0 0 75%;\n    max-width: 75%; }\n\n  .col-lg-10 {\n    flex: 0 0 83.3333333333%;\n    max-width: 83.3333333333%; }\n\n  .col-lg-11 {\n    flex: 0 0 91.6666666667%;\n    max-width: 91.6666666667%; }\n\n  .col-lg-12 {\n    flex: 0 0 100%;\n    max-width: 100%; }\n\n  .order-lg-first {\n    order: -1; }\n\n  .order-lg-last {\n    order: 13; }\n\n  .order-lg-0 {\n    order: 0; }\n\n  .order-lg-1 {\n    order: 1; }\n\n  .order-lg-2 {\n    order: 2; }\n\n  .order-lg-3 {\n    order: 3; }\n\n  .order-lg-4 {\n    order: 4; }\n\n  .order-lg-5 {\n    order: 5; }\n\n  .order-lg-6 {\n    order: 6; }\n\n  .order-lg-7 {\n    order: 7; }\n\n  .order-lg-8 {\n    order: 8; }\n\n  .order-lg-9 {\n    order: 9; }\n\n  .order-lg-10 {\n    order: 10; }\n\n  .order-lg-11 {\n    order: 11; }\n\n  .order-lg-12 {\n    order: 12; }\n\n  .offset-lg-0 {\n    margin-left: 0; }\n\n  .offset-lg-1 {\n    margin-left: 8.3333333333%; }\n\n  .offset-lg-2 {\n    margin-left: 16.6666666667%; }\n\n  .offset-lg-3 {\n    margin-left: 25%; }\n\n  .offset-lg-4 {\n    margin-left: 33.3333333333%; }\n\n  .offset-lg-5 {\n    margin-left: 41.6666666667%; }\n\n  .offset-lg-6 {\n    margin-left: 50%; }\n\n  .offset-lg-7 {\n    margin-left: 58.3333333333%; }\n\n  .offset-lg-8 {\n    margin-left: 66.6666666667%; }\n\n  .offset-lg-9 {\n    margin-left: 75%; }\n\n  .offset-lg-10 {\n    margin-left: 83.3333333333%; }\n\n  .offset-lg-11 {\n    margin-left: 91.6666666667%; } }\n@media (min-width: 1200px) {\n  .col-xl {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%; }\n\n  .col-xl-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: none; }\n\n  .col-xl-1 {\n    flex: 0 0 8.3333333333%;\n    max-width: 8.3333333333%; }\n\n  .col-xl-2 {\n    flex: 0 0 16.6666666667%;\n    max-width: 16.6666666667%; }\n\n  .col-xl-3 {\n    flex: 0 0 25%;\n    max-width: 25%; }\n\n  .col-xl-4 {\n    flex: 0 0 33.3333333333%;\n    max-width: 33.3333333333%; }\n\n  .col-xl-5 {\n    flex: 0 0 41.6666666667%;\n    max-width: 41.6666666667%; }\n\n  .col-xl-6 {\n    flex: 0 0 50%;\n    max-width: 50%; }\n\n  .col-xl-7 {\n    flex: 0 0 58.3333333333%;\n    max-width: 58.3333333333%; }\n\n  .col-xl-8 {\n    flex: 0 0 66.6666666667%;\n    max-width: 66.6666666667%; }\n\n  .col-xl-9 {\n    flex: 0 0 75%;\n    max-width: 75%; }\n\n  .col-xl-10 {\n    flex: 0 0 83.3333333333%;\n    max-width: 83.3333333333%; }\n\n  .col-xl-11 {\n    flex: 0 0 91.6666666667%;\n    max-width: 91.6666666667%; }\n\n  .col-xl-12 {\n    flex: 0 0 100%;\n    max-width: 100%; }\n\n  .order-xl-first {\n    order: -1; }\n\n  .order-xl-last {\n    order: 13; }\n\n  .order-xl-0 {\n    order: 0; }\n\n  .order-xl-1 {\n    order: 1; }\n\n  .order-xl-2 {\n    order: 2; }\n\n  .order-xl-3 {\n    order: 3; }\n\n  .order-xl-4 {\n    order: 4; }\n\n  .order-xl-5 {\n    order: 5; }\n\n  .order-xl-6 {\n    order: 6; }\n\n  .order-xl-7 {\n    order: 7; }\n\n  .order-xl-8 {\n    order: 8; }\n\n  .order-xl-9 {\n    order: 9; }\n\n  .order-xl-10 {\n    order: 10; }\n\n  .order-xl-11 {\n    order: 11; }\n\n  .order-xl-12 {\n    order: 12; }\n\n  .offset-xl-0 {\n    margin-left: 0; }\n\n  .offset-xl-1 {\n    margin-left: 8.3333333333%; }\n\n  .offset-xl-2 {\n    margin-left: 16.6666666667%; }\n\n  .offset-xl-3 {\n    margin-left: 25%; }\n\n  .offset-xl-4 {\n    margin-left: 33.3333333333%; }\n\n  .offset-xl-5 {\n    margin-left: 41.6666666667%; }\n\n  .offset-xl-6 {\n    margin-left: 50%; }\n\n  .offset-xl-7 {\n    margin-left: 58.3333333333%; }\n\n  .offset-xl-8 {\n    margin-left: 66.6666666667%; }\n\n  .offset-xl-9 {\n    margin-left: 75%; }\n\n  .offset-xl-10 {\n    margin-left: 83.3333333333%; }\n\n  .offset-xl-11 {\n    margin-left: 91.6666666667%; } }\n.table {\n  width: 100%;\n  max-width: 100%;\n  margin-bottom: 1rem;\n  background-color: transparent; }\n  .table th,\n  .table td {\n    padding: 0.75rem;\n    vertical-align: top;\n    border-top: 1px solid #dee2e6; }\n  .table thead th {\n    vertical-align: bottom;\n    border-bottom: 2px solid #dee2e6; }\n  .table tbody + tbody {\n    border-top: 2px solid #dee2e6; }\n  .table .table {\n    background-color: #fff; }\n\n.table-sm th,\n.table-sm td {\n  padding: 0.3rem; }\n\n.table-bordered {\n  border: 1px solid #dee2e6; }\n  .table-bordered th,\n  .table-bordered td {\n    border: 1px solid #dee2e6; }\n  .table-bordered thead th,\n  .table-bordered thead td {\n    border-bottom-width: 2px; }\n\n.table-borderless th,\n.table-borderless td,\n.table-borderless thead th,\n.table-borderless tbody + tbody {\n  border: 0; }\n\n.table-striped tbody tr:nth-of-type(odd) {\n  background-color: rgba(0, 0, 0, 0.05); }\n\n.table-hover tbody tr:hover {\n  background-color: rgba(0, 0, 0, 0.075); }\n\n.table-primary,\n.table-primary > th,\n.table-primary > td {\n  background-color: #b8daff; }\n\n.table-hover .table-primary:hover {\n  background-color: #9fcdff; }\n  .table-hover .table-primary:hover > td,\n  .table-hover .table-primary:hover > th {\n    background-color: #9fcdff; }\n\n.table-secondary,\n.table-secondary > th,\n.table-secondary > td {\n  background-color: #d6d8db; }\n\n.table-hover .table-secondary:hover {\n  background-color: #c8cbcf; }\n  .table-hover .table-secondary:hover > td,\n  .table-hover .table-secondary:hover > th {\n    background-color: #c8cbcf; }\n\n.table-success,\n.table-success > th,\n.table-success > td {\n  background-color: #c3e6cb; }\n\n.table-hover .table-success:hover {\n  background-color: #b1dfbb; }\n  .table-hover .table-success:hover > td,\n  .table-hover .table-success:hover > th {\n    background-color: #b1dfbb; }\n\n.table-info,\n.table-info > th,\n.table-info > td {\n  background-color: #bee5eb; }\n\n.table-hover .table-info:hover {\n  background-color: #abdde5; }\n  .table-hover .table-info:hover > td,\n  .table-hover .table-info:hover > th {\n    background-color: #abdde5; }\n\n.table-warning,\n.table-warning > th,\n.table-warning > td {\n  background-color: #ffeeba; }\n\n.table-hover .table-warning:hover {\n  background-color: #ffe8a1; }\n  .table-hover .table-warning:hover > td,\n  .table-hover .table-warning:hover > th {\n    background-color: #ffe8a1; }\n\n.table-danger,\n.table-danger > th,\n.table-danger > td {\n  background-color: #f5c6cb; }\n\n.table-hover .table-danger:hover {\n  background-color: #f1b0b7; }\n  .table-hover .table-danger:hover > td,\n  .table-hover .table-danger:hover > th {\n    background-color: #f1b0b7; }\n\n.table-light,\n.table-light > th,\n.table-light > td {\n  background-color: #fdfdfe; }\n\n.table-hover .table-light:hover {\n  background-color: #ececf6; }\n  .table-hover .table-light:hover > td,\n  .table-hover .table-light:hover > th {\n    background-color: #ececf6; }\n\n.table-dark,\n.table-dark > th,\n.table-dark > td {\n  background-color: #c6c8ca; }\n\n.table-hover .table-dark:hover {\n  background-color: #b9bbbe; }\n  .table-hover .table-dark:hover > td,\n  .table-hover .table-dark:hover > th {\n    background-color: #b9bbbe; }\n\n.table-active,\n.table-active > th,\n.table-active > td {\n  background-color: rgba(0, 0, 0, 0.075); }\n\n.table-hover .table-active:hover {\n  background-color: rgba(0, 0, 0, 0.075); }\n  .table-hover .table-active:hover > td,\n  .table-hover .table-active:hover > th {\n    background-color: rgba(0, 0, 0, 0.075); }\n\n.table .thead-dark th {\n  color: #fff;\n  background-color: #212529;\n  border-color: #32383e; }\n.table .thead-light th {\n  color: #495057;\n  background-color: #e9ecef;\n  border-color: #dee2e6; }\n\n.table-dark {\n  color: #fff;\n  background-color: #212529; }\n  .table-dark th,\n  .table-dark td,\n  .table-dark thead th {\n    border-color: #32383e; }\n  .table-dark.table-bordered {\n    border: 0; }\n  .table-dark.table-striped tbody tr:nth-of-type(odd) {\n    background-color: rgba(255, 255, 255, 0.05); }\n  .table-dark.table-hover tbody tr:hover {\n    background-color: rgba(255, 255, 255, 0.075); }\n\n@media (max-width: 575.98px) {\n  .table-responsive-sm {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    -ms-overflow-style: -ms-autohiding-scrollbar; }\n    .table-responsive-sm > .table-bordered {\n      border: 0; } }\n@media (max-width: 767.98px) {\n  .table-responsive-md {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    -ms-overflow-style: -ms-autohiding-scrollbar; }\n    .table-responsive-md > .table-bordered {\n      border: 0; } }\n@media (max-width: 991.98px) {\n  .table-responsive-lg {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    -ms-overflow-style: -ms-autohiding-scrollbar; }\n    .table-responsive-lg > .table-bordered {\n      border: 0; } }\n@media (max-width: 1199.98px) {\n  .table-responsive-xl {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    -ms-overflow-style: -ms-autohiding-scrollbar; }\n    .table-responsive-xl > .table-bordered {\n      border: 0; } }\n.table-responsive {\n  display: block;\n  width: 100%;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  -ms-overflow-style: -ms-autohiding-scrollbar; }\n  .table-responsive > .table-bordered {\n    border: 0; }\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: 0.375rem 0.75rem;\n  font-size: 1rem;\n  line-height: 1.5;\n  color: #495057;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }\n  .form-control1 {\n    display: block;\n    width: 100%;\n    padding: 0.375rem 0.75rem;\n    font-size: 1rem;\n    line-height: 1.5;\n    color: #495057;\n    background-color: #fff;\n    background-clip: padding-box;\n    border: 1px solid #ced4da;\n    border-radius: 0.25rem;\n    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }\n    .form-control3 {\n      display: block;\n      width: 210%;\n      padding: 0.375rem 0.75rem;\n      font-size: 1rem;\n      line-height: 1.5;\n      color: #495057;\n      background-color: #fff;\n      background-clip: padding-box;\n      border: 1px solid #ced4da;\n      border-radius: 0.25rem;\n      transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }\n  \n    .form-control2 {\n      display: block;\n      width: 96%;\n      padding: 0.375rem 0.75rem;\n      font-size: 1rem;\n      line-height: 1.5;\n      color: #495057;\n      background-color: #fff;\n      background-clip: padding-box;\n      border: 1px solid #ced4da;\n      border-radius: 0.25rem;\n      transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }\n  @media screen and (prefers-reduced-motion: reduce) {\n    .form-control {\n      transition: none; } }\n  .form-control::-ms-expand {\n    background-color: transparent;\n    border: 0; }\n  .form-control:focus {\n    color: #495057;\n    background-color: #fff;\n    border-color: #80bdff;\n    outline: 0;\n    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25); }\n  .form-control::placeholder {\n    color: #6c757d;\n    opacity: 1; }\n  .form-control:disabled, .form-control[readonly] {\n    background-color: #e9ecef;\n    opacity: 1; }\n\nselect.form-control:not([size]):not([multiple]) {\n  height: calc(2.25rem + 2px); }\nselect.form-control:focus::-ms-value {\n  color: #495057;\n  background-color: #fff; }\n\n.form-control-file,\n.form-control-range {\n  display: block;\n  width: 100%; }\n\n.col-form-label {\n  padding-top: calc(0.375rem + 1px);\n  padding-bottom: calc(0.375rem + 1px);\n  margin-bottom: 0;\n  font-size: inherit;\n  line-height: 1.5; }\n\n.col-form-label-lg {\n  padding-top: calc(0.5rem + 1px);\n  padding-bottom: calc(0.5rem + 1px);\n  font-size: 1.25rem;\n  line-height: 1.5; }\n\n.col-form-label-sm {\n  padding-top: calc(0.25rem + 1px);\n  padding-bottom: calc(0.25rem + 1px);\n  font-size: 0.875rem;\n  line-height: 1.5; }\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding-top: 0.375rem;\n  padding-bottom: 0.375rem;\n  margin-bottom: 0;\n  line-height: 1.5;\n  color: #212529;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: 1px 0; }\n  .form-control-plaintext.form-control-sm, .input-group-sm > .form-control-plaintext.form-control,\n  .input-group-sm > .input-group-prepend > .form-control-plaintext.input-group-text,\n  .input-group-sm > .input-group-append > .form-control-plaintext.input-group-text,\n  .input-group-sm > .input-group-prepend > .form-control-plaintext.btn,\n  .input-group-sm > .input-group-append > .form-control-plaintext.btn, .form-control-plaintext.form-control-lg, .input-group-lg > .form-control-plaintext.form-control,\n  .input-group-lg > .input-group-prepend > .form-control-plaintext.input-group-text,\n  .input-group-lg > .input-group-append > .form-control-plaintext.input-group-text,\n  .input-group-lg > .input-group-prepend > .form-control-plaintext.btn,\n  .input-group-lg > .input-group-append > .form-control-plaintext.btn {\n    padding-right: 0;\n    padding-left: 0; }\n\n.form-control-sm, .input-group-sm > .form-control,\n.input-group-sm > .input-group-prepend > .input-group-text,\n.input-group-sm > .input-group-append > .input-group-text,\n.input-group-sm > .input-group-prepend > .btn,\n.input-group-sm > .input-group-append > .btn {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  border-radius: 0.2rem; }\n\nselect.form-control-sm:not([size]):not([multiple]), .input-group-sm > select.form-control:not([size]):not([multiple]),\n.input-group-sm > .input-group-prepend > select.input-group-text:not([size]):not([multiple]),\n.input-group-sm > .input-group-append > select.input-group-text:not([size]):not([multiple]),\n.input-group-sm > .input-group-prepend > select.btn:not([size]):not([multiple]),\n.input-group-sm > .input-group-append > select.btn:not([size]):not([multiple]) {\n  height: calc(1.8125rem + 2px); }\n\n.form-control-lg, .input-group-lg > .form-control,\n.input-group-lg > .input-group-prepend > .input-group-text,\n.input-group-lg > .input-group-append > .input-group-text,\n.input-group-lg > .input-group-prepend > .btn,\n.input-group-lg > .input-group-append > .btn {\n  padding: 0.5rem 1rem;\n  font-size: 1.25rem;\n  line-height: 1.5;\n  border-radius: 0.3rem; }\n\nselect.form-control-lg:not([size]):not([multiple]), .input-group-lg > select.form-control:not([size]):not([multiple]),\n.input-group-lg > .input-group-prepend > select.input-group-text:not([size]):not([multiple]),\n.input-group-lg > .input-group-append > select.input-group-text:not([size]):not([multiple]),\n.input-group-lg > .input-group-prepend > select.btn:not([size]):not([multiple]),\n.input-group-lg > .input-group-append > select.btn:not([size]):not([multiple]) {\n  height: calc(2.875rem + 2px); }\n\n.form-group {\n  margin-bottom: 1rem; }\n  .form-group2 {\n    margin-bottom: 1rem; }\n\n.form-group1 {\n    margin-top: -95px;\n  margin-right:-40px }\n.form-group3{\n  margin-bottom: 50px; \n  margin-left:835px;\n  margin-top:-98px;\n}\n\n.form-text {\n  display: block;\n  margin-top: 0.25rem; }\n\n.form-row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -5px;\n  margin-left: -5px; }\n  .form-row > .col,\n  .form-row > [class*=\"col-\"] {\n    padding-right: 5px;\n    padding-left: 5px; }\n\n.form-check {\n  position: relative;\n  display: block;\n  padding-left: 1.25rem; }\n\n.form-check-input {\n  position: absolute;\n  margin-top: 0.3rem;\n  margin-left: -1.25rem; }\n  .form-check-input:disabled ~ .form-check-label {\n    color: #6c757d; }\n\n.form-check-label {\n  margin-bottom: 0; }\n\n.form-check-inline {\n  display: inline-flex;\n  align-items: center;\n  padding-left: 0;\n  margin-right: 0.75rem; }\n  .form-check-inline .form-check-input {\n    position: static;\n    margin-top: 0;\n    margin-right: 0.3125rem;\n    margin-left: 0; }\n\n.valid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 80%;\n  color: #28a745; }\n\n.valid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: .5rem;\n  margin-top: .1rem;\n  font-size: .875rem;\n  line-height: 1;\n  color: #fff;\n  background-color: rgba(40, 167, 69, 0.8);\n  border-radius: .2rem; }\n\n.was-validated .form-control:valid, .form-control.is-valid,\n.was-validated .custom-select:valid,\n.custom-select.is-valid {\n  border-color: #28a745; }\n  .was-validated .form-control:valid:focus, .form-control.is-valid:focus,\n  .was-validated .custom-select:valid:focus,\n  .custom-select.is-valid:focus {\n    border-color: #28a745;\n    box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25); }\n  .was-validated .form-control:valid ~ .valid-feedback,\n  .was-validated .form-control:valid ~ .valid-tooltip, .form-control.is-valid ~ .valid-feedback,\n  .form-control.is-valid ~ .valid-tooltip,\n  .was-validated .custom-select:valid ~ .valid-feedback,\n  .was-validated .custom-select:valid ~ .valid-tooltip,\n  .custom-select.is-valid ~ .valid-feedback,\n  .custom-select.is-valid ~ .valid-tooltip {\n    display: block; }\n\n.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {\n  color: #28a745; }\n.was-validated .form-check-input:valid ~ .valid-feedback,\n.was-validated .form-check-input:valid ~ .valid-tooltip, .form-check-input.is-valid ~ .valid-feedback,\n.form-check-input.is-valid ~ .valid-tooltip {\n  display: block; }\n\n.was-validated .custom-control-input:valid ~ .custom-control-label, .custom-control-input.is-valid ~ .custom-control-label {\n  color: #28a745; }\n  .was-validated .custom-control-input:valid ~ .custom-control-label::before, .custom-control-input.is-valid ~ .custom-control-label::before {\n    background-color: #71dd8a; }\n.was-validated .custom-control-input:valid ~ .valid-feedback,\n.was-validated .custom-control-input:valid ~ .valid-tooltip, .custom-control-input.is-valid ~ .valid-feedback,\n.custom-control-input.is-valid ~ .valid-tooltip {\n  display: block; }\n.was-validated .custom-control-input:valid:checked ~ .custom-control-label::before, .custom-control-input.is-valid:checked ~ .custom-control-label::before {\n  background-color: #34ce57; }\n.was-validated .custom-control-input:valid:focus ~ .custom-control-label::before, .custom-control-input.is-valid:focus ~ .custom-control-label::before {\n  box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(40, 167, 69, 0.25); }\n\n.was-validated .custom-file-input:valid ~ .custom-file-label, .custom-file-input.is-valid ~ .custom-file-label {\n  border-color: #28a745; }\n  .was-validated .custom-file-input:valid ~ .custom-file-label::before, .custom-file-input.is-valid ~ .custom-file-label::before {\n    border-color: inherit; }\n.was-validated .custom-file-input:valid ~ .valid-feedback,\n.was-validated .custom-file-input:valid ~ .valid-tooltip, .custom-file-input.is-valid ~ .valid-feedback,\n.custom-file-input.is-valid ~ .valid-tooltip {\n  display: block; }\n.was-validated .custom-file-input:valid:focus ~ .custom-file-label, .custom-file-input.is-valid:focus ~ .custom-file-label {\n  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25); }\n\n.invalid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 80%;\n  color: #dc3545; }\n\n.invalid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: .5rem;\n  margin-top: .1rem;\n  font-size: .875rem;\n  line-height: 1;\n  color: #fff;\n  background-color: rgba(220, 53, 69, 0.8);\n  border-radius: .2rem; }\n\n.was-validated .form-control:invalid, .form-control.is-invalid,\n.was-validated .custom-select:invalid,\n.custom-select.is-invalid {\n  border-color: #dc3545; }\n  .was-validated .form-control:invalid:focus, .form-control.is-invalid:focus,\n  .was-validated .custom-select:invalid:focus,\n  .custom-select.is-invalid:focus {\n    border-color: #dc3545;\n    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25); }\n  .was-validated .form-control:invalid ~ .invalid-feedback,\n  .was-validated .form-control:invalid ~ .invalid-tooltip, .form-control.is-invalid ~ .invalid-feedback,\n  .form-control.is-invalid ~ .invalid-tooltip,\n  .was-validated .custom-select:invalid ~ .invalid-feedback,\n  .was-validated .custom-select:invalid ~ .invalid-tooltip,\n  .custom-select.is-invalid ~ .invalid-feedback,\n  .custom-select.is-invalid ~ .invalid-tooltip {\n    display: block; }\n\n.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {\n  color: #dc3545; }\n.was-validated .form-check-input:invalid ~ .invalid-feedback,\n.was-validated .form-check-input:invalid ~ .invalid-tooltip, .form-check-input.is-invalid ~ .invalid-feedback,\n.form-check-input.is-invalid ~ .invalid-tooltip {\n  display: block; }\n\n.was-validated .custom-control-input:invalid ~ .custom-control-label, .custom-control-input.is-invalid ~ .custom-control-label {\n  color: #dc3545; }\n  .was-validated .custom-control-input:invalid ~ .custom-control-label::before, .custom-control-input.is-invalid ~ .custom-control-label::before {\n    background-color: #efa2a9; }\n.was-validated .custom-control-input:invalid ~ .invalid-feedback,\n.was-validated .custom-control-input:invalid ~ .invalid-tooltip, .custom-control-input.is-invalid ~ .invalid-feedback,\n.custom-control-input.is-invalid ~ .invalid-tooltip {\n  display: block; }\n.was-validated .custom-control-input:invalid:checked ~ .custom-control-label::before, .custom-control-input.is-invalid:checked ~ .custom-control-label::before {\n  background-color: #e4606d; }\n.was-validated .custom-control-input:invalid:focus ~ .custom-control-label::before, .custom-control-input.is-invalid:focus ~ .custom-control-label::before {\n  box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(220, 53, 69, 0.25); }\n\n.was-validated .custom-file-input:invalid ~ .custom-file-label, .custom-file-input.is-invalid ~ .custom-file-label {\n  border-color: #dc3545; }\n  .was-validated .custom-file-input:invalid ~ .custom-file-label::before, .custom-file-input.is-invalid ~ .custom-file-label::before {\n    border-color: inherit; }\n.was-validated .custom-file-input:invalid ~ .invalid-feedback,\n.was-validated .custom-file-input:invalid ~ .invalid-tooltip, .custom-file-input.is-invalid ~ .invalid-feedback,\n.custom-file-input.is-invalid ~ .invalid-tooltip {\n  display: block; }\n.was-validated .custom-file-input:invalid:focus ~ .custom-file-label, .custom-file-input.is-invalid:focus ~ .custom-file-label {\n  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25); }\n\n.form-inline {\n  display: flex;\n  flex-flow: row wrap;\n  align-items: center; }\n  .form-inline .form-check {\n    width: 100%; }\n  @media (min-width: 576px) {\n    .form-inline label {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      margin-bottom: 0; }\n    .form-inline .form-group {\n      display: flex;\n      flex: 0 0 auto;\n      flex-flow: row wrap;\n      align-items: center;\n      margin-bottom: 0; }\n    .form-inline .form-control {\n      display: inline-block;\n      width: auto;\n      vertical-align: middle; }\n    .form-inline .form-control-plaintext {\n      display: inline-block; }\n    .form-inline .input-group,\n    .form-inline .custom-select {\n      width: auto; }\n    .form-inline .form-check {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: auto;\n      padding-left: 0; }\n    .form-inline .form-check-input {\n      position: relative;\n      margin-top: 0;\n      margin-right: 0.25rem;\n      margin-left: 0; }\n    .form-inline .custom-control {\n      align-items: center;\n      justify-content: center; }\n    .form-inline .custom-control-label {\n      margin-bottom: 0; } }\n\n.btn {\n  display: inline-block;\n  font-weight: 400;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  user-select: none;\n  border: 1px solid transparent;\n  padding: 0.375rem 0.75rem;\n  /* font-size: 1rem; */\n  line-height: 1.5;\n  border-radius: 0.25rem;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }\n  @media screen and (prefers-reduced-motion: reduce) {\n    .btn {\n      transition: none; } }\n  .btn:hover, .btn:focus {\n    text-decoration: none; }\n  .btn:focus, .btn.focus {\n    outline: 0;\n    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25); }\n  .btn.disabled, .btn:disabled {\n    opacity: 0.65; }\n  .btn:not(:disabled):not(.disabled) {\n    cursor: pointer; }\n  .btn:not(:disabled):not(.disabled):active, .btn:not(:disabled):not(.disabled).active {\n    background-image: none; }\n\na.btn.disabled,\nfieldset:disabled a.btn {\n  pointer-events: none; }\n  .btn1 {\n    display: inline-block;\n    font-weight: 500;\n    text-align: center;\n    white-space: nowrap;\n    vertical-align: middle;\n    user-select: none;\n    border: 1px solid transparent;\n    padding: 0.375rem 0.75rem;\n    font-size: 0.8rem;\n    line-height: 1.4;\n    border-radius: 0px;\n    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }\n    @media screen and (prefers-reduced-motion: reduce) {\n      .btn1 {\n        transition: none; } }\n    .btn1:hover, .btn1:focus {\n      text-decoration: none; }\n    .btn1:focus, .btn1.focus {\n      outline: 0;\n      box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25); }\n    .btn1.disabled, .btn1:disabled {\n      opacity: 0.65; }\n    .btn1:not(:disabled):not(.disabled) {\n      cursor: pointer; }\n    .btn1:not(:disabled):not(.disabled):active, .btn1:not(:disabled):not(.disabled).active {\n      background-image: none; }\n  \n  a.btn1.disabled,\n  fieldset:disabled a.btn1 {\n    pointer-events: none; }\n  \n.btn-primary {\n  color: #fff;\n  background-color: #007bff;\n  border-color: #007bff; }\n  .btn-primary:hover {\n    color: #fff;\n    background-color: #0069d9;\n    border-color: #0062cc; }\n  .btn-primary:focus, .btn-primary.focus {\n    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5); }\n  .btn-primary.disabled, .btn-primary:disabled {\n    color: #fff;\n    background-color: #007bff;\n    border-color: #007bff; }\n  .btn-primary:not(:disabled):not(.disabled):active, .btn-primary:not(:disabled):not(.disabled).active, .show > .btn-primary.dropdown-toggle {\n    color: #fff;\n    background-color: #0062cc;\n    border-color: #005cbf; }\n    .btn-primary:not(:disabled):not(.disabled):active:focus, .btn-primary:not(:disabled):not(.disabled).active:focus, .show > .btn-primary.dropdown-toggle:focus {\n      box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5); }\n\n.btn-secondary {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d; }\n  .btn-secondary:hover {\n    color: #fff;\n    background-color: #5a6268;\n    border-color: #545b62; }\n  .btn-secondary:focus, .btn-secondary.focus {\n    box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5); }\n  .btn-secondary.disabled, .btn-secondary:disabled {\n    color: #fff;\n    background-color: #6c757d;\n    border-color: #6c757d; }\n  .btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active, .show > .btn-secondary.dropdown-toggle {\n    color: #fff;\n    background-color: #545b62;\n    border-color: #4e555b; }\n    .btn-secondary:not(:disabled):not(.disabled):active:focus, .btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-secondary.dropdown-toggle:focus {\n      box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5); }\n\n.btn-success {\n  color: #fff;\n  background-color: #28a745;\n  border-color: #28a745; }\n  .btn-success:hover {\n    color: #fff;\n    background-color: #218838;\n    border-color: #1e7e34; }\n  .btn-success:focus, .btn-success.focus {\n    box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5); }\n  .btn-success.disabled, .btn-success:disabled {\n    color: #fff;\n    background-color: #28a745;\n    border-color: #28a745; }\n  .btn-success:not(:disabled):not(.disabled):active, .btn-success:not(:disabled):not(.disabled).active, .show > .btn-success.dropdown-toggle {\n    color: #fff;\n    background-color: #1e7e34;\n    border-color: #1c7430; }\n    .btn-success:not(:disabled):not(.disabled):active:focus, .btn-success:not(:disabled):not(.disabled).active:focus, .show > .btn-success.dropdown-toggle:focus {\n      box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5); }\n\n.btn-info {\n  color: #fff;\n  background-color: #17a2b8;\n  border-color: #17a2b8; }\n  .btn-info:hover {\n    color: #fff;\n    background-color: #138496;\n    border-color: #117a8b; }\n  .btn-info:focus, .btn-info.focus {\n    box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5); }\n  .btn-info.disabled, .btn-info:disabled {\n    color: #fff;\n    background-color: #17a2b8;\n    border-color: #17a2b8; }\n  .btn-info:not(:disabled):not(.disabled):active, .btn-info:not(:disabled):not(.disabled).active, .show > .btn-info.dropdown-toggle {\n    color: #fff;\n    background-color: #117a8b;\n    border-color: #10707f; }\n    .btn-info:not(:disabled):not(.disabled):active:focus, .btn-info:not(:disabled):not(.disabled).active:focus, .show > .btn-info.dropdown-toggle:focus {\n      box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5); }\n\n.btn-warning {\n  color: #212529;\n  background-color: #ffc107;\n  border-color: #ffc107; }\n  .btn-warning:hover {\n    color: #212529;\n    background-color: #e0a800;\n    border-color: #d39e00; }\n  .btn-warning:focus, .btn-warning.focus {\n    box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5); }\n  .btn-warning.disabled, .btn-warning:disabled {\n    color: #212529;\n    background-color: #ffc107;\n    border-color: #ffc107; }\n  .btn-warning:not(:disabled):not(.disabled):active, .btn-warning:not(:disabled):not(.disabled).active, .show > .btn-warning.dropdown-toggle {\n    color: #212529;\n    background-color: #d39e00;\n    border-color: #c69500; }\n    .btn-warning:not(:disabled):not(.disabled):active:focus, .btn-warning:not(:disabled):not(.disabled).active:focus, .show > .btn-warning.dropdown-toggle:focus {\n      box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5); }\n\n.btn-danger {\n  color: #fff;\n  background-color: #dc3545;\n  border-color: #dc3545; }\n  .btn-danger:hover {\n    color: #fff;\n    background-color: #c82333;\n    border-color: #bd2130; }\n  .btn-danger:focus, .btn-danger.focus {\n    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.5); }\n  .btn-danger.disabled, .btn-danger:disabled {\n    color: #fff;\n    background-color: #dc3545;\n    border-color: #dc3545; }\n  .btn-danger:not(:disabled):not(.disabled):active, .btn-danger:not(:disabled):not(.disabled).active, .show > .btn-danger.dropdown-toggle {\n    color: #fff;\n    background-color: #bd2130;\n    border-color: #b21f2d; }\n    .btn-danger:not(:disabled):not(.disabled):active:focus, .btn-danger:not(:disabled):not(.disabled).active:focus, .show > .btn-danger.dropdown-toggle:focus {\n      box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.5); }\n\n.btn-light {\n  color: #212529;\n  background-color: #f8f9fa;\n  border-color: #f8f9fa; }\n  .btn-light:hover {\n    color: #212529;\n    background-color: #e2e6ea;\n    border-color: #dae0e5; }\n  .btn-light:focus, .btn-light.focus {\n    box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5); }\n  .btn-light.disabled, .btn-light:disabled {\n    color: #212529;\n    background-color: #f8f9fa;\n    border-color: #f8f9fa; }\n  .btn-light:not(:disabled):not(.disabled):active, .btn-light:not(:disabled):not(.disabled).active, .show > .btn-light.dropdown-toggle {\n    color: #212529;\n    background-color: #dae0e5;\n    border-color: #d3d9df; }\n    .btn-light:not(:disabled):not(.disabled):active:focus, .btn-light:not(:disabled):not(.disabled).active:focus, .show > .btn-light.dropdown-toggle:focus {\n      box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5); }\n\n.btn-dark {\n  color: #fff;\n  background-color: #343a40;\n  border-color: #343a40; }\n  .btn-dark:hover {\n    color: #fff;\n    background-color: #23272b;\n    border-color: #1d2124; }\n  .btn-dark:focus, .btn-dark.focus {\n    box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5); }\n  .btn-dark.disabled, .btn-dark:disabled {\n    color: #fff;\n    background-color: #343a40;\n    border-color: #343a40; }\n  .btn-dark:not(:disabled):not(.disabled):active, .btn-dark:not(:disabled):not(.disabled).active, .show > .btn-dark.dropdown-toggle {\n    color: #fff;\n    background-color: #1d2124;\n    border-color: #171a1d; }\n    .btn-dark:not(:disabled):not(.disabled):active:focus, .btn-dark:not(:disabled):not(.disabled).active:focus, .show > .btn-dark.dropdown-toggle:focus {\n      box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5); }\n\n.btn-outline-primary {\n  color: #007bff;\n  background-color: transparent;\n  background-image: none;\n  border-color: #007bff; }\n  .btn-outline-primary:hover {\n    color: #fff;\n    background-color: #007bff;\n    border-color: #007bff; }\n  .btn-outline-primary:focus, .btn-outline-primary.focus {\n    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5); }\n  .btn-outline-primary.disabled, .btn-outline-primary:disabled {\n    color: #007bff;\n    background-color: transparent; }\n  .btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .btn-outline-primary.dropdown-toggle {\n    color: #fff;\n    background-color: #007bff;\n    border-color: #007bff; }\n    .btn-outline-primary:not(:disabled):not(.disabled):active:focus, .btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-primary.dropdown-toggle:focus {\n      box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5); }\n\n.btn-outline-secondary {\n  color: #6c757d;\n  background-color: transparent;\n  background-image: none;\n  border-color: #6c757d; }\n  .btn-outline-secondary:hover {\n    color: #fff;\n    background-color: #6c757d;\n    border-color: #6c757d; }\n  .btn-outline-secondary:focus, .btn-outline-secondary.focus {\n    box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5); }\n  .btn-outline-secondary.disabled, .btn-outline-secondary:disabled {\n    color: #6c757d;\n    background-color: transparent; }\n  .btn-outline-secondary:not(:disabled):not(.disabled):active, .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .btn-outline-secondary.dropdown-toggle {\n    color: #fff;\n    background-color: #6c757d;\n    border-color: #6c757d; }\n    .btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-secondary.dropdown-toggle:focus {\n      box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5); }\n\n.btn-outline-success {\n  color: #28a745;\n  background-color: transparent;\n  background-image: none;\n  border-color: #28a745; }\n  .btn-outline-success:hover {\n    color: #fff;\n    background-color: #28a745;\n    border-color: #28a745; }\n  .btn-outline-success:focus, .btn-outline-success.focus {\n    box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5); }\n  .btn-outline-success.disabled, .btn-outline-success:disabled {\n    color: #28a745;\n    background-color: transparent; }\n  .btn-outline-success:not(:disabled):not(.disabled):active, .btn-outline-success:not(:disabled):not(.disabled).active, .show > .btn-outline-success.dropdown-toggle {\n    color: #fff;\n    background-color: #28a745;\n    border-color: #28a745; }\n    .btn-outline-success:not(:disabled):not(.disabled):active:focus, .btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-success.dropdown-toggle:focus {\n      box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5); }\n\n.btn-outline-info {\n  color: #17a2b8;\n  background-color: transparent;\n  background-image: none;\n  border-color: #17a2b8; }\n  .btn-outline-info:hover {\n    color: #fff;\n    background-color: #17a2b8;\n    border-color: #17a2b8; }\n  .btn-outline-info:focus, .btn-outline-info.focus {\n    box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5); }\n  .btn-outline-info.disabled, .btn-outline-info:disabled {\n    color: #17a2b8;\n    background-color: transparent; }\n  .btn-outline-info:not(:disabled):not(.disabled):active, .btn-outline-info:not(:disabled):not(.disabled).active, .show > .btn-outline-info.dropdown-toggle {\n    color: #fff;\n    background-color: #17a2b8;\n    border-color: #17a2b8; }\n    .btn-outline-info:not(:disabled):not(.disabled):active:focus, .btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-info.dropdown-toggle:focus {\n      box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5); }\n\n.btn-outline-warning {\n  color: #ffc107;\n  background-color: transparent;\n  background-image: none;\n  border-color: #ffc107; }\n  .btn-outline-warning:hover {\n    color: #212529;\n    background-color: #ffc107;\n    border-color: #ffc107; }\n  .btn-outline-warning:focus, .btn-outline-warning.focus {\n    box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5); }\n  .btn-outline-warning.disabled, .btn-outline-warning:disabled {\n    color: #ffc107;\n    background-color: transparent; }\n  .btn-outline-warning:not(:disabled):not(.disabled):active, .btn-outline-warning:not(:disabled):not(.disabled).active, .show > .btn-outline-warning.dropdown-toggle {\n    color: #212529;\n    background-color: #ffc107;\n    border-color: #ffc107; }\n    .btn-outline-warning:not(:disabled):not(.disabled):active:focus, .btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-warning.dropdown-toggle:focus {\n      box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5); }\n\n.btn-outline-danger {\n  color: #dc3545;\n  background-color: transparent;\n  background-image: none;\n  border-color: #dc3545; }\n  .btn-outline-danger:hover {\n    color: #fff;\n    background-color: #dc3545;\n    border-color: #dc3545; }\n  .btn-outline-danger:focus, .btn-outline-danger.focus {\n    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.5); }\n  .btn-outline-danger.disabled, .btn-outline-danger:disabled {\n    color: #dc3545;\n    background-color: transparent; }\n  .btn-outline-danger:not(:disabled):not(.disabled):active, .btn-outline-danger:not(:disabled):not(.disabled).active, .show > .btn-outline-danger.dropdown-toggle {\n    color: #fff;\n    background-color: #dc3545;\n    border-color: #dc3545; }\n    .btn-outline-danger:not(:disabled):not(.disabled):active:focus, .btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-danger.dropdown-toggle:focus {\n      box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.5); }\n\n.btn-outline-light {\n  color: #f8f9fa;\n  background-color: transparent;\n  background-image: none;\n  border-color: #f8f9fa; }\n  .btn-outline-light:hover {\n    color: #212529;\n    background-color: #f8f9fa;\n    border-color: #f8f9fa; }\n  .btn-outline-light:focus, .btn-outline-light.focus {\n    box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5); }\n  .btn-outline-light.disabled, .btn-outline-light:disabled {\n    color: #f8f9fa;\n    background-color: transparent; }\n  .btn-outline-light:not(:disabled):not(.disabled):active, .btn-outline-light:not(:disabled):not(.disabled).active, .show > .btn-outline-light.dropdown-toggle {\n    color: #212529;\n    background-color: #f8f9fa;\n    border-color: #f8f9fa; }\n    .btn-outline-light:not(:disabled):not(.disabled):active:focus, .btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-light.dropdown-toggle:focus {\n      box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5); }\n\n.btn-outline-dark {\n  color: #343a40;\n  background-color: transparent;\n  background-image: none;\n  border-color: #343a40; }\n  .btn-outline-dark:hover {\n    color: #fff;\n    background-color: #343a40;\n    border-color: #343a40; }\n  .btn-outline-dark:focus, .btn-outline-dark.focus {\n    box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5); }\n  .btn-outline-dark.disabled, .btn-outline-dark:disabled {\n    color: #343a40;\n    background-color: transparent; }\n  .btn-outline-dark:not(:disabled):not(.disabled):active, .btn-outline-dark:not(:disabled):not(.disabled).active, .show > .btn-outline-dark.dropdown-toggle {\n    color: #fff;\n    background-color: #343a40;\n    border-color: #343a40; }\n    .btn-outline-dark:not(:disabled):not(.disabled):active:focus, .btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-dark.dropdown-toggle:focus {\n      box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5); }\n\n.btn-link {\n  font-weight: 400;\n  color: #007bff;\n  background-color: transparent; }\n  .btn-link:hover {\n    color: #0056b3;\n    text-decoration: underline;\n    background-color: transparent;\n    border-color: transparent; }\n  .btn-link:focus, .btn-link.focus {\n    text-decoration: underline;\n    border-color: transparent;\n    box-shadow: none; }\n  .btn-link:disabled, .btn-link.disabled {\n    color: #6c757d;\n    pointer-events: none; }\n\n.btn-lg, .btn-group-lg > .btn {\n  padding: 0.5rem 1rem;\n  font-size: 1.25rem;\n  line-height: 1.5;\n  border-radius: 0.3rem; }\n\n.btn-sm, .btn-group-sm > .btn {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  border-radius: 0.2rem; }\n\n.btn-block {\n  display: block;\n  width: 100%; }\n  .btn-block + .btn-block {\n    margin-top: 0.5rem; }\n\ninput[type=\"submit\"].btn-block,\ninput[type=\"reset\"].btn-block,\ninput[type=\"button\"].btn-block {\n  width: 100%; }\n\n.fade {\n  transition: opacity 0.15s linear; }\n  @media screen and (prefers-reduced-motion: reduce) {\n    .fade {\n      transition: none; } }\n  .fade:not(.show) {\n    opacity: 0; }\n\n.collapse:not(.show) {\n  display: none; }\n\n.collapsing {\n  position: relative;\n  height: 0;\n  overflow: hidden;\n  transition: height 0.35s ease; }\n  @media screen and (prefers-reduced-motion: reduce) {\n    .collapsing {\n      transition: none; } }\n\n.dropup,\n.dropright,\n.dropdown,\n.dropleft {\n  position: relative; }\n\n.dropdown-toggle::after {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0;\n  border-left: 0.3em solid transparent; }\n.dropdown-toggle:empty::after {\n  margin-left: 0; }\n\n.dropdown-menu, span.twitter-typeahead .tt-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 1000;\n  display: none;\n  float: left;\n  min-width: 10rem;\n  padding: 0.5rem 0;\n  margin: 0.125rem 0 0;\n  font-size: 1rem;\n  color: #212529;\n  text-align: left;\n  list-style: none;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.25rem; }\n\n.dropdown-menu-right {\n  right: 0;\n  left: auto; }\n\n.dropup .dropdown-menu, .dropup span.twitter-typeahead .tt-menu, span.twitter-typeahead .dropup .tt-menu {\n  top: auto;\n  bottom: 100%;\n  margin-top: 0;\n  margin-bottom: 0.125rem; }\n.dropup .dropdown-toggle::after {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0.3em solid;\n  border-left: 0.3em solid transparent; }\n.dropup .dropdown-toggle:empty::after {\n  margin-left: 0; }\n\n.dropright .dropdown-menu, .dropright span.twitter-typeahead .tt-menu, span.twitter-typeahead .dropright .tt-menu {\n  top: 0;\n  right: auto;\n  left: 100%;\n  margin-top: 0;\n  margin-left: 0.125rem; }\n.dropright .dropdown-toggle::after {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid transparent;\n  border-right: 0;\n  border-bottom: 0.3em solid transparent;\n  border-left: 0.3em solid; }\n.dropright .dropdown-toggle:empty::after {\n  margin-left: 0; }\n.dropright .dropdown-toggle::after {\n  vertical-align: 0; }\n\n.dropleft .dropdown-menu, .dropleft span.twitter-typeahead .tt-menu, span.twitter-typeahead .dropleft .tt-menu {\n  top: 0;\n  right: 100%;\n  left: auto;\n  margin-top: 0;\n  margin-right: 0.125rem; }\n.dropleft .dropdown-toggle::after {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\"; }\n.dropleft .dropdown-toggle::after {\n  display: none; }\n.dropleft .dropdown-toggle::before {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  margin-right: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid transparent;\n  border-right: 0.3em solid;\n  border-bottom: 0.3em solid transparent; }\n.dropleft .dropdown-toggle:empty::after {\n  margin-left: 0; }\n.dropleft .dropdown-toggle::before {\n  vertical-align: 0; }\n\n.dropdown-menu[x-placement^=\"top\"], span.twitter-typeahead [x-placement^=\"top\"].tt-menu, .dropdown-menu[x-placement^=\"right\"], span.twitter-typeahead [x-placement^=\"right\"].tt-menu, .dropdown-menu[x-placement^=\"bottom\"], span.twitter-typeahead [x-placement^=\"bottom\"].tt-menu, .dropdown-menu[x-placement^=\"left\"], span.twitter-typeahead [x-placement^=\"left\"].tt-menu {\n  right: auto;\n  bottom: auto; }\n\n.dropdown-divider {\n  height: 0;\n  margin: 0.5rem 0;\n  overflow: hidden;\n  border-top: 1px solid #e9ecef; }\n\n.dropdown-item, span.twitter-typeahead .tt-suggestion {\n  display: block;\n  width: 100%;\n  padding: 0.25rem 1.5rem;\n  clear: both;\n  font-weight: 400;\n  color: #212529;\n  text-align: inherit;\n  white-space: nowrap;\n  background-color: transparent;\n  border: 0; }\n  .dropdown-item:hover, span.twitter-typeahead .tt-suggestion:hover, .dropdown-item:focus, span.twitter-typeahead .tt-suggestion:focus {\n    color: #16181b;\n    text-decoration: none;\n    background-color: #f8f9fa; }\n  .dropdown-item.active, span.twitter-typeahead .active.tt-suggestion, span.twitter-typeahead .tt-suggestion.tt-cursor, .dropdown-item:active, span.twitter-typeahead .tt-suggestion:active {\n    color: #fff;\n    text-decoration: none;\n    background-color: #007bff; }\n  .dropdown-item.disabled, span.twitter-typeahead .disabled.tt-suggestion, .dropdown-item:disabled, span.twitter-typeahead .tt-suggestion:disabled {\n    color: #6c757d;\n    background-color: transparent; }\n\n.dropdown-menu.show, span.twitter-typeahead .show.tt-menu {\n  display: block; }\n\n.dropdown-header {\n  display: block;\n  padding: 0.5rem 1.5rem;\n  margin-bottom: 0;\n  font-size: 0.875rem;\n  color: #6c757d;\n  white-space: nowrap; }\n\n.dropdown-item-text {\n  display: block;\n  padding: 0.25rem 1.5rem;\n  color: #212529; }\n\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; }\n  .btn-group > .btn,\n  .btn-group-vertical > .btn {\n    position: relative;\n    flex: 0 1 auto; }\n    .btn-group > .btn:hover,\n    .btn-group-vertical > .btn:hover {\n      z-index: 1; }\n    .btn-group > .btn:focus, .btn-group > .btn:active, .btn-group > .btn.active,\n    .btn-group-vertical > .btn:focus,\n    .btn-group-vertical > .btn:active,\n    .btn-group-vertical > .btn.active {\n      z-index: 1; }\n  .btn-group .btn + .btn,\n  .btn-group .btn + .btn-group,\n  .btn-group .btn-group + .btn,\n  .btn-group .btn-group + .btn-group,\n  .btn-group-vertical .btn + .btn,\n  .btn-group-vertical .btn + .btn-group,\n  .btn-group-vertical .btn-group + .btn,\n  .btn-group-vertical .btn-group + .btn-group {\n    margin-left: -1px; }\n\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start; }\n  .btn-toolbar .input-group {\n    width: auto; }\n\n.btn-group > .btn:first-child {\n  margin-left: 0; }\n.btn-group > .btn:not(:last-child):not(.dropdown-toggle),\n.btn-group > .btn-group:not(:last-child) > .btn {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0; }\n.btn-group > .btn:not(:first-child),\n.btn-group > .btn-group:not(:first-child) > .btn {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0; }\n\n.dropdown-toggle-split {\n  padding-right: 0.5625rem;\n  padding-left: 0.5625rem; }\n  .dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropright .dropdown-toggle-split::after {\n    margin-left: 0; }\n  .dropleft .dropdown-toggle-split::before {\n    margin-right: 0; }\n\n.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {\n  padding-right: 0.375rem;\n  padding-left: 0.375rem; }\n\n.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {\n  padding-right: 0.75rem;\n  padding-left: 0.75rem; }\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center; }\n  .btn-group-vertical .btn,\n  .btn-group-vertical .btn-group {\n    width: 100%; }\n  .btn-group-vertical > .btn + .btn,\n  .btn-group-vertical > .btn + .btn-group,\n  .btn-group-vertical > .btn-group + .btn,\n  .btn-group-vertical > .btn-group + .btn-group {\n    margin-top: -1px;\n    margin-left: 0; }\n  .btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),\n  .btn-group-vertical > .btn-group:not(:last-child) > .btn {\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 0; }\n  .btn-group-vertical > .btn:not(:first-child),\n  .btn-group-vertical > .btn-group:not(:first-child) > .btn {\n    border-top-left-radius: 0;\n    border-top-right-radius: 0; }\n\n.btn-group-toggle > .btn,\n.btn-group-toggle > .btn-group > .btn {\n  margin-bottom: 0; }\n  .btn-group-toggle > .btn input[type=\"radio\"],\n  .btn-group-toggle > .btn input[type=\"checkbox\"],\n  .btn-group-toggle > .btn-group > .btn input[type=\"radio\"],\n  .btn-group-toggle > .btn-group > .btn input[type=\"checkbox\"] {\n    position: absolute;\n    clip: rect(0, 0, 0, 0);\n    pointer-events: none; }\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: stretch;\n  width: 100%; }\n  .input-group > .form-control,\n  .input-group > .custom-select,\n  .input-group > .custom-file {\n    position: relative;\n    flex: 1 1 auto;\n    width: 1%;\n    margin-bottom: 0; }\n    .input-group > .form-control:focus,\n    .input-group > .custom-select:focus,\n    .input-group > .custom-file:focus {\n      z-index: 3; }\n    .input-group > .form-control + .form-control,\n    .input-group > .form-control + .custom-select,\n    .input-group > .form-control + .custom-file,\n    .input-group > .custom-select + .form-control,\n    .input-group > .custom-select + .custom-select,\n    .input-group > .custom-select + .custom-file,\n    .input-group > .custom-file + .form-control,\n    .input-group > .custom-file + .custom-select,\n    .input-group > .custom-file + .custom-file {\n      margin-left: -1px; }\n  .input-group > .form-control:not(:last-child),\n  .input-group > .custom-select:not(:last-child) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0; }\n  .input-group > .form-control:not(:first-child),\n  .input-group > .custom-select:not(:first-child) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0; }\n  .input-group > .custom-file {\n    display: flex;\n    align-items: center; }\n    .input-group > .custom-file:not(:last-child) .custom-file-label, .input-group > .custom-file:not(:last-child) .custom-file-label::after {\n      border-top-right-radius: 0;\n      border-bottom-right-radius: 0; }\n    .input-group > .custom-file:not(:first-child) .custom-file-label, .input-group > .custom-file:not(:first-child) .custom-file-label::after {\n      border-top-left-radius: 0;\n      border-bottom-left-radius: 0; }\n\n.input-group-prepend,\n.input-group-append {\n  display: flex; }\n  .input-group-prepend .btn,\n  .input-group-append .btn {\n    position: relative;\n    z-index: 2; }\n  .input-group-prepend .btn + .btn,\n  .input-group-prepend .btn + .input-group-text,\n  .input-group-prepend .input-group-text + .input-group-text,\n  .input-group-prepend .input-group-text + .btn,\n  .input-group-append .btn + .btn,\n  .input-group-append .btn + .input-group-text,\n  .input-group-append .input-group-text + .input-group-text,\n  .input-group-append .input-group-text + .btn {\n    margin-left: -1px; }\n\n.input-group-prepend {\n  margin-right: -1px; }\n\n.input-group-append {\n  margin-left: -1px; }\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: 0.375rem 0.75rem;\n  margin-bottom: 0;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #495057;\n  text-align: center;\n  white-space: nowrap;\n  background-color: #e9ecef;\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem; }\n  .input-group-text input[type=\"radio\"],\n  .input-group-text input[type=\"checkbox\"] {\n    margin-top: 0; }\n\n.input-group > .input-group-prepend > .btn,\n.input-group > .input-group-prepend > .input-group-text,\n.input-group > .input-group-append:not(:last-child) > .btn,\n.input-group > .input-group-append:not(:last-child) > .input-group-text,\n.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),\n.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0; }\n\n.input-group > .input-group-append > .btn,\n.input-group > .input-group-append > .input-group-text,\n.input-group > .input-group-prepend:not(:first-child) > .btn,\n.input-group > .input-group-prepend:not(:first-child) > .input-group-text,\n.input-group > .input-group-prepend:first-child > .btn:not(:first-child),\n.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0; }\n\n.custom-control {\n  position: relative;\n  display: block;\n  min-height: 1.5rem;\n  padding-left: 1.5rem; }\n\n.custom-control-inline {\n  display: inline-flex;\n  margin-right: 1rem; }\n\n.custom-control-input {\n  position: absolute;\n  z-index: -1;\n  opacity: 0; }\n  .custom-control-input:checked ~ .custom-control-label::before {\n    color: #fff;\n    background-color: #007bff; }\n  .custom-control-input:focus ~ .custom-control-label::before {\n    box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(0, 123, 255, 0.25); }\n  .custom-control-input:active ~ .custom-control-label::before {\n    color: #fff;\n    background-color: #b3d7ff; }\n  .custom-control-input:disabled ~ .custom-control-label {\n    color: #6c757d; }\n    .custom-control-input:disabled ~ .custom-control-label::before {\n      background-color: #e9ecef; }\n\n.custom-control-label {\n  margin-bottom: 0; }\n  .custom-control-label::before {\n    position: absolute;\n    top: 0.25rem;\n    left: 0;\n    display: block;\n    width: 1rem;\n    height: 1rem;\n    pointer-events: none;\n    content: \"\";\n    user-select: none;\n    background-color: #dee2e6; }\n  .custom-control-label::after {\n    position: absolute;\n    top: 0.25rem;\n    left: 0;\n    display: block;\n    width: 1rem;\n    height: 1rem;\n    content: \"\";\n    background-repeat: no-repeat;\n    background-position: center center;\n    background-size: 50% 50%; }\n\n.custom-checkbox .custom-control-label::before {\n  border-radius: 0.25rem; }\n.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {\n  background-color: #007bff; }\n.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {\n  background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3E%3C/svg%3E\"); }\n.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::before {\n  background-color: #007bff; }\n.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::after {\n  background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 4'%3E%3Cpath stroke='%23fff' d='M0 2h4'/%3E%3C/svg%3E\"); }\n.custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {\n  background-color: rgba(0, 123, 255, 0.5); }\n.custom-checkbox .custom-control-input:disabled:indeterminate ~ .custom-control-label::before {\n  background-color: rgba(0, 123, 255, 0.5); }\n\n.custom-radio .custom-control-label::before {\n  border-radius: 50%; }\n.custom-radio .custom-control-input:checked ~ .custom-control-label::before {\n  background-color: #007bff; }\n.custom-radio .custom-control-input:checked ~ .custom-control-label::after {\n  background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='3' fill='%23fff'/%3E%3C/svg%3E\"); }\n.custom-radio .custom-control-input:disabled:checked ~ .custom-control-label::before {\n  background-color: rgba(0, 123, 255, 0.5); }\n\n.custom-select {\n  display: inline-block;\n  width: 100%;\n  height: calc(2.25rem + 2px);\n  padding: 0.375rem 1.75rem 0.375rem 0.75rem;\n  line-height: 1.5;\n  color: #495057;\n  vertical-align: middle;\n  background: #fff url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3E%3Cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E\") no-repeat right 0.75rem center;\n  background-size: 8px 10px;\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n  appearance: none; }\n  .custom-select:focus {\n    border-color: #80bdff;\n    outline: 0;\n    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075), 0 0 5px rgba(128, 189, 255, 0.5); }\n    .custom-select:focus::-ms-value {\n      color: #495057;\n      background-color: #fff; }\n  .custom-select[multiple], .custom-select[size]:not([size=\"1\"]) {\n    height: auto;\n    padding-right: 0.75rem;\n    background-image: none; }\n  .custom-select:disabled {\n    color: #6c757d;\n    background-color: #e9ecef; }\n  .custom-select::-ms-expand {\n    opacity: 0; }\n\n.custom-select-sm {\n  height: calc(1.8125rem + 2px);\n  padding-top: 0.375rem;\n  padding-bottom: 0.375rem;\n  font-size: 75%; }\n\n.custom-select-lg {\n  height: calc(2.875rem + 2px);\n  padding-top: 0.375rem;\n  padding-bottom: 0.375rem;\n  font-size: 125%; }\n\n.custom-file {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  height: calc(2.25rem + 2px);\n  margin-bottom: 0; }\n\n.custom-file-input {\n  position: relative;\n  z-index: 2;\n  width: 100%;\n  height: calc(2.25rem + 2px);\n  margin: 0;\n  opacity: 0; }\n  .custom-file-input:focus ~ .custom-file-label {\n    border-color: #80bdff;\n    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25); }\n    .custom-file-input:focus ~ .custom-file-label::after {\n      border-color: #80bdff; }\n  .custom-file-input:lang(en) ~ .custom-file-label::after {\n    content: \"Browse\"; }\n\n.custom-file-label {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1;\n  height: calc(2.25rem + 2px);\n  padding: 0.375rem 0.75rem;\n  line-height: 1.5;\n  color: #495057;\n  background-color: #fff;\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem; }\n  .custom-file-label::after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 3;\n    display: block;\n    height: calc(calc(2.25rem + 2px) - 1px * 2);\n    padding: 0.375rem 0.75rem;\n    line-height: 1.5;\n    color: #495057;\n    content: \"Browse\";\n    background-color: #e9ecef;\n    border-left: 1px solid #ced4da;\n    border-radius: 0 0.25rem 0.25rem 0; }\n\n.custom-range {\n  width: 100%;\n  padding-left: 0;\n  background-color: transparent;\n  appearance: none; }\n  .custom-range:focus {\n    outline: none; }\n  .custom-range::-moz-focus-outer {\n    border: 0; }\n  .custom-range::-webkit-slider-thumb {\n    width: 1rem;\n    height: 1rem;\n    margin-top: -0.25rem;\n    background-color: #007bff;\n    border: 0;\n    border-radius: 1rem;\n    appearance: none; }\n    .custom-range::-webkit-slider-thumb:focus {\n      outline: none;\n      box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(0, 123, 255, 0.25); }\n    .custom-range::-webkit-slider-thumb:active {\n      background-color: #b3d7ff; }\n  .custom-range::-webkit-slider-runnable-track {\n    width: 100%;\n    height: 0.5rem;\n    color: transparent;\n    cursor: pointer;\n    background-color: #dee2e6;\n    border-color: transparent;\n    border-radius: 1rem; }\n  .custom-range::-moz-range-thumb {\n    width: 1rem;\n    height: 1rem;\n    background-color: #007bff;\n    border: 0;\n    border-radius: 1rem;\n    appearance: none; }\n    .custom-range::-moz-range-thumb:focus {\n      outline: none;\n      box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(0, 123, 255, 0.25); }\n    .custom-range::-moz-range-thumb:active {\n      background-color: #b3d7ff; }\n  .custom-range::-moz-range-track {\n    width: 100%;\n    height: 0.5rem;\n    color: transparent;\n    cursor: pointer;\n    background-color: #dee2e6;\n    border-color: transparent;\n    border-radius: 1rem; }\n  .custom-range::-ms-thumb {\n    width: 1rem;\n    height: 1rem;\n    background-color: #007bff;\n    border: 0;\n    border-radius: 1rem;\n    appearance: none; }\n    .custom-range::-ms-thumb:focus {\n      outline: none;\n      box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(0, 123, 255, 0.25); }\n    .custom-range::-ms-thumb:active {\n      background-color: #b3d7ff; }\n  .custom-range::-ms-track {\n    width: 100%;\n    height: 0.5rem;\n    color: transparent;\n    cursor: pointer;\n    background-color: transparent;\n    border-color: transparent;\n    border-width: 0.5rem; }\n  .custom-range::-ms-fill-lower {\n    background-color: #dee2e6;\n    border-radius: 1rem; }\n  .custom-range::-ms-fill-upper {\n    margin-right: 15px;\n    background-color: #dee2e6;\n    border-radius: 1rem; }\n\n.nav {\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none; }\n\n.nav-link {\n  display: block;\n  padding: 0.5rem 1rem; }\n  .nav-link:hover, .nav-link:focus {\n    text-decoration: none; }\n  .nav-link.disabled {\n    color: #6c757d; }\n\n.nav-tabs {\n  border-bottom: 1px solid #dee2e6; }\n  .nav-tabs .nav-item {\n    margin-bottom: -1px; }\n  .nav-tabs .nav-link {\n    border: 1px solid transparent;\n    border-top-left-radius: 0.25rem;\n    border-top-right-radius: 0.25rem; }\n    .nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {\n      border-color: #e9ecef #e9ecef #dee2e6; }\n    .nav-tabs .nav-link.disabled {\n      color: #6c757d;\n      background-color: transparent;\n      border-color: transparent; }\n  .nav-tabs .nav-link.active,\n  .nav-tabs .nav-item.show .nav-link {\n    color: #495057;\n    background-color: #fff;\n    border-color: #dee2e6 #dee2e6 #fff; }\n  .nav-tabs .dropdown-menu, .nav-tabs span.twitter-typeahead .tt-menu, span.twitter-typeahead .nav-tabs .tt-menu {\n    margin-top: -1px;\n    border-top-left-radius: 0;\n    border-top-right-radius: 0; }\n\n.nav-pills .nav-link {\n  border-radius: 0.25rem; }\n.nav-pills .nav-link.active,\n.nav-pills .show > .nav-link {\n  color: #fff;\n  background-color: #007bff; }\n\n.nav-fill .nav-item {\n  flex: 1 1 auto;\n  text-align: center; }\n\n.nav-justified .nav-item {\n  flex-basis: 0;\n  flex-grow: 1;\n  text-align: center; }\n\n.tab-content > .tab-pane {\n  display: none; }\n.tab-content > .active {\n  display: block; }\n\n.navbar {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.5rem 1rem; }\n  .navbar > .container,\n  .navbar > .container-fluid {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between; }\n\n.navbar-brand {\n  display: inline-block;\n  padding-top: 0.3125rem;\n  padding-bottom: 0.3125rem;\n  margin-right: 1rem;\n  font-size: 1.25rem;\n  line-height: inherit;\n  white-space: nowrap; }\n  .navbar-brand:hover, .navbar-brand:focus {\n    text-decoration: none; }\n\n.navbar-nav {\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none; }\n  .navbar-nav .nav-link {\n    padding-right: 0;\n    padding-left: 0; }\n  .navbar-nav .dropdown-menu, .navbar-nav span.twitter-typeahead .tt-menu, span.twitter-typeahead .navbar-nav .tt-menu {\n    position: static;\n    float: none; }\n\n.navbar-text {\n  display: inline-block;\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem; }\n\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  align-items: center; }\n\n.navbar-toggler {\n  padding: 0.25rem 0.75rem;\n  font-size: 1.25rem;\n  line-height: 1;\n  background-color: transparent;\n  border: 1px solid transparent;\n  border-radius: 0.25rem; }\n  .navbar-toggler:hover, .navbar-toggler:focus {\n    text-decoration: none; }\n  .navbar-toggler:not(:disabled):not(.disabled) {\n    cursor: pointer; }\n\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  content: \"\";\n  background: no-repeat center center;\n  background-size: 100% 100%; }\n\n@media (max-width: 575.98px) {\n  .navbar-expand-sm > .container,\n  .navbar-expand-sm > .container-fluid {\n    padding-right: 0;\n    padding-left: 0; } }\n@media (min-width: 576px) {\n  .navbar-expand-sm {\n    flex-flow: row nowrap;\n    justify-content: flex-start; }\n    .navbar-expand-sm .navbar-nav {\n      flex-direction: row; }\n      .navbar-expand-sm .navbar-nav .dropdown-menu, .navbar-expand-sm .navbar-nav span.twitter-typeahead .tt-menu, span.twitter-typeahead .navbar-expand-sm .navbar-nav .tt-menu {\n        position: absolute; }\n      .navbar-expand-sm .navbar-nav .nav-link {\n        padding-right: 0.5rem;\n        padding-left: 0.5rem; }\n    .navbar-expand-sm > .container,\n    .navbar-expand-sm > .container-fluid {\n      flex-wrap: nowrap; }\n    .navbar-expand-sm .navbar-collapse {\n      display: flex !important;\n      flex-basis: auto; }\n    .navbar-expand-sm .navbar-toggler {\n      display: none; } }\n@media (max-width: 767.98px) {\n  .navbar-expand-md > .container,\n  .navbar-expand-md > .container-fluid {\n    padding-right: 0;\n    padding-left: 0; } }\n@media (min-width: 768px) {\n  .navbar-expand-md {\n    flex-flow: row nowrap;\n    justify-content: flex-start; }\n    .navbar-expand-md .navbar-nav {\n      flex-direction: row; }\n      .navbar-expand-md .navbar-nav .dropdown-menu, .navbar-expand-md .navbar-nav span.twitter-typeahead .tt-menu, span.twitter-typeahead .navbar-expand-md .navbar-nav .tt-menu {\n        position: absolute; }\n      .navbar-expand-md .navbar-nav .nav-link {\n        padding-right: 0.5rem;\n        padding-left: 0.5rem; }\n    .navbar-expand-md > .container,\n    .navbar-expand-md > .container-fluid {\n      flex-wrap: nowrap; }\n    .navbar-expand-md .navbar-collapse {\n      display: flex !important;\n      flex-basis: auto; }\n    .navbar-expand-md .navbar-toggler {\n      display: none; } }\n@media (max-width: 991.98px) {\n  .navbar-expand-lg > .container,\n  .navbar-expand-lg > .container-fluid {\n    padding-right: 0;\n    padding-left: 0; } }\n@media (min-width: 992px) {\n  .navbar-expand-lg {\n    flex-flow: row nowrap;\n    justify-content: flex-start; }\n    .navbar-expand-lg .navbar-nav {\n      flex-direction: row; }\n      .navbar-expand-lg .navbar-nav .dropdown-menu, .navbar-expand-lg .navbar-nav span.twitter-typeahead .tt-menu, span.twitter-typeahead .navbar-expand-lg .navbar-nav .tt-menu {\n        position: absolute; }\n      .navbar-expand-lg .navbar-nav .nav-link {\n        padding-right: 0.5rem;\n        padding-left: 0.5rem; }\n    .navbar-expand-lg > .container,\n    .navbar-expand-lg > .container-fluid {\n      flex-wrap: nowrap; }\n    .navbar-expand-lg .navbar-collapse {\n      display: flex !important;\n      flex-basis: auto; }\n    .navbar-expand-lg .navbar-toggler {\n      display: none; } }\n@media (max-width: 1199.98px) {\n  .navbar-expand-xl > .container,\n  .navbar-expand-xl > .container-fluid {\n    padding-right: 0;\n    padding-left: 0; } }\n@media (min-width: 1200px) {\n  .navbar-expand-xl {\n    flex-flow: row nowrap;\n    justify-content: flex-start; }\n    .navbar-expand-xl .navbar-nav {\n      flex-direction: row; }\n      .navbar-expand-xl .navbar-nav .dropdown-menu, .navbar-expand-xl .navbar-nav span.twitter-typeahead .tt-menu, span.twitter-typeahead .navbar-expand-xl .navbar-nav .tt-menu {\n        position: absolute; }\n      .navbar-expand-xl .navbar-nav .nav-link {\n        padding-right: 0.5rem;\n        padding-left: 0.5rem; }\n    .navbar-expand-xl > .container,\n    .navbar-expand-xl > .container-fluid {\n      flex-wrap: nowrap; }\n    .navbar-expand-xl .navbar-collapse {\n      display: flex !important;\n      flex-basis: auto; }\n    .navbar-expand-xl .navbar-toggler {\n      display: none; } }\n.navbar-expand {\n  flex-flow: row nowrap;\n  justify-content: flex-start; }\n  .navbar-expand > .container,\n  .navbar-expand > .container-fluid {\n    padding-right: 0;\n    padding-left: 0; }\n  .navbar-expand .navbar-nav {\n    flex-direction: row; }\n    .navbar-expand .navbar-nav .dropdown-menu, .navbar-expand .navbar-nav span.twitter-typeahead .tt-menu, span.twitter-typeahead .navbar-expand .navbar-nav .tt-menu {\n      position: absolute; }\n    .navbar-expand .navbar-nav .nav-link {\n      padding-right: 0.5rem;\n      padding-left: 0.5rem; }\n  .navbar-expand > .container,\n  .navbar-expand > .container-fluid {\n    flex-wrap: nowrap; }\n  .navbar-expand .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto; }\n  .navbar-expand .navbar-toggler {\n    display: none; }\n\n.navbar-light .navbar-brand {\n  color: rgba(0, 0, 0, 0.9); }\n  .navbar-light .navbar-brand:hover, .navbar-light .navbar-brand:focus {\n    color: rgba(0, 0, 0, 0.9); }\n.navbar-light .navbar-nav .nav-link {\n  color: rgba(0, 0, 0, 0.5); }\n  .navbar-light .navbar-nav .nav-link:hover, .navbar-light .navbar-nav .nav-link:focus {\n    color: rgba(0, 0, 0, 0.7); }\n  .navbar-light .navbar-nav .nav-link.disabled {\n    color: rgba(0, 0, 0, 0.3); }\n.navbar-light .navbar-nav .show > .nav-link,\n.navbar-light .navbar-nav .active > .nav-link,\n.navbar-light .navbar-nav .nav-link.show,\n.navbar-light .navbar-nav .nav-link.active {\n  color: rgba(0, 0, 0, 0.9); }\n.navbar-light .navbar-toggler {\n  color: rgba(0, 0, 0, 0.5);\n  border-color: rgba(0, 0, 0, 0.1); }\n.navbar-light .navbar-toggler-icon {\n  background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(0, 0, 0, 0.5)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\"); }\n.navbar-light .navbar-text {\n  color: rgba(0, 0, 0, 0.5); }\n  .navbar-light .navbar-text a {\n    color: rgba(0, 0, 0, 0.9); }\n    .navbar-light .navbar-text a:hover, .navbar-light .navbar-text a:focus {\n      color: rgba(0, 0, 0, 0.9); }\n\n.navbar-dark .navbar-brand {\n  color: #fff; }\n  .navbar-dark .navbar-brand:hover, .navbar-dark .navbar-brand:focus {\n    color: #fff; }\n.navbar-dark .navbar-nav .nav-link {\n  color: rgba(255, 255, 255, 0.5); }\n  .navbar-dark .navbar-nav .nav-link:hover, .navbar-dark .navbar-nav .nav-link:focus {\n    color: rgba(255, 255, 255, 0.75); }\n  .navbar-dark .navbar-nav .nav-link.disabled {\n    color: rgba(255, 255, 255, 0.25); }\n.navbar-dark .navbar-nav .show > .nav-link,\n.navbar-dark .navbar-nav .active > .nav-link,\n.navbar-dark .navbar-nav .nav-link.show,\n.navbar-dark .navbar-nav .nav-link.active {\n  color: #fff; }\n.navbar-dark .navbar-toggler {\n  color: rgba(255, 255, 255, 0.5);\n  border-color: rgba(255, 255, 255, 0.1); }\n.navbar-dark .navbar-toggler-icon {\n  background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(255, 255, 255, 0.5)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\"); }\n.navbar-dark .navbar-text {\n  color: rgba(255, 255, 255, 0.5); }\n  .navbar-dark .navbar-text a {\n    color: #fff; }\n    .navbar-dark .navbar-text a:hover, .navbar-dark .navbar-text a:focus {\n      color: #fff; }\n\n.card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  word-wrap: break-word;\n  background-color: #fff;\n  background-clip: border-box;\n  border: 1px solid rgba(0, 0, 0, 0.125);\n  border-radius: 0.25rem; }\n  .card > hr {\n    margin-right: 0;\n    margin-left: 0; }\n  .card > .list-group:first-child .list-group-item:first-child {\n    border-top-left-radius: 0.25rem;\n    border-top-right-radius: 0.25rem; }\n  .card > .list-group:last-child .list-group-item:last-child {\n    border-bottom-right-radius: 0.25rem;\n    border-bottom-left-radius: 0.25rem; }\n\n.card-body {\n  flex: 1 1 auto;\n  padding: 1.25rem; }\n\n.card-title {\n  margin-bottom: 0.75rem; }\n\n.card-subtitle {\n  margin-top: -0.375rem;\n  margin-bottom: 0; }\n\n.card-text:last-child {\n  margin-bottom: 0; }\n\n.card-link:hover {\n  text-decoration: none; }\n.card-link + .card-link {\n  margin-left: 1.25rem; }\n\n.card-header {\n  padding: 0.75rem 1.25rem;\n  margin-bottom: 0;\n  background-color: rgba(0, 0, 0, 0.03);\n  border-bottom: 1px solid rgba(0, 0, 0, 0.125); }\n  .card-header:first-child {\n    border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0; }\n  .card-header + .list-group .list-group-item:first-child {\n    border-top: 0; }\n\n.card-footer {\n  padding: 0.75rem 1.25rem;\n  background-color: rgba(0, 0, 0, 0.03);\n  border-top: 1px solid rgba(0, 0, 0, 0.125); }\n  .card-footer:last-child {\n    border-radius: 0 0 calc(0.25rem - 1px) calc(0.25rem - 1px); }\n\n.card-header-tabs {\n  margin-right: -0.625rem;\n  margin-bottom: -0.75rem;\n  margin-left: -0.625rem;\n  border-bottom: 0; }\n\n.card-header-pills {\n  margin-right: -0.625rem;\n  margin-left: -0.625rem; }\n\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: 1.25rem; }\n\n.card-img {\n  width: 100%;\n  border-radius: calc(0.25rem - 1px); }\n\n.card-img-top {\n  width: 100%;\n  border-top-left-radius: calc(0.25rem - 1px);\n  border-top-right-radius: calc(0.25rem - 1px); }\n\n.card-img-bottom {\n  width: 100%;\n  border-bottom-right-radius: calc(0.25rem - 1px);\n  border-bottom-left-radius: calc(0.25rem - 1px); }\n\n.card-deck {\n  display: flex;\n  flex-direction: column; }\n  .card-deck .card {\n    margin-bottom: 15px; }\n  @media (min-width: 576px) {\n    .card-deck {\n      flex-flow: row wrap;\n      margin-right: -15px;\n      margin-left: -15px; }\n      .card-deck .card {\n        display: flex;\n        flex: 1 0 0%;\n        flex-direction: column;\n        margin-right: 15px;\n        margin-bottom: 0;\n        margin-left: 15px; } }\n\n.card-group {\n  display: flex;\n  flex-direction: column; }\n  .card-group > .card {\n    margin-bottom: 15px; }\n  @media (min-width: 576px) {\n    .card-group {\n      flex-flow: row wrap; }\n      .card-group > .card {\n        flex: 1 0 0%;\n        margin-bottom: 0; }\n        .card-group > .card + .card {\n          margin-left: 0;\n          border-left: 0; }\n        .card-group > .card:first-child {\n          border-top-right-radius: 0;\n          border-bottom-right-radius: 0; }\n          .card-group > .card:first-child .card-img-top,\n          .card-group > .card:first-child .card-header {\n            border-top-right-radius: 0; }\n          .card-group > .card:first-child .card-img-bottom,\n          .card-group > .card:first-child .card-footer {\n            border-bottom-right-radius: 0; }\n        .card-group > .card:last-child {\n          border-top-left-radius: 0;\n          border-bottom-left-radius: 0; }\n          .card-group > .card:last-child .card-img-top,\n          .card-group > .card:last-child .card-header {\n            border-top-left-radius: 0; }\n          .card-group > .card:last-child .card-img-bottom,\n          .card-group > .card:last-child .card-footer {\n            border-bottom-left-radius: 0; }\n        .card-group > .card:only-child {\n          border-radius: 0.25rem; }\n          .card-group > .card:only-child .card-img-top,\n          .card-group > .card:only-child .card-header {\n            border-top-left-radius: 0.25rem;\n            border-top-right-radius: 0.25rem; }\n          .card-group > .card:only-child .card-img-bottom,\n          .card-group > .card:only-child .card-footer {\n            border-bottom-right-radius: 0.25rem;\n            border-bottom-left-radius: 0.25rem; }\n        .card-group > .card:not(:first-child):not(:last-child):not(:only-child) {\n          border-radius: 0; }\n          .card-group > .card:not(:first-child):not(:last-child):not(:only-child) .card-img-top,\n          .card-group > .card:not(:first-child):not(:last-child):not(:only-child) .card-img-bottom,\n          .card-group > .card:not(:first-child):not(:last-child):not(:only-child) .card-header,\n          .card-group > .card:not(:first-child):not(:last-child):not(:only-child) .card-footer {\n            border-radius: 0; } }\n\n.card-columns .card {\n  margin-bottom: 0.75rem; }\n@media (min-width: 576px) {\n  .card-columns {\n    column-count: 3;\n    column-gap: 1.25rem;\n    orphans: 1;\n    widows: 1; }\n    .card-columns .card {\n      display: inline-block;\n      width: 100%; } }\n\n.accordion .card:not(:first-of-type):not(:last-of-type) {\n  border-bottom: 0;\n  border-radius: 0; }\n.accordion .card:not(:first-of-type) .card-header:first-child {\n  border-radius: 0; }\n.accordion .card:first-of-type {\n  border-bottom: 0;\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0; }\n.accordion .card:last-of-type {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0; }\n\n.breadcrumb {\n  display: flex;\n  flex-wrap: wrap;\n  padding: 0.75rem 1rem;\n  margin-bottom: 1rem;\n  list-style: none;\n  background-color: #e9ecef;\n  border-radius: 0.25rem; }\n\n.breadcrumb-item + .breadcrumb-item {\n  padding-left: 0.5rem; }\n  .breadcrumb-item + .breadcrumb-item::before {\n    display: inline-block;\n    padding-right: 0.5rem;\n    color: #6c757d;\n    content: \"/\"; }\n.breadcrumb-item + .breadcrumb-item:hover::before {\n  text-decoration: underline; }\n.breadcrumb-item + .breadcrumb-item:hover::before {\n  text-decoration: none; }\n.breadcrumb-item.active {\n  color: #6c757d; }\n\n.pagination {\n  display: flex;\n  padding-left: 0;\n  list-style: none;\n  border-radius: 0.25rem; }\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: 0.5rem 0.75rem;\n  margin-left: -1px;\n  line-height: 1.25;\n  color: #007bff;\n  background-color: #fff;\n  border: 1px solid #dee2e6; }\n  .page-link:hover {\n    z-index: 2;\n    color: #0056b3;\n    text-decoration: none;\n    background-color: #e9ecef;\n    border-color: #dee2e6; }\n  .page-link:focus {\n    z-index: 2;\n    outline: 0;\n    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25); }\n  .page-link:not(:disabled):not(.disabled) {\n    cursor: pointer; }\n\n.page-item:first-child .page-link {\n  margin-left: 0;\n  border-top-left-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem; }\n.page-item:last-child .page-link {\n  border-top-right-radius: 0.25rem;\n  border-bottom-right-radius: 0.25rem; }\n.page-item.active .page-link {\n  z-index: 1;\n  color: #fff;\n  background-color: #007bff;\n  border-color: #007bff; }\n.page-item.disabled .page-link {\n  color: #6c757d;\n  pointer-events: none;\n  cursor: auto;\n  background-color: #fff;\n  border-color: #dee2e6; }\n\n.pagination-lg .page-link {\n  padding: 0.75rem 1.5rem;\n  font-size: 1.25rem;\n  line-height: 1.5; }\n.pagination-lg .page-item:first-child .page-link {\n  border-top-left-radius: 0.3rem;\n  border-bottom-left-radius: 0.3rem; }\n.pagination-lg .page-item:last-child .page-link {\n  border-top-right-radius: 0.3rem;\n  border-bottom-right-radius: 0.3rem; }\n\n.pagination-sm .page-link {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.875rem;\n  line-height: 1.5; }\n.pagination-sm .page-item:first-child .page-link {\n  border-top-left-radius: 0.2rem;\n  border-bottom-left-radius: 0.2rem; }\n.pagination-sm .page-item:last-child .page-link {\n  border-top-right-radius: 0.2rem;\n  border-bottom-right-radius: 0.2rem; }\n\n.badge {\n  display: inline-block;\n  padding: 0.25em 0.4em;\n  font-size: 75%;\n  font-weight: 700;\n  line-height: 1;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: 0.25rem; }\n  .badge:empty {\n    display: none; }\n\n.btn .badge {\n  position: relative;\n  top: -1px; }\n\n.badge-pill {\n  padding-right: 0.6em;\n  padding-left: 0.6em;\n  border-radius: 10rem; }\n\n.badge-primary {\n  color: #fff;\n  background-color: #007bff; }\n  .badge-primary[href]:hover, .badge-primary[href]:focus {\n    color: #fff;\n    text-decoration: none;\n    background-color: #0062cc; }\n\n.badge-secondary {\n  color: #fff;\n  background-color: #6c757d; }\n  .badge-secondary[href]:hover, .badge-secondary[href]:focus {\n    color: #fff;\n    text-decoration: none;\n    background-color: #545b62; }\n\n.badge-success {\n  color: #fff;\n  background-color: #28a745; }\n  .badge-success[href]:hover, .badge-success[href]:focus {\n    color: #fff;\n    text-decoration: none;\n    background-color: #1e7e34; }\n\n.badge-info {\n  color: #fff;\n  background-color: #17a2b8; }\n  .badge-info[href]:hover, .badge-info[href]:focus {\n    color: #fff;\n    text-decoration: none;\n    background-color: #117a8b; }\n\n.badge-warning {\n  color: #212529;\n  background-color: #ffc107; }\n  .badge-warning[href]:hover, .badge-warning[href]:focus {\n    color: #212529;\n    text-decoration: none;\n    background-color: #d39e00; }\n\n.badge-danger {\n  color: #fff;\n  background-color: #dc3545; }\n  .badge-danger[href]:hover, .badge-danger[href]:focus {\n    color: #fff;\n    text-decoration: none;\n    background-color: #bd2130; }\n\n.badge-light {\n  color: #212529;\n  background-color: #f8f9fa; }\n  .badge-light[href]:hover, .badge-light[href]:focus {\n    color: #212529;\n    text-decoration: none;\n    background-color: #dae0e5; }\n\n.badge-dark {\n  color: #fff;\n  background-color: #343a40; }\n  .badge-dark[href]:hover, .badge-dark[href]:focus {\n    color: #fff;\n    text-decoration: none;\n    background-color: #1d2124; }\n\n.jumbotron {\n  padding: 2rem 1rem;\n  margin-bottom: 2rem;\n  background-color: #e9ecef;\n  border-radius: 0.3rem; }\n  @media (min-width: 576px) {\n    .jumbotron {\n      padding: 4rem 2rem; } }\n\n.jumbotron-fluid {\n  padding-right: 0;\n  padding-left: 0;\n  border-radius: 0; }\n\n.alert {\n  position: relative;\n  padding: 0.75rem 1.25rem;\n  margin-bottom: 1rem;\n  border: 1px solid transparent;\n  border-radius: 0.25rem; }\n\n.alert-heading {\n  color: inherit; }\n\n.alert-link {\n  font-weight: 700; }\n\n.alert-dismissible {\n  padding-right: 4rem; }\n  .alert-dismissible .close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    padding: 0.75rem 1.25rem;\n    color: inherit; }\n\n.alert-primary {\n  color: #004085;\n  background-color: #cce5ff;\n  border-color: #b8daff; }\n  .alert-primary hr {\n    border-top-color: #9fcdff; }\n  .alert-primary .alert-link {\n    color: #002752; }\n\n.alert-secondary {\n  color: #383d41;\n  background-color: #e2e3e5;\n  border-color: #d6d8db; }\n  .alert-secondary hr {\n    border-top-color: #c8cbcf; }\n  .alert-secondary .alert-link {\n    color: #202326; }\n\n.alert-success {\n  color: #155724;\n  background-color: #d4edda;\n  border-color: #c3e6cb; }\n  .alert-success hr {\n    border-top-color: #b1dfbb; }\n  .alert-success .alert-link {\n    color: #0b2e13; }\n\n.alert-info {\n  color: #0c5460;\n  background-color: #d1ecf1;\n  border-color: #bee5eb; }\n  .alert-info hr {\n    border-top-color: #abdde5; }\n  .alert-info .alert-link {\n    color: #062c33; }\n\n.alert-warning {\n  color: #856404;\n  background-color: #fff3cd;\n  border-color: #ffeeba; }\n  .alert-warning hr {\n    border-top-color: #ffe8a1; }\n  .alert-warning .alert-link {\n    color: #533f03; }\n\n.alert-danger {\n  color: #721c24;\n  background-color: #f8d7da;\n  border-color: #f5c6cb; }\n  .alert-danger hr {\n    border-top-color: #f1b0b7; }\n  .alert-danger .alert-link {\n    color: #491217; }\n\n.alert-light {\n  color: #818182;\n  background-color: #fefefe;\n  border-color: #fdfdfe; }\n  .alert-light hr {\n    border-top-color: #ececf6; }\n  .alert-light .alert-link {\n    color: #686868; }\n\n.alert-dark {\n  color: #1b1e21;\n  background-color: #d6d8d9;\n  border-color: #c6c8ca; }\n  .alert-dark hr {\n    border-top-color: #b9bbbe; }\n  .alert-dark .alert-link {\n    color: #040505; }\n\n@keyframes progress-bar-stripes {\n  from {\n    background-position: 1rem 0; }\n  to {\n    background-position: 0 0; } }\n.progress {\n  display: flex;\n  height: 1rem;\n  overflow: hidden;\n  font-size: 0.75rem;\n  background-color: #e9ecef;\n  border-radius: 0.25rem; }\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  color: #fff;\n  text-align: center;\n  white-space: nowrap;\n  background-color: #007bff;\n  transition: width 0.6s ease; }\n  @media screen and (prefers-reduced-motion: reduce) {\n    .progress-bar {\n      transition: none; } }\n\n.progress-bar-striped {\n  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-size: 1rem 1rem; }\n\n.progress-bar-animated {\n  animation: progress-bar-stripes 1s linear infinite; }\n\n.media {\n  display: flex;\n  align-items: flex-start; }\n\n.media-body {\n  flex: 1; }\n\n.list-group {\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0; }\n\n.list-group-item-action {\n  width: 100%;\n  color: #495057;\n  text-align: inherit; }\n  .list-group-item-action:hover, .list-group-item-action:focus {\n    color: #495057;\n    text-decoration: none;\n    background-color: #f8f9fa; }\n  .list-group-item-action:active {\n    color: #212529;\n    background-color: #e9ecef; }\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: 0.75rem 1.25rem;\n  margin-bottom: -1px;\n  background-color: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.125); }\n  .list-group-item:first-child {\n    border-top-left-radius: 0.25rem;\n    border-top-right-radius: 0.25rem; }\n  .list-group-item:last-child {\n    margin-bottom: 0;\n    border-bottom-right-radius: 0.25rem;\n    border-bottom-left-radius: 0.25rem; }\n  .list-group-item:hover, .list-group-item:focus {\n    z-index: 1;\n    text-decoration: none; }\n  .list-group-item.disabled, .list-group-item:disabled {\n    color: #6c757d;\n    background-color: #fff; }\n  .list-group-item.active {\n    z-index: 2;\n    color: #fff;\n    background-color: #007bff;\n    border-color: #007bff; }\n\n.list-group-flush .list-group-item {\n  border-right: 0;\n  border-left: 0;\n  border-radius: 0; }\n.list-group-flush:first-child .list-group-item:first-child {\n  border-top: 0; }\n.list-group-flush:last-child .list-group-item:last-child {\n  border-bottom: 0; }\n\n.list-group-item-primary {\n  color: #004085;\n  background-color: #b8daff; }\n  .list-group-item-primary.list-group-item-action:hover, .list-group-item-primary.list-group-item-action:focus {\n    color: #004085;\n    background-color: #9fcdff; }\n  .list-group-item-primary.list-group-item-action.active {\n    color: #fff;\n    background-color: #004085;\n    border-color: #004085; }\n\n.list-group-item-secondary {\n  color: #383d41;\n  background-color: #d6d8db; }\n  .list-group-item-secondary.list-group-item-action:hover, .list-group-item-secondary.list-group-item-action:focus {\n    color: #383d41;\n    background-color: #c8cbcf; }\n  .list-group-item-secondary.list-group-item-action.active {\n    color: #fff;\n    background-color: #383d41;\n    border-color: #383d41; }\n\n.list-group-item-success {\n  color: #155724;\n  background-color: #c3e6cb; }\n  .list-group-item-success.list-group-item-action:hover, .list-group-item-success.list-group-item-action:focus {\n    color: #155724;\n    background-color: #b1dfbb; }\n  .list-group-item-success.list-group-item-action.active {\n    color: #fff;\n    background-color: #155724;\n    border-color: #155724; }\n\n.list-group-item-info {\n  color: #0c5460;\n  background-color: #bee5eb; }\n  .list-group-item-info.list-group-item-action:hover, .list-group-item-info.list-group-item-action:focus {\n    color: #0c5460;\n    background-color: #abdde5; }\n  .list-group-item-info.list-group-item-action.active {\n    color: #fff;\n    background-color: #0c5460;\n    border-color: #0c5460; }\n\n.list-group-item-warning {\n  color: #856404;\n  background-color: #ffeeba; }\n  .list-group-item-warning.list-group-item-action:hover, .list-group-item-warning.list-group-item-action:focus {\n    color: #856404;\n    background-color: #ffe8a1; }\n  .list-group-item-warning.list-group-item-action.active {\n    color: #fff;\n    background-color: #856404;\n    border-color: #856404; }\n\n.list-group-item-danger {\n  color: #721c24;\n  background-color: #f5c6cb; }\n  .list-group-item-danger.list-group-item-action:hover, .list-group-item-danger.list-group-item-action:focus {\n    color: #721c24;\n    background-color: #f1b0b7; }\n  .list-group-item-danger.list-group-item-action.active {\n    color: #fff;\n    background-color: #721c24;\n    border-color: #721c24; }\n\n.list-group-item-light {\n  color: #818182;\n  background-color: #fdfdfe; }\n  .list-group-item-light.list-group-item-action:hover, .list-group-item-light.list-group-item-action:focus {\n    color: #818182;\n    background-color: #ececf6; }\n  .list-group-item-light.list-group-item-action.active {\n    color: #fff;\n    background-color: #818182;\n    border-color: #818182; }\n\n.list-group-item-dark {\n  color: #1b1e21;\n  background-color: #c6c8ca; }\n  .list-group-item-dark.list-group-item-action:hover, .list-group-item-dark.list-group-item-action:focus {\n    color: #1b1e21;\n    background-color: #b9bbbe; }\n  .list-group-item-dark.list-group-item-action.active {\n    color: #fff;\n    background-color: #1b1e21;\n    border-color: #1b1e21; }\n\n.close {\n  float: right;\n  font-size: 1.5rem;\n  font-weight: 700;\n  line-height: 1;\n  color: #000;\n  text-shadow: 0 1px 0 #fff;\n  opacity: .5; }\n  .close:hover, .close:focus {\n    color: #000;\n    text-decoration: none;\n    opacity: .75; }\n  .close:not(:disabled):not(.disabled) {\n    cursor: pointer; }\n\nbutton.close {\n  padding: 0;\n  background-color: transparent;\n  border: 0;\n  -webkit-appearance: none; }\n\n.modal-open {\n  overflow: hidden; }\n\n.modal {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1050;\n  display: none;\n  overflow: hidden;\n  outline: 0; }\n  .modal-open .modal {\n    overflow-x: hidden;\n    overflow-y: auto; }\n\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: 0.5rem;\n  pointer-events: none; }\n  .modal.fade .modal-dialog {\n    transition: transform 0.3s ease-out;\n    transform: translate(0, -25%); }\n    @media screen and (prefers-reduced-motion: reduce) {\n      .modal.fade .modal-dialog {\n        transition: none; } }\n  .modal.show .modal-dialog {\n    transform: translate(0, 0); }\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - (0.5rem * 2)); }\n\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  pointer-events: auto;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  border-radius: 0.3rem;\n  outline: 0; }\n\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1040;\n  background-color: #000; }\n  .modal-backdrop.fade {\n    opacity: 0; }\n  .modal-backdrop.show {\n    opacity: 0.5; }\n\n.modal-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 1rem;\n  border-bottom: 1px solid #e9ecef;\n  border-top-left-radius: 0.3rem;\n  border-top-right-radius: 0.3rem; }\n  .modal-header .close {\n    padding: 1rem;\n    margin: -1rem -1rem -1rem auto; }\n\n.modal-title {\n  margin-bottom: 0;\n  line-height: 1.5; }\n\n.modal-body {\n  position: relative;\n  flex: 1 1 auto;\n  padding: 1rem; }\n\n.modal-footer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  padding: 1rem;\n  border-top: 1px solid #e9ecef; }\n  .modal-footer > :not(:first-child) {\n    margin-left: .25rem; }\n  .modal-footer > :not(:last-child) {\n    margin-right: .25rem; }\n\n.modal-scrollbar-measure {\n  position: absolute;\n  top: -9999px;\n  width: 50px;\n  height: 50px;\n  overflow: scroll; }\n\n@media (min-width: 576px) {\n  .modal-dialog {\n    max-width: 650px;\n    margin: 1.75rem auto; }\n\n  .modal-dialog-centered {\n    min-height: calc(100% - (1.75rem * 2)); }\n\n  .modal-sm {\n    max-width: 300px; } }\n@media (min-width: 992px) {\n  .modal-lg {\n    max-width: 800px; } }\n.tooltip {\n  position: absolute;\n  z-index: 1070;\n  display: block;\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  white-space: normal;\n  line-break: auto;\n  font-size: 0.875rem;\n  word-wrap: break-word;\n  opacity: 0; }\n  .tooltip.show {\n    opacity: 0.9; }\n  .tooltip .arrow {\n    position: absolute;\n    display: block;\n    width: 0.8rem;\n    height: 0.4rem; }\n    .tooltip .arrow::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid; }\n\n.bs-tooltip-top, .bs-tooltip-auto[x-placement^=\"top\"] {\n  padding: 0.4rem 0; }\n  .bs-tooltip-top .arrow, .bs-tooltip-auto[x-placement^=\"top\"] .arrow {\n    bottom: 0; }\n    .bs-tooltip-top .arrow::before, .bs-tooltip-auto[x-placement^=\"top\"] .arrow::before {\n      top: 0;\n      border-width: 0.4rem 0.4rem 0;\n      border-top-color: #000; }\n\n.bs-tooltip-right, .bs-tooltip-auto[x-placement^=\"right\"] {\n  padding: 0 0.4rem; }\n  .bs-tooltip-right .arrow, .bs-tooltip-auto[x-placement^=\"right\"] .arrow {\n    left: 0;\n    width: 0.4rem;\n    height: 0.8rem; }\n    .bs-tooltip-right .arrow::before, .bs-tooltip-auto[x-placement^=\"right\"] .arrow::before {\n      right: 0;\n      border-width: 0.4rem 0.4rem 0.4rem 0;\n      border-right-color: #000; }\n\n.bs-tooltip-bottom, .bs-tooltip-auto[x-placement^=\"bottom\"] {\n  padding: 0.4rem 0; }\n  .bs-tooltip-bottom .arrow, .bs-tooltip-auto[x-placement^=\"bottom\"] .arrow {\n    top: 0; }\n    .bs-tooltip-bottom .arrow::before, .bs-tooltip-auto[x-placement^=\"bottom\"] .arrow::before {\n      bottom: 0;\n      border-width: 0 0.4rem 0.4rem;\n      border-bottom-color: #000; }\n\n.bs-tooltip-left, .bs-tooltip-auto[x-placement^=\"left\"] {\n  padding: 0 0.4rem; }\n  .bs-tooltip-left .arrow, .bs-tooltip-auto[x-placement^=\"left\"] .arrow {\n    right: 0;\n    width: 0.4rem;\n    height: 0.8rem; }\n    .bs-tooltip-left .arrow::before, .bs-tooltip-auto[x-placement^=\"left\"] .arrow::before {\n      left: 0;\n      border-width: 0.4rem 0 0.4rem 0.4rem;\n      border-left-color: #000; }\n\n.tooltip-inner {\n  max-width: 200px;\n  padding: 0.25rem 0.5rem;\n  color: #fff;\n  text-align: center;\n  background-color: #000;\n  border-radius: 0.25rem; }\n\n.popover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1060;\n  display: block;\n  max-width: 276px;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  white-space: normal;\n  line-break: auto;\n  font-size: 0.875rem;\n  word-wrap: break-word;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  border-radius: 0.3rem; }\n  .popover .arrow {\n    position: absolute;\n    display: block;\n    width: 1rem;\n    height: 0.5rem;\n    margin: 0 0.3rem; }\n    .popover .arrow::before, .popover .arrow::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid; }\n\n.bs-popover-top, .bs-popover-auto[x-placement^=\"top\"] {\n  margin-bottom: 0.5rem; }\n  .bs-popover-top .arrow, .bs-popover-auto[x-placement^=\"top\"] .arrow {\n    bottom: calc((0.5rem + 1px) * -1); }\n  .bs-popover-top .arrow::before, .bs-popover-auto[x-placement^=\"top\"] .arrow::before,\n  .bs-popover-top .arrow::after,\n  .bs-popover-auto[x-placement^=\"top\"] .arrow::after {\n    border-width: 0.5rem 0.5rem 0; }\n  .bs-popover-top .arrow::before, .bs-popover-auto[x-placement^=\"top\"] .arrow::before {\n    bottom: 0;\n    border-top-color: rgba(0, 0, 0, 0.25); }\n  .bs-popover-top .arrow::after, .bs-popover-auto[x-placement^=\"top\"] .arrow::after {\n    bottom: 1px;\n    border-top-color: #fff; }\n\n.bs-popover-right, .bs-popover-auto[x-placement^=\"right\"] {\n  margin-left: 0.5rem; }\n  .bs-popover-right .arrow, .bs-popover-auto[x-placement^=\"right\"] .arrow {\n    left: calc((0.5rem + 1px) * -1);\n    width: 0.5rem;\n    height: 1rem;\n    margin: 0.3rem 0; }\n  .bs-popover-right .arrow::before, .bs-popover-auto[x-placement^=\"right\"] .arrow::before,\n  .bs-popover-right .arrow::after,\n  .bs-popover-auto[x-placement^=\"right\"] .arrow::after {\n    border-width: 0.5rem 0.5rem 0.5rem 0; }\n  .bs-popover-right .arrow::before, .bs-popover-auto[x-placement^=\"right\"] .arrow::before {\n    left: 0;\n    border-right-color: rgba(0, 0, 0, 0.25); }\n  .bs-popover-right .arrow::after, .bs-popover-auto[x-placement^=\"right\"] .arrow::after {\n    left: 1px;\n    border-right-color: #fff; }\n\n.bs-popover-bottom, .bs-popover-auto[x-placement^=\"bottom\"] {\n  margin-top: 0.5rem; }\n  .bs-popover-bottom .arrow, .bs-popover-auto[x-placement^=\"bottom\"] .arrow {\n    top: calc((0.5rem + 1px) * -1); }\n  .bs-popover-bottom .arrow::before, .bs-popover-auto[x-placement^=\"bottom\"] .arrow::before,\n  .bs-popover-bottom .arrow::after,\n  .bs-popover-auto[x-placement^=\"bottom\"] .arrow::after {\n    border-width: 0 0.5rem 0.5rem 0.5rem; }\n  .bs-popover-bottom .arrow::before, .bs-popover-auto[x-placement^=\"bottom\"] .arrow::before {\n    top: 0;\n    border-bottom-color: rgba(0, 0, 0, 0.25); }\n  .bs-popover-bottom .arrow::after, .bs-popover-auto[x-placement^=\"bottom\"] .arrow::after {\n    top: 1px;\n    border-bottom-color: #fff; }\n  .bs-popover-bottom .popover-header::before, .bs-popover-auto[x-placement^=\"bottom\"] .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: 1rem;\n    margin-left: -0.5rem;\n    content: \"\";\n    border-bottom: 1px solid #f7f7f7; }\n\n.bs-popover-left, .bs-popover-auto[x-placement^=\"left\"] {\n  margin-right: 0.5rem; }\n  .bs-popover-left .arrow, .bs-popover-auto[x-placement^=\"left\"] .arrow {\n    right: calc((0.5rem + 1px) * -1);\n    width: 0.5rem;\n    height: 1rem;\n    margin: 0.3rem 0; }\n  .bs-popover-left .arrow::before, .bs-popover-auto[x-placement^=\"left\"] .arrow::before,\n  .bs-popover-left .arrow::after,\n  .bs-popover-auto[x-placement^=\"left\"] .arrow::after {\n    border-width: 0.5rem 0 0.5rem 0.5rem; }\n  .bs-popover-left .arrow::before, .bs-popover-auto[x-placement^=\"left\"] .arrow::before {\n    right: 0;\n    border-left-color: rgba(0, 0, 0, 0.25); }\n  .bs-popover-left .arrow::after, .bs-popover-auto[x-placement^=\"left\"] .arrow::after {\n    right: 1px;\n    border-left-color: #fff; }\n\n.popover-header {\n  padding: 0.5rem 0.75rem;\n  margin-bottom: 0;\n  font-size: 1rem;\n  color: inherit;\n  background-color: #f7f7f7;\n  border-bottom: 1px solid #ebebeb;\n  border-top-left-radius: calc(0.3rem - 1px);\n  border-top-right-radius: calc(0.3rem - 1px); }\n  .popover-header:empty {\n    display: none; }\n\n.popover-body {\n  padding: 0.5rem 0.75rem;\n  color: #212529; }\n\n.carousel {\n  position: relative; }\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden; }\n\n.carousel-item {\n  position: relative;\n  display: none;\n  align-items: center;\n  width: 100%;\n  transition: transform 0.6s ease;\n  backface-visibility: hidden;\n  perspective: 1000px; }\n  @media screen and (prefers-reduced-motion: reduce) {\n    .carousel-item {\n      transition: none; } }\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block; }\n\n.carousel-item-next,\n.carousel-item-prev {\n  position: absolute;\n  top: 0; }\n\n.carousel-item-next.carousel-item-left,\n.carousel-item-prev.carousel-item-right {\n  transform: translateX(0); }\n  @supports (transform-style: preserve-3d) {\n    .carousel-item-next.carousel-item-left,\n    .carousel-item-prev.carousel-item-right {\n      transform: translate3d(0, 0, 0); } }\n\n.carousel-item-next,\n.active.carousel-item-right {\n  transform: translateX(100%); }\n  @supports (transform-style: preserve-3d) {\n    .carousel-item-next,\n    .active.carousel-item-right {\n      transform: translate3d(100%, 0, 0); } }\n\n.carousel-item-prev,\n.active.carousel-item-left {\n  transform: translateX(-100%); }\n  @supports (transform-style: preserve-3d) {\n    .carousel-item-prev,\n    .active.carousel-item-left {\n      transform: translate3d(-100%, 0, 0); } }\n\n.carousel-fade .carousel-item {\n  opacity: 0;\n  transition-duration: .6s;\n  transition-property: opacity; }\n.carousel-fade .carousel-item.active,\n.carousel-fade .carousel-item-next.carousel-item-left,\n.carousel-fade .carousel-item-prev.carousel-item-right {\n  opacity: 1; }\n.carousel-fade .active.carousel-item-left,\n.carousel-fade .active.carousel-item-right {\n  opacity: 0; }\n.carousel-fade .carousel-item-next,\n.carousel-fade .carousel-item-prev,\n.carousel-fade .carousel-item.active,\n.carousel-fade .active.carousel-item-left,\n.carousel-fade .active.carousel-item-prev {\n  transform: translateX(0); }\n  @supports (transform-style: preserve-3d) {\n    .carousel-fade .carousel-item-next,\n    .carousel-fade .carousel-item-prev,\n    .carousel-fade .carousel-item.active,\n    .carousel-fade .active.carousel-item-left,\n    .carousel-fade .active.carousel-item-prev {\n      transform: translate3d(0, 0, 0); } }\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 15%;\n  color: #fff;\n  text-align: center;\n  opacity: 0.5; }\n  .carousel-control-prev:hover, .carousel-control-prev:focus,\n  .carousel-control-next:hover,\n  .carousel-control-next:focus {\n    color: #fff;\n    text-decoration: none;\n    outline: 0;\n    opacity: .9; }\n\n.carousel-control-prev {\n  left: 0; }\n\n.carousel-control-next {\n  right: 0; }\n\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  background: transparent no-repeat center center;\n  background-size: 100% 100%; }\n\n.carousel-control-prev-icon {\n  background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' viewBox='0 0 8 8'%3E%3Cpath d='M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z'/%3E%3C/svg%3E\"); }\n\n.carousel-control-next-icon {\n  background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' viewBox='0 0 8 8'%3E%3Cpath d='M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z'/%3E%3C/svg%3E\"); }\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 10px;\n  left: 0;\n  z-index: 15;\n  display: flex;\n  justify-content: center;\n  padding-left: 0;\n  margin-right: 15%;\n  margin-left: 15%;\n  list-style: none; }\n  .carousel-indicators li {\n    position: relative;\n    flex: 0 1 auto;\n    width: 30px;\n    height: 3px;\n    margin-right: 3px;\n    margin-left: 3px;\n    text-indent: -999px;\n    background-color: rgba(255, 255, 255, 0.5); }\n    .carousel-indicators li::before {\n      position: absolute;\n      top: -10px;\n      left: 0;\n      display: inline-block;\n      width: 100%;\n      height: 10px;\n      content: \"\"; }\n    .carousel-indicators li::after {\n      position: absolute;\n      bottom: -10px;\n      left: 0;\n      display: inline-block;\n      width: 100%;\n      height: 10px;\n      content: \"\"; }\n  .carousel-indicators .active {\n    background-color: #fff; }\n\n.carousel-caption {\n  position: absolute;\n  right: 15%;\n  bottom: 20px;\n  left: 15%;\n  z-index: 10;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  color: #fff;\n  text-align: center; }\n\n.align-baseline {\n  vertical-align: baseline !important; }\n\n.align-top {\n  vertical-align: top !important; }\n\n.align-middle {\n  vertical-align: middle !important; }\n\n.align-bottom {\n  vertical-align: bottom !important; }\n\n.align-text-bottom {\n  vertical-align: text-bottom !important; }\n\n.align-text-top {\n  vertical-align: text-top !important; }\n\n.bg-primary {\n  background-color: #007bff !important; }\n\na.bg-primary:hover, a.bg-primary:focus,\nbutton.bg-primary:hover,\nbutton.bg-primary:focus {\n  background-color: #0062cc !important; }\n\n.bg-secondary {\n  background-color: #6c757d !important; }\n\na.bg-secondary:hover, a.bg-secondary:focus,\nbutton.bg-secondary:hover,\nbutton.bg-secondary:focus {\n  background-color: #545b62 !important; }\n\n.bg-success {\n  background-color: #28a745 !important; }\n\na.bg-success:hover, a.bg-success:focus,\nbutton.bg-success:hover,\nbutton.bg-success:focus {\n  background-color: #1e7e34 !important; }\n\n.bg-info {\n  background-color: #015ec9 !important; }\n\na.bg-info:hover, a.bg-info:focus,\nbutton.bg-info:hover,\nbutton.bg-info:focus {\n  background-color: #117a8b !important; }\n\n.bg-warning {\n  background-color: #ffc107 !important; }\n\na.bg-warning:hover, a.bg-warning:focus,\nbutton.bg-warning:hover,\nbutton.bg-warning:focus {\n  background-color: #d39e00 !important; }\n\n.bg-danger {\n  background-color: #dc3545 !important; }\n\na.bg-danger:hover, a.bg-danger:focus,\nbutton.bg-danger:hover,\nbutton.bg-danger:focus {\n  background-color: #bd2130 !important; }\n\n.bg-light {\n  background-color: #f8f9fa !important; }\n\na.bg-light:hover, a.bg-light:focus,\nbutton.bg-light:hover,\nbutton.bg-light:focus {\n  background-color: #dae0e5 !important; }\n\n.bg-dark {\n  background-color: #343a40 !important; }\n\na.bg-dark:hover, a.bg-dark:focus,\nbutton.bg-dark:hover,\nbutton.bg-dark:focus {\n  background-color: #1d2124 !important; }\n\n.bg-white {\n  background-color: #fff !important; }\n\n.bg-transparent {\n  background-color: transparent !important; }\n\n.border {\n  border: 1px solid #dee2e6 !important; }\n\n.border-top {\n  border-top: 1px solid #dee2e6 !important; }\n\n.border-right {\n  border-right: 1px solid #dee2e6 !important; }\n\n.border-bottom {\n  border-bottom: 1px solid #dee2e6 !important; }\n\n.border-left {\n  border-left: 1px solid #dee2e6 !important; }\n\n.border-0 {\n  border: 0 !important; }\n\n.border-top-0 {\n  border-top: 0 !important; }\n\n.border-right-0 {\n  border-right: 0 !important; }\n\n.border-bottom-0 {\n  border-bottom: 0 !important; }\n\n.border-left-0 {\n  border-left: 0 !important; }\n\n.border-primary {\n  border-color: #007bff !important; }\n\n.border-secondary {\n  border-color: #6c757d !important; }\n\n.border-success {\n  border-color: #28a745 !important; }\n\n.border-info {\n  border-color: #17a2b8 !important; }\n\n.border-warning {\n  border-color: #ffc107 !important; }\n\n.border-danger {\n  border-color: #dc3545 !important; }\n\n.border-light {\n  border-color: #f8f9fa !important; }\n\n.border-dark {\n  border-color: #343a40 !important; }\n\n.border-white {\n  border-color: #fff !important; }\n\n.rounded {\n  border-radius: 0.25rem !important; }\n\n.rounded-top {\n  border-top-left-radius: 0.25rem !important;\n  border-top-right-radius: 0.25rem !important; }\n\n.rounded-right {\n  border-top-right-radius: 0.25rem !important;\n  border-bottom-right-radius: 0.25rem !important; }\n\n.rounded-bottom {\n  border-bottom-right-radius: 0.25rem !important;\n  border-bottom-left-radius: 0.25rem !important; }\n\n.rounded-left {\n  border-top-left-radius: 0.25rem !important;\n  border-bottom-left-radius: 0.25rem !important; }\n\n.rounded-circle {\n  border-radius: 50% !important; }\n\n.rounded-0 {\n  border-radius: 0 !important; }\n\n.clearfix::after {\n  display: block;\n  clear: both;\n  content: \"\"; }\n\n.d-none {\n  display: none !important; }\n\n.d-inline {\n  display: inline !important; }\n\n.d-inline-block {\n  display: inline-block !important; }\n\n.d-block {\n  display: block !important; }\n\n.d-table {\n  display: table !important; }\n\n.d-table-row {\n  display: table-row !important; }\n\n.d-table-cell {\n  display: table-cell !important; }\n\n.d-flex {\n  display: flex !important; }\n\n.d-inline-flex {\n  display: inline-flex !important; }\n\n@media (min-width: 576px) {\n  .d-sm-none {\n    display: none !important; }\n\n  .d-sm-inline {\n    display: inline !important; }\n\n  .d-sm-inline-block {\n    display: inline-block !important; }\n\n  .d-sm-block {\n    display: block !important; }\n\n  .d-sm-table {\n    display: table !important; }\n\n  .d-sm-table-row {\n    display: table-row !important; }\n\n  .d-sm-table-cell {\n    display: table-cell !important; }\n\n  .d-sm-flex {\n    display: flex !important; }\n\n  .d-sm-inline-flex {\n    display: inline-flex !important; } }\n@media (min-width: 768px) {\n  .d-md-none {\n    display: none !important; }\n\n  .d-md-inline {\n    display: inline !important; }\n\n  .d-md-inline-block {\n    display: inline-block !important; }\n\n  .d-md-block {\n    display: block !important; }\n\n  .d-md-table {\n    display: table !important; }\n\n  .d-md-table-row {\n    display: table-row !important; }\n\n  .d-md-table-cell {\n    display: table-cell !important; }\n\n  .d-md-flex {\n    display: flex !important; }\n\n  .d-md-inline-flex {\n    display: inline-flex !important; } }\n@media (min-width: 992px) {\n  .d-lg-none {\n    display: none !important; }\n\n  .d-lg-inline {\n    display: inline !important; }\n\n  .d-lg-inline-block {\n    display: inline-block !important; }\n\n  .d-lg-block {\n    display: block !important; }\n\n  .d-lg-table {\n    display: table !important; }\n\n  .d-lg-table-row {\n    display: table-row !important; }\n\n  .d-lg-table-cell {\n    display: table-cell !important; }\n\n  .d-lg-flex {\n    display: flex !important; }\n\n  .d-lg-inline-flex {\n    display: inline-flex !important; } }\n@media (min-width: 1200px) {\n  .d-xl-none {\n    display: none !important; }\n\n  .d-xl-inline {\n    display: inline !important; }\n\n  .d-xl-inline-block {\n    display: inline-block !important; }\n\n  .d-xl-block {\n    display: block !important; }\n\n  .d-xl-table {\n    display: table !important; }\n\n  .d-xl-table-row {\n    display: table-row !important; }\n\n  .d-xl-table-cell {\n    display: table-cell !important; }\n\n  .d-xl-flex {\n    display: flex !important; }\n\n  .d-xl-inline-flex {\n    display: inline-flex !important; } }\n@media print {\n  .d-print-none {\n    display: none !important; }\n\n  .d-print-inline {\n    display: inline !important; }\n\n  .d-print-inline-block {\n    display: inline-block !important; }\n\n  .d-print-block {\n    display: block !important; }\n\n  .d-print-table {\n    display: table !important; }\n\n  .d-print-table-row {\n    display: table-row !important; }\n\n  .d-print-table-cell {\n    display: table-cell !important; }\n\n  .d-print-flex {\n    display: flex !important; }\n\n  .d-print-inline-flex {\n    display: inline-flex !important; } }\n.embed-responsive {\n  position: relative;\n  display: block;\n  width: 100%;\n  padding: 0;\n  overflow: hidden; }\n  .embed-responsive::before {\n    display: block;\n    content: \"\"; }\n  .embed-responsive .embed-responsive-item,\n  .embed-responsive iframe,\n  .embed-responsive embed,\n  .embed-responsive object,\n  .embed-responsive video {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    border: 0; }\n\n.embed-responsive-21by9::before {\n  padding-top: 42.8571428571%; }\n\n.embed-responsive-16by9::before {\n  padding-top: 56.25%; }\n\n.embed-responsive-4by3::before {\n  padding-top: 75%; }\n\n.embed-responsive-1by1::before {\n  padding-top: 100%; }\n\n.flex-row {\n  flex-direction: row !important; }\n\n.flex-column {\n  flex-direction: column !important; }\n\n.flex-row-reverse {\n  flex-direction: row-reverse !important; }\n\n.flex-column-reverse {\n  flex-direction: column-reverse !important; }\n\n.flex-wrap {\n  flex-wrap: wrap !important; }\n\n.flex-nowrap {\n  flex-wrap: nowrap !important; }\n\n.flex-wrap-reverse {\n  flex-wrap: wrap-reverse !important; }\n\n.flex-fill {\n  flex: 1 1 auto !important; }\n\n.flex-grow-0 {\n  flex-grow: 0 !important; }\n\n.flex-grow-1 {\n  flex-grow: 1 !important; }\n\n.flex-shrink-0 {\n  flex-shrink: 0 !important; }\n\n.flex-shrink-1 {\n  flex-shrink: 1 !important; }\n\n.justify-content-start {\n  justify-content: flex-start !important; }\n\n.justify-content-end {\n  justify-content: flex-end !important; }\n\n.justify-content-center {\n  justify-content: center !important; }\n\n.justify-content-between {\n  justify-content: space-between !important; }\n\n.justify-content-around {\n  justify-content: space-around !important; }\n\n.align-items-start {\n  align-items: flex-start !important; }\n\n.align-items-end {\n  align-items: flex-end !important; }\n\n.align-items-center {\n  align-items: center !important; }\n\n.align-items-baseline {\n  align-items: baseline !important; }\n\n.align-items-stretch {\n  align-items: stretch !important; }\n\n.align-content-start {\n  align-content: flex-start !important; }\n\n.align-content-end {\n  align-content: flex-end !important; }\n\n.align-content-center {\n  align-content: center !important; }\n\n.align-content-between {\n  align-content: space-between !important; }\n\n.align-content-around {\n  align-content: space-around !important; }\n\n.align-content-stretch {\n  align-content: stretch !important; }\n\n.align-self-auto {\n  align-self: auto !important; }\n\n.align-self-start {\n  align-self: flex-start !important; }\n\n.align-self-end {\n  align-self: flex-end !important; }\n\n.align-self-center {\n  align-self: center !important; }\n\n.align-self-baseline {\n  align-self: baseline !important; }\n\n.align-self-stretch {\n  align-self: stretch !important; }\n\n@media (min-width: 576px) {\n  .flex-sm-row {\n    flex-direction: row !important; }\n\n  .flex-sm-column {\n    flex-direction: column !important; }\n\n  .flex-sm-row-reverse {\n    flex-direction: row-reverse !important; }\n\n  .flex-sm-column-reverse {\n    flex-direction: column-reverse !important; }\n\n  .flex-sm-wrap {\n    flex-wrap: wrap !important; }\n\n  .flex-sm-nowrap {\n    flex-wrap: nowrap !important; }\n\n  .flex-sm-wrap-reverse {\n    flex-wrap: wrap-reverse !important; }\n\n  .flex-sm-fill {\n    flex: 1 1 auto !important; }\n\n  .flex-sm-grow-0 {\n    flex-grow: 0 !important; }\n\n  .flex-sm-grow-1 {\n    flex-grow: 1 !important; }\n\n  .flex-sm-shrink-0 {\n    flex-shrink: 0 !important; }\n\n  .flex-sm-shrink-1 {\n    flex-shrink: 1 !important; }\n\n  .justify-content-sm-start {\n    justify-content: flex-start !important; }\n\n  .justify-content-sm-end {\n    justify-content: flex-end !important; }\n\n  .justify-content-sm-center {\n    justify-content: center !important; }\n\n  .justify-content-sm-between {\n    justify-content: space-between !important; }\n\n  .justify-content-sm-around {\n    justify-content: space-around !important; }\n\n  .align-items-sm-start {\n    align-items: flex-start !important; }\n\n  .align-items-sm-end {\n    align-items: flex-end !important; }\n\n  .align-items-sm-center {\n    align-items: center !important; }\n\n  .align-items-sm-baseline {\n    align-items: baseline !important; }\n\n  .align-items-sm-stretch {\n    align-items: stretch !important; }\n\n  .align-content-sm-start {\n    align-content: flex-start !important; }\n\n  .align-content-sm-end {\n    align-content: flex-end !important; }\n\n  .align-content-sm-center {\n    align-content: center !important; }\n\n  .align-content-sm-between {\n    align-content: space-between !important; }\n\n  .align-content-sm-around {\n    align-content: space-around !important; }\n\n  .align-content-sm-stretch {\n    align-content: stretch !important; }\n\n  .align-self-sm-auto {\n    align-self: auto !important; }\n\n  .align-self-sm-start {\n    align-self: flex-start !important; }\n\n  .align-self-sm-end {\n    align-self: flex-end !important; }\n\n  .align-self-sm-center {\n    align-self: center !important; }\n\n  .align-self-sm-baseline {\n    align-self: baseline !important; }\n\n  .align-self-sm-stretch {\n    align-self: stretch !important; } }\n@media (min-width: 768px) {\n  .flex-md-row {\n    flex-direction: row !important; }\n\n  .flex-md-column {\n    flex-direction: column !important; }\n\n  .flex-md-row-reverse {\n    flex-direction: row-reverse !important; }\n\n  .flex-md-column-reverse {\n    flex-direction: column-reverse !important; }\n\n  .flex-md-wrap {\n    flex-wrap: wrap !important; }\n\n  .flex-md-nowrap {\n    flex-wrap: nowrap !important; }\n\n  .flex-md-wrap-reverse {\n    flex-wrap: wrap-reverse !important; }\n\n  .flex-md-fill {\n    flex: 1 1 auto !important; }\n\n  .flex-md-grow-0 {\n    flex-grow: 0 !important; }\n\n  .flex-md-grow-1 {\n    flex-grow: 1 !important; }\n\n  .flex-md-shrink-0 {\n    flex-shrink: 0 !important; }\n\n  .flex-md-shrink-1 {\n    flex-shrink: 1 !important; }\n\n  .justify-content-md-start {\n    justify-content: flex-start !important; }\n\n  .justify-content-md-end {\n    justify-content: flex-end !important; }\n\n  .justify-content-md-center {\n    justify-content: center !important; }\n\n  .justify-content-md-between {\n    justify-content: space-between !important; }\n\n  .justify-content-md-around {\n    justify-content: space-around !important; }\n\n  .align-items-md-start {\n    align-items: flex-start !important; }\n\n  .align-items-md-end {\n    align-items: flex-end !important; }\n\n  .align-items-md-center {\n    align-items: center !important; }\n\n  .align-items-md-baseline {\n    align-items: baseline !important; }\n\n  .align-items-md-stretch {\n    align-items: stretch !important; }\n\n  .align-content-md-start {\n    align-content: flex-start !important; }\n\n  .align-content-md-end {\n    align-content: flex-end !important; }\n\n  .align-content-md-center {\n    align-content: center !important; }\n\n  .align-content-md-between {\n    align-content: space-between !important; }\n\n  .align-content-md-around {\n    align-content: space-around !important; }\n\n  .align-content-md-stretch {\n    align-content: stretch !important; }\n\n  .align-self-md-auto {\n    align-self: auto !important; }\n\n  .align-self-md-start {\n    align-self: flex-start !important; }\n\n  .align-self-md-end {\n    align-self: flex-end !important; }\n\n  .align-self-md-center {\n    align-self: center !important; }\n\n  .align-self-md-baseline {\n    align-self: baseline !important; }\n\n  .align-self-md-stretch {\n    align-self: stretch !important; } }\n@media (min-width: 992px) {\n  .flex-lg-row {\n    flex-direction: row !important; }\n\n  .flex-lg-column {\n    flex-direction: column !important; }\n\n  .flex-lg-row-reverse {\n    flex-direction: row-reverse !important; }\n\n  .flex-lg-column-reverse {\n    flex-direction: column-reverse !important; }\n\n  .flex-lg-wrap {\n    flex-wrap: wrap !important; }\n\n  .flex-lg-nowrap {\n    flex-wrap: nowrap !important; }\n\n  .flex-lg-wrap-reverse {\n    flex-wrap: wrap-reverse !important; }\n\n  .flex-lg-fill {\n    flex: 1 1 auto !important; }\n\n  .flex-lg-grow-0 {\n    flex-grow: 0 !important; }\n\n  .flex-lg-grow-1 {\n    flex-grow: 1 !important; }\n\n  .flex-lg-shrink-0 {\n    flex-shrink: 0 !important; }\n\n  .flex-lg-shrink-1 {\n    flex-shrink: 1 !important; }\n\n  .justify-content-lg-start {\n    justify-content: flex-start !important; }\n\n  .justify-content-lg-end {\n    justify-content: flex-end !important; }\n\n  .justify-content-lg-center {\n    justify-content: center !important; }\n\n  .justify-content-lg-between {\n    justify-content: space-between !important; }\n\n  .justify-content-lg-around {\n    justify-content: space-around !important; }\n\n  .align-items-lg-start {\n    align-items: flex-start !important; }\n\n  .align-items-lg-end {\n    align-items: flex-end !important; }\n\n  .align-items-lg-center {\n    align-items: center !important; }\n\n  .align-items-lg-baseline {\n    align-items: baseline !important; }\n\n  .align-items-lg-stretch {\n    align-items: stretch !important; }\n\n  .align-content-lg-start {\n    align-content: flex-start !important; }\n\n  .align-content-lg-end {\n    align-content: flex-end !important; }\n\n  .align-content-lg-center {\n    align-content: center !important; }\n\n  .align-content-lg-between {\n    align-content: space-between !important; }\n\n  .align-content-lg-around {\n    align-content: space-around !important; }\n\n  .align-content-lg-stretch {\n    align-content: stretch !important; }\n\n  .align-self-lg-auto {\n    align-self: auto !important; }\n\n  .align-self-lg-start {\n    align-self: flex-start !important; }\n\n  .align-self-lg-end {\n    align-self: flex-end !important; }\n\n  .align-self-lg-center {\n    align-self: center !important; }\n\n  .align-self-lg-baseline {\n    align-self: baseline !important; }\n\n  .align-self-lg-stretch {\n    align-self: stretch !important; } }\n@media (min-width: 1200px) {\n  .flex-xl-row {\n    flex-direction: row !important; }\n\n  .flex-xl-column {\n    flex-direction: column !important; }\n\n  .flex-xl-row-reverse {\n    flex-direction: row-reverse !important; }\n\n  .flex-xl-column-reverse {\n    flex-direction: column-reverse !important; }\n\n  .flex-xl-wrap {\n    flex-wrap: wrap !important; }\n\n  .flex-xl-nowrap {\n    flex-wrap: nowrap !important; }\n\n  .flex-xl-wrap-reverse {\n    flex-wrap: wrap-reverse !important; }\n\n  .flex-xl-fill {\n    flex: 1 1 auto !important; }\n\n  .flex-xl-grow-0 {\n    flex-grow: 0 !important; }\n\n  .flex-xl-grow-1 {\n    flex-grow: 1 !important; }\n\n  .flex-xl-shrink-0 {\n    flex-shrink: 0 !important; }\n\n  .flex-xl-shrink-1 {\n    flex-shrink: 1 !important; }\n\n  .justify-content-xl-start {\n    justify-content: flex-start !important; }\n\n  .justify-content-xl-end {\n    justify-content: flex-end !important; }\n\n  .justify-content-xl-center {\n    justify-content: center !important; }\n\n  .justify-content-xl-between {\n    justify-content: space-between !important; }\n\n  .justify-content-xl-around {\n    justify-content: space-around !important; }\n\n  .align-items-xl-start {\n    align-items: flex-start !important; }\n\n  .align-items-xl-end {\n    align-items: flex-end !important; }\n\n  .align-items-xl-center {\n    align-items: center !important; }\n\n  .align-items-xl-baseline {\n    align-items: baseline !important; }\n\n  .align-items-xl-stretch {\n    align-items: stretch !important; }\n\n  .align-content-xl-start {\n    align-content: flex-start !important; }\n\n  .align-content-xl-end {\n    align-content: flex-end !important; }\n\n  .align-content-xl-center {\n    align-content: center !important; }\n\n  .align-content-xl-between {\n    align-content: space-between !important; }\n\n  .align-content-xl-around {\n    align-content: space-around !important; }\n\n  .align-content-xl-stretch {\n    align-content: stretch !important; }\n\n  .align-self-xl-auto {\n    align-self: auto !important; }\n\n  .align-self-xl-start {\n    align-self: flex-start !important; }\n\n  .align-self-xl-end {\n    align-self: flex-end !important; }\n\n  .align-self-xl-center {\n    align-self: center !important; }\n\n  .align-self-xl-baseline {\n    align-self: baseline !important; }\n\n  .align-self-xl-stretch {\n    align-self: stretch !important; } }\n.float-left {\n  float: left !important; }\n\n.float-right {\n  float: right !important; }\n\n.float-none {\n  float: none !important; }\n\n@media (min-width: 576px) {\n  .float-sm-left {\n    float: left !important; }\n\n  .float-sm-right {\n    float: right !important; }\n\n  .float-sm-none {\n    float: none !important; } }\n@media (min-width: 768px) {\n  .float-md-left {\n    float: left !important; }\n\n  .float-md-right {\n    float: right !important; }\n\n  .float-md-none {\n    float: none !important; } }\n@media (min-width: 992px) {\n  .float-lg-left {\n    float: left !important; }\n\n  .float-lg-right {\n    float: right !important; }\n\n  .float-lg-none {\n    float: none !important; } }\n@media (min-width: 1200px) {\n  .float-xl-left {\n    float: left !important; }\n\n  .float-xl-right {\n    float: right !important; }\n\n  .float-xl-none {\n    float: none !important; } }\n.position-static {\n  position: static !important; }\n\n.position-relative {\n  position: relative !important; }\n\n.position-absolute {\n  position: absolute !important; }\n\n.position-fixed {\n  position: fixed !important; }\n\n.position-sticky {\n  position: sticky !important; }\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1030; }\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1030; }\n\n@supports (position: sticky) {\n  .sticky-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020; } }\n\n.sr-only, .bootstrap-datetimepicker-widget .btn[data-action=\"incrementHours\"]::after, .bootstrap-datetimepicker-widget .btn[data-action=\"incrementMinutes\"]::after, .bootstrap-datetimepicker-widget .btn[data-action=\"decrementHours\"]::after, .bootstrap-datetimepicker-widget .btn[data-action=\"decrementMinutes\"]::after, .bootstrap-datetimepicker-widget .btn[data-action=\"showHours\"]::after, .bootstrap-datetimepicker-widget .btn[data-action=\"showMinutes\"]::after, .bootstrap-datetimepicker-widget .btn[data-action=\"togglePeriod\"]::after, .bootstrap-datetimepicker-widget .btn[data-action=\"clear\"]::after, .bootstrap-datetimepicker-widget .btn[data-action=\"today\"]::after, .bootstrap-datetimepicker-widget .picker-switch::after, .bootstrap-datetimepicker-widget table th.prev::after, .bootstrap-datetimepicker-widget table th.next::after {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0; }\n\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  position: static;\n  width: auto;\n  height: auto;\n  overflow: visible;\n  clip: auto;\n  white-space: normal; }\n\n.shadow-sm {\n  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important; }\n\n.shadow {\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important; }\n\n.shadow-lg {\n  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important; }\n\n.shadow-none {\n  box-shadow: none !important; }\n\n.w-25 {\n  width: 25% !important; }\n\n.w-50 {\n  width: 50% !important; }\n\n.w-75 {\n  width: 75% !important; }\n\n.w-100 {\n  width: 100% !important; }\n\n.w-auto {\n  width: auto !important; }\n\n.h-25 {\n  height: 25% !important; }\n\n.h-50 {\n  height: 50% !important; }\n\n.h-75 {\n  height: 75% !important; }\n\n.h-100 {\n  height: 100% !important; }\n\n.h-auto {\n  height: auto !important; }\n\n.mw-100 {\n  max-width: 100% !important; }\n\n.mh-100 {\n  max-height: 100% !important; }\n\n.m-0 {\n  margin: 0 !important; }\n\n.mt-0,\n.my-0 {\n  margin-top: 0 !important; }\n\n.mr-0,\n.mx-0 {\n  margin-right: 0 !important; }\n\n.mb-0,\n.my-0 {\n  margin-bottom: 0 !important; }\n\n.ml-0,\n.mx-0 {\n  margin-left: 0 !important; }\n\n.m-1 {\n  margin: 0.25rem !important; }\n\n.mt-1,\n.my-1 {\n  margin-top: 0.25rem !important; }\n\n.mr-1,\n.mx-1 {\n  margin-right: 0.25rem !important; }\n\n.mb-1,\n.my-1 {\n  margin-bottom: 0.25rem !important; }\n\n.ml-1,\n.mx-1 {\n  margin-left: 0.25rem !important; }\n\n.m-2 {\n  margin: 0.5rem !important; }\n\n.mt-2,\n.my-2 {\n  margin-top: 0.5rem !important; }\n\n.mr-2,\n.mx-2 {\n  margin-right: 0.5rem !important; }\n\n.mb-2,\n.my-2 {\n  margin-bottom: 0.5rem !important; }\n\n.ml-2,\n.mx-2 {\n  margin-left: 0.5rem !important; }\n\n.m-3 {\n  margin: 1rem !important; }\n\n.mt-3,\n.my-3 {\n  margin-top: 1rem !important; }\n\n.mr-3,\n.mx-3 {\n  margin-right: 1rem !important; }\n\n.mb-3,\n.my-3 {\n  margin-bottom: 1rem !important; }\n\n.ml-3,\n.mx-3 {\n  margin-left: 1rem !important; }\n\n.m-4 {\n  margin: 1.5rem !important; }\n\n.mt-4,\n.my-4 {\n  margin-top: 1.5rem !important; }\n\n.mr-4,\n.mx-4 {\n  margin-right: 1.5rem !important; }\n\n.mb-4,\n.my-4 {\n  margin-bottom: 1.5rem !important; }\n\n.ml-4,\n.mx-4 {\n  margin-left: 1.5rem !important; }\n\n.m-5 {\n  margin: 3rem !important; }\n\n.mt-5,\n.my-5 {\n  margin-top: 3rem !important; }\n\n.mr-5,\n.mx-5 {\n  margin-right: 3rem !important; }\n\n.mb-5,\n.my-5 {\n  margin-bottom: 3rem !important; }\n\n.ml-5,\n.mx-5 {\n  margin-left: 3rem !important; }\n\n.p-0 {\n  padding: 0 !important; }\n\n.pt-0,\n.py-0 {\n  padding-top: 0 !important; }\n\n.pr-0,\n.px-0 {\n  padding-right: 0 !important; }\n\n.pb-0,\n.py-0 {\n  padding-bottom: 0 !important; }\n\n.pl-0,\n.px-0 {\n  padding-left: 0 !important; }\n\n.p-1 {\n  padding: 0.25rem !important; }\n\n.pt-1,\n.py-1 {\n  padding-top: 0.25rem !important; }\n\n.pr-1,\n.px-1 {\n  padding-right: 0.25rem !important; }\n\n.pb-1,\n.py-1 {\n  padding-bottom: 0.25rem !important; }\n\n.pl-1,\n.px-1 {\n  padding-left: 0.25rem !important; }\n\n.p-2 {\n  padding: 0.5rem !important; }\n\n.pt-2,\n.py-2 {\n  padding-top: 0.5rem !important; }\n\n.pr-2,\n.px-2 {\n  padding-right: 0.5rem !important; }\n\n.pb-2,\n.py-2 {\n  padding-bottom: 0.5rem !important; }\n\n.pl-2,\n.px-2 {\n  padding-left: 0.5rem !important; }\n\n.p-3 {\n  padding: 1rem !important; }\n\n.pt-3,\n.py-3 {\n  padding-top: 1rem !important; }\n\n.pr-3,\n.px-3 {\n  padding-right: 1rem !important; }\n\n.pb-3,\n.py-3 {\n  padding-bottom: 1rem !important; }\n\n.pl-3,\n.px-3 {\n  padding-left: 1rem !important; }\n\n.p-4 {\n  padding: 1.5rem !important; }\n\n.pt-4,\n.py-4 {\n  padding-top: 1.5rem !important; }\n\n.pr-4,\n.px-4 {\n  padding-right: 1.5rem !important; }\n\n.pb-4,\n.py-4 {\n  padding-bottom: 1.5rem !important; }\n\n.pl-4,\n.px-4 {\n  padding-left: 1.5rem !important; }\n\n.p-5 {\n  padding: 3rem !important; }\n\n.pt-5,\n.py-5 {\n  padding-top: 3rem !important; }\n\n.pr-5,\n.px-5 {\n  padding-right: 3rem !important; }\n\n.pb-5,\n.py-5 {\n  padding-bottom: 3rem !important; }\n\n.pl-5,\n.px-5 {\n  padding-left: 3rem !important; }\n\n.m-auto {\n  margin: auto !important; }\n\n.mt-auto,\n.my-auto {\n  margin-top: auto !important; }\n\n.mr-auto,\n.mx-auto {\n  margin-right: auto !important; }\n\n.mb-auto,\n.my-auto {\n  margin-bottom: auto !important; }\n\n.ml-auto,\n.mx-auto {\n  margin-left: auto !important; }\n\n@media (min-width: 576px) {\n  .m-sm-0 {\n    margin: 0 !important; }\n\n  .mt-sm-0,\n  .my-sm-0 {\n    margin-top: 0 !important; }\n\n  .mr-sm-0,\n  .mx-sm-0 {\n    margin-right: 0 !important; }\n\n  .mb-sm-0,\n  .my-sm-0 {\n    margin-bottom: 0 !important; }\n\n  .ml-sm-0,\n  .mx-sm-0 {\n    margin-left: 0 !important; }\n\n  .m-sm-1 {\n    margin: 0.25rem !important; }\n\n  .mt-sm-1,\n  .my-sm-1 {\n    margin-top: 0.25rem !important; }\n\n  .mr-sm-1,\n  .mx-sm-1 {\n    margin-right: 0.25rem !important; }\n\n  .mb-sm-1,\n  .my-sm-1 {\n    margin-bottom: 0.25rem !important; }\n\n  .ml-sm-1,\n  .mx-sm-1 {\n    margin-left: 0.25rem !important; }\n\n  .m-sm-2 {\n    margin: 0.5rem !important; }\n\n  .mt-sm-2,\n  .my-sm-2 {\n    margin-top: 0.5rem !important; }\n\n  .mr-sm-2,\n  .mx-sm-2 {\n    margin-right: 0.5rem !important; }\n\n  .mb-sm-2,\n  .my-sm-2 {\n    margin-bottom: 0.5rem !important; }\n\n  .ml-sm-2,\n  .mx-sm-2 {\n    margin-left: 0.5rem !important; }\n\n  .m-sm-3 {\n    margin: 1rem !important; }\n\n  .mt-sm-3,\n  .my-sm-3 {\n    margin-top: 1rem !important; }\n\n  .mr-sm-3,\n  .mx-sm-3 {\n    margin-right: 1rem !important; }\n\n  .mb-sm-3,\n  .my-sm-3 {\n    margin-bottom: 1rem !important; }\n\n  .ml-sm-3,\n  .mx-sm-3 {\n    margin-left: 1rem !important; }\n\n  .m-sm-4 {\n    margin: 1.5rem !important; }\n\n  .mt-sm-4,\n  .my-sm-4 {\n    margin-top: 1.5rem !important; }\n\n  .mr-sm-4,\n  .mx-sm-4 {\n    margin-right: 1.5rem !important; }\n\n  .mb-sm-4,\n  .my-sm-4 {\n    margin-bottom: 1.5rem !important; }\n\n  .ml-sm-4,\n  .mx-sm-4 {\n    margin-left: 1.5rem !important; }\n\n  .m-sm-5 {\n    margin: 3rem !important; }\n\n  .mt-sm-5,\n  .my-sm-5 {\n    margin-top: 3rem !important; }\n\n  .mr-sm-5,\n  .mx-sm-5 {\n    margin-right: 3rem !important; }\n\n  .mb-sm-5,\n  .my-sm-5 {\n    margin-bottom: 3rem !important; }\n\n  .ml-sm-5,\n  .mx-sm-5 {\n    margin-left: 3rem !important; }\n\n  .p-sm-0 {\n    padding: 0 !important; }\n\n  .pt-sm-0,\n  .py-sm-0 {\n    padding-top: 0 !important; }\n\n  .pr-sm-0,\n  .px-sm-0 {\n    padding-right: 0 !important; }\n\n  .pb-sm-0,\n  .py-sm-0 {\n    padding-bottom: 0 !important; }\n\n  .pl-sm-0,\n  .px-sm-0 {\n    padding-left: 0 !important; }\n\n  .p-sm-1 {\n    padding: 0.25rem !important; }\n\n  .pt-sm-1,\n  .py-sm-1 {\n    padding-top: 0.25rem !important; }\n\n  .pr-sm-1,\n  .px-sm-1 {\n    padding-right: 0.25rem !important; }\n\n  .pb-sm-1,\n  .py-sm-1 {\n    padding-bottom: 0.25rem !important; }\n\n  .pl-sm-1,\n  .px-sm-1 {\n    padding-left: 0.25rem !important; }\n\n  .p-sm-2 {\n    padding: 0.5rem !important; }\n\n  .pt-sm-2,\n  .py-sm-2 {\n    padding-top: 0.5rem !important; }\n\n  .pr-sm-2,\n  .px-sm-2 {\n    padding-right: 0.5rem !important; }\n\n  .pb-sm-2,\n  .py-sm-2 {\n    padding-bottom: 0.5rem !important; }\n\n  .pl-sm-2,\n  .px-sm-2 {\n    padding-left: 0.5rem !important; }\n\n  .p-sm-3 {\n    padding: 1rem !important; }\n\n  .pt-sm-3,\n  .py-sm-3 {\n    padding-top: 1rem !important; }\n\n  .pr-sm-3,\n  .px-sm-3 {\n    padding-right: 1rem !important; }\n\n  .pb-sm-3,\n  .py-sm-3 {\n    padding-bottom: 1rem !important; }\n\n  .pl-sm-3,\n  .px-sm-3 {\n    padding-left: 1rem !important; }\n\n  .p-sm-4 {\n    padding: 1.5rem !important; }\n\n  .pt-sm-4,\n  .py-sm-4 {\n    padding-top: 1.5rem !important; }\n\n  .pr-sm-4,\n  .px-sm-4 {\n    padding-right: 1.5rem !important; }\n\n  .pb-sm-4,\n  .py-sm-4 {\n    padding-bottom: 1.5rem !important; }\n\n  .pl-sm-4,\n  .px-sm-4 {\n    padding-left: 1.5rem !important; }\n\n  .p-sm-5 {\n    padding: 3rem !important; }\n\n  .pt-sm-5,\n  .py-sm-5 {\n    padding-top: 3rem !important; }\n\n  .pr-sm-5,\n  .px-sm-5 {\n    padding-right: 3rem !important; }\n\n  .pb-sm-5,\n  .py-sm-5 {\n    padding-bottom: 3rem !important; }\n\n  .pl-sm-5,\n  .px-sm-5 {\n    padding-left: 3rem !important; }\n\n  .m-sm-auto {\n    margin: auto !important; }\n\n  .mt-sm-auto,\n  .my-sm-auto {\n    margin-top: auto !important; }\n\n  .mr-sm-auto,\n  .mx-sm-auto {\n    margin-right: auto !important; }\n\n  .mb-sm-auto,\n  .my-sm-auto {\n    margin-bottom: auto !important; }\n\n  .ml-sm-auto,\n  .mx-sm-auto {\n    margin-left: auto !important; } }\n@media (min-width: 768px) {\n  .m-md-0 {\n    margin: 0 !important; }\n\n  .mt-md-0,\n  .my-md-0 {\n    margin-top: 0 !important; }\n\n  .mr-md-0,\n  .mx-md-0 {\n    margin-right: 0 !important; }\n\n  .mb-md-0,\n  .my-md-0 {\n    margin-bottom: 0 !important; }\n\n  .ml-md-0,\n  .mx-md-0 {\n    margin-left: 0 !important; }\n\n  .m-md-1 {\n    margin: 0.25rem !important; }\n\n  .mt-md-1,\n  .my-md-1 {\n    margin-top: 0.25rem !important; }\n\n  .mr-md-1,\n  .mx-md-1 {\n    margin-right: 0.25rem !important; }\n\n  .mb-md-1,\n  .my-md-1 {\n    margin-bottom: 0.25rem !important; }\n\n  .ml-md-1,\n  .mx-md-1 {\n    margin-left: 0.25rem !important; }\n\n  .m-md-2 {\n    margin: 0.5rem !important; }\n\n  .mt-md-2,\n  .my-md-2 {\n    margin-top: 0.5rem !important; }\n\n  .mr-md-2,\n  .mx-md-2 {\n    margin-right: 0.5rem !important; }\n\n  .mb-md-2,\n  .my-md-2 {\n    margin-bottom: 0.5rem !important; }\n\n  .ml-md-2,\n  .mx-md-2 {\n    margin-left: 0.5rem !important; }\n\n  .m-md-3 {\n    margin: 1rem !important; }\n\n  .mt-md-3,\n  .my-md-3 {\n    margin-top: 1rem !important; }\n\n  .mr-md-3,\n  .mx-md-3 {\n    margin-right: 1rem !important; }\n\n  .mb-md-3,\n  .my-md-3 {\n    margin-bottom: 1rem !important; }\n\n  .ml-md-3,\n  .mx-md-3 {\n    margin-left: 1rem !important; }\n\n  .m-md-4 {\n    margin: 1.5rem !important; }\n\n  .mt-md-4,\n  .my-md-4 {\n    margin-top: 1.5rem !important; }\n\n  .mr-md-4,\n  .mx-md-4 {\n    margin-right: 1.5rem !important; }\n\n  .mb-md-4,\n  .my-md-4 {\n    margin-bottom: 1.5rem !important; }\n\n  .ml-md-4,\n  .mx-md-4 {\n    margin-left: 1.5rem !important; }\n\n  .m-md-5 {\n    margin: 3rem !important; }\n\n  .mt-md-5,\n  .my-md-5 {\n    margin-top: 3rem !important; }\n\n  .mr-md-5,\n  .mx-md-5 {\n    margin-right: 3rem !important; }\n\n  .mb-md-5,\n  .my-md-5 {\n    margin-bottom: 3rem !important; }\n\n  .ml-md-5,\n  .mx-md-5 {\n    margin-left: 3rem !important; }\n\n  .p-md-0 {\n    padding: 0 !important; }\n\n  .pt-md-0,\n  .py-md-0 {\n    padding-top: 0 !important; }\n\n  .pr-md-0,\n  .px-md-0 {\n    padding-right: 0 !important; }\n\n  .pb-md-0,\n  .py-md-0 {\n    padding-bottom: 0 !important; }\n\n  .pl-md-0,\n  .px-md-0 {\n    padding-left: 0 !important; }\n\n  .p-md-1 {\n    padding: 0.25rem !important; }\n\n  .pt-md-1,\n  .py-md-1 {\n    padding-top: 0.25rem !important; }\n\n  .pr-md-1,\n  .px-md-1 {\n    padding-right: 0.25rem !important; }\n\n  .pb-md-1,\n  .py-md-1 {\n    padding-bottom: 0.25rem !important; }\n\n  .pl-md-1,\n  .px-md-1 {\n    padding-left: 0.25rem !important; }\n\n  .p-md-2 {\n    padding: 0.5rem !important; }\n\n  .pt-md-2,\n  .py-md-2 {\n    padding-top: 0.5rem !important; }\n\n  .pr-md-2,\n  .px-md-2 {\n    padding-right: 0.5rem !important; }\n\n  .pb-md-2,\n  .py-md-2 {\n    padding-bottom: 0.5rem !important; }\n\n  .pl-md-2,\n  .px-md-2 {\n    padding-left: 0.5rem !important; }\n\n  .p-md-3 {\n    padding: 1rem !important; }\n\n  .pt-md-3,\n  .py-md-3 {\n    padding-top: 1rem !important; }\n\n  .pr-md-3,\n  .px-md-3 {\n    padding-right: 1rem !important; }\n\n  .pb-md-3,\n  .py-md-3 {\n    padding-bottom: 1rem !important; }\n\n  .pl-md-3,\n  .px-md-3 {\n    padding-left: 1rem !important; }\n\n  .p-md-4 {\n    padding: 1.5rem !important; }\n\n  .pt-md-4,\n  .py-md-4 {\n    padding-top: 1.5rem !important; }\n\n  .pr-md-4,\n  .px-md-4 {\n    padding-right: 1.5rem !important; }\n\n  .pb-md-4,\n  .py-md-4 {\n    padding-bottom: 1.5rem !important; }\n\n  .pl-md-4,\n  .px-md-4 {\n    padding-left: 1.5rem !important; }\n\n  .p-md-5 {\n    padding: 3rem !important; }\n\n  .pt-md-5,\n  .py-md-5 {\n    padding-top: 3rem !important; }\n\n  .pr-md-5,\n  .px-md-5 {\n    padding-right: 3rem !important; }\n\n  .pb-md-5,\n  .py-md-5 {\n    padding-bottom: 3rem !important; }\n\n  .pl-md-5,\n  .px-md-5 {\n    padding-left: 3rem !important; }\n\n  .m-md-auto {\n    margin: auto !important; }\n\n  .mt-md-auto,\n  .my-md-auto {\n    margin-top: auto !important; }\n\n  .mr-md-auto,\n  .mx-md-auto {\n    margin-right: auto !important; }\n\n  .mb-md-auto,\n  .my-md-auto {\n    margin-bottom: auto !important; }\n\n  .ml-md-auto,\n  .mx-md-auto {\n    margin-left: auto !important; } }\n@media (min-width: 992px) {\n  .m-lg-0 {\n    margin: 0 !important; }\n\n  .mt-lg-0,\n  .my-lg-0 {\n    margin-top: 0 !important; }\n\n  .mr-lg-0,\n  .mx-lg-0 {\n    margin-right: 0 !important; }\n\n  .mb-lg-0,\n  .my-lg-0 {\n    margin-bottom: 0 !important; }\n\n  .ml-lg-0,\n  .mx-lg-0 {\n    margin-left: 0 !important; }\n\n  .m-lg-1 {\n    margin: 0.25rem !important; }\n\n  .mt-lg-1,\n  .my-lg-1 {\n    margin-top: 0.25rem !important; }\n\n  .mr-lg-1,\n  .mx-lg-1 {\n    margin-right: 0.25rem !important; }\n\n  .mb-lg-1,\n  .my-lg-1 {\n    margin-bottom: 0.25rem !important; }\n\n  .ml-lg-1,\n  .mx-lg-1 {\n    margin-left: 0.25rem !important; }\n\n  .m-lg-2 {\n    margin: 0.5rem !important; }\n\n  .mt-lg-2,\n  .my-lg-2 {\n    margin-top: 0.5rem !important; }\n\n  .mr-lg-2,\n  .mx-lg-2 {\n    margin-right: 0.5rem !important; }\n\n  .mb-lg-2,\n  .my-lg-2 {\n    margin-bottom: 0.5rem !important; }\n\n  .ml-lg-2,\n  .mx-lg-2 {\n    margin-left: 0.5rem !important; }\n\n  .m-lg-3 {\n    margin: 1rem !important; }\n\n  .mt-lg-3,\n  .my-lg-3 {\n    margin-top: 1rem !important; }\n\n  .mr-lg-3,\n  .mx-lg-3 {\n    margin-right: 1rem !important; }\n\n  .mb-lg-3,\n  .my-lg-3 {\n    margin-bottom: 1rem !important; }\n\n  .ml-lg-3,\n  .mx-lg-3 {\n    margin-left: 1rem !important; }\n\n  .m-lg-4 {\n    margin: 1.5rem !important; }\n\n  .mt-lg-4,\n  .my-lg-4 {\n    margin-top: 1.5rem !important; }\n\n  .mr-lg-4,\n  .mx-lg-4 {\n    margin-right: 1.5rem !important; }\n\n  .mb-lg-4,\n  .my-lg-4 {\n    margin-bottom: 1.5rem !important; }\n\n  .ml-lg-4,\n  .mx-lg-4 {\n    margin-left: 1.5rem !important; }\n\n  .m-lg-5 {\n    margin: 3rem !important; }\n\n  .mt-lg-5,\n  .my-lg-5 {\n    margin-top: 3rem !important; }\n\n  .mr-lg-5,\n  .mx-lg-5 {\n    margin-right: 3rem !important; }\n\n  .mb-lg-5,\n  .my-lg-5 {\n    margin-bottom: 3rem !important; }\n\n  .ml-lg-5,\n  .mx-lg-5 {\n    margin-left: 3rem !important; }\n\n  .p-lg-0 {\n    padding: 0 !important; }\n\n  .pt-lg-0,\n  .py-lg-0 {\n    padding-top: 0 !important; }\n\n  .pr-lg-0,\n  .px-lg-0 {\n    padding-right: 0 !important; }\n\n  .pb-lg-0,\n  .py-lg-0 {\n    padding-bottom: 0 !important; }\n\n  .pl-lg-0,\n  .px-lg-0 {\n    padding-left: 0 !important; }\n\n  .p-lg-1 {\n    padding: 0.25rem !important; }\n\n  .pt-lg-1,\n  .py-lg-1 {\n    padding-top: 0.25rem !important; }\n\n  .pr-lg-1,\n  .px-lg-1 {\n    padding-right: 0.25rem !important; }\n\n  .pb-lg-1,\n  .py-lg-1 {\n    padding-bottom: 0.25rem !important; }\n\n  .pl-lg-1,\n  .px-lg-1 {\n    padding-left: 0.25rem !important; }\n\n  .p-lg-2 {\n    padding: 0.5rem !important; }\n\n  .pt-lg-2,\n  .py-lg-2 {\n    padding-top: 0.5rem !important; }\n\n  .pr-lg-2,\n  .px-lg-2 {\n    padding-right: 0.5rem !important; }\n\n  .pb-lg-2,\n  .py-lg-2 {\n    padding-bottom: 0.5rem !important; }\n\n  .pl-lg-2,\n  .px-lg-2 {\n    padding-left: 0.5rem !important; }\n\n  .p-lg-3 {\n    padding: 1rem !important; }\n\n  .pt-lg-3,\n  .py-lg-3 {\n    padding-top: 1rem !important; }\n\n  .pr-lg-3,\n  .px-lg-3 {\n    padding-right: 1rem !important; }\n\n  .pb-lg-3,\n  .py-lg-3 {\n    padding-bottom: 1rem !important; }\n\n  .pl-lg-3,\n  .px-lg-3 {\n    padding-left: 1rem !important; }\n\n  .p-lg-4 {\n    padding: 1.5rem !important; }\n\n  .pt-lg-4,\n  .py-lg-4 {\n    padding-top: 1.5rem !important; }\n\n  .pr-lg-4,\n  .px-lg-4 {\n    padding-right: 1.5rem !important; }\n\n  .pb-lg-4,\n  .py-lg-4 {\n    padding-bottom: 1.5rem !important; }\n\n  .pl-lg-4,\n  .px-lg-4 {\n    padding-left: 1.5rem !important; }\n\n  .p-lg-5 {\n    padding: 3rem !important; }\n\n  .pt-lg-5,\n  .py-lg-5 {\n    padding-top: 3rem !important; }\n\n  .pr-lg-5,\n  .px-lg-5 {\n    padding-right: 3rem !important; }\n\n  .pb-lg-5,\n  .py-lg-5 {\n    padding-bottom: 3rem !important; }\n\n  .pl-lg-5,\n  .px-lg-5 {\n    padding-left: 3rem !important; }\n\n  .m-lg-auto {\n    margin: auto !important; }\n\n  .mt-lg-auto,\n  .my-lg-auto {\n    margin-top: auto !important; }\n\n  .mr-lg-auto,\n  .mx-lg-auto {\n    margin-right: auto !important; }\n\n  .mb-lg-auto,\n  .my-lg-auto {\n    margin-bottom: auto !important; }\n\n  .ml-lg-auto,\n  .mx-lg-auto {\n    margin-left: auto !important; } }\n@media (min-width: 1200px) {\n  .m-xl-0 {\n    margin: 0 !important; }\n\n  .mt-xl-0,\n  .my-xl-0 {\n    margin-top: 0 !important; }\n\n  .mr-xl-0,\n  .mx-xl-0 {\n    margin-right: 0 !important; }\n\n  .mb-xl-0,\n  .my-xl-0 {\n    margin-bottom: 0 !important; }\n\n  .ml-xl-0,\n  .mx-xl-0 {\n    margin-left: 0 !important; }\n\n  .m-xl-1 {\n    margin: 0.25rem !important; }\n\n  .mt-xl-1,\n  .my-xl-1 {\n    margin-top: 0.25rem !important; }\n\n  .mr-xl-1,\n  .mx-xl-1 {\n    margin-right: 0.25rem !important; }\n\n  .mb-xl-1,\n  .my-xl-1 {\n    margin-bottom: 0.25rem !important; }\n\n  .ml-xl-1,\n  .mx-xl-1 {\n    margin-left: 0.25rem !important; }\n\n  .m-xl-2 {\n    margin: 0.5rem !important; }\n\n  .mt-xl-2,\n  .my-xl-2 {\n    margin-top: 0.5rem !important; }\n\n  .mr-xl-2,\n  .mx-xl-2 {\n    margin-right: 0.5rem !important; }\n\n  .mb-xl-2,\n  .my-xl-2 {\n    margin-bottom: 0.5rem !important; }\n\n  .ml-xl-2,\n  .mx-xl-2 {\n    margin-left: 0.5rem !important; }\n\n  .m-xl-3 {\n    margin: 1rem !important; }\n\n  .mt-xl-3,\n  .my-xl-3 {\n    margin-top: 1rem !important; }\n\n  .mr-xl-3,\n  .mx-xl-3 {\n    margin-right: 1rem !important; }\n\n  .mb-xl-3,\n  .my-xl-3 {\n    margin-bottom: 1rem !important; }\n\n  .ml-xl-3,\n  .mx-xl-3 {\n    margin-left: 1rem !important; }\n\n  .m-xl-4 {\n    margin: 1.5rem !important; }\n\n  .mt-xl-4,\n  .my-xl-4 {\n    margin-top: 1.5rem !important; }\n\n  .mr-xl-4,\n  .mx-xl-4 {\n    margin-right: 1.5rem !important; }\n\n  .mb-xl-4,\n  .my-xl-4 {\n    margin-bottom: 1.5rem !important; }\n\n  .ml-xl-4,\n  .mx-xl-4 {\n    margin-left: 1.5rem !important; }\n\n  .m-xl-5 {\n    margin: 3rem !important; }\n\n  .mt-xl-5,\n  .my-xl-5 {\n    margin-top: 3rem !important; }\n\n  .mr-xl-5,\n  .mx-xl-5 {\n    margin-right: 3rem !important; }\n\n  .mb-xl-5,\n  .my-xl-5 {\n    margin-bottom: 3rem !important; }\n\n  .ml-xl-5,\n  .mx-xl-5 {\n    margin-left: 3rem !important; }\n\n  .p-xl-0 {\n    padding: 0 !important; }\n\n  .pt-xl-0,\n  .py-xl-0 {\n    padding-top: 0 !important; }\n\n  .pr-xl-0,\n  .px-xl-0 {\n    padding-right: 0 !important; }\n\n  .pb-xl-0,\n  .py-xl-0 {\n    padding-bottom: 0 !important; }\n\n  .pl-xl-0,\n  .px-xl-0 {\n    padding-left: 0 !important; }\n\n  .p-xl-1 {\n    padding: 0.25rem !important; }\n\n  .pt-xl-1,\n  .py-xl-1 {\n    padding-top: 0.25rem !important; }\n\n  .pr-xl-1,\n  .px-xl-1 {\n    padding-right: 0.25rem !important; }\n\n  .pb-xl-1,\n  .py-xl-1 {\n    padding-bottom: 0.25rem !important; }\n\n  .pl-xl-1,\n  .px-xl-1 {\n    padding-left: 0.25rem !important; }\n\n  .p-xl-2 {\n    padding: 0.5rem !important; }\n\n  .pt-xl-2,\n  .py-xl-2 {\n    padding-top: 0.5rem !important; }\n\n  .pr-xl-2,\n  .px-xl-2 {\n    padding-right: 0.5rem !important; }\n\n  .pb-xl-2,\n  .py-xl-2 {\n    padding-bottom: 0.5rem !important; }\n\n  .pl-xl-2,\n  .px-xl-2 {\n    padding-left: 0.5rem !important; }\n\n  .p-xl-3 {\n    padding: 1rem !important; }\n\n  .pt-xl-3,\n  .py-xl-3 {\n    padding-top: 1rem !important; }\n\n  .pr-xl-3,\n  .px-xl-3 {\n    padding-right: 1rem !important; }\n\n  .pb-xl-3,\n  .py-xl-3 {\n    padding-bottom: 1rem !important; }\n\n  .pl-xl-3,\n  .px-xl-3 {\n    padding-left: 1rem !important; }\n\n  .p-xl-4 {\n    padding: 1.5rem !important; }\n\n  .pt-xl-4,\n  .py-xl-4 {\n    padding-top: 1.5rem !important; }\n\n  .pr-xl-4,\n  .px-xl-4 {\n    padding-right: 1.5rem !important; }\n\n  .pb-xl-4,\n  .py-xl-4 {\n    padding-bottom: 1.5rem !important; }\n\n  .pl-xl-4,\n  .px-xl-4 {\n    padding-left: 1.5rem !important; }\n\n  .p-xl-5 {\n    padding: 3rem !important; }\n\n  .pt-xl-5,\n  .py-xl-5 {\n    padding-top: 3rem !important; }\n\n  .pr-xl-5,\n  .px-xl-5 {\n    padding-right: 3rem !important; }\n\n  .pb-xl-5,\n  .py-xl-5 {\n    padding-bottom: 3rem !important; }\n\n  .pl-xl-5,\n  .px-xl-5 {\n    padding-left: 3rem !important; }\n\n  .m-xl-auto {\n    margin: auto !important; }\n\n  .mt-xl-auto,\n  .my-xl-auto {\n    margin-top: auto !important; }\n\n  .mr-xl-auto,\n  .mx-xl-auto {\n    margin-right: auto !important; }\n\n  .mb-xl-auto,\n  .my-xl-auto {\n    margin-bottom: auto !important; }\n\n  .ml-xl-auto,\n  .mx-xl-auto {\n    margin-left: auto !important; } }\n.text-monospace {\n  font-family: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace; }\n\n.text-justify {\n  text-align: justify !important; }\n\n.text-nowrap {\n  white-space: nowrap !important; }\n\n.text-truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap; }\n\n.text-left {\n  text-align: left !important; }\n\n.text-right {\n  text-align: right !important; }\n\n.text-center {\n  text-align: center !important; }\n\n@media (min-width: 576px) {\n  .text-sm-left {\n    text-align: left !important; }\n\n  .text-sm-right {\n    text-align: right !important; }\n\n  .text-sm-center {\n    text-align: center !important; } }\n@media (min-width: 768px) {\n  .text-md-left {\n    text-align: left !important; }\n\n  .text-md-right {\n    text-align: right !important; }\n\n  .text-md-center {\n    text-align: center !important; } }\n@media (min-width: 992px) {\n  .text-lg-left {\n    text-align: left !important; }\n\n  .text-lg-right {\n    text-align: right !important; }\n\n  .text-lg-center {\n    text-align: center !important; } }\n@media (min-width: 1200px) {\n  .text-xl-left {\n    text-align: left !important; }\n\n  .text-xl-right {\n    text-align: right !important; }\n\n  .text-xl-center {\n    text-align: center !important; } }\n.text-lowercase {\n  text-transform: lowercase !important; }\n\n.text-uppercase {\n  text-transform: uppercase !important; }\n\n.text-capitalize {\n  text-transform: capitalize !important; }\n\n.font-weight-light {\n  font-weight: 300 !important; }\n\n.font-weight-normal {\n  font-weight: 400 !important; }\n\n.font-weight-bold {\n  font-weight: 700 !important; }\n\n.font-italic {\n  font-style: italic !important; }\n\n.text-white {\n  color: #fff !important; }\n\n.text-primary {\n  color: #007bff !important; }\n\na.text-primary:hover, a.text-primary:focus {\n  color: #0062cc !important; }\n\n.text-secondary {\n  color: #6c757d !important; }\n\na.text-secondary:hover, a.text-secondary:focus {\n  color: #545b62 !important; }\n\n.text-success {\n  color: #28a745 !important; }\n\na.text-success:hover, a.text-success:focus {\n  color: #1e7e34 !important; }\n\n.text-info {\n  color: #17a2b8 !important; }\n\na.text-info:hover, a.text-info:focus {\n  color: #117a8b !important; }\n\n.text-warning {\n  color: #ffc107 !important; }\n\na.text-warning:hover, a.text-warning:focus {\n  color: #d39e00 !important; }\n\n.text-danger {\n  color: #dc3545 !important; }\n\na.text-danger:hover, a.text-danger:focus {\n  color: #bd2130 !important; }\n\n.text-light {\n  color: #f8f9fa !important; }\n\na.text-light:hover, a.text-light:focus {\n  color: #dae0e5 !important; }\n\n.text-dark {\n  color: #343a40 !important; }\n\na.text-dark:hover, a.text-dark:focus {\n  color: #1d2124 !important; }\n\n.text-body {\n  color: #212529 !important; }\n\n.text-muted {\n  color: #6c757d !important; }\n\n.text-black-50 {\n  color: rgba(0, 0, 0, 0.5) !important; }\n\n.text-white-50 {\n  color: rgba(255, 255, 255, 0.5) !important; }\n\n.text-hide {\n  font: 0/0 a;\n  color: transparent;\n  text-shadow: none;\n  background-color: transparent;\n  border: 0; }\n\n.visible {\n  visibility: visible !important; }\n\n.invisible {\n  visibility: hidden !important; }\n\n@media print {\n  *,\n  *::before,\n  *::after {\n    text-shadow: none !important;\n    box-shadow: none !important; }\n\n  a:not(.btn) {\n    text-decoration: underline; }\n\n  abbr[title]::after {\n    content: \" (\" attr(title) \")\"; }\n\n  pre {\n    white-space: pre-wrap !important; }\n\n  pre,\n  blockquote {\n    border: 1px solid #adb5bd;\n    page-break-inside: avoid; }\n\n  thead {\n    display: table-header-group; }\n\n  tr,\n  img {\n    page-break-inside: avoid; }\n\n  p,\n  h2,\n  h3 {\n    orphans: 3;\n    widows: 3; }\n\n  h2,\n  h3 {\n    page-break-after: avoid; }\n\n  @page {\n    size: a3; }\n  body {\n    min-width: 992px !important; }\n\n  .container {\n    min-width: 992px !important; }\n\n  .navbar {\n    display: none; }\n\n  .badge {\n    border: 1px solid #000; }\n\n  .table {\n    border-collapse: collapse !important; }\n    .table td,\n    .table th {\n      background-color: #fff !important; }\n\n  .table-bordered th,\n  .table-bordered td {\n    border: 1px solid #dee2e6 !important; } }\n/*========Typeaheadjs css start=======*/\nspan.twitter-typeahead {\n  width: 100%; }\n  span.twitter-typeahead .tt-menu {\n    width: 100%; }\n  span.twitter-typeahead .tt-suggestion {\n    font-size: 14px; }\n  .input-group span.twitter-typeahead {\n    display: flex !important;\n    align-items: center;\n    position: relative;\n    flex: 1 1 auto;\n    width: 1%; }\n    .input-group span.twitter-typeahead .tt-menu, .input-group span.twitter-typeahead .tt-hint, .input-group span.twitter-typeahead .tt-input {\n      width: 100%; }\n\n/*========Typeaheadjs css end=======*/\n.bootstrap-datetimepicker-widget {\n  list-style: none; }\n  .bootstrap-datetimepicker-widget.dropdown-menu, span.twitter-typeahead .bootstrap-datetimepicker-widget.tt-menu {\n    display: block;\n    margin: 2px 0;\n    padding: 4px;\n    width: 14rem; }\n    @media (min-width: 576px) {\n      .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs, span.twitter-typeahead .bootstrap-datetimepicker-widget.timepicker-sbs.tt-menu {\n        width: 38em; } }\n    @media (min-width: 768px) {\n      .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs, span.twitter-typeahead .bootstrap-datetimepicker-widget.timepicker-sbs.tt-menu {\n        width: 38em; } }\n    @media (min-width: 992px) {\n      .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs, span.twitter-typeahead .bootstrap-datetimepicker-widget.timepicker-sbs.tt-menu {\n        width: 38em; } }\n    .bootstrap-datetimepicker-widget.dropdown-menu:before, span.twitter-typeahead .bootstrap-datetimepicker-widget.tt-menu:before, .bootstrap-datetimepicker-widget.dropdown-menu:after, span.twitter-typeahead .bootstrap-datetimepicker-widget.tt-menu:after {\n      content: '';\n      display: inline-block;\n      position: absolute; }\n    .bootstrap-datetimepicker-widget.dropdown-menu.bottom:before, span.twitter-typeahead .bootstrap-datetimepicker-widget.bottom.tt-menu:before {\n      border-left: 7px solid transparent;\n      border-right: 7px solid transparent;\n      border-bottom: 7px solid #ccc;\n      border-bottom-color: rgba(0, 0, 0, 0.2);\n      top: -7px;\n      left: 7px; }\n    .bootstrap-datetimepicker-widget.dropdown-menu.bottom:after, span.twitter-typeahead .bootstrap-datetimepicker-widget.bottom.tt-menu:after {\n      border-left: 6px solid transparent;\n      border-right: 6px solid transparent;\n      border-bottom: 6px solid white;\n      top: -6px;\n      left: 8px; }\n    .bootstrap-datetimepicker-widget.dropdown-menu.top:before, span.twitter-typeahead .bootstrap-datetimepicker-widget.top.tt-menu:before {\n      border-left: 7px solid transparent;\n      border-right: 7px solid transparent;\n      border-top: 7px solid #ccc;\n      border-top-color: rgba(0, 0, 0, 0.2);\n      bottom: -7px;\n      left: 6px; }\n    .bootstrap-datetimepicker-widget.dropdown-menu.top:after, span.twitter-typeahead .bootstrap-datetimepicker-widget.top.tt-menu:after {\n      border-left: 6px solid transparent;\n      border-right: 6px solid transparent;\n      border-top: 6px solid white;\n      bottom: -6px;\n      left: 7px; }\n    .bootstrap-datetimepicker-widget.dropdown-menu.float-right:before, span.twitter-typeahead .bootstrap-datetimepicker-widget.float-right.tt-menu:before {\n      left: auto;\n      right: 6px; }\n    .bootstrap-datetimepicker-widget.dropdown-menu.float-right:after, span.twitter-typeahead .bootstrap-datetimepicker-widget.float-right.tt-menu:after {\n      left: auto;\n      right: 7px; }\n  .bootstrap-datetimepicker-widget .list-unstyled {\n    margin: 0; }\n  .bootstrap-datetimepicker-widget a[data-action] {\n    padding: 6px 0; }\n  .bootstrap-datetimepicker-widget a[data-action]:active {\n    box-shadow: none; }\n  .bootstrap-datetimepicker-widget .timepicker-hour, .bootstrap-datetimepicker-widget .timepicker-minute, .bootstrap-datetimepicker-widget .timepicker-second {\n    width: 54px;\n    font-weight: bold;\n    font-size: 1.2em;\n    margin: 0; }\n  .bootstrap-datetimepicker-widget button[data-action] {\n    padding: 6px; }\n  .bootstrap-datetimepicker-widget .btn[data-action=\"incrementHours\"]::after {\n    content: \"Increment Hours\"; }\n  .bootstrap-datetimepicker-widget .btn[data-action=\"incrementMinutes\"]::after {\n    content: \"Increment Minutes\"; }\n  .bootstrap-datetimepicker-widget .btn[data-action=\"decrementHours\"]::after {\n    content: \"Decrement Hours\"; }\n  .bootstrap-datetimepicker-widget .btn[data-action=\"decrementMinutes\"]::after {\n    content: \"Decrement Minutes\"; }\n  .bootstrap-datetimepicker-widget .btn[data-action=\"showHours\"]::after {\n    content: \"Show Hours\"; }\n  .bootstrap-datetimepicker-widget .btn[data-action=\"showMinutes\"]::after {\n    content: \"Show Minutes\"; }\n  .bootstrap-datetimepicker-widget .btn[data-action=\"togglePeriod\"]::after {\n    content: \"Toggle AM/PM\"; }\n  .bootstrap-datetimepicker-widget .btn[data-action=\"clear\"]::after {\n    content: \"Clear the picker\"; }\n  .bootstrap-datetimepicker-widget .btn[data-action=\"today\"]::after {\n    content: \"Set the date to today\"; }\n  .bootstrap-datetimepicker-widget .picker-switch {\n    text-align: center; }\n    .bootstrap-datetimepicker-widget .picker-switch::after {\n      content: \"Toggle Date and Time Screens\"; }\n    .bootstrap-datetimepicker-widget .picker-switch td {\n      padding: 0;\n      margin: 0;\n      height: auto;\n      width: auto;\n      line-height: inherit; }\n      .bootstrap-datetimepicker-widget .picker-switch td span {\n        line-height: 2.5;\n        height: 2.5em;\n        width: 100%; }\n  .bootstrap-datetimepicker-widget table {\n    width: 100%;\n    margin: 0; }\n    .bootstrap-datetimepicker-widget table td, .bootstrap-datetimepicker-widget table th {\n      text-align: center;\n      border-radius: 0.25rem; }\n    .bootstrap-datetimepicker-widget table th {\n      height: 20px;\n      line-height: 20px;\n      width: 20px; }\n      .bootstrap-datetimepicker-widget table th.picker-switch {\n        width: 145px; }\n      .bootstrap-datetimepicker-widget table th.disabled, .bootstrap-datetimepicker-widget table th.disabled:hover {\n        background: none;\n        color: #6c757d;\n        cursor: not-allowed; }\n      .bootstrap-datetimepicker-widget table th.prev::after {\n        content: \"Previous Month\"; }\n      .bootstrap-datetimepicker-widget table th.next::after {\n        content: \"Next Month\"; }\n    .bootstrap-datetimepicker-widget table thead tr:first-child th {\n      cursor: pointer; }\n      .bootstrap-datetimepicker-widget table thead tr:first-child th:hover {\n        background: #e9ecef; }\n    .bootstrap-datetimepicker-widget table td {\n      height: 54px;\n      line-height: 54px;\n      width: 54px; }\n      .bootstrap-datetimepicker-widget table td.cw {\n        font-size: .8em;\n        height: 20px;\n        line-height: 20px;\n        color: #6c757d; }\n      .bootstrap-datetimepicker-widget table td.day {\n        height: 20px;\n        line-height: 20px;\n        width: 20px; }\n      .bootstrap-datetimepicker-widget table td.day:hover, .bootstrap-datetimepicker-widget table td.hour:hover, .bootstrap-datetimepicker-widget table td.minute:hover, .bootstrap-datetimepicker-widget table td.second:hover {\n        background: #e9ecef;\n        cursor: pointer; }\n      .bootstrap-datetimepicker-widget table td.old, .bootstrap-datetimepicker-widget table td.new {\n        color: #6c757d; }\n      .bootstrap-datetimepicker-widget table td.today {\n        position: relative; }\n        .bootstrap-datetimepicker-widget table td.today:before {\n          content: '';\n          display: inline-block;\n          border: solid transparent;\n          border-width: 0 0 7px 7px;\n          border-bottom-color: #ab8ce4;\n          border-top-color: rgba(0, 0, 0, 0.2);\n          position: absolute;\n          bottom: 4px;\n          right: 4px; }\n      .bootstrap-datetimepicker-widget table td.active, .bootstrap-datetimepicker-widget table td.active:hover {\n        background-color: #ab8ce4;\n        color: #fff;\n        text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25); }\n      .bootstrap-datetimepicker-widget table td.active.today:before {\n        border-bottom-color: #fff; }\n      .bootstrap-datetimepicker-widget table td.disabled, .bootstrap-datetimepicker-widget table td.disabled:hover {\n        background: none;\n        color: #6c757d;\n        cursor: not-allowed; }\n      .bootstrap-datetimepicker-widget table td span {\n        display: inline-block;\n        width: 54px;\n        height: 54px;\n        line-height: 54px;\n        margin: 2px 1.5px;\n        cursor: pointer;\n        border-radius: 0.25rem; }\n        .bootstrap-datetimepicker-widget table td span:hover {\n          background: #e9ecef; }\n        .bootstrap-datetimepicker-widget table td span.active {\n          background-color: #ab8ce4;\n          color: #fff;\n          text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25); }\n        .bootstrap-datetimepicker-widget table td span.old {\n          color: #6c757d; }\n        .bootstrap-datetimepicker-widget table td span.disabled, .bootstrap-datetimepicker-widget table td span.disabled:hover {\n          background: none;\n          color: #6c757d;\n          cursor: not-allowed; }\n  .bootstrap-datetimepicker-widget.usetwentyfour td.hour {\n    height: 27px;\n    line-height: 27px; }\n\n.input-group [data-toggle=\"datetimepicker\"] {\n  cursor: pointer; }\n.entity-form-group{\n  max-width:20%;\n  margin-bottom: 16px; \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
